/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddCommentRequest } from '../model';
// @ts-ignore
import { AddOrganizationCreateRequest200Response } from '../model';
// @ts-ignore
import { AddOrganizationCreateRequestRequest } from '../model';
// @ts-ignore
import { AddPointToOrganizationRequest } from '../model';
// @ts-ignore
import { AgreeToOlInfoSharingConsent200Response } from '../model';
// @ts-ignore
import { AnalyzeEvidence200Response } from '../model';
// @ts-ignore
import { AnalyzeInvoiceOfPaymentRequests200Response } from '../model';
// @ts-ignore
import { ApplyFraudLockStatus200Response } from '../model';
// @ts-ignore
import { ApproveOrganizationIdentityVerification200Response } from '../model';
// @ts-ignore
import { ApprovePurchaseApplicationRequest } from '../model';
// @ts-ignore
import { ApproveWorkflowStepPaymentRequestsRequest } from '../model';
// @ts-ignore
import { AutomaticallyJournalizeDealsFromRulesRequest } from '../model';
// @ts-ignore
import { BankAccountActivitiesWithdrawalReserve200Response } from '../model';
// @ts-ignore
import { BankAccountActivitiesWithdrawalReserveRequest } from '../model';
// @ts-ignore
import { BulkDisableDailyUserUsageLimit200ResponseInner } from '../model';
// @ts-ignore
import { BulkDisableDailyUserUsageLimitRequest } from '../model';
// @ts-ignore
import { BulkDisableMonthlyUsageLimit200ResponseInner } from '../model';
// @ts-ignore
import { BulkDisableMonthlyUsageLimitRequest } from '../model';
// @ts-ignore
import { BulkInviteUsersAdmin200Response } from '../model';
// @ts-ignore
import { BulkInviteUsersAdmin400Response } from '../model';
// @ts-ignore
import { BulkInviteUsersAdmin403Response } from '../model';
// @ts-ignore
import { BulkInviteUsersAdminRequest } from '../model';
// @ts-ignore
import { BulkUpdateDailyUsageLimit200ResponseInner } from '../model';
// @ts-ignore
import { BulkUpdateDailyUsageLimitRequest } from '../model';
// @ts-ignore
import { BulkUpdateMonthlyUsageLimit200ResponseInner } from '../model';
// @ts-ignore
import { BulkUpdateMonthlyUsageLimitRequest } from '../model';
// @ts-ignore
import { BulkUpdateOrganizationUserPrivilegesRequest } from '../model';
// @ts-ignore
import { ChangeIdentityVerificationScheduledDate200Response } from '../model';
// @ts-ignore
import { ChangeIdentityVerificationScheduledDateRequest } from '../model';
// @ts-ignore
import { ChangeInvoiceEmail200Response } from '../model';
// @ts-ignore
import { ChangeInvoiceEmailRequest } from '../model';
// @ts-ignore
import { ChangeToTheSpecifiedEkycResultRequest } from '../model';
// @ts-ignore
import { CheckAlreadyRegisteredPhoneNumber200Response } from '../model';
// @ts-ignore
import { CheckAlreadyRegisteredPhoneNumberRequest } from '../model';
// @ts-ignore
import { CheckDuplicateEmailAddresses200ResponseInner } from '../model';
// @ts-ignore
import { CompleteRedirectFromSlack200Response } from '../model';
// @ts-ignore
import { CompleteRedirectFromSlackRequest } from '../model';
// @ts-ignore
import { ConfirmFufuHotelReservation200Response } from '../model';
// @ts-ignore
import { ConfirmFufuHotelReservationRequest } from '../model';
// @ts-ignore
import { ConnectFreeeForAccounting403Response } from '../model';
// @ts-ignore
import { ConnectFreeeForAccountingRequest } from '../model';
// @ts-ignore
import { CountDealsRequest } from '../model';
// @ts-ignore
import { CreateBankTransfers200Response } from '../model';
// @ts-ignore
import { CreateBankTransfersRequest } from '../model';
// @ts-ignore
import { CreateCategoryOfThePurchaseApplicationTemplateRequest } from '../model';
// @ts-ignore
import { CreateCommentTemplateRequest } from '../model';
// @ts-ignore
import { CreateDepositRestrictionForOrganizationRequest } from '../model';
// @ts-ignore
import { CreateDraftOfPaymentRequests200Response } from '../model';
// @ts-ignore
import { CreateDraftOfPaymentRequestsRequest } from '../model';
// @ts-ignore
import { CreateEtcCardIssuanceRequest200Response } from '../model';
// @ts-ignore
import { CreateEtcCardIssuanceRequest400Response } from '../model';
// @ts-ignore
import { CreateEtcCardIssuanceRequest403Response } from '../model';
// @ts-ignore
import { CreateEtcCardIssuanceRequest500Response } from '../model';
// @ts-ignore
import { CreateEtcCardIssuanceRequestRequest } from '../model';
// @ts-ignore
import { CreateEvidenceRequest200Response } from '../model';
// @ts-ignore
import { CreateFreeeAuthForAccounting200Response } from '../model';
// @ts-ignore
import { CreateFreeePartner200Response } from '../model';
// @ts-ignore
import { CreateFreeePartnerRequest } from '../model';
// @ts-ignore
import { CreatePastDealsRequest } from '../model';
// @ts-ignore
import { CreatePurchaseApplicationRequest } from '../model';
// @ts-ignore
import { CreatePurchaseApplicationTemplateRequest } from '../model';
// @ts-ignore
import { CreateSlackCardNotificationsRequest } from '../model';
// @ts-ignore
import { CreateSlackNotificationSettingsForPurchaseApplicationRequest } from '../model';
// @ts-ignore
import { CreateTeamsCardNotificationsRequest } from '../model';
// @ts-ignore
import { CreateUserAccountGroups200ResponseInner } from '../model';
// @ts-ignore
import { CreateUserAccountGroups400Response } from '../model';
// @ts-ignore
import { CreateUserAccountGroupsRequest } from '../model';
// @ts-ignore
import { DeactivateCard200Response } from '../model';
// @ts-ignore
import { DeactivateEtcCard200Response } from '../model';
// @ts-ignore
import { DefrostCard200Response } from '../model';
// @ts-ignore
import { DeleteFreeeConnected200Response } from '../model';
// @ts-ignore
import { DeleteUserAccountGroup200ResponseInner } from '../model';
// @ts-ignore
import { DepositGuaranteeMoneyBalanceRequest } from '../model';
// @ts-ignore
import { DisableApproval200Response } from '../model';
// @ts-ignore
import { DisableDailyUserUsageLimit200Response } from '../model';
// @ts-ignore
import { DisablePhysicalStorePaymentForTheUserAccount200Response } from '../model';
// @ts-ignore
import { DisableTransactionUpperLimitForTheUserAccount200Response } from '../model';
// @ts-ignore
import { DisableUserUsageLimit200Response } from '../model';
// @ts-ignore
import { DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest } from '../model';
// @ts-ignore
import { EnablePhysicalStorePaymentForTheUserAccount200Response } from '../model';
// @ts-ignore
import { FreezeCard200Response } from '../model';
// @ts-ignore
import { FreezeOrganization200Response } from '../model';
// @ts-ignore
import { FreezeOrganizationRequest } from '../model';
// @ts-ignore
import { GenerateCreateAccountTokenRequest } from '../model';
// @ts-ignore
import { GenerateFreeeRedirectUrl200Response } from '../model';
// @ts-ignore
import { GetACardDetailAsAdmin200Response } from '../model';
// @ts-ignore
import { GetAdminUsers200Response } from '../model';
// @ts-ignore
import { GetAdmins200ResponseInner } from '../model';
// @ts-ignore
import { GetAgreementRequests200ResponseInner } from '../model';
// @ts-ignore
import { GetAllBanks200ResponseInner } from '../model';
// @ts-ignore
import { GetAnalysisInvoiceOfPaymentRequest200Response } from '../model';
// @ts-ignore
import { GetAnnualFeesEligibility200Response } from '../model';
// @ts-ignore
import { GetApprovers200ResponseInner } from '../model';
// @ts-ignore
import { GetAvailableMerchantCategoryOptions200Response } from '../model';
// @ts-ignore
import { GetBalanceState200Response } from '../model';
// @ts-ignore
import { GetBankAccountActivities200Response } from '../model';
// @ts-ignore
import { GetBankAccountConfirmedActivities200ResponseInner } from '../model';
// @ts-ignore
import { GetBankByName200Response } from '../model';
// @ts-ignore
import { GetBankTransfer200Response } from '../model';
// @ts-ignore
import { GetBanksAllBranches200ResponseInner } from '../model';
// @ts-ignore
import { GetBookkeepers200ResponseInner } from '../model';
// @ts-ignore
import { GetBranch200Response } from '../model';
// @ts-ignore
import { GetBusinessDescriptions200ResponseInner } from '../model';
// @ts-ignore
import { GetCanCloseStatuses200Response } from '../model';
// @ts-ignore
import { GetCanDeactivate200Response } from '../model';
// @ts-ignore
import { GetCanaryRoutingStatus200Response } from '../model';
// @ts-ignore
import { GetCanaryRoutingStatus401Response } from '../model';
// @ts-ignore
import { GetCanaryRoutingStatus403Response } from '../model';
// @ts-ignore
import { GetCardBill200Response } from '../model';
// @ts-ignore
import { GetCardDetail200Response } from '../model';
// @ts-ignore
import { GetCardDetail400Response } from '../model';
// @ts-ignore
import { GetCardDetail403Response } from '../model';
// @ts-ignore
import { GetCardMonthlyTransactions200Response } from '../model';
// @ts-ignore
import { GetCardPointsRateConfigsByOrganizationId200ResponseInner } from '../model';
// @ts-ignore
import { GetCardTransactionDetails200Response } from '../model';
// @ts-ignore
import { GetCardTransactionEvidenceRecords200ResponseInner } from '../model';
// @ts-ignore
import { GetCardTransactions200Response } from '../model';
// @ts-ignore
import { GetCards200ResponseInner } from '../model';
// @ts-ignore
import { GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner } from '../model';
// @ts-ignore
import { GetCategoryOfThePurchaseApplicationTemplate200ResponseInner } from '../model';
// @ts-ignore
import { GetComment200ResponseInner } from '../model';
// @ts-ignore
import { GetCommentTemplates200ResponseInner } from '../model';
// @ts-ignore
import { GetCommentTemplatesCommentTemplateId200Response } from '../model';
// @ts-ignore
import { GetCurrentCardAssociatedWithTheUserAccount200Response } from '../model';
// @ts-ignore
import { GetCurrentEtcCard200Response } from '../model';
// @ts-ignore
import { GetDealsTotalAmountRequest } from '../model';
// @ts-ignore
import { GetDefaultCommentTemplate200Response } from '../model';
// @ts-ignore
import { GetDepositBankAccount200Response } from '../model';
// @ts-ignore
import { GetDepositRestrictionForOrganization200Response } from '../model';
// @ts-ignore
import { GetDepositRestrictionListForOrganization200ResponseInner } from '../model';
// @ts-ignore
import { GetDepositRestrictions200ResponseInner } from '../model';
// @ts-ignore
import { GetDraftPaymentRequest200Response } from '../model';
// @ts-ignore
import { GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner } from '../model';
// @ts-ignore
import { GetEarliestExpiringGuaranteeMoneyForOrganization200Response } from '../model';
// @ts-ignore
import { GetEmailNotifications200ResponseInner } from '../model';
// @ts-ignore
import { GetErrorBills200ResponseInner } from '../model';
// @ts-ignore
import { GetEtcAccount200Response } from '../model';
// @ts-ignore
import { GetEtcAmounts200Response } from '../model';
// @ts-ignore
import { GetEtcCardCount200Response } from '../model';
// @ts-ignore
import { GetEtcCardDetail200Response } from '../model';
// @ts-ignore
import { GetEtcCardTransactions200Response } from '../model';
// @ts-ignore
import { GetEtcCards200Response } from '../model';
// @ts-ignore
import { GetEvidence200Response } from '../model';
// @ts-ignore
import { GetEvidenceInformationForCardTransactions200Response } from '../model';
// @ts-ignore
import { GetEvidenceRecords200ResponseInner } from '../model';
// @ts-ignore
import { GetEvidences200ResponseInner } from '../model';
// @ts-ignore
import { GetEvidencesCount200Response } from '../model';
// @ts-ignore
import { GetFraudLockedCardTransaction200Response } from '../model';
// @ts-ignore
import { GetFreeeAccountItems200ResponseInner } from '../model';
// @ts-ignore
import { GetFreeeCompanies200ResponseInner } from '../model';
// @ts-ignore
import { GetFreeeConnected200Response } from '../model';
// @ts-ignore
import { GetFreeeConnectedUser200Response } from '../model';
// @ts-ignore
import { GetFreeeConnectionLinkedAccountForAccounting200Response } from '../model';
// @ts-ignore
import { GetFreeeConnectionSettingsForAccounting200Response } from '../model';
// @ts-ignore
import { GetFreeeItems200ResponseInner } from '../model';
// @ts-ignore
import { GetFreeeMemoTags200ResponseInner } from '../model';
// @ts-ignore
import { GetFreeePartners200ResponseInner } from '../model';
// @ts-ignore
import { GetFreeeSections200ResponseInner } from '../model';
// @ts-ignore
import { GetFreeeSegmentTags200ResponseInner } from '../model';
// @ts-ignore
import { GetFreeeSyncStatus200Response } from '../model';
// @ts-ignore
import { GetFreeeTags200ResponseInner } from '../model';
// @ts-ignore
import { GetFreeeTaxes200ResponseInner } from '../model';
// @ts-ignore
import { GetFreeeToken200Response } from '../model';
// @ts-ignore
import { GetGuaranteeMoneyBalanceHistory200ResponseInner } from '../model';
// @ts-ignore
import { GetGuaranteeMoneyBalanceInformationForOrganization200Response } from '../model';
// @ts-ignore
import { GetGuaranteeMoneyDepositsForOrganization200ResponseInner } from '../model';
// @ts-ignore
import { GetIdentifyVerificationsLatest200Response } from '../model';
// @ts-ignore
import { GetIdentityVerifications200ResponseInner } from '../model';
// @ts-ignore
import { GetInvoiceList200Response } from '../model';
// @ts-ignore
import { GetIssuableStatus200Response } from '../model';
// @ts-ignore
import { GetJwtSso200Response } from '../model';
// @ts-ignore
import { GetKycReaderUsers200ResponseInner } from '../model';
// @ts-ignore
import { GetLatestTimeOfSyncToFreee200Response } from '../model';
// @ts-ignore
import { GetLockStatusOfEvidences200Response } from '../model';
// @ts-ignore
import { GetMerchantGeneralBlock200ResponseInner } from '../model';
// @ts-ignore
import { GetMerchantGeneralBlockDetail200Response } from '../model';
// @ts-ignore
import { GetMerchantOrgBlock200ResponseInner } from '../model';
// @ts-ignore
import { GetMerchantOrgBlockList200ResponseInner } from '../model';
// @ts-ignore
import { GetMerchantOrganizationUserAccountYearMonthSummary200Response } from '../model';
// @ts-ignore
import { GetMerchantsCategoryKinds200ResponseInner } from '../model';
// @ts-ignore
import { GetModifiableDailyLimitsForTheUserAccount200Response } from '../model';
// @ts-ignore
import { GetModifiableMonthlyLimitsForTheUserAccount200Response } from '../model';
// @ts-ignore
import { GetModifiableTransactionLimitsForTheUserAccount200Response } from '../model';
// @ts-ignore
import { GetMoneytreeConnected200Response } from '../model';
// @ts-ignore
import { GetMoneytreeOauthUrl200Response } from '../model';
// @ts-ignore
import { GetMoneytreeStatus200Response } from '../model';
// @ts-ignore
import { GetMonthlyCardBill200Response } from '../model';
// @ts-ignore
import { GetMonthlyCardTransactionsForTheOrganization200Response } from '../model';
// @ts-ignore
import { GetMonthlyCardTransactionsForTheUser200Response } from '../model';
// @ts-ignore
import { GetMonthlyServiceCharges200Response } from '../model';
// @ts-ignore
import { GetMonthlyUserCardSummaries200ResponseInner } from '../model';
// @ts-ignore
import { GetOlInfoSharingConsent200Response } from '../model';
// @ts-ignore
import { GetOnboardingRequestById200Response } from '../model';
// @ts-ignore
import { GetOnboardingRequestPersonalInfo200Response } from '../model';
// @ts-ignore
import { GetOnboardingRequests200Response } from '../model';
// @ts-ignore
import { GetOrgAccountState200Response } from '../model';
// @ts-ignore
import { GetOrganization200Response } from '../model';
// @ts-ignore
import { GetOrganizationAccountingCsvFieldsTypes200ResponseInner } from '../model';
// @ts-ignore
import { GetOrganizationCardsExtended200ResponseInner } from '../model';
// @ts-ignore
import { GetOrganizationCardsLight200ResponseInner } from '../model';
// @ts-ignore
import { GetOrganizationChartDepartments200ResponseInner } from '../model';
// @ts-ignore
import { GetOrganizationChartEmployees200ResponseInner } from '../model';
// @ts-ignore
import { GetOrganizationChartRoles200ResponseInner } from '../model';
// @ts-ignore
import { GetOrganizationCreateRequests200Response } from '../model';
// @ts-ignore
import { GetOrganizationMe200Response } from '../model';
// @ts-ignore
import { GetOrganizationPaymentSchemes200ResponseInnerInner } from '../model';
// @ts-ignore
import { GetOrganizationPaymentSummary200Response } from '../model';
// @ts-ignore
import { GetOrganizationPayments200ResponseInner } from '../model';
// @ts-ignore
import { GetOrganizations200ResponseInner } from '../model';
// @ts-ignore
import { GetOrganizationsBills200ResponseInner } from '../model';
// @ts-ignore
import { GetOrganizationsDeals200ResponseInner } from '../model';
// @ts-ignore
import { GetPaymentRequestDetail200Response } from '../model';
// @ts-ignore
import { GetPaymentRequestEvidence200Response } from '../model';
// @ts-ignore
import { GetPaymentRequestEvidenceRecords200ResponseInner } from '../model';
// @ts-ignore
import { GetPaymentRequestEvidences200ResponseInner } from '../model';
// @ts-ignore
import { GetPaymentRequestsBankAccountsList200ResponseInner } from '../model';
// @ts-ignore
import { GetPinretrieverDecryptPinBlock200Response } from '../model';
// @ts-ignore
import { GetPinretrieverDecryptPinBlockRequest } from '../model';
// @ts-ignore
import { GetPinretrieverEncryptPin200Response } from '../model';
// @ts-ignore
import { GetPinretrieverEncryptPinRequest } from '../model';
// @ts-ignore
import { GetPinretrieverHsmPublickey200Response } from '../model';
// @ts-ignore
import { GetPurchaseApplication200Response } from '../model';
// @ts-ignore
import { GetPurchaseApplicationTemplates200ResponseInner } from '../model';
// @ts-ignore
import { GetPurchaseApplicationTemplatesDetail200Response } from '../model';
// @ts-ignore
import { GetPurchaseApplications200Response } from '../model';
// @ts-ignore
import { GetPurchaseApplicationsRequestedCount200Response } from '../model';
// @ts-ignore
import { GetPurchaseApplicationsRequestedList200ResponseInner } from '../model';
// @ts-ignore
import { GetPurchaseApplicationsSubmittedSelf200ResponseInner } from '../model';
// @ts-ignore
import { GetQualifiedInvoiceIssuer200Response } from '../model';
// @ts-ignore
import { GetRewardPointBalance200Response } from '../model';
// @ts-ignore
import { GetRewardPointTransactions200Response } from '../model';
// @ts-ignore
import { GetRewards200ResponseInner } from '../model';
// @ts-ignore
import { GetRoleResourceForUser200ResponseInner } from '../model';
// @ts-ignore
import { GetRoles200ResponseInner } from '../model';
// @ts-ignore
import { GetRolesWithTopRelatedResources200ResponseInner } from '../model';
// @ts-ignore
import { GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner } from '../model';
// @ts-ignore
import { GetSlackCardNotificationSettings200ResponseInner } from '../model';
// @ts-ignore
import { GetSlackChannel200Response } from '../model';
// @ts-ignore
import { GetSlackChannels200ResponseInner } from '../model';
// @ts-ignore
import { GetSlackChannelsWithCursor200Response } from '../model';
// @ts-ignore
import { GetSlackEvidenceReminder200ResponseInner } from '../model';
// @ts-ignore
import { GetSlackEvidenceReminderPerChannel200Response } from '../model';
// @ts-ignore
import { GetSlackNotificationChannelSettingForPurchaseApplication200Response } from '../model';
// @ts-ignore
import { GetSlackNotificationSettingsForPurchaseApplication200ResponseInner } from '../model';
// @ts-ignore
import { GetSlackTeam200Response } from '../model';
// @ts-ignore
import { GetSlackVersion200Response } from '../model';
// @ts-ignore
import { GetSubmittedTrustdockData200Response } from '../model';
// @ts-ignore
import { GetSuspiciousTransactions200Response } from '../model';
// @ts-ignore
import { GetTeamsCardNotificationSettings200ResponseInner } from '../model';
// @ts-ignore
import { GetTeamsChannel200Response } from '../model';
// @ts-ignore
import { GetTeamsChannelsWithCursor200Response } from '../model';
// @ts-ignore
import { GetTeamsTeam200Response } from '../model';
// @ts-ignore
import { GetTeamsVersion200Response } from '../model';
// @ts-ignore
import { GetTechnicalSupportUsers200ResponseInner } from '../model';
// @ts-ignore
import { GetTheUserAccountInformation200Response } from '../model';
// @ts-ignore
import { GetTransactionEvidenceEmailAddress200Response } from '../model';
// @ts-ignore
import { GetTransactionEvidenceEmails200ResponseInner } from '../model';
// @ts-ignore
import { GetTrustdockIdentityVerifications200Response } from '../model';
// @ts-ignore
import { GetTrustdockSubmitIdentificationDocumentPublishUrl200Response } from '../model';
// @ts-ignore
import { GetTrustdockVerifications200Response } from '../model';
// @ts-ignore
import { GetUnreadMessageCount200Response } from '../model';
// @ts-ignore
import { GetUsageFee200Response } from '../model';
// @ts-ignore
import { GetUserAccountGroups200ResponseInner } from '../model';
// @ts-ignore
import { GetUserAccountYearMonthSummary200ResponseInner } from '../model';
// @ts-ignore
import { GetUserAccountsWithDefaultCommentTemplate200ResponseInner } from '../model';
// @ts-ignore
import { GetUserCards200ResponseInner } from '../model';
// @ts-ignore
import { GetUserCardsExtended200ResponseInner } from '../model';
// @ts-ignore
import { GetUserCardsExtendedForRoleResources200ResponseInner } from '../model';
// @ts-ignore
import { GetUserCardsLight200ResponseInner } from '../model';
// @ts-ignore
import { GetUserCardsLightForRoleResources200ResponseInner } from '../model';
// @ts-ignore
import { GetUserEtcCardCount200Response } from '../model';
// @ts-ignore
import { GetUserEtcCards200Response } from '../model';
// @ts-ignore
import { GetUserMessageDetail200Response } from '../model';
// @ts-ignore
import { GetUserMessages200Response } from '../model';
// @ts-ignore
import { GetUsers200ResponseInner } from '../model';
// @ts-ignore
import { GetUsersMe200Response } from '../model';
// @ts-ignore
import { GetVentureCapitals200ResponseInner } from '../model';
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner } from '../model';
// @ts-ignore
import { GetZeusOrganizations200Response } from '../model';
// @ts-ignore
import { GivePointsToOrganizations200Response } from '../model';
// @ts-ignore
import { GivePointsToOrganizations400Response } from '../model';
// @ts-ignore
import { GivePointsToOrganizationsRequest } from '../model';
// @ts-ignore
import { InitiateEtcService200Response } from '../model';
// @ts-ignore
import { IntrospectChallengeSuccessToken200Response } from '../model';
// @ts-ignore
import { IntrospectChallengeSuccessToken401Response } from '../model';
// @ts-ignore
import { IntrospectChallengeSuccessTokenRequest } from '../model';
// @ts-ignore
import { InviteUserFromUser200Response } from '../model';
// @ts-ignore
import { InviteUserFromUser400Response } from '../model';
// @ts-ignore
import { InviteUserFromUser403Response } from '../model';
// @ts-ignore
import { InviteUserFromUserRequest } from '../model';
// @ts-ignore
import { IssueChallenge200Response } from '../model';
// @ts-ignore
import { IssueChallenge400Response } from '../model';
// @ts-ignore
import { IssueChallenge401Response } from '../model';
// @ts-ignore
import { IssueChallengeRequest } from '../model';
// @ts-ignore
import { LockCardForPotentialFraud200Response } from '../model';
// @ts-ignore
import { LockCardForPotentialFraudRequest } from '../model';
// @ts-ignore
import { LockCardOnFraudDetected200Response } from '../model';
// @ts-ignore
import { LockCardOnFraudDetectedRequest } from '../model';
// @ts-ignore
import { Login200Response } from '../model';
// @ts-ignore
import { LoginApp200Response } from '../model';
// @ts-ignore
import { LoginAppRequest } from '../model';
// @ts-ignore
import { LoginRecoveryCode200Response } from '../model';
// @ts-ignore
import { LoginRecoveryCodeRequest } from '../model';
// @ts-ignore
import { LoginRequest } from '../model';
// @ts-ignore
import { LoginSms200Response } from '../model';
// @ts-ignore
import { LoginSmsRequest } from '../model';
// @ts-ignore
import { MoveSlackNotificationSettingForCardRequest } from '../model';
// @ts-ignore
import { MoveTeamsNotificationSettingForCardRequest } from '../model';
// @ts-ignore
import { OrganizationCreatePreRequest200Response } from '../model';
// @ts-ignore
import { OrganizationCreatePreRequestRequest } from '../model';
// @ts-ignore
import { ParseOrganizationChartForWorkflow200Response } from '../model';
// @ts-ignore
import { PostAdditionMerchantGeneralBlockList200Response } from '../model';
// @ts-ignore
import { PostAdditionMerchantGeneralBlockListRequest } from '../model';
// @ts-ignore
import { PostAlliancesGcpApplications200Response } from '../model';
// @ts-ignore
import { PostAlliancesGcpApplicationsRequest } from '../model';
// @ts-ignore
import { PostAlliancesGwsApplications200Response } from '../model';
// @ts-ignore
import { PostAlliancesGwsApplicationsRequest } from '../model';
// @ts-ignore
import { PostBalances200ResponseInner } from '../model';
// @ts-ignore
import { PostBalancesRequest } from '../model';
// @ts-ignore
import { PostBulkAdditionMerchantOrgBlockListsRequestInner } from '../model';
// @ts-ignore
import { PostCallbackFreeeAuthForAccountingRequest } from '../model';
// @ts-ignore
import { PostCanaryRoutingCheck200Response } from '../model';
// @ts-ignore
import { PostCanaryRoutingCheck401Response } from '../model';
// @ts-ignore
import { PostCanaryRoutingCheck403Response } from '../model';
// @ts-ignore
import { PostCancelRequestForEvidenceRequest200Response } from '../model';
// @ts-ignore
import { PostCardsVirtualIssue200Response } from '../model';
// @ts-ignore
import { PostCardsVirtualIssueRequest } from '../model';
// @ts-ignore
import { PostCardsVirtualOndemandIssue200Response } from '../model';
// @ts-ignore
import { PostFaceToFaceKycRequest200Response } from '../model';
// @ts-ignore
import { PostFaceToFaceKycRequestRequest } from '../model';
// @ts-ignore
import { PostFreeeAccountForPointsRequest } from '../model';
// @ts-ignore
import { PostOrganizationsDealsRequest } from '../model';
// @ts-ignore
import { PostOrganizationsPointClawBacks200Response } from '../model';
// @ts-ignore
import { PostOrganizationsPointClawBacksRequest } from '../model';
// @ts-ignore
import { PostPaymentRequestsBankAccount200Response } from '../model';
// @ts-ignore
import { PostPaymentRequestsBankAccountRequest } from '../model';
// @ts-ignore
import { PostSlackMessageToCoworker200Response } from '../model';
// @ts-ignore
import { PostSlackMessageToCoworkerRequest } from '../model';
// @ts-ignore
import { PostTransactions200ResponseInner } from '../model';
// @ts-ignore
import { PostTransactionsRequest } from '../model';
// @ts-ignore
import { PostTrustdockWebhooksRequest } from '../model';
// @ts-ignore
import { PostTrustdockWebhooksSnailMailRequest } from '../model';
// @ts-ignore
import { PutFreeeEndJournalEntryTransitionModeRequest } from '../model';
// @ts-ignore
import { PutOrganizationPaymentMethodRequest } from '../model';
// @ts-ignore
import { PutOrganizationsDealsRequest } from '../model';
// @ts-ignore
import { PutPaymentRequestRequest } from '../model';
// @ts-ignore
import { PutPaymentRequestsBankAccount200Response } from '../model';
// @ts-ignore
import { PutPaymentRequestsBankAccountRequest } from '../model';
// @ts-ignore
import { PutTransactionEvidenceEmailsLinkToTransactionRequest } from '../model';
// @ts-ignore
import { PutTransactionEvidenceEmailsMarkAsRead200Response } from '../model';
// @ts-ignore
import { PutTransactionEvidenceEmailsMarkAsReadRequest } from '../model';
// @ts-ignore
import { PutTransactionEvidenceEmailsMoveToTrashRequest } from '../model';
// @ts-ignore
import { PutZeusGiveRewardPointsRequest } from '../model';
// @ts-ignore
import { QueryByIdsPaymentRequests200ResponseInner } from '../model';
// @ts-ignore
import { QueryByIdsPaymentRequestsRequest } from '../model';
// @ts-ignore
import { RegisterNoteForOrganizationIdentityVerification200Response } from '../model';
// @ts-ignore
import { RegisterNoteForOrganizationIdentityVerificationRequest } from '../model';
// @ts-ignore
import { RegisterNoteRequest } from '../model';
// @ts-ignore
import { RegisterOrganizationChartForWorkflowRequest } from '../model';
// @ts-ignore
import { RegisterTfaAppVerificationCode200Response } from '../model';
// @ts-ignore
import { RegisterTfaAppVerificationCodeRequest } from '../model';
// @ts-ignore
import { RegisterTfaSmsAuth200Response } from '../model';
// @ts-ignore
import { RegisterTfaSmsAuthRequest } from '../model';
// @ts-ignore
import { ReissueCard200Response } from '../model';
// @ts-ignore
import { ReissueCardRequest } from '../model';
// @ts-ignore
import { RejectOrganizationIdentityVerification200Response } from '../model';
// @ts-ignore
import { RejectPurchaseApplicationRequest } from '../model';
// @ts-ignore
import { RemoveFraudLockStatus200Response } from '../model';
// @ts-ignore
import { RenameUserAccountGroup200ResponseInner } from '../model';
// @ts-ignore
import { RenameUserAccountGroupRequest } from '../model';
// @ts-ignore
import { ReplaceVirtualCard200Response } from '../model';
// @ts-ignore
import { ReplaceVirtualCardRequest } from '../model';
// @ts-ignore
import { RequestAddSystemAdminRole400Response } from '../model';
// @ts-ignore
import { RequestAddSystemAdminRoleRequest } from '../model';
// @ts-ignore
import { RequestSendingMetalCardRequest } from '../model';
// @ts-ignore
import { RequestSendingRequest } from '../model';
// @ts-ignore
import { RequestSyncBankTransactionsToFreeeForAccountingRequest } from '../model';
// @ts-ignore
import { RequestSyncCardTransactionsToFreeeForAccountingRequest } from '../model';
// @ts-ignore
import { RequestUpdateSystemAdminRole400Response } from '../model';
// @ts-ignore
import { RequestUpdateSystemAdminRoleRequest } from '../model';
// @ts-ignore
import { ResendSnailMailForOrganizationIdentityVerificationRequest } from '../model';
// @ts-ignore
import { ResendUserInvite200Response } from '../model';
// @ts-ignore
import { ResumeCard200Response } from '../model';
// @ts-ignore
import { ResynchronizeCardTransactionsForFreeeRequest } from '../model';
// @ts-ignore
import { SaveDealAsDraft200Response } from '../model';
// @ts-ignore
import { SaveDealAsDraftRequest } from '../model';
// @ts-ignore
import { SaveDealAsIgnore200Response } from '../model';
// @ts-ignore
import { SaveDealAsReturnToEditing200Response } from '../model';
// @ts-ignore
import { SaveDealWithJournalizing200Response } from '../model';
// @ts-ignore
import { SaveDealWithJournalizingRequest } from '../model';
// @ts-ignore
import { SaveDealsAsIgnoreRequest } from '../model';
// @ts-ignore
import { SaveDealsAsJournalizedRequest } from '../model';
// @ts-ignore
import { SaveDealsAsReturnToEditingRequest } from '../model';
// @ts-ignore
import { SearchBankTransfers200ResponseInner } from '../model';
// @ts-ignore
import { SearchCorporationsInNationalTaxAgency200ResponseInner } from '../model';
// @ts-ignore
import { SearchDeals200ResponseInner } from '../model';
// @ts-ignore
import { SearchDealsRequest } from '../model';
// @ts-ignore
import { SearchEvidences200ResponseInner } from '../model';
// @ts-ignore
import { SearchMyPaymentRequests200ResponseInner } from '../model';
// @ts-ignore
import { SearchOrganizations200ResponseInner } from '../model';
// @ts-ignore
import { SearchPaymentRequests200ResponseInner } from '../model';
// @ts-ignore
import { SendOrganizationIdentityVerificationRequest } from '../model';
// @ts-ignore
import { SendTransactionAuthorizationRequestRequest } from '../model';
// @ts-ignore
import { SetAccountingActivationRequest } from '../model';
// @ts-ignore
import { SignUpForSlackRequest } from '../model';
// @ts-ignore
import { SubmitCompletedWorkflowOfDraftPaymentRequests200Response } from '../model';
// @ts-ignore
import { SubmitCompletedWorkflowOfDraftPaymentRequestsRequest } from '../model';
// @ts-ignore
import { SubmitCompletedWorkflowOfPaymentRequests200Response } from '../model';
// @ts-ignore
import { SubmitCompletedWorkflowOfPaymentRequestsRequest } from '../model';
// @ts-ignore
import { SuspendCard200Response } from '../model';
// @ts-ignore
import { SyncMoneytreeAccessToken200Response } from '../model';
// @ts-ignore
import { SyncPointUsageToAccountingServiceRequest } from '../model';
// @ts-ignore
import { SyncRequestForFreeeDealsRequest } from '../model';
// @ts-ignore
import { TwoFactorAuthResetAsTokenRequest } from '../model';
// @ts-ignore
import { UnlockCardForNotPotentialFraud200Response } from '../model';
// @ts-ignore
import { UnlockCardOnFraudCleared200Response } from '../model';
// @ts-ignore
import { UpdateAvailableCurrencies200Response } from '../model';
// @ts-ignore
import { UpdateAvailableCurrenciesRequest } from '../model';
// @ts-ignore
import { UpdateAvailableMerchantCategories200Response } from '../model';
// @ts-ignore
import { UpdateAvailableMerchantCategoriesRequest } from '../model';
// @ts-ignore
import { UpdateCardAccountUnitRequest } from '../model';
// @ts-ignore
import { UpdateCardCountLimitRequest } from '../model';
// @ts-ignore
import { UpdateCardHolder200Response } from '../model';
// @ts-ignore
import { UpdateCardHolderRequest } from '../model';
// @ts-ignore
import { UpdateCardLock200Response } from '../model';
// @ts-ignore
import { UpdateCardUnlock200Response } from '../model';
// @ts-ignore
import { UpdateCommentRequest } from '../model';
// @ts-ignore
import { UpdateCommentTemplateRequest } from '../model';
// @ts-ignore
import { UpdateCorporateDocumentResultRequest } from '../model';
// @ts-ignore
import { UpdateDailyUserUsageLimit200Response } from '../model';
// @ts-ignore
import { UpdateDailyUserUsageLimitRequest } from '../model';
// @ts-ignore
import { UpdateDepositRestrictionForOrganizationRequest } from '../model';
// @ts-ignore
import { UpdateEmailNotificationRequest } from '../model';
// @ts-ignore
import { UpdateEmbedUrlMethodRequest } from '../model';
// @ts-ignore
import { UpdateEtcCardHolder200Response } from '../model';
// @ts-ignore
import { UpdateEtcCardHolderRequest } from '../model';
// @ts-ignore
import { UpdateEtcCardLabel200Response } from '../model';
// @ts-ignore
import { UpdateEtcCardLabelRequest } from '../model';
// @ts-ignore
import { UpdateEvidenceInfoRequest } from '../model';
// @ts-ignore
import { UpdateFreeeConnect200Response } from '../model';
// @ts-ignore
import { UpdateFreeeConnectionSettingsForAccountingRequest } from '../model';
// @ts-ignore
import { UpdateFreeeJournalingRequest } from '../model';
// @ts-ignore
import { UpdateFreeeSelectCompany200Response } from '../model';
// @ts-ignore
import { UpdateFreeeSelectCompanyRequest } from '../model';
// @ts-ignore
import { UpdateLockStatusOfEvidencesRequest } from '../model';
// @ts-ignore
import { UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest } from '../model';
// @ts-ignore
import { UpdateMerchantGeneralBlockListRequest } from '../model';
// @ts-ignore
import { UpdateMerchantOrgBlockListRequest } from '../model';
// @ts-ignore
import { UpdateMerchantOrganizationCommentRequest } from '../model';
// @ts-ignore
import { UpdateOrganization200Response } from '../model';
// @ts-ignore
import { UpdateOrganizationRequest } from '../model';
// @ts-ignore
import { UpdatePaymentRequestEvidenceRequest } from '../model';
// @ts-ignore
import { UpdatePurchaseApplicationTemplateRequest } from '../model';
// @ts-ignore
import { UpdateRemoveUserAccountGroupRequest } from '../model';
// @ts-ignore
import { UpdateRoleResourceForUserRequest } from '../model';
// @ts-ignore
import { UpdateRolesByResourceIdRequest } from '../model';
// @ts-ignore
import { UpdateSlackEvidenceReminderPerChannelRequest } from '../model';
// @ts-ignore
import { UpdateSlackNotificationSettingForCardRequest } from '../model';
// @ts-ignore
import { UpdateSlackNotificationSettingForPurchaseApplicationRequest } from '../model';
// @ts-ignore
import { UpdateSynchronizeToFreeeLogConfirmRequest } from '../model';
// @ts-ignore
import { UpdateTeamsNotificationSettingForCardRequest } from '../model';
// @ts-ignore
import { UpdateTransactionUpperLimitForTheUserAccount200Response } from '../model';
// @ts-ignore
import { UpdateTransactionUpperLimitForTheUserAccountRequest } from '../model';
// @ts-ignore
import { UpdateUserAccountGroupRequest } from '../model';
// @ts-ignore
import { UpdateUserAccountName200Response } from '../model';
// @ts-ignore
import { UpdateUserAccountNameRequest } from '../model';
// @ts-ignore
import { UpdateUserEmail400Response } from '../model';
// @ts-ignore
import { UpdateUserEmail403Response } from '../model';
// @ts-ignore
import { UpdateUserEmailRequest } from '../model';
// @ts-ignore
import { UpdateUserNameRequest } from '../model';
// @ts-ignore
import { UpdateUserOrganizationRequest } from '../model';
// @ts-ignore
import { UpdateUserPassword400Response } from '../model';
// @ts-ignore
import { UpdateUserPasswordRequest } from '../model';
// @ts-ignore
import { UpdateUserPrivilegeRequest } from '../model';
// @ts-ignore
import { UpdateUserUsageLimit200Response } from '../model';
// @ts-ignore
import { UpdateUserUsageLimitRequest } from '../model';
// @ts-ignore
import { UploadPaymentRequestEvidenceImage400Response } from '../model';
// @ts-ignore
import { UploadPaymentRequestEvidenceImage404Response } from '../model';
// @ts-ignore
import { UploadPaymentRequestEvidenceImage500Response } from '../model';
// @ts-ignore
import { UsersEmailConfirm200Response } from '../model';
// @ts-ignore
import { UsersEmailConfirmRequest } from '../model';
// @ts-ignore
import { VerifyChallenge200Response } from '../model';
// @ts-ignore
import { VerifyChallenge400Response } from '../model';
// @ts-ignore
import { VerifyChallenge401Response } from '../model';
// @ts-ignore
import { VerifyChallenge403Response } from '../model';
// @ts-ignore
import { VerifyChallengeRequest } from '../model';
// @ts-ignore
import { VerifyMoneytreeConnections200Response } from '../model';
// @ts-ignore
import { ZeusUpdateUserEmail400Response } from '../model';
// @ts-ignore
import { ZeusUpdateUserEmailRequest } from '../model';
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment: async (organizationId: string, paymentReferenceId: string, addCommentRequest: AddCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addComment', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('addComment', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'addCommentRequest' is not null or undefined
            assertParamExists('addComment', 'addCommentRequest', addCommentRequest)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/comment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add Organization Create Request
         * @param {AddOrganizationCreateRequestRequest} addOrganizationCreateRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationCreateRequest: async (addOrganizationCreateRequestRequest: AddOrganizationCreateRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrganizationCreateRequestRequest' is not null or undefined
            assertParamExists('addOrganizationCreateRequest', 'addOrganizationCreateRequestRequest', addOrganizationCreateRequestRequest)
            const localVarPath = `/organization_create_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrganizationCreateRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add point to organization
         * @param {string} organizationId 
         * @param {AddPointToOrganizationRequest} addPointToOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPointToOrganization: async (organizationId: string, addPointToOrganizationRequest: AddPointToOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('addPointToOrganization', 'organizationId', organizationId)
            // verify required parameter 'addPointToOrganizationRequest' is not null or undefined
            assertParamExists('addPointToOrganization', 'addPointToOrganizationRequest', addPointToOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}/give_points`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPointToOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Agree to the agreement request
         * @param {string} organizationId 
         * @param {string} agreementRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToAgreementRequest: async (organizationId: string, agreementRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('agreeToAgreementRequest', 'organizationId', organizationId)
            // verify required parameter 'agreementRequestId' is not null or undefined
            assertParamExists('agreeToAgreementRequest', 'agreementRequestId', agreementRequestId)
            const localVarPath = `/organizations/{organizationId}/agreement_requests/{agreementRequestId}/agree`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"agreementRequestId"}}`, encodeURIComponent(String(agreementRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Agree to OL info sharing consent
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToOlInfoSharingConsent: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('agreeToOlInfoSharingConsent', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/ol-consent/agree`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Analyze evidence
         * @param {string} organizationId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeEvidence: async (organizationId: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('analyzeEvidence', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/evidences/analyze`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Analyze invoice of payment requests
         * @param {string} organizationId 
         * @param {File} file 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeInvoiceOfPaymentRequests: async (organizationId: string, file: File, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('analyzeInvoiceOfPaymentRequests', 'organizationId', organizationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('analyzeInvoiceOfPaymentRequests', 'file', file)
            const localVarPath = `/organizations/{organizationId}/payment_requests/invoice_analyze`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply fraud lock status
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyFraudLockStatus: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('applyFraudLockStatus', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/apply_fraud_lock_status`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve organization identity verification
         * @param {number} organizationIdentityVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrganizationIdentityVerification: async (organizationIdentityVerificationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('approveOrganizationIdentityVerification', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            const localVarPath = `/organization_identity_verifications/{organizationIdentityVerificationId}/approve`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {ApprovePurchaseApplicationRequest} approvePurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePurchaseApplication: async (organizationId: string, purchaseApplicationId: string, approvePurchaseApplicationRequest: ApprovePurchaseApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('approvePurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('approvePurchaseApplication', 'purchaseApplicationId', purchaseApplicationId)
            // verify required parameter 'approvePurchaseApplicationRequest' is not null or undefined
            assertParamExists('approvePurchaseApplication', 'approvePurchaseApplicationRequest', approvePurchaseApplicationRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}/approve`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approvePurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve workflow step of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {ApproveWorkflowStepPaymentRequestsRequest} [approveWorkflowStepPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveWorkflowStepPaymentRequests: async (organizationId: string, xUpsidrSwitchUser?: string, approveWorkflowStepPaymentRequestsRequest?: ApproveWorkflowStepPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('approveWorkflowStepPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/approve`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveWorkflowStepPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Automatically journalize deals from rules
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {AutomaticallyJournalizeDealsFromRulesRequest} automaticallyJournalizeDealsFromRulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automaticallyJournalizeDealsFromRules: async (organizationId: string, companyId: string, automaticallyJournalizeDealsFromRulesRequest: AutomaticallyJournalizeDealsFromRulesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('automaticallyJournalizeDealsFromRules', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('automaticallyJournalizeDealsFromRules', 'companyId', companyId)
            // verify required parameter 'automaticallyJournalizeDealsFromRulesRequest' is not null or undefined
            assertParamExists('automaticallyJournalizeDealsFromRules', 'automaticallyJournalizeDealsFromRulesRequest', automaticallyJournalizeDealsFromRulesRequest)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/journalize_from_rules`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(automaticallyJournalizeDealsFromRulesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bank Account Activities Withdrawal Reserve
         * @param {BankAccountActivitiesWithdrawalReserveRequest} bankAccountActivitiesWithdrawalReserveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountActivitiesWithdrawalReserve: async (bankAccountActivitiesWithdrawalReserveRequest: BankAccountActivitiesWithdrawalReserveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankAccountActivitiesWithdrawalReserveRequest' is not null or undefined
            assertParamExists('bankAccountActivitiesWithdrawalReserve', 'bankAccountActivitiesWithdrawalReserveRequest', bankAccountActivitiesWithdrawalReserveRequest)
            const localVarPath = `/bank_account_activities/withdrawal/reserve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankAccountActivitiesWithdrawalReserveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {BulkDisableDailyUserUsageLimitRequest} bulkDisableDailyUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDisableDailyUserUsageLimit: async (bulkDisableDailyUserUsageLimitRequest: BulkDisableDailyUserUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDisableDailyUserUsageLimitRequest' is not null or undefined
            assertParamExists('bulkDisableDailyUserUsageLimit', 'bulkDisableDailyUserUsageLimitRequest', bulkDisableDailyUserUsageLimitRequest)
            const localVarPath = `/user_accounts/disable_daily_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDisableDailyUserUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk disable monthly usage limit
         * @param {BulkDisableMonthlyUsageLimitRequest} bulkDisableMonthlyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDisableMonthlyUsageLimit: async (bulkDisableMonthlyUsageLimitRequest: BulkDisableMonthlyUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDisableMonthlyUsageLimitRequest' is not null or undefined
            assertParamExists('bulkDisableMonthlyUsageLimit', 'bulkDisableMonthlyUsageLimitRequest', bulkDisableMonthlyUsageLimitRequest)
            const localVarPath = `/user_accounts/disable_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDisableMonthlyUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows organization administrators to invite multiple users at once by providing user details (email, name, and role). This endpoint accepts up to 300 users per request. 
         * @summary Bulk invite users to organization
         * @param {string} organizationId The ID of the organization
         * @param {BulkInviteUsersAdminRequest} bulkInviteUsersAdminRequest 
         * @param {string} [xChallengeSuccessToken] sudo-mode challenge 検証成功時に発行される token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInviteUsersAdmin: async (organizationId: string, bulkInviteUsersAdminRequest: BulkInviteUsersAdminRequest, xChallengeSuccessToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('bulkInviteUsersAdmin', 'organizationId', organizationId)
            // verify required parameter 'bulkInviteUsersAdminRequest' is not null or undefined
            assertParamExists('bulkInviteUsersAdmin', 'bulkInviteUsersAdminRequest', bulkInviteUsersAdminRequest)
            const localVarPath = `/organizations/{organizationId}/users/bulk_invite_admin`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xChallengeSuccessToken != null) {
                localVarHeaderParameter['x-challenge-success-token'] = String(xChallengeSuccessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkInviteUsersAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk update daily usage limit
         * @param {BulkUpdateDailyUsageLimitRequest} bulkUpdateDailyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateDailyUsageLimit: async (bulkUpdateDailyUsageLimitRequest: BulkUpdateDailyUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateDailyUsageLimitRequest' is not null or undefined
            assertParamExists('bulkUpdateDailyUsageLimit', 'bulkUpdateDailyUsageLimitRequest', bulkUpdateDailyUsageLimitRequest)
            const localVarPath = `/user_accounts/update_daily_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateDailyUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk update monthly usage limit
         * @param {BulkUpdateMonthlyUsageLimitRequest} bulkUpdateMonthlyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateMonthlyUsageLimit: async (bulkUpdateMonthlyUsageLimitRequest: BulkUpdateMonthlyUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateMonthlyUsageLimitRequest' is not null or undefined
            assertParamExists('bulkUpdateMonthlyUsageLimit', 'bulkUpdateMonthlyUsageLimitRequest', bulkUpdateMonthlyUsageLimitRequest)
            const localVarPath = `/user_accounts/update_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateMonthlyUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Update Organization User Privileges
         * @param {string} organizationId 
         * @param {BulkUpdateOrganizationUserPrivilegesRequest} bulkUpdateOrganizationUserPrivilegesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateOrganizationUserPrivileges: async (organizationId: string, bulkUpdateOrganizationUserPrivilegesRequest: BulkUpdateOrganizationUserPrivilegesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('bulkUpdateOrganizationUserPrivileges', 'organizationId', organizationId)
            // verify required parameter 'bulkUpdateOrganizationUserPrivilegesRequest' is not null or undefined
            assertParamExists('bulkUpdateOrganizationUserPrivileges', 'bulkUpdateOrganizationUserPrivilegesRequest', bulkUpdateOrganizationUserPrivilegesRequest)
            const localVarPath = `/organizations/user_privilege/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateOrganizationUserPrivilegesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDraftPaymentRequest: async (organizationId: string, draftPaymentRequestId: string, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cancelDraftPaymentRequest', 'organizationId', organizationId)
            // verify required parameter 'draftPaymentRequestId' is not null or undefined
            assertParamExists('cancelDraftPaymentRequest', 'draftPaymentRequestId', draftPaymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts/{draftPaymentRequestId}/cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftPaymentRequestId"}}`, encodeURIComponent(String(draftPaymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel payment request
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPaymentRequest: async (organizationId: string, paymentRequestId: string, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('cancelPaymentRequest', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('cancelPaymentRequest', 'paymentRequestId', paymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Identity Verification Scheduled Date
         * @param {string} organizationId 
         * @param {ChangeIdentityVerificationScheduledDateRequest} changeIdentityVerificationScheduledDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIdentityVerificationScheduledDate: async (organizationId: string, changeIdentityVerificationScheduledDateRequest: ChangeIdentityVerificationScheduledDateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('changeIdentityVerificationScheduledDate', 'organizationId', organizationId)
            // verify required parameter 'changeIdentityVerificationScheduledDateRequest' is not null or undefined
            assertParamExists('changeIdentityVerificationScheduledDate', 'changeIdentityVerificationScheduledDateRequest', changeIdentityVerificationScheduledDateRequest)
            const localVarPath = `/organizations/{organizationId}/identity_verification_scheduled_date`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeIdentityVerificationScheduledDateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Invoice Email
         * @param {string} organizationId 
         * @param {ChangeInvoiceEmailRequest} changeInvoiceEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeInvoiceEmail: async (organizationId: string, changeInvoiceEmailRequest: ChangeInvoiceEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('changeInvoiceEmail', 'organizationId', organizationId)
            // verify required parameter 'changeInvoiceEmailRequest' is not null or undefined
            assertParamExists('changeInvoiceEmail', 'changeInvoiceEmailRequest', changeInvoiceEmailRequest)
            const localVarPath = `/organizations/{organizationId}/change_invoice_email`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeInvoiceEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change to the specified ekyc result
         * @param {string} identificationId 
         * @param {ChangeToTheSpecifiedEkycResultRequest} changeToTheSpecifiedEkycResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeToTheSpecifiedEkycResult: async (identificationId: string, changeToTheSpecifiedEkycResultRequest: ChangeToTheSpecifiedEkycResultRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identificationId' is not null or undefined
            assertParamExists('changeToTheSpecifiedEkycResult', 'identificationId', identificationId)
            // verify required parameter 'changeToTheSpecifiedEkycResultRequest' is not null or undefined
            assertParamExists('changeToTheSpecifiedEkycResult', 'changeToTheSpecifiedEkycResultRequest', changeToTheSpecifiedEkycResultRequest)
            const localVarPath = `/organization_identity_verifications/identifications/{identificationId}/result`
                .replace(`{${"identificationId"}}`, encodeURIComponent(String(identificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeToTheSpecifiedEkycResultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check Already Registered Phone Number
         * @param {CheckAlreadyRegisteredPhoneNumberRequest} checkAlreadyRegisteredPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAlreadyRegisteredPhoneNumber: async (checkAlreadyRegisteredPhoneNumberRequest: CheckAlreadyRegisteredPhoneNumberRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkAlreadyRegisteredPhoneNumberRequest' is not null or undefined
            assertParamExists('checkAlreadyRegisteredPhoneNumber', 'checkAlreadyRegisteredPhoneNumberRequest', checkAlreadyRegisteredPhoneNumberRequest)
            const localVarPath = `/two_factor_auth/sms/check_already_registered_phone_number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkAlreadyRegisteredPhoneNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check All Organization Available Limit And Notify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAvailableLimit: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/check_available_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check duplicate email addresses
         * @param {Array<string>} [emailAddresses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDuplicateEmailAddresses: async (emailAddresses?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization_create_requests/check_duplicate_email_addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (emailAddresses) {
                localVarQueryParameter['emailAddresses[]'] = emailAddresses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMonthlyUsageLimit: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/check_monthly_usage_limit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * It is an API that waits for a redirect after the payment request fix button is pressed in the Slack App. This API does three things:   - Slack message modification - remove each button attached to the original message   - Post messages to Slack - communicate the fact that the edit button was pressed   - Create payment request for draft data
         * @summary Complete redirect from slack
         * @param {string} organizationId 
         * @param {CompleteRedirectFromSlackRequest} [completeRedirectFromSlackRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRedirectFromSlack: async (organizationId: string, completeRedirectFromSlackRequest?: CompleteRedirectFromSlackRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('completeRedirectFromSlack', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/complete_redirect`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeRedirectFromSlackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm Fufu hotel reservation
         * @param {ConfirmFufuHotelReservationRequest} confirmFufuHotelReservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmFufuHotelReservation: async (confirmFufuHotelReservationRequest: ConfirmFufuHotelReservationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmFufuHotelReservationRequest' is not null or undefined
            assertParamExists('confirmFufuHotelReservation', 'confirmFufuHotelReservationRequest', confirmFufuHotelReservationRequest)
            const localVarPath = `/reward_point/hotel/fufu/reservation_confirmations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmFufuHotelReservationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary freee接続
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {ConnectFreeeForAccountingRequest} [connectFreeeForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectFreeeForAccounting: async (orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, connectFreeeForAccountingRequest?: ConnectFreeeForAccountingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccountId' is not null or undefined
            assertParamExists('connectFreeeForAccounting', 'orgAccountId', orgAccountId)
            const localVarPath = `/org_accounts/{orgAccountId}/freee/connection`
                .replace(`{${"orgAccountId"}}`, encodeURIComponent(String(orgAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upsidrPrivateClientApiInternal != null) {
                localVarHeaderParameter['upsidr-private-client-api-internal'] = typeof upsidrPrivateClientApiInternal === 'string' 
                    ? upsidrPrivateClientApiInternal 
                    : JSON.stringify(upsidrPrivateClientApiInternal);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectFreeeForAccountingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count deals
         * @param {string} organizationId 
         * @param {CountDealsRequest} [countDealsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDeals: async (organizationId: string, countDealsRequest?: CountDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('countDeals', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/count_deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create bank transfers for the specified payment requests.
         * @summary Create bank transfers
         * @param {string} organizationId 
         * @param {CreateBankTransfersRequest} createBankTransfersRequest 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankTransfers: async (organizationId: string, createBankTransfersRequest: CreateBankTransfersRequest, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createBankTransfers', 'organizationId', organizationId)
            // verify required parameter 'createBankTransfersRequest' is not null or undefined
            assertParamExists('createBankTransfers', 'createBankTransfersRequest', createBankTransfersRequest)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (transferDateJstFrom !== undefined) {
                localVarQueryParameter['transferDateJstFrom'] = transferDateJstFrom;
            }

            if (transferDateJstTo !== undefined) {
                localVarQueryParameter['transferDateJstTo'] = transferDateJstTo;
            }

            if (sourceBankAccountId !== undefined) {
                localVarQueryParameter['sourceBankAccountId'] = sourceBankAccountId;
            }

            if (downloaded !== undefined) {
                localVarQueryParameter['downloaded'] = downloaded;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBankTransfersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create category of the purchase application template.
         * @param {string} organizationId 
         * @param {CreateCategoryOfThePurchaseApplicationTemplateRequest} createCategoryOfThePurchaseApplicationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategoryOfThePurchaseApplicationTemplate: async (organizationId: string, createCategoryOfThePurchaseApplicationTemplateRequest: CreateCategoryOfThePurchaseApplicationTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createCategoryOfThePurchaseApplicationTemplate', 'organizationId', organizationId)
            // verify required parameter 'createCategoryOfThePurchaseApplicationTemplateRequest' is not null or undefined
            assertParamExists('createCategoryOfThePurchaseApplicationTemplate', 'createCategoryOfThePurchaseApplicationTemplateRequest', createCategoryOfThePurchaseApplicationTemplateRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/category/submit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryOfThePurchaseApplicationTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create comment template
         * @param {string} organizationId 
         * @param {CreateCommentTemplateRequest} createCommentTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommentTemplate: async (organizationId: string, createCommentTemplateRequest: CreateCommentTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createCommentTemplate', 'organizationId', organizationId)
            // verify required parameter 'createCommentTemplateRequest' is not null or undefined
            assertParamExists('createCommentTemplate', 'createCommentTemplateRequest', createCommentTemplateRequest)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommentTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create deposit restriction for organization
         * @param {string} organizationId 
         * @param {CreateDepositRestrictionForOrganizationRequest} createDepositRestrictionForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepositRestrictionForOrganization: async (organizationId: string, createDepositRestrictionForOrganizationRequest: CreateDepositRestrictionForOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createDepositRestrictionForOrganization', 'organizationId', organizationId)
            // verify required parameter 'createDepositRestrictionForOrganizationRequest' is not null or undefined
            assertParamExists('createDepositRestrictionForOrganization', 'createDepositRestrictionForOrganizationRequest', createDepositRestrictionForOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepositRestrictionForOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create draft of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {CreateDraftOfPaymentRequestsRequest} [createDraftOfPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftOfPaymentRequests: async (organizationId: string, xUpsidrSwitchUser?: string, createDraftOfPaymentRequestsRequest?: CreateDraftOfPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createDraftOfPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDraftOfPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create ETC card issuance request
         * @param {string} organizationId 
         * @param {CreateEtcCardIssuanceRequestRequest} createEtcCardIssuanceRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEtcCardIssuanceRequest: async (organizationId: string, createEtcCardIssuanceRequestRequest: CreateEtcCardIssuanceRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createEtcCardIssuanceRequest', 'organizationId', organizationId)
            // verify required parameter 'createEtcCardIssuanceRequestRequest' is not null or undefined
            assertParamExists('createEtcCardIssuanceRequest', 'createEtcCardIssuanceRequestRequest', createEtcCardIssuanceRequestRequest)
            const localVarPath = `/organizations/{organizationId}/etc_cards/issuance_requests`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEtcCardIssuanceRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create evidence request
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidenceRequest: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createEvidenceRequest', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('createEvidenceRequest', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/request`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary freee認可URL作成
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreeeAuthForAccounting: async (orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccountId' is not null or undefined
            assertParamExists('createFreeeAuthForAccounting', 'orgAccountId', orgAccountId)
            const localVarPath = `/org_accounts/{orgAccountId}/auth/freee/authorize_url`
                .replace(`{${"orgAccountId"}}`, encodeURIComponent(String(orgAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upsidrPrivateClientApiInternal != null) {
                localVarHeaderParameter['upsidr-private-client-api-internal'] = typeof upsidrPrivateClientApiInternal === 'string' 
                    ? upsidrPrivateClientApiInternal 
                    : JSON.stringify(upsidrPrivateClientApiInternal);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create freee partner
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {CreateFreeePartnerRequest} createFreeePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreeePartner: async (organizationId: string, companyId: string, createFreeePartnerRequest: CreateFreeePartnerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createFreeePartner', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('createFreeePartner', 'companyId', companyId)
            // verify required parameter 'createFreeePartnerRequest' is not null or undefined
            assertParamExists('createFreeePartner', 'createFreeePartnerRequest', createFreeePartnerRequest)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/partners`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFreeePartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create past deals
         * @param {string} organizationId 
         * @param {CreatePastDealsRequest} createPastDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPastDeals: async (organizationId: string, createPastDealsRequest: CreatePastDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createPastDeals', 'organizationId', organizationId)
            // verify required parameter 'createPastDealsRequest' is not null or undefined
            assertParamExists('createPastDeals', 'createPastDealsRequest', createPastDealsRequest)
            const localVarPath = `/organizations/{organizationId}/past_deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPastDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create purchase application.
         * @param {string} organizationId 
         * @param {CreatePurchaseApplicationRequest} createPurchaseApplicationRequest 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseApplication: async (organizationId: string, createPurchaseApplicationRequest: CreatePurchaseApplicationRequest, visaTransactionReferenceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'createPurchaseApplicationRequest' is not null or undefined
            assertParamExists('createPurchaseApplication', 'createPurchaseApplicationRequest', createPurchaseApplicationRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/submit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create purchase application template.
         * @param {string} organizationId 
         * @param {CreatePurchaseApplicationTemplateRequest} createPurchaseApplicationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseApplicationTemplate: async (organizationId: string, createPurchaseApplicationTemplateRequest: CreatePurchaseApplicationTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createPurchaseApplicationTemplate', 'organizationId', organizationId)
            // verify required parameter 'createPurchaseApplicationTemplateRequest' is not null or undefined
            assertParamExists('createPurchaseApplicationTemplate', 'createPurchaseApplicationTemplateRequest', createPurchaseApplicationTemplateRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/submit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPurchaseApplicationTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Slack card notification settings of an organization
         * @param {string} organizationId 
         * @param {CreateSlackCardNotificationsRequest} createSlackCardNotificationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlackCardNotifications: async (organizationId: string, createSlackCardNotificationsRequest: CreateSlackCardNotificationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createSlackCardNotifications', 'organizationId', organizationId)
            // verify required parameter 'createSlackCardNotificationsRequest' is not null or undefined
            assertParamExists('createSlackCardNotifications', 'createSlackCardNotificationsRequest', createSlackCardNotificationsRequest)
            const localVarPath = `/slack/organizations/{organizationId}/cards/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSlackCardNotificationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create slack notification settings for purchase-application
         * @param {string} organizationId 
         * @param {CreateSlackNotificationSettingsForPurchaseApplicationRequest} createSlackNotificationSettingsForPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlackNotificationSettingsForPurchaseApplication: async (organizationId: string, createSlackNotificationSettingsForPurchaseApplicationRequest: CreateSlackNotificationSettingsForPurchaseApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createSlackNotificationSettingsForPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'createSlackNotificationSettingsForPurchaseApplicationRequest' is not null or undefined
            assertParamExists('createSlackNotificationSettingsForPurchaseApplication', 'createSlackNotificationSettingsForPurchaseApplicationRequest', createSlackNotificationSettingsForPurchaseApplicationRequest)
            const localVarPath = `/slack/organizations/{organizationId}/purchase_applications/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSlackNotificationSettingsForPurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Teams card notification settings of an organization
         * @param {string} organizationId 
         * @param {CreateTeamsCardNotificationsRequest} createTeamsCardNotificationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamsCardNotifications: async (organizationId: string, createTeamsCardNotificationsRequest: CreateTeamsCardNotificationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createTeamsCardNotifications', 'organizationId', organizationId)
            // verify required parameter 'createTeamsCardNotificationsRequest' is not null or undefined
            assertParamExists('createTeamsCardNotifications', 'createTeamsCardNotificationsRequest', createTeamsCardNotificationsRequest)
            const localVarPath = `/teams/organizations/{organizationId}/cards/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTeamsCardNotificationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create user account groups
         * @param {string} organizationId 
         * @param {CreateUserAccountGroupsRequest} [createUserAccountGroupsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccountGroups: async (organizationId: string, createUserAccountGroupsRequest?: CreateUserAccountGroupsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createUserAccountGroups', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/user_account_groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserAccountGroupsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCard: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('deactivateCard', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/deactivate`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate ETC card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateEtcCard: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('deactivateEtcCard', 'cardId', cardId)
            const localVarPath = `/etc_cards/{cardId}/deactivate`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deactivateUser', 'userId', userId)
            const localVarPath = `/users/{userId}/deactivate`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Defrost a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defrostCard: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('defrostCard', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/defrost`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Card Points Rate Configs
         * @param {string} rateConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCardPointsRateConfig: async (rateConfigId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rateConfigId' is not null or undefined
            assertParamExists('deleteCardPointsRateConfig', 'rateConfigId', rateConfigId)
            const localVarPath = `/card_points/rate_configs/{rateConfigId}`
                .replace(`{${"rateConfigId"}}`, encodeURIComponent(String(rateConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete category of the purchase application template.
         * @param {string} organizationId 
         * @param {string} purchaseTemplateCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryOfThePurchaseApplicationTemplate: async (organizationId: string, purchaseTemplateCategoryId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteCategoryOfThePurchaseApplicationTemplate', 'organizationId', organizationId)
            // verify required parameter 'purchaseTemplateCategoryId' is not null or undefined
            assertParamExists('deleteCategoryOfThePurchaseApplicationTemplate', 'purchaseTemplateCategoryId', purchaseTemplateCategoryId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/categories/{purchaseTemplateCategoryId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseTemplateCategoryId"}}`, encodeURIComponent(String(purchaseTemplateCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment: async (organizationId: string, paymentReferenceId: string, cardTransactionCommentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteComment', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('deleteComment', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionCommentId' is not null or undefined
            assertParamExists('deleteComment', 'cardTransactionCommentId', cardTransactionCommentId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/comment/{cardTransactionCommentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionCommentId"}}`, encodeURIComponent(String(cardTransactionCommentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentTemplate: async (organizationId: string, templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteCommentTemplate', 'organizationId', organizationId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteCommentTemplate', 'templateId', templateId)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates/{templateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepositRestrictionForOrganization: async (organizationId: string, depositRestrictionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteDepositRestrictionForOrganization', 'organizationId', organizationId)
            // verify required parameter 'depositRestrictionId' is not null or undefined
            assertParamExists('deleteDepositRestrictionForOrganization', 'depositRestrictionId', depositRestrictionId)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions/{depositRestrictionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"depositRestrictionId"}}`, encodeURIComponent(String(depositRestrictionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete evidence
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvidence: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteEvidence', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('deleteEvidence', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('deleteEvidence', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete freee connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFreeeConnected: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteFreeeConnected', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/connected`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Freee End Journal Entry Transition Mode
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFreeeEndJournalEntryTransitionMode: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteFreeeEndJournalEntryTransitionMode', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/end_journal_entry_transition_mode`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete merchant general block allowed organization ids
         * @param {string} merchantGeneralBlockListId 
         * @param {string} allowedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantGeneralBlockAllowedOrganizationIds: async (merchantGeneralBlockListId: string, allowedOrganizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('deleteMerchantGeneralBlockAllowedOrganizationIds', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            // verify required parameter 'allowedOrganizationId' is not null or undefined
            assertParamExists('deleteMerchantGeneralBlockAllowedOrganizationIds', 'allowedOrganizationId', allowedOrganizationId)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}/allowed_organizations/{allowedOrganizationId}`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)))
                .replace(`{${"allowedOrganizationId"}}`, encodeURIComponent(String(allowedOrganizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete merchant general block list
         * @param {string} merchantGeneralBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantGeneralBlockList: async (merchantGeneralBlockListId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('deleteMerchantGeneralBlockList', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete merchant org block list
         * @param {string} merchantOrgBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantOrgBlockList: async (merchantOrgBlockListId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantOrgBlockListId' is not null or undefined
            assertParamExists('deleteMerchantOrgBlockList', 'merchantOrgBlockListId', merchantOrgBlockListId)
            const localVarPath = `/merchant_org_block_lists/{merchantOrgBlockListId}`
                .replace(`{${"merchantOrgBlockListId"}}`, encodeURIComponent(String(merchantOrgBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an onboarding request
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingRequest: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('deleteOnboardingRequest', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Organization Create Request
         * @param {string} organizationCreateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationCreateRequest: async (organizationCreateRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationCreateRequestId' is not null or undefined
            assertParamExists('deleteOrganizationCreateRequest', 'organizationCreateRequestId', organizationCreateRequestId)
            const localVarPath = `/organization_create_requests/{organizationCreateRequestId}`
                .replace(`{${"organizationCreateRequestId"}}`, encodeURIComponent(String(organizationCreateRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a payment request evidence specified by evidenceId.
         * @summary Delete the specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentRequestEvidence: async (organizationId: string, paymentRequestId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePaymentRequestEvidence', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('deletePaymentRequestEvidence', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('deletePaymentRequestEvidence', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseApplication: async (organizationId: string, purchaseApplicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('deletePurchaseApplication', 'purchaseApplicationId', purchaseApplicationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete purchase application templates detail
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseApplicationTemplatesDetail: async (organizationId: string, purchaseTemplateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePurchaseApplicationTemplatesDetail', 'organizationId', organizationId)
            // verify required parameter 'purchaseTemplateId' is not null or undefined
            assertParamExists('deletePurchaseApplicationTemplatesDetail', 'purchaseTemplateId', purchaseTemplateId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/{purchaseTemplateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseTemplateId"}}`, encodeURIComponent(String(purchaseTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlackNotificationChannelSettingForPurchaseApplication: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteSlackNotificationChannelSettingForPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('deleteSlackNotificationChannelSettingForPurchaseApplication', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/purchase_applications/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlackNotificationSettingForCard: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteSlackNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('deleteSlackNotificationSettingForCard', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/cards/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete system admin role
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSystemAdminRole: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteSystemAdminRole', 'userId', userId)
            const localVarPath = `/users/{userId}/roles/system`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamsNotificationSettingForCard: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteTeamsNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('deleteTeamsNotificationSettingForCard', 'channelId', channelId)
            const localVarPath = `/teams/organizations/{organizationId}/channels/{channelId}/cards/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user account group
         * @param {number} userAccountGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAccountGroup: async (userAccountGroupId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountGroupId' is not null or undefined
            assertParamExists('deleteUserAccountGroup', 'userAccountGroupId', userAccountGroupId)
            const localVarPath = `/user_account_groups/{userAccountGroupId}`
                .replace(`{${"userAccountGroupId"}}`, encodeURIComponent(String(userAccountGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deposit Guarantee Money Balance
         * @param {string} organizationId 
         * @param {DepositGuaranteeMoneyBalanceRequest} depositGuaranteeMoneyBalanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        depositGuaranteeMoneyBalance: async (organizationId: string, depositGuaranteeMoneyBalanceRequest: DepositGuaranteeMoneyBalanceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('depositGuaranteeMoneyBalance', 'organizationId', organizationId)
            // verify required parameter 'depositGuaranteeMoneyBalanceRequest' is not null or undefined
            assertParamExists('depositGuaranteeMoneyBalance', 'depositGuaranteeMoneyBalanceRequest', depositGuaranteeMoneyBalanceRequest)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_balance/deposit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(depositGuaranteeMoneyBalanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable Approval
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableApproval: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('disableApproval', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/disable_approval`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDailyUserUsageLimit: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('disableDailyUserUsageLimit', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/disable_daily_usage_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable physical store payment for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disablePhysicalStorePaymentForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('disablePhysicalStorePaymentForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/disable_physical_store_payment`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable transaction upper limit for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTransactionUpperLimitForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('disableTransactionUpperLimitForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/disable_transaction_upper_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable usage limit for an user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUserUsageLimit: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('disableUserUsageLimit', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/disable_usage_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disagree to the agreement request
         * @param {string} organizationId 
         * @param {string} agreementRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disagreeToAgreementRequest: async (organizationId: string, agreementRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('disagreeToAgreementRequest', 'organizationId', organizationId)
            // verify required parameter 'agreementRequestId' is not null or undefined
            assertParamExists('disagreeToAgreementRequest', 'agreementRequestId', agreementRequestId)
            const localVarPath = `/organizations/{organizationId}/agreement_requests/{agreementRequestId}/disagree`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"agreementRequestId"}}`, encodeURIComponent(String(agreementRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary freee接続解除
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectFreeeForAccounting: async (orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccountId' is not null or undefined
            assertParamExists('disconnectFreeeForAccounting', 'orgAccountId', orgAccountId)
            const localVarPath = `/org_accounts/{orgAccountId}/freee/connection`
                .replace(`{${"orgAccountId"}}`, encodeURIComponent(String(orgAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upsidrPrivateClientApiInternal != null) {
                localVarHeaderParameter['upsidr-private-client-api-internal'] = typeof upsidrPrivateClientApiInternal === 'string' 
                    ? upsidrPrivateClientApiInternal 
                    : JSON.stringify(upsidrPrivateClientApiInternal);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download bank transfer file
         * @param {string} organizationId 
         * @param {string} bankTransferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBankTransferFile: async (organizationId: string, bankTransferId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadBankTransferFile', 'organizationId', organizationId)
            // verify required parameter 'bankTransferId' is not null or undefined
            assertParamExists('downloadBankTransferFile', 'bankTransferId', bankTransferId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers/{bankTransferId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"bankTransferId"}}`, encodeURIComponent(String(bankTransferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download bank transfers csv
         * @param {string} organizationId 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBankTransfersCsv: async (organizationId: string, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadBankTransfersCsv', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers/csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (transferDateJstFrom !== undefined) {
                localVarQueryParameter['transferDateJstFrom'] = transferDateJstFrom;
            }

            if (transferDateJstTo !== undefined) {
                localVarQueryParameter['transferDateJstTo'] = transferDateJstTo;
            }

            if (sourceBankAccountId !== undefined) {
                localVarQueryParameter['sourceBankAccountId'] = sourceBankAccountId;
            }

            if (downloaded !== undefined) {
                localVarQueryParameter['downloaded'] = downloaded;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download ETC accounting CSV
         * @param {string} organizationId 
         * @param {string} yearMonth Target year-month in YYYYMM format
         * @param {'USAGE_MONTH' | 'BILLING_MONTH'} dateType Date aggregation basis (USAGE_MONTH &#x3D; by usage month, BILLING_MONTH &#x3D; by billing month)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEtcAccountingCsv: async (organizationId: string, yearMonth: string, dateType: 'USAGE_MONTH' | 'BILLING_MONTH', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadEtcAccountingCsv', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('downloadEtcAccountingCsv', 'yearMonth', yearMonth)
            // verify required parameter 'dateType' is not null or undefined
            assertParamExists('downloadEtcAccountingCsv', 'dateType', dateType)
            const localVarPath = `/organizations/{organizationId}/etc_cards/accounting/download_csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (dateType !== undefined) {
                localVarQueryParameter['dateType'] = dateType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download journal entry for freee csv
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadJournalEntryForFreeeCsv: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadJournalEntryForFreeeCsv', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('downloadJournalEntryForFreeeCsv', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/deals/download_csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download Organizations Accounting Csv
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrganizationsAccountingCsv: async (organizationId: string, yearMonth: string, isMergedFiles: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadOrganizationsAccountingCsv', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('downloadOrganizationsAccountingCsv', 'yearMonth', yearMonth)
            // verify required parameter 'isMergedFiles' is not null or undefined
            assertParamExists('downloadOrganizationsAccountingCsv', 'isMergedFiles', isMergedFiles)
            const localVarPath = `/organizations/{organizationId}/cards/accounting/download_csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (isMergedFiles !== undefined) {
                localVarQueryParameter['isMergedFiles'] = isMergedFiles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download payment requests csv
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified status.
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPaymentRequestsCsv: async (organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', freeWord?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadPaymentRequestsCsv', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dueDateJstFrom !== undefined) {
                localVarQueryParameter['dueDateJstFrom'] = dueDateJstFrom;
            }

            if (dueDateJstTo !== undefined) {
                localVarQueryParameter['dueDateJstTo'] = dueDateJstTo;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (transferDataCreated !== undefined) {
                localVarQueryParameter['transferDataCreated'] = transferDataCreated;
            }

            if (withholdingApplied !== undefined) {
                localVarQueryParameter['withholdingApplied'] = withholdingApplied;
            }

            if (transferFeeResponsibility !== undefined) {
                localVarQueryParameter['transferFeeResponsibility'] = transferFeeResponsibility;
            }

            if (freeWord !== undefined) {
                localVarQueryParameter['freeWord'] = freeWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download payment requests csv for payment request ids specification
         * @param {string} organizationId 
         * @param {DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest} [downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPaymentRequestsCsvForPaymentRequestIdsSpecification: async (organizationId: string, downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest?: DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('downloadPaymentRequestsCsvForPaymentRequestIdsSpecification', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/download_csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable physical store payment for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enablePhysicalStorePaymentForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('enablePhysicalStorePaymentForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/enable_physical_store_payment`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Freeze a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeCard: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('freezeCard', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/freeze`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Freeze Organization
         * @param {string} organizationId 
         * @param {FreezeOrganizationRequest} freezeOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeOrganization: async (organizationId: string, freezeOrganizationRequest: FreezeOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('freezeOrganization', 'organizationId', organizationId)
            // verify required parameter 'freezeOrganizationRequest' is not null or undefined
            assertParamExists('freezeOrganization', 'freezeOrganizationRequest', freezeOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}/frozen`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(freezeOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Annual Fees Invoice
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAnnualFeesInvoice: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('generateAnnualFeesInvoice', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/annual_fees/invoices/generate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate Create Account Token
         * @param {GenerateCreateAccountTokenRequest} generateCreateAccountTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCreateAccountToken: async (generateCreateAccountTokenRequest: GenerateCreateAccountTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateCreateAccountTokenRequest' is not null or undefined
            assertParamExists('generateCreateAccountToken', 'generateCreateAccountTokenRequest', generateCreateAccountTokenRequest)
            const localVarPath = `/generate_create_account_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCreateAccountTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate freee redirect url
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFreeeRedirectUrl: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('generateFreeeRedirectUrl', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/redirect_url`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate org account ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOrgAccountIds: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/generate_org_account_id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Card Detail as Admin
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACardDetailAsAdmin: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getACardDetailAsAdmin', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/detail_as_admin`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get accounting csv for the organization.
         * @param {string} organizationId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {'FREEE' | 'MONEY_FORWARD'} accountingSystemType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingCsvForTheOrganization: async (organizationId: string, startYearMonth: string, endYearMonth: string, accountingSystemType: 'FREEE' | 'MONEY_FORWARD', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAccountingCsvForTheOrganization', 'organizationId', organizationId)
            // verify required parameter 'startYearMonth' is not null or undefined
            assertParamExists('getAccountingCsvForTheOrganization', 'startYearMonth', startYearMonth)
            // verify required parameter 'endYearMonth' is not null or undefined
            assertParamExists('getAccountingCsvForTheOrganization', 'endYearMonth', endYearMonth)
            // verify required parameter 'accountingSystemType' is not null or undefined
            assertParamExists('getAccountingCsvForTheOrganization', 'accountingSystemType', accountingSystemType)
            const localVarPath = `/organizations/{organizationId}/accounting/download_csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }

            if (accountingSystemType !== undefined) {
                localVarQueryParameter['accountingSystemType'] = accountingSystemType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get accounting csv for the user account.
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingCsvForTheUserAccount: async (userAccountId: string, yearMonth: string, isMergedFiles: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getAccountingCsvForTheUserAccount', 'userAccountId', userAccountId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getAccountingCsvForTheUserAccount', 'yearMonth', yearMonth)
            // verify required parameter 'isMergedFiles' is not null or undefined
            assertParamExists('getAccountingCsvForTheUserAccount', 'isMergedFiles', isMergedFiles)
            const localVarPath = `/user_accounts/{userAccountId}/accounting/download_csv`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (isMergedFiles !== undefined) {
                localVarQueryParameter['isMergedFiles'] = isMergedFiles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admin users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/system_admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admins
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAdmins', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/users/admins`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get agreement requests
         * @param {string} organizationId 
         * @param {boolean} waitingForAgreement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementRequests: async (organizationId: string, waitingForAgreement: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAgreementRequests', 'organizationId', organizationId)
            // verify required parameter 'waitingForAgreement' is not null or undefined
            assertParamExists('getAgreementRequests', 'waitingForAgreement', waitingForAgreement)
            const localVarPath = `/organizations/{organizationId}/agreement_requests`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (waitingForAgreement !== undefined) {
                localVarQueryParameter['waitingForAgreement'] = waitingForAgreement;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all banks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBanks: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/banks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get analysis invoice of payment request
         * @param {string} organizationId 
         * @param {string} fileId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisInvoiceOfPaymentRequest: async (organizationId: string, fileId: string, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAnalysisInvoiceOfPaymentRequest', 'organizationId', organizationId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getAnalysisInvoiceOfPaymentRequest', 'fileId', fileId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/invoice_analyze`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['fileId'] = fileId;
            }

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get annual fees eligibility
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnualFeesEligibility: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAnnualFeesEligibility', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/annual_fees/eligibility`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get approvers
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovers: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getApprovers', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/purchase_applications/approvers`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get available currency options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableCurrencyOptions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user_accounts/available_currency_options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <p>   Return a list of feature names that are available for the organization.   Most features are unconditionally available to all organizations and   are not included in the response of this API, while some new features are not   available for the organization unless their names are included in this response. </p> <p>   The response schema are designed to ensure that information about new features   is not disclosed to organizations that cannot use them. </p>
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFeatures: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAvailableFeatures', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/available_features`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Available merchant category options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableMerchantCategoryOptions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user_accounts/available_merchant_category_options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get balance state
         * @param {string} organizationId 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceState: async (organizationId: string, targetDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBalanceState', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/balance_state`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = targetDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get bank account activities
         * @param {number} bankAccountActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountActivities: async (bankAccountActivityId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankAccountActivityId' is not null or undefined
            assertParamExists('getBankAccountActivities', 'bankAccountActivityId', bankAccountActivityId)
            const localVarPath = `/bank_account_activities/{bankAccountActivityId}`
                .replace(`{${"bankAccountActivityId"}}`, encodeURIComponent(String(bankAccountActivityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a bank account confirmed activities
         * @param {string} organizationId 
         * @param {'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY' | 'SERVICE_CHARGE'} [type] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountConfirmedActivities: async (organizationId: string, type?: 'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY' | 'SERVICE_CHARGE', limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBankAccountConfirmedActivities', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/bank_account_confirmed_activities`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get bank by name
         * @param {string} bankName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankByName: async (bankName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankName' is not null or undefined
            assertParamExists('getBankByName', 'bankName', bankName)
            const localVarPath = `/banks/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bankName !== undefined) {
                localVarQueryParameter['bankName'] = bankName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a bank transfer
         * @param {string} organizationId 
         * @param {string} bankTransferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransfer: async (organizationId: string, bankTransferId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBankTransfer', 'organizationId', organizationId)
            // verify required parameter 'bankTransferId' is not null or undefined
            assertParamExists('getBankTransfer', 'bankTransferId', bankTransferId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers/{bankTransferId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"bankTransferId"}}`, encodeURIComponent(String(bankTransferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the specified bank\'s all branches
         * @param {string} bankCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanksAllBranches: async (bankCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankCode' is not null or undefined
            assertParamExists('getBanksAllBranches', 'bankCode', bankCode)
            const localVarPath = `/banks/{bankCode}/branches`
                .replace(`{${"bankCode"}}`, encodeURIComponent(String(bankCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get bookkeepers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookkeepers: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBookkeepers', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/users/bookkeepers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get branch
         * @param {string} bankCode 
         * @param {string} branchName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranch: async (bankCode: string, branchName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankCode' is not null or undefined
            assertParamExists('getBranch', 'bankCode', bankCode)
            // verify required parameter 'branchName' is not null or undefined
            assertParamExists('getBranch', 'branchName', branchName)
            const localVarPath = `/bank_branches/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bankCode !== undefined) {
                localVarQueryParameter['bankCode'] = bankCode;
            }

            if (branchName !== undefined) {
                localVarQueryParameter['branchName'] = branchName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all business descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessDescriptions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/business-descriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get if an organization can activate cards
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanActivateCard: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCanActivateCard', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/can_activate_card`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the status of whether the organization can close
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanCloseStatuses: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCanCloseStatuses', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/can_close_statuses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get can deactivate
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanDeactivate: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCanDeactivate', 'userId', userId)
            const localVarPath = `/users/{userId}/can_deactivate`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get if the user can read card\'s sensitive info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanReadCardSensitive: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/can_read_card_sensitive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get if an organization can request a real card to be issued.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanRequestSendingCard: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCanRequestSendingCard', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/can_request_sending_card`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns whether the current user is eligible for canary routing (read-only, no cookie side-effect)
         * @summary Get canary routing eligibility status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanaryRoutingStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/canary/routing/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Bill
         * @param {string} cardBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardBill: async (cardBillId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardBillId' is not null or undefined
            assertParamExists('getCardBill', 'cardBillId', cardBillId)
            const localVarPath = `/cards/{cardBillId}`
                .replace(`{${"cardBillId"}}`, encodeURIComponent(String(cardBillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Detail
         * @param {string} cardId 
         * @param {string} [xChallengeSuccessToken] sudo-mode challenge 検証成功時に発行される token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardDetail: async (cardId: string, xChallengeSuccessToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCardDetail', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/detail`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xChallengeSuccessToken != null) {
                localVarHeaderParameter['x-challenge-success-token'] = String(xChallengeSuccessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get card monthly transactions
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardMonthlyTransactions: async (userAccountId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getCardMonthlyTransactions', 'userAccountId', userAccountId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getCardMonthlyTransactions', 'yearMonth', yearMonth)
            const localVarPath = `/user_accounts/{userAccountId}/cards/monthly_transactions`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Points Rate Configs By OrganizationId
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardPointsRateConfigsByOrganizationId: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardPointsRateConfigsByOrganizationId', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/card_points/rate_configs`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get card transaction details
         * @param {string} organizationId 
         * @param {string} visaTransactionReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionDetails: async (organizationId: string, visaTransactionReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardTransactionDetails', 'organizationId', organizationId)
            // verify required parameter 'visaTransactionReferenceId' is not null or undefined
            assertParamExists('getCardTransactionDetails', 'visaTransactionReferenceId', visaTransactionReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/details`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get card transaction evidence record image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {string} id 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionEvidenceRecordImage: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, id: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecordImage', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecordImage', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecordImage', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecordImage', 'id', id)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}/records/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get card transaction evidence records
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionEvidenceRecords: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecords', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecords', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('getCardTransactionEvidenceRecords', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}/records`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Card Transactions
         * @param {string} userAccountId 
         * @param {string} merchantId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactions: async (userAccountId: string, merchantId: string, toYearMonth: string, fromYearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getCardTransactions', 'userAccountId', userAccountId)
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getCardTransactions', 'merchantId', merchantId)
            // verify required parameter 'toYearMonth' is not null or undefined
            assertParamExists('getCardTransactions', 'toYearMonth', toYearMonth)
            const localVarPath = `/user_accounts/{userAccountId}/cards/transactions`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (fromYearMonth !== undefined) {
                localVarQueryParameter['fromYearMonth'] = fromYearMonth;
            }

            if (toYearMonth !== undefined) {
                localVarQueryParameter['toYearMonth'] = toYearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cards
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCards: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCards', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cards transactions with purchase application unlinked
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsTransactionsWithPurchaseApplicationUnlinked: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCardsTransactionsWithPurchaseApplicationUnlinked', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getCardsTransactionsWithPurchaseApplicationUnlinked', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/cards/monthly_transactions/purchase_application/unlinked`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the category of the purchase application template for use.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryOfThePurchaseApplicationTemplate: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCategoryOfThePurchaseApplicationTemplate', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/categories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComment: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getComment', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getComment', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/comment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comment templates
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentTemplates: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCommentTemplates', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentTemplatesCommentTemplateId: async (organizationId: string, templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCommentTemplatesCommentTemplateId', 'organizationId', organizationId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getCommentTemplatesCommentTemplateId', 'templateId', templateId)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates/{templateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current card associated with the user account
         * @param {string} userAccountId 
         * @param {boolean} [includeMerchantCategories] Whether to include available merchant categories in the response. Set to false to improve performance when merchant categories are not needed.
         * @param {Array<'reissue'>} [expand] Stripe-style expand parameter for opt-in property expansion. Specifies optional properties to include in the response; properties not listed are omitted from the response body entirely (the key is absent, not &#x60;null&#x60;).  Multiple values can be specified by repeating the parameter, e.g. &#x60;/current_card?expand&#x3D;reissue&amp;expand&#x3D;foo&#x60;.  Currently supported values:  - &#x60;reissue&#x60;: includes the &#x60;reissue&#x60; object describing the previous card    that was replaced by automatic reissuance. &#x60;null&#x60; if this card is not    a reissued card.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCardAssociatedWithTheUserAccount: async (userAccountId: string, includeMerchantCategories?: boolean, expand?: Array<'reissue'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getCurrentCardAssociatedWithTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/current_card`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeMerchantCategories !== undefined) {
                localVarQueryParameter['includeMerchantCategories'] = includeMerchantCategories;
            }

            if (expand) {
                localVarQueryParameter['expand'] = expand;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current ETC card associated with the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentEtcCard: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getCurrentEtcCard', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/current_etc_card`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get deals total amount
         * @param {number} organizationId 
         * @param {GetDealsTotalAmountRequest} [getDealsTotalAmountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealsTotalAmount: async (organizationId: number, getDealsTotalAmountRequest?: GetDealsTotalAmountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDealsTotalAmount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/deals/total_amount`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDealsTotalAmountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get default comment template for user account
         * @param {string} organizationId 
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultCommentTemplate: async (organizationId: string, userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDefaultCommentTemplate', 'organizationId', organizationId)
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getDefaultCommentTemplate', 'userAccountId', userAccountId)
            const localVarPath = `/organizations/{organizationId}/user_accounts/{userAccountId}/default_comment_template`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deposit bank account
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositBankAccount: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDepositBankAccount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/deposit_bank_account`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictionForOrganization: async (organizationId: string, depositRestrictionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDepositRestrictionForOrganization', 'organizationId', organizationId)
            // verify required parameter 'depositRestrictionId' is not null or undefined
            assertParamExists('getDepositRestrictionForOrganization', 'depositRestrictionId', depositRestrictionId)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions/{depositRestrictionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"depositRestrictionId"}}`, encodeURIComponent(String(depositRestrictionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deposit restriction list for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictionListForOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDepositRestrictionListForOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all deposit restrictions for the organization of the currently authenticated user
         * @summary Get deposit restrictions for current user\'s organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deposit_restrictions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequest: async (organizationId: string, draftPaymentRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDraftPaymentRequest', 'organizationId', organizationId)
            // verify required parameter 'draftPaymentRequestId' is not null or undefined
            assertParamExists('getDraftPaymentRequest', 'draftPaymentRequestId', draftPaymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts/{draftPaymentRequestId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftPaymentRequestId"}}`, encodeURIComponent(String(draftPaymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get draft payment request evidence file
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequestEvidenceFile: async (organizationId: string, draftPaymentRequestId: string, evidenceId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDraftPaymentRequestEvidenceFile', 'organizationId', organizationId)
            // verify required parameter 'draftPaymentRequestId' is not null or undefined
            assertParamExists('getDraftPaymentRequestEvidenceFile', 'draftPaymentRequestId', draftPaymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getDraftPaymentRequestEvidenceFile', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts/{draftPaymentRequestId}/evidences/{evidenceId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftPaymentRequestId"}}`, encodeURIComponent(String(draftPaymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get draft payment requests only created own
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequestsOnlyCreatedOwn: async (organizationId: string, xUpsidrSwitchUser?: string, freeWord?: string, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDraftPaymentRequestsOnlyCreatedOwn', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (freeWord !== undefined) {
                localVarQueryParameter['freeWord'] = freeWord;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get earliest expiring guarantee money for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarliestExpiringGuaranteeMoneyForOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEarliestExpiringGuaranteeMoneyForOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_deposits/upcoming_expiration`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtain email notification configuration information for each user.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailNotifications: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getEmailNotifications', 'userId', userId)
            const localVarPath = `/users/{userId}/email_notifications`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get error bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorBills: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/error-bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if an ETC account exists for the specified organization. This is used to determine if ETC service has been initiated for the organization.
         * @summary Get ETC account status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcAccount: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEtcAccount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/etc_accounts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get ETC card billing amounts per card for specified yearMonth
         * @param {string} organizationId 
         * @param {string} yearMonth Settlement year-month in YYYYMM format (e.g., \&quot;202603\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcAmounts: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEtcAmounts', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getEtcAmounts', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/card_bills/etc_amounts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get ETC card count for organization
         * @param {string} organizationId 
         * @param {string} [searchWord] Search by card label or holder name (partial match)
         * @param {Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>} [statuses] Filter by card status
         * @param {Array<string>} [groups] Filter by user account group IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcCardCount: async (organizationId: string, searchWord?: string, statuses?: Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>, groups?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEtcCardCount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/etc_cards/count`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (groups) {
                localVarQueryParameter['groups'] = groups;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns sensitive card information. Only accessible by the card holder. - Card number: 16 digits, displayed with spaces (e.g., \"1234 5678 9012 3456\") - Expiry: Year and month separately - Cardholder name: Copyable 
         * @summary Get ETC card personal information (card number, expiry, cardholder name)
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcCardDetail: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getEtcCardDetail', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/current_etc_card/detail`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns ETC card usage history with pagination. - Amount: Negative for normal transactions, positive for cancellations - Display format for usedAt: \"12月9日\" (without zero padding) 
         * @summary Get ETC card transactions
         * @param {string} userAccountId 
         * @param {string} yearMonth Target year and month (format: yyyyMM)
         * @param {string} [search] Search query (filter by highway name)
         * @param {number} [limit] Number of items to return (default 50, max 200)
         * @param {string} [nextCursor] Cursor for pagination. Pass the &#x60;nextCursor&#x60; value returned in the previous response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcCardTransactions: async (userAccountId: string, yearMonth: string, search?: string, limit?: number, nextCursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getEtcCardTransactions', 'userAccountId', userAccountId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getEtcCardTransactions', 'yearMonth', yearMonth)
            const localVarPath = `/user_accounts/{userAccountId}/etc_card/transactions`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextCursor !== undefined) {
                localVarQueryParameter['nextCursor'] = nextCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get ETC cards
         * @param {string} organizationId 
         * @param {string} [searchWord] Search by card label or holder name (partial match)
         * @param {Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>} [statuses] Filter by card status
         * @param {Array<string>} [groups] Filter by user account group IDs
         * @param {number} [limit] Number of items to return (default 50, max 200)
         * @param {string} [nextCursor] Cursor for pagination. Pass the &#x60;nextCursor&#x60; value returned in the previous response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcCards: async (organizationId: string, searchWord?: string, statuses?: Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>, groups?: Array<string>, limit?: number, nextCursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEtcCards', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/etc_cards`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (groups) {
                localVarQueryParameter['groups'] = groups;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextCursor !== undefined) {
                localVarQueryParameter['nextCursor'] = nextCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the evidence specified by evidenceId.
         * @summary Get a specific evidence.
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidence: async (organizationId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidence', 'organizationId', organizationId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidence', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/evidences/{evidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence file
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceFile: async (organizationId: string, evidenceId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceFile', 'organizationId', organizationId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidenceFile', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/evidences/{evidenceId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceImage: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceImage', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getEvidenceImage', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('getEvidenceImage', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence information for card transactions
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceInformationForCardTransactions: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceInformationForCardTransactions', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getEvidenceInformationForCardTransactions', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/request/info`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence record image
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {string} recordId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceRecordImage: async (organizationId: string, evidenceId: string, recordId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceRecordImage', 'organizationId', organizationId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidenceRecordImage', 'evidenceId', evidenceId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('getEvidenceRecordImage', 'recordId', recordId)
            const localVarPath = `/organizations/{organizationId}/evidences/{evidenceId}/records/{recordId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)))
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence records
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceRecords: async (organizationId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceRecords', 'organizationId', organizationId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidenceRecords', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/evidences/{evidenceId}/records`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidence zip for the organization.
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceZipForTheOrganization: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidenceZipForTheOrganization', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getEvidenceZipForTheOrganization', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/accounting/download_evidences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get evidences
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidences: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidences', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('getEvidences', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count evidences
         * @param {string} organizationId 
         * @param {string} [issuer] This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
         * @param {number} [amountMin] 
         * @param {number} [amountMax] 
         * @param {string} [paidAtFrom] 
         * @param {string} [paidAtTo] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {string} [keyword] Specified keyword is searched from the issuer and the note by partial match.
         * @param {boolean} [includesDeleted] 
         * @param {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>} [legalValidities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidencesCount: async (organizationId: string, issuer?: string, amountMin?: number, amountMax?: number, paidAtFrom?: string, paidAtTo?: string, irrelevantToLedger?: boolean, keyword?: string, includesDeleted?: boolean, legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getEvidencesCount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/evidences/count`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (issuer !== undefined) {
                localVarQueryParameter['issuer'] = issuer;
            }

            if (amountMin !== undefined) {
                localVarQueryParameter['amountMin'] = amountMin;
            }

            if (amountMax !== undefined) {
                localVarQueryParameter['amountMax'] = amountMax;
            }

            if (paidAtFrom !== undefined) {
                localVarQueryParameter['paidAtFrom'] = (paidAtFrom as any instanceof Date) ?
                    (paidAtFrom as any).toISOString() :
                    paidAtFrom;
            }

            if (paidAtTo !== undefined) {
                localVarQueryParameter['paidAtTo'] = (paidAtTo as any instanceof Date) ?
                    (paidAtTo as any).toISOString() :
                    paidAtTo;
            }

            if (irrelevantToLedger !== undefined) {
                localVarQueryParameter['irrelevantToLedger'] = irrelevantToLedger;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (includesDeleted !== undefined) {
                localVarQueryParameter['includesDeleted'] = includesDeleted;
            }

            if (legalValidities) {
                localVarQueryParameter['legalValidities'] = legalValidities;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the triggered transaction of a fraud locked card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFraudLockedCardTransaction: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFraudLockedCardTransaction', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getFraudLockedCardTransaction', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/lock_on_fraud_detected/transaction`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee account items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeAccountItems: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeAccountItems', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeAccountItems', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/account_items`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee companies
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeCompanies: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeCompanies', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/companies`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnected: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeConnected', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/connected`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Freee Connected User
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnectedUser: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeConnectedUser', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/connected_user`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary freee接続中のユーザー取得
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnectionLinkedAccountForAccounting: async (orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccountId' is not null or undefined
            assertParamExists('getFreeeConnectionLinkedAccountForAccounting', 'orgAccountId', orgAccountId)
            const localVarPath = `/org_accounts/{orgAccountId}/freee/connection/linked_account`
                .replace(`{${"orgAccountId"}}`, encodeURIComponent(String(orgAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upsidrPrivateClientApiInternal != null) {
                localVarHeaderParameter['upsidr-private-client-api-internal'] = typeof upsidrPrivateClientApiInternal === 'string' 
                    ? upsidrPrivateClientApiInternal 
                    : JSON.stringify(upsidrPrivateClientApiInternal);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary freee設定取得
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnectionSettingsForAccounting: async (orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccountId' is not null or undefined
            assertParamExists('getFreeeConnectionSettingsForAccounting', 'orgAccountId', orgAccountId)
            const localVarPath = `/org_accounts/{orgAccountId}/freee/connection/settings`
                .replace(`{${"orgAccountId"}}`, encodeURIComponent(String(orgAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upsidrPrivateClientApiInternal != null) {
                localVarHeaderParameter['upsidr-private-client-api-internal'] = typeof upsidrPrivateClientApiInternal === 'string' 
                    ? upsidrPrivateClientApiInternal 
                    : JSON.stringify(upsidrPrivateClientApiInternal);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeItems: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeItems', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeItems', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/items`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee memo tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeMemoTags: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeMemoTags', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeMemoTags', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/memo_tags`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee partners
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeePartners: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeePartners', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeePartners', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/partners`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee sections
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSections: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeSections', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeSections', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/sections`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee segment tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSegmentTags: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeSegmentTags', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeSegmentTags', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/segment_tags`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee sync status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSyncStatus: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeSyncStatus', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/sync_status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {string} tagName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeTags: async (organizationId: string, companyId: string, tagName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeTags', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeTags', 'companyId', companyId)
            // verify required parameter 'tagName' is not null or undefined
            assertParamExists('getFreeeTags', 'tagName', tagName)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/tags`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"tagName"}}`, encodeURIComponent(String(tagName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee taxes
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeTaxes: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeTaxes', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getFreeeTaxes', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/taxes`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get freee token
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeToken: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getFreeeToken', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/freee/token`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a guarantee money balance history
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyBalanceHistory: async (organizationId: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGuaranteeMoneyBalanceHistory', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_balance_history`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a guarantee money balance information for a organization
         * @param {string} organizationId 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyBalanceInformationForOrganization: async (organizationId: string, targetDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGuaranteeMoneyBalanceInformationForOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_balance`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = targetDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get guarantee money deposits for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyDepositsForOrganization: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getGuaranteeMoneyDepositsForOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/guarantee_money_deposits`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [from] yyyy-MM-dd format date in JST.
         * @param {string} [to] yyyy-MM-dd format date in JST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidays: async (from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentifyVerificationsLatest: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIdentifyVerificationsLatest', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/identity_verifications/latest`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityVerifications: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIdentityVerifications', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/identity_verifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Invoice List
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceList: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getInvoiceList', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/invoices`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Invoice Pdf
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicePdf: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getInvoicePdf', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getInvoicePdf', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/invoices/{yearMonth}.pdf`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"yearMonth"}}`, encodeURIComponent(String(yearMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get issuable status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssuableStatus: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getIssuableStatus', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/issuable_status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get jwt for SSO
         * @param {string} nonce 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJwtSso: async (nonce: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonce' is not null or undefined
            assertParamExists('getJwtSso', 'nonce', nonce)
            const localVarPath = `/sso/jwt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nonce !== undefined) {
                localVarQueryParameter['nonce'] = nonce;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of KYC reader users ordered by creation date in descending order.
         * @summary Get KYC Reader Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKycReaderUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zeus/users/kyc_reader`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get latest time of sync to freee
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTimeOfSyncToFreee: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLatestTimeOfSyncToFreee', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getLatestTimeOfSyncToFreee', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/latest_sync_time`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get lock status of evidences
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLockStatusOfEvidences: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getLockStatusOfEvidences', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getLockStatusOfEvidences', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/evidence/lock`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant general blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantGeneralBlock: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/merchant_general_block_lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant general block detail
         * @param {string} merchantGeneralBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantGeneralBlockDetail: async (merchantGeneralBlockListId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('getMerchantGeneralBlockDetail', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant org blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrgBlock: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/merchant_org_block_lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant org block list
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrgBlockList: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMerchantOrgBlockList', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/merchant_org_block_lists`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant organization user account year month summary
         * @param {string} organizationId 
         * @param {string} merchantId 
         * @param {string} userAccountId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrganizationUserAccountYearMonthSummary: async (organizationId: string, merchantId: string, userAccountId: string, toYearMonth: string, fromYearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMerchantOrganizationUserAccountYearMonthSummary', 'organizationId', organizationId)
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantOrganizationUserAccountYearMonthSummary', 'merchantId', merchantId)
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getMerchantOrganizationUserAccountYearMonthSummary', 'userAccountId', userAccountId)
            // verify required parameter 'toYearMonth' is not null or undefined
            assertParamExists('getMerchantOrganizationUserAccountYearMonthSummary', 'toYearMonth', toYearMonth)
            const localVarPath = `/organizations/{organizationId}/merchants/{merchantId}/user_accounts/{userAccountId}/user_account_year_month_summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromYearMonth !== undefined) {
                localVarQueryParameter['fromYearMonth'] = fromYearMonth;
            }

            if (toYearMonth !== undefined) {
                localVarQueryParameter['toYearMonth'] = toYearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of MerchantCategoryKind
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantsCategoryKinds: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMerchantsCategoryKinds', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/merchants/category_kinds`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Modifiable Daily Limits For The User Account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableDailyLimitsForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getModifiableDailyLimitsForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/modifiable_limit/daily_limits`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get modifiable monthly limits for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableMonthlyLimitsForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getModifiableMonthlyLimitsForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/modifiable_limit/monthly_limits`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Modifiable Transaction Limits For The User Account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableTransactionLimitsForTheUserAccount: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getModifiableTransactionLimitsForTheUserAccount', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/modifiable_limit/transaction_limits`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get moneytree connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeConnected: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMoneytreeConnected', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/connected`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get moneytree oauth url
         * @param {string} organizationId 
         * @param {string} [nextTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeOauthUrl: async (organizationId: string, nextTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMoneytreeOauthUrl', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/oauth_url`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nextTo !== undefined) {
                localVarQueryParameter['next_to'] = nextTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get moneytree status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeStatus: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMoneytreeStatus', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get monthly card bills for specified yearMonths
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {string} [startYearMonth] 
         * @param {string} [endYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardBill: async (organizationId: string, yearMonth?: string, startYearMonth?: string, endYearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMonthlyCardBill', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/monthly_card_bill`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get monthly card transactions for the organization.
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardTransactionsForTheOrganization: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMonthlyCardTransactionsForTheOrganization', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getMonthlyCardTransactionsForTheOrganization', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/cards/monthly_transactions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get monthly card transactions for the user
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardTransactionsForTheUser: async (yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getMonthlyCardTransactionsForTheUser', 'yearMonth', yearMonth)
            const localVarPath = `/users/cards/monthly_transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定された組織・年月のFlora課金情報（サービス料金）を取得します。 年会費、ラウンジ利用料などのFlora課金明細を返却します。  **注意**: このAPIはFlora課金情報のみを返します。カード決済情報は `/cards/monthly_card_bill` APIを使用してください。 
         * @summary Get Monthly Service Charges
         * @param {string} organizationId 
         * @param {string} yearMonth Year and month in yyyyMM format (e.g., 202506)
         * @param {number} [limit] Maximum number of items to return (1-100, default: 100)
         * @param {number} [offset] Number of items to skip (default: 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyServiceCharges: async (organizationId: string, yearMonth: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMonthlyServiceCharges', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getMonthlyServiceCharges', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/service_charges/{yearMonth}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"yearMonth"}}`, encodeURIComponent(String(yearMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get monthly user card summaries
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyUserCardSummaries: async (organizationId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getMonthlyUserCardSummaries', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getMonthlyUserCardSummaries', 'yearMonth', yearMonth)
            const localVarPath = `/organizations/{organizationId}/cards/monthly_user_card_summaries`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get OL info sharing consent status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOlInfoSharingConsent: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOlInfoSharingConsent', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/ol-consent`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific onboarding request for zeus
         * @param {string} onboardingRequestId The ID of the onboarding request to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequestById: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('getOnboardingRequestById', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get personal information of the onboarding request.
         * @summary Get Personal Information
         * @param {string} onboardingRequestId Onboarding request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequestPersonalInfo: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('getOnboardingRequestPersonalInfo', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/personal_info`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get onboarding requests for zeus
         * @param {string} [key] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'id' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequests: async (key?: string, createdAtFrom?: string, createdAtTo?: string, limit?: number, offset?: number, sort?: 'id' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zeus/onboarding_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get org account state
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgAccountState: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrgAccountState', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/account_state`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization
         * @param {string} organizationId 
         * @param {boolean} [underContractOnly] 
         * @param {boolean} [withCredit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (organizationId: string, underContractOnly?: boolean, withCredit?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganization', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"underContractOnly"}}`, encodeURIComponent(String(underContractOnly)))
                .replace(`{${"withCredit"}}`, encodeURIComponent(String(withCredit)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Accounting Csv Fields Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAccountingCsvFieldsTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/cards/accounting/csv_field_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization cards extended
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCardsExtended: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationCardsExtended', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/extended`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization cards light
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCardsLight: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationCardsLight', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/light`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization chart departments
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartDepartments: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationChartDepartments', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/workflows/organization_charts/departments`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization chart employees
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartEmployees: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationChartEmployees', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/workflows/organization_charts/employees`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization chart roles
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartRoles: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationChartRoles', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/workflows/organization_charts/roles`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organizations create requests for zeus
         * @param {string} [key] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'id' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCreateRequests: async (key?: string, createdAtFrom?: string, createdAtTo?: string, limit?: number, offset?: number, sort?: 'id' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zeus/organization_create_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization payment schemes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPaymentSchemes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/payment_schemes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 請求画面トップのサマリー表示に必要な情報を、組織レベルで取得する。 個別の請求実体（CardBill / ServiceCharge）に依存せず、組織に設定されている 支払スキームと、対象支払予定日に紐づく合算情報を返す。  ## 用途 - UPSIDER 請求画面トップ（`/payments/`）のサマリーカード表示 - ETC-only 組織（CARD 請求が発生しない組織）でもサマリーを描画可能にする  ## 関連 - 個別請求の詳細取得は引き続き以下を使用：   - カード請求: `/cards/{cardBillId}`   - サービス利用料明細: `/organizations/{organizationId}/service_charges/{yearMonth}` - 請求一覧（履歴全件）の取得: `/organizations/{organizationId}/payments` 
         * @summary Get payment summary for organization
         * @param {string} organizationId 
         * @param {string} [yearMonth] 対象利用月（yyyyMM 形式、例: 202604）。 指定された月に対応する MonthlyPayment のサマリーを返す。 未指定の場合は組織の「最新の MonthlyPayment（直近の支払予定日のもの）」のサマリーを返す。 ※「最新」の具体定義はバックエンド実装時に確定。 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPaymentSummary: async (organizationId: string, yearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationPaymentSummary', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payments/summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization payments
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPayments: async (organizationId: string, yearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationPayments', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payments`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organizations Accounting Csv Export Fields
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsAccountingCsvExportFields: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationsAccountingCsvExportFields', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/cards/accounting/csv_export_fields`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a organization\'s bill
         * @param {string} organizationId 
         * @param {boolean} [beforeReservationOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsBills: async (organizationId: string, beforeReservationOnly?: boolean, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationsBills', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/bills`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (beforeReservationOnly !== undefined) {
                localVarQueryParameter['beforeReservationOnly'] = beforeReservationOnly;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organizations deals
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsDeals: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationsDeals', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment request detail
         * @param {string} organizationId 
         * @param {string} [paymentRequestId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestDetail: async (organizationId: string, paymentRequestId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestDetail', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a payment request evidence specified by evidenceId.
         * @summary Get a specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidence: async (organizationId: string, paymentRequestId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidence', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidence', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getPaymentRequestEvidence', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment request evidence file
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceFile: async (organizationId: string, paymentRequestId: string, evidenceId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceFile', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceFile', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceFile', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment request evidence record file
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {string} recordId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceRecordFile: async (organizationId: string, paymentRequestId: string, evidenceId: string, recordId: string, inPdf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecordFile', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecordFile', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecordFile', 'evidenceId', evidenceId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecordFile', 'recordId', recordId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}/records/{recordId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)))
                .replace(`{${"recordId"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (inPdf !== undefined) {
                localVarQueryParameter['inPdf'] = inPdf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment request evidence records
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceRecords: async (organizationId: string, paymentRequestId: string, evidenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecords', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecords', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getPaymentRequestEvidenceRecords', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}/records`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all evidences for a specific payment request
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidences: async (organizationId: string, paymentRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestEvidences', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('getPaymentRequestEvidences', 'paymentRequestId', paymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment requests bank accounts list
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsBankAccountsList: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestsBankAccountsList', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_accounts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment requests count linked bank transfer
         * @param {string} organizationId 
         * @param {string} paymentRequestIds When specifying more than one, separate them by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsCountLinkedBankTransfer: async (organizationId: string, paymentRequestIds: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPaymentRequestsCountLinkedBankTransfer', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestIds' is not null or undefined
            assertParamExists('getPaymentRequestsCountLinkedBankTransfer', 'paymentRequestIds', paymentRequestIds)
            const localVarPath = `/organizations/{organizationId}/payment_requests/linked_bank_transfers/count`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (paymentRequestIds !== undefined) {
                localVarQueryParameter['paymentRequestIds'] = paymentRequestIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get pinretriever decrypt pin block
         * @param {GetPinretrieverDecryptPinBlockRequest} getPinretrieverDecryptPinBlockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverDecryptPinBlock: async (getPinretrieverDecryptPinBlockRequest: GetPinretrieverDecryptPinBlockRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPinretrieverDecryptPinBlockRequest' is not null or undefined
            assertParamExists('getPinretrieverDecryptPinBlock', 'getPinretrieverDecryptPinBlockRequest', getPinretrieverDecryptPinBlockRequest)
            const localVarPath = `/pinretriever/decrypt_pin_block`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPinretrieverDecryptPinBlockRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get pinretriever encrypt pin
         * @param {GetPinretrieverEncryptPinRequest} getPinretrieverEncryptPinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverEncryptPin: async (getPinretrieverEncryptPinRequest: GetPinretrieverEncryptPinRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPinretrieverEncryptPinRequest' is not null or undefined
            assertParamExists('getPinretrieverEncryptPin', 'getPinretrieverEncryptPinRequest', getPinretrieverEncryptPinRequest)
            const localVarPath = `/pinretriever/encrypt_pin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPinretrieverEncryptPinRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get pinretriever hsm publickey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverHsmPublickey: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pinretriever/hsm_publickey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchase application
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplication: async (organizationId: string, purchaseApplicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('getPurchaseApplication', 'purchaseApplicationId', purchaseApplicationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchase application templates
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationTemplates: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPurchaseApplicationTemplates', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchase application templates detail
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationTemplatesDetail: async (organizationId: string, purchaseTemplateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPurchaseApplicationTemplatesDetail', 'organizationId', organizationId)
            // verify required parameter 'purchaseTemplateId' is not null or undefined
            assertParamExists('getPurchaseApplicationTemplatesDetail', 'purchaseTemplateId', purchaseTemplateId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/{purchaseTemplateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseTemplateId"}}`, encodeURIComponent(String(purchaseTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get purchase applications
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplications: async (organizationId: string, yearMonth?: string, visaTransactionReferenceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPurchaseApplications', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsRequestedCount: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPurchaseApplicationsRequestedCount', 'userId', userId)
            const localVarPath = `/users/{userId}/purchase_applications/requested/count`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the purchase applications requested list
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsRequestedList: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPurchaseApplicationsRequestedList', 'userId', userId)
            const localVarPath = `/users/{userId}/purchase_applications/requested/list`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the purchase applications submitted self
         * @param {string} userId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsSubmittedSelf: async (userId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPurchaseApplicationsSubmittedSelf', 'userId', userId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getPurchaseApplicationsSubmittedSelf', 'yearMonth', yearMonth)
            const localVarPath = `/users/{userId}/purchase_applications/submitted/self`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get(search) qualified invoice issuer
         * @param {string} registrationNumber 
         * @param {string} [issuerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualifiedInvoiceIssuer: async (registrationNumber: string, issuerName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationNumber' is not null or undefined
            assertParamExists('getQualifiedInvoiceIssuer', 'registrationNumber', registrationNumber)
            const localVarPath = `/qualified_invoice_issuers/{registrationNumber}`
                .replace(`{${"registrationNumber"}}`, encodeURIComponent(String(registrationNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (issuerName !== undefined) {
                localVarQueryParameter['issuerName'] = issuerName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Redirect URL from Tiny URL
         * @param {string} tinyUrlParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedirectUrlFromTinyUrl: async (tinyUrlParam: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tinyUrlParam' is not null or undefined
            assertParamExists('getRedirectUrlFromTinyUrl', 'tinyUrlParam', tinyUrlParam)
            const localVarPath = `/txn/{tinyUrlParam}`
                .replace(`{${"tinyUrlParam"}}`, encodeURIComponent(String(tinyUrlParam)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the reward points balance for the specified organization.
         * @summary Get reward points balance
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardPointBalance: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRewardPointBalance', 'organizationId', organizationId)
            const localVarPath = `/zeus/organizations/{organizationId}/reward_points/balance`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get reward point transactions for the specified organization
         * @summary Get reward point transactions
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardPointTransactions: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRewardPointTransactions', 'organizationId', organizationId)
            const localVarPath = `/zeus/organizations/{organizationId}/reward_points/transactions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Rewards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewards: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get role resource for user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleResourceForUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getRoleResourceForUser', 'userId', userId)
            const localVarPath = `/roles/user_account/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get roles
         * @param {string} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (category: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getRoles', 'category', category)
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithTopRelatedResources: async (resourceScope: string, resourceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceScope' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResources', 'resourceScope', resourceScope)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResources', 'resourceId', resourceId)
            const localVarPath = `/roles/user_account/{resourceScope}/{resourceId}/with_top_related_resources`
                .replace(`{${"resourceScope"}}`, encodeURIComponent(String(resourceScope)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources by Organization id
         * @param {string} organizationId 
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithTopRelatedResourcesByOrganizationId: async (organizationId: string, resourceScope: string, resourceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResourcesByOrganizationId', 'organizationId', organizationId)
            // verify required parameter 'resourceScope' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResourcesByOrganizationId', 'resourceScope', resourceScope)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getRolesWithTopRelatedResourcesByOrganizationId', 'resourceId', resourceId)
            const localVarPath = `/roles/organizations/{organizationId}/user_account/{resourceScope}/{resourceId}/with_top_related_resources`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"resourceScope"}}`, encodeURIComponent(String(resourceScope)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack card notification settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackCardNotificationSettings: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackCardNotificationSettings', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/cards/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Slack channels of an organization by SlackChannelID
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannel: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackChannel', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getSlackChannel', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack channels of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannels: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackChannels', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/channels`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack channels with cursor of an organization
         * @param {string} organizationId 
         * @param {string} [cursor] This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannelsWithCursor: async (organizationId: string, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackChannelsWithCursor', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/channels_with_cursor`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackEvidenceReminder: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackEvidenceReminder', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/cards/evidence_reminders`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an slack channel
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackEvidenceReminderPerChannel: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackEvidenceReminderPerChannel', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getSlackEvidenceReminderPerChannel', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/cards/evidence_reminders/{channelId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackNotificationChannelSettingForPurchaseApplication: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackNotificationChannelSettingForPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getSlackNotificationChannelSettingForPurchaseApplication', 'channelId', channelId)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/purchase_applications/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get slack notification settings for purchase-application
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackNotificationSettingsForPurchaseApplication: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackNotificationSettingsForPurchaseApplication', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/purchase_applications/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack team
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackTeam: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSlackTeam', 'organizationId', organizationId)
            const localVarPath = `/slack/organizations/{organizationId}/team`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Slack version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackVersion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/slack/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get submitted trustdock data
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmittedTrustdockData: async (trustdockIdentificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trustdockIdentificationId' is not null or undefined
            assertParamExists('getSubmittedTrustdockData', 'trustdockIdentificationId', trustdockIdentificationId)
            const localVarPath = `/organization_create_requests/submitted_data/{trustdockIdentificationId}`
                .replace(`{${"trustdockIdentificationId"}}`, encodeURIComponent(String(trustdockIdentificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get suspicious transaction detail list
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuspiciousTransactions: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getSuspiciousTransactions', 'userAccountId', userAccountId)
            const localVarPath = `/users/cards/suspicious_fraud_transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userAccountId !== undefined) {
                localVarQueryParameter['userAccountId'] = userAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams card notification settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsCardNotificationSettings: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTeamsCardNotificationSettings', 'organizationId', organizationId)
            const localVarPath = `/teams/organizations/{organizationId}/cards/notifications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams channels of an organization by TeamsChannelID
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsChannel: async (organizationId: string, channelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTeamsChannel', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getTeamsChannel', 'channelId', channelId)
            const localVarPath = `/teams/organizations/{organizationId}/channels/{channelId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams channels with cursor of an organization
         * @param {string} organizationId 
         * @param {string} [cursor] This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsChannelsWithCursor: async (organizationId: string, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTeamsChannelsWithCursor', 'organizationId', organizationId)
            const localVarPath = `/teams/organizations/{organizationId}/channels_with_cursor`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams team
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsTeam: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTeamsTeam', 'organizationId', organizationId)
            const localVarPath = `/teams/organizations/{organizationId}/team`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Teams version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsVersion: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Technical Support Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnicalSupportUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/technical_support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Tfa App QR Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppQrCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/app/generate_qr_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppRecoveryCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/app/download_recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get TFA SMS Recovery Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaSmsRecoveryCode: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/sms/download_recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the count of monthly transactions for the user account
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheCountOfMonthlyTransactionsForTheUserAccount: async (userAccountId: string, yearMonth: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTheCountOfMonthlyTransactionsForTheUserAccount', 'userAccountId', userAccountId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('getTheCountOfMonthlyTransactionsForTheUserAccount', 'yearMonth', yearMonth)
            const localVarPath = `/user_accounts/{userAccountId}/cards/monthly_transactions/count`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the user account information
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheUserAccountInformation: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTheUserAccountInformation', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transaction evidence email address
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmailAddress: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTransactionEvidenceEmailAddress', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/transaction_evidence_email_address`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Transaction Evidence Email File
         * @param {string} userAccountId 
         * @param {number} transactionEvidenceEmailFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmailFile: async (userAccountId: string, transactionEvidenceEmailFileId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTransactionEvidenceEmailFile', 'userAccountId', userAccountId)
            // verify required parameter 'transactionEvidenceEmailFileId' is not null or undefined
            assertParamExists('getTransactionEvidenceEmailFile', 'transactionEvidenceEmailFileId', transactionEvidenceEmailFileId)
            const localVarPath = `/user_accounts/{userAccountId}/transaction_evidence_files/{transactionEvidenceEmailFileId}`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)))
                .replace(`{${"transactionEvidenceEmailFileId"}}`, encodeURIComponent(String(transactionEvidenceEmailFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transaction evidence emails
         * @param {string} userAccountId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {boolean} [isTrash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmails: async (userAccountId: string, startYearMonth: string, endYearMonth: string, isTrash?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('getTransactionEvidenceEmails', 'userAccountId', userAccountId)
            // verify required parameter 'startYearMonth' is not null or undefined
            assertParamExists('getTransactionEvidenceEmails', 'startYearMonth', startYearMonth)
            // verify required parameter 'endYearMonth' is not null or undefined
            assertParamExists('getTransactionEvidenceEmails', 'endYearMonth', endYearMonth)
            const localVarPath = `/transaction_evidence_emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userAccountId !== undefined) {
                localVarQueryParameter['userAccountId'] = userAccountId;
            }

            if (startYearMonth !== undefined) {
                localVarQueryParameter['startYearMonth'] = startYearMonth;
            }

            if (endYearMonth !== undefined) {
                localVarQueryParameter['endYearMonth'] = endYearMonth;
            }

            if (isTrash !== undefined) {
                localVarQueryParameter['isTrash'] = isTrash;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Trustdock Identity Verifications
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockIdentityVerifications: async (trustdockIdentificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trustdockIdentificationId' is not null or undefined
            assertParamExists('getTrustdockIdentityVerifications', 'trustdockIdentificationId', trustdockIdentificationId)
            const localVarPath = `/trustdock/{trustdockIdentificationId}/identity_verifications`
                .replace(`{${"trustdockIdentificationId"}}`, encodeURIComponent(String(trustdockIdentificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Trustdock Submit Identification Document Publish URL
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockSubmitIdentificationDocumentPublishUrl: async (trustdockIdentificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trustdockIdentificationId' is not null or undefined
            assertParamExists('getTrustdockSubmitIdentificationDocumentPublishUrl', 'trustdockIdentificationId', trustdockIdentificationId)
            const localVarPath = `/trustdock/submit_identification_document/{trustdockIdentificationId}/publish_url`
                .replace(`{${"trustdockIdentificationId"}}`, encodeURIComponent(String(trustdockIdentificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Trustdock Verifications
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockVerifications: async (trustdockIdentificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trustdockIdentificationId' is not null or undefined
            assertParamExists('getTrustdockVerifications', 'trustdockIdentificationId', trustdockIdentificationId)
            const localVarPath = `/trustdock/verifications/{trustdockIdentificationId}`
                .replace(`{${"trustdockIdentificationId"}}`, encodeURIComponent(String(trustdockIdentificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get unread message count for a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessageCount: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUnreadMessageCount', 'userId', userId)
            const localVarPath = `/users/{userId}/user_messages/unread_count`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an usage fee
         * @param {number} usageFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageFee: async (usageFeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageFeeId' is not null or undefined
            assertParamExists('getUsageFee', 'usageFeeId', usageFeeId)
            const localVarPath = `/usage_fees/{usageFeeId}`
                .replace(`{${"usageFeeId"}}`, encodeURIComponent(String(usageFeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user account groups
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountGroups: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUserAccountGroups', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/user_account_groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user account year month summary
         * @param {string} organizationId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountYearMonthSummary: async (organizationId: string, toYearMonth: string, fromYearMonth?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUserAccountYearMonthSummary', 'organizationId', organizationId)
            // verify required parameter 'toYearMonth' is not null or undefined
            assertParamExists('getUserAccountYearMonthSummary', 'toYearMonth', toYearMonth)
            const localVarPath = `/organizations/{organizationId}/merchants/user_account_year_month_summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromYearMonth !== undefined) {
                localVarQueryParameter['fromYearMonth'] = fromYearMonth;
            }

            if (toYearMonth !== undefined) {
                localVarQueryParameter['toYearMonth'] = toYearMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user accounts with default comment template
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountsWithDefaultCommentTemplate: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUserAccountsWithDefaultCommentTemplate', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/user_accounts_with_default_comment_template`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCards: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCards', 'userId', userId)
            const localVarPath = `/users/{userId}/cards`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards extended
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsExtended: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCardsExtended', 'userId', userId)
            const localVarPath = `/users/{userId}/cards/extended`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards extended for role resources
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsExtendedForRoleResources: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCardsExtendedForRoleResources', 'userId', userId)
            const localVarPath = `/users/{userId}/cards/extended/user_account_role_resources`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards light
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsLight: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCardsLight', 'userId', userId)
            const localVarPath = `/users/{userId}/cards/light`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user cards light for role resources
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsLightForRoleResources: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCardsLightForRoleResources', 'userId', userId)
            const localVarPath = `/users/{userId}/cards/user_account_role_resources/light`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get ETC card count for a user
         * @param {string} userId 
         * @param {string} [searchWord] Search by card label or holder name (partial match)
         * @param {Array<string>} [groups] Filter by user account group IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEtcCardCount: async (userId: string, searchWord?: string, groups?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserEtcCardCount', 'userId', userId)
            const localVarPath = `/users/{userId}/etc_cards/count`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            if (groups) {
                localVarQueryParameter['groups'] = groups;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get ETC cards for a user
         * @param {string} userId 
         * @param {string} [searchWord] Search by card label or holder name (partial match)
         * @param {Array<string>} [groups] Filter by user account group IDs
         * @param {number} [limit] Number of items to return (default 50, min 1, max 200)
         * @param {string} [nextCursor] Cursor for pagination. Pass the &#x60;nextCursor&#x60; or &#x60;prevCursor&#x60; value returned in the previous response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEtcCards: async (userId: string, searchWord?: string, groups?: Array<string>, limit?: number, nextCursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserEtcCards', 'userId', userId)
            const localVarPath = `/users/{userId}/etc_cards`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchWord !== undefined) {
                localVarQueryParameter['searchWord'] = searchWord;
            }

            if (groups) {
                localVarQueryParameter['groups'] = groups;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextCursor !== undefined) {
                localVarQueryParameter['nextCursor'] = nextCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get message detail
         * @param {string} userMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMessageDetail: async (userMessageId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMessageId' is not null or undefined
            assertParamExists('getUserMessageDetail', 'userMessageId', userMessageId)
            const localVarPath = `/user_messages/{userMessageId}`
                .replace(`{${"userMessageId"}}`, encodeURIComponent(String(userMessageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get messages for a user
         * @param {string} userId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMessages: async (userId: string, offset: number, limit: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserMessages', 'userId', userId)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getUserMessages', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getUserMessages', 'limit', limit)
            const localVarPath = `/users/{userId}/user_messages`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users
         * @param {string} organizationId 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (organizationId: string, email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUsers', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get information on login user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get venture capitals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVentureCapitals: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/venture_capitals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定された組織の取引時確認詳細情報を取得します。 createdAtの降順で返却されます。 
         * @summary 取引時確認詳細取得（ZEUS)(PRESIDENT)
         * @param {string} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeusOrganizationIdentityVerificationsForPresident: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getZeusOrganizationIdentityVerificationsForPresident', 'organizationId', organizationId)
            const localVarPath = `/zeus/organizations/{organizationId}/identity_verifications_for_president`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organizations for zeus
         * @param {string} [key] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'ASC' | 'DESC'} [sort] 
         * @param {boolean} [connectedMoneytree] 
         * @param {'UPSIDER' | 'PRESIDENT_CARD'} [brandType] 
         * @param {boolean} [isSuspended] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeusOrganizations: async (key?: string, limit?: number, offset?: number, sort?: 'ASC' | 'DESC', connectedMoneytree?: boolean, brandType?: 'UPSIDER' | 'PRESIDENT_CARD', isSuspended?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zeus/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (connectedMoneytree !== undefined) {
                localVarQueryParameter['connectedMoneytree'] = connectedMoneytree;
            }

            if (brandType !== undefined) {
                localVarQueryParameter['brandType'] = brandType;
            }

            if (isSuspended !== undefined) {
                localVarQueryParameter['isSuspended'] = isSuspended;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * give points to organizations in bulk
         * @param {GivePointsToOrganizationsRequest} givePointsToOrganizationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        givePointsToOrganizations: async (givePointsToOrganizationsRequest: GivePointsToOrganizationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'givePointsToOrganizationsRequest' is not null or undefined
            assertParamExists('givePointsToOrganizations', 'givePointsToOrganizationsRequest', givePointsToOrganizationsRequest)
            const localVarPath = `/organizations/give_points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(givePointsToOrganizationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initialize Modifiable Limit For The User Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeModifiableLimitForTheUserAccounts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user_accounts/modifiable_limit/initialize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates ETC card service for the specified organization. This creates an ETC account on the yachi microservice that will manage ETC cards. The orgAccountId is derived internally from the organizationId.
         * @summary Initiate ETC service for an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEtcService: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('initiateEtcService', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/etc_accounts/initiate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 保持している challengeSuccessToken がまだ有効かどうかを確認する。 保護対象エンドポイントを実際に叩く前に、フロントがチャレンジモーダルを 表示すべきか判断する用途を想定。 
         * @summary challengeSuccessToken の有効性確認
         * @param {string} userId 
         * @param {IntrospectChallengeSuccessTokenRequest} introspectChallengeSuccessTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introspectChallengeSuccessToken: async (userId: string, introspectChallengeSuccessTokenRequest: IntrospectChallengeSuccessTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('introspectChallengeSuccessToken', 'userId', userId)
            // verify required parameter 'introspectChallengeSuccessTokenRequest' is not null or undefined
            assertParamExists('introspectChallengeSuccessToken', 'introspectChallengeSuccessTokenRequest', introspectChallengeSuccessTokenRequest)
            const localVarPath = `/users/{userId}/challenge/introspect`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(introspectChallengeSuccessTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invite a new user from user
         * @param {InviteUserFromUserRequest} inviteUserFromUserRequest 
         * @param {string} [xChallengeSuccessToken] sudo-mode challenge 検証成功時に発行される token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUserFromUser: async (inviteUserFromUserRequest: InviteUserFromUserRequest, xChallengeSuccessToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteUserFromUserRequest' is not null or undefined
            assertParamExists('inviteUserFromUser', 'inviteUserFromUserRequest', inviteUserFromUserRequest)
            const localVarPath = `/users/invite_from_user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xChallengeSuccessToken != null) {
                localVarHeaderParameter['x-challenge-success-token'] = String(xChallengeSuccessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserFromUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 6桁コードを生成し、登録済みメールアドレスへ送信する。 同一 (userId, scope) の組に既に有効なチャレンジが存在する場合は置き換える （異なる scope のチャレンジは互いに影響せず並行して有効）。 
         * @summary sudo-mode チャレンジの発行
         * @param {string} userId 
         * @param {IssueChallengeRequest} issueChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueChallenge: async (userId: string, issueChallengeRequest: IssueChallengeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('issueChallenge', 'userId', userId)
            // verify required parameter 'issueChallengeRequest' is not null or undefined
            assertParamExists('issueChallenge', 'issueChallengeRequest', issueChallengeRequest)
            const localVarPath = `/users/{userId}/challenge`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(issueChallengeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Linking purchase to transaction.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {string} [visaTransactionReferenceId] 
         * @param {string} [userAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkingPurchaseToTransaction: async (organizationId: string, purchaseApplicationId: string, visaTransactionReferenceId?: string, userAccountId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('linkingPurchaseToTransaction', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('linkingPurchaseToTransaction', 'purchaseApplicationId', purchaseApplicationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}/link`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }

            if (userAccountId !== undefined) {
                localVarQueryParameter['userAccountId'] = userAccountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lock a card due to potential fraud
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {LockCardForPotentialFraudRequest} lockCardForPotentialFraudRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockCardForPotentialFraud: async (organizationId: string, cardId: string, lockCardForPotentialFraudRequest: LockCardForPotentialFraudRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('lockCardForPotentialFraud', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('lockCardForPotentialFraud', 'cardId', cardId)
            // verify required parameter 'lockCardForPotentialFraudRequest' is not null or undefined
            assertParamExists('lockCardForPotentialFraud', 'lockCardForPotentialFraudRequest', lockCardForPotentialFraudRequest)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/lock_for_potential_fraud`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockCardForPotentialFraudRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lock a card due to fraud detected
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {LockCardOnFraudDetectedRequest} lockCardOnFraudDetectedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockCardOnFraudDetected: async (organizationId: string, cardId: string, lockCardOnFraudDetectedRequest: LockCardOnFraudDetectedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('lockCardOnFraudDetected', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('lockCardOnFraudDetected', 'cardId', cardId)
            // verify required parameter 'lockCardOnFraudDetectedRequest' is not null or undefined
            assertParamExists('lockCardOnFraudDetected', 'lockCardOnFraudDetectedRequest', lockCardOnFraudDetectedRequest)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/lock_on_fraud_detected`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockCardOnFraudDetectedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with APP two factor auth
         * @param {LoginAppRequest} loginAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginApp: async (loginAppRequest: LoginAppRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginAppRequest' is not null or undefined
            assertParamExists('loginApp', 'loginAppRequest', loginAppRequest)
            const localVarPath = `/login/two_factor_auth/app`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginAppRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with recovery code of two factor auth
         * @param {LoginRecoveryCodeRequest} loginRecoveryCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginRecoveryCode: async (loginRecoveryCodeRequest: LoginRecoveryCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRecoveryCodeRequest' is not null or undefined
            assertParamExists('loginRecoveryCode', 'loginRecoveryCodeRequest', loginRecoveryCodeRequest)
            const localVarPath = `/login/two_factor_auth/recovery_code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRecoveryCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with SMS two factor auth
         * @param {LoginSmsRequest} loginSmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSms: async (loginSmsRequest: LoginSmsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginSmsRequest' is not null or undefined
            assertParamExists('loginSms', 'loginSmsRequest', loginSmsRequest)
            const localVarPath = `/login/two_factor_auth/sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginSmsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} currentChannelId 
         * @param {MoveSlackNotificationSettingForCardRequest} moveSlackNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSlackNotificationSettingForCard: async (organizationId: string, currentChannelId: string, moveSlackNotificationSettingForCardRequest: MoveSlackNotificationSettingForCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('moveSlackNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'currentChannelId' is not null or undefined
            assertParamExists('moveSlackNotificationSettingForCard', 'currentChannelId', currentChannelId)
            // verify required parameter 'moveSlackNotificationSettingForCardRequest' is not null or undefined
            assertParamExists('moveSlackNotificationSettingForCard', 'moveSlackNotificationSettingForCardRequest', moveSlackNotificationSettingForCardRequest)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{currentChannelId}/cards/notification/move`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"currentChannelId"}}`, encodeURIComponent(String(currentChannelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveSlackNotificationSettingForCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} currentChannelId 
         * @param {MoveTeamsNotificationSettingForCardRequest} moveTeamsNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTeamsNotificationSettingForCard: async (organizationId: string, currentChannelId: string, moveTeamsNotificationSettingForCardRequest: MoveTeamsNotificationSettingForCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('moveTeamsNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'currentChannelId' is not null or undefined
            assertParamExists('moveTeamsNotificationSettingForCard', 'currentChannelId', currentChannelId)
            // verify required parameter 'moveTeamsNotificationSettingForCardRequest' is not null or undefined
            assertParamExists('moveTeamsNotificationSettingForCard', 'moveTeamsNotificationSettingForCardRequest', moveTeamsNotificationSettingForCardRequest)
            const localVarPath = `/teams/organizations/{organizationId}/channels/{currentChannelId}/cards/notification/move`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"currentChannelId"}}`, encodeURIComponent(String(currentChannelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveTeamsNotificationSettingForCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Organization Create Pre Request
         * @param {OrganizationCreatePreRequestRequest} organizationCreatePreRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreatePreRequest: async (organizationCreatePreRequestRequest: OrganizationCreatePreRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationCreatePreRequestRequest' is not null or undefined
            assertParamExists('organizationCreatePreRequest', 'organizationCreatePreRequestRequest', organizationCreatePreRequestRequest)
            const localVarPath = `/organization_create_pre_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationCreatePreRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Parse organization chart for workflow
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseOrganizationChartForWorkflow: async (file: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('parseOrganizationChartForWorkflow', 'file', file)
            const localVarPath = `/workflows/parse_organization_chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Addition Merchant General Block List
         * @param {PostAdditionMerchantGeneralBlockListRequest} postAdditionMerchantGeneralBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdditionMerchantGeneralBlockList: async (postAdditionMerchantGeneralBlockListRequest: PostAdditionMerchantGeneralBlockListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postAdditionMerchantGeneralBlockListRequest' is not null or undefined
            assertParamExists('postAdditionMerchantGeneralBlockList', 'postAdditionMerchantGeneralBlockListRequest', postAdditionMerchantGeneralBlockListRequest)
            const localVarPath = `/merchant_general_block_lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAdditionMerchantGeneralBlockListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {PostAlliancesGcpApplicationsRequest} postAlliancesGcpApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlliancesGcpApplications: async (organizationId: string, postAlliancesGcpApplicationsRequest: PostAlliancesGcpApplicationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postAlliancesGcpApplications', 'organizationId', organizationId)
            // verify required parameter 'postAlliancesGcpApplicationsRequest' is not null or undefined
            assertParamExists('postAlliancesGcpApplications', 'postAlliancesGcpApplicationsRequest', postAlliancesGcpApplicationsRequest)
            const localVarPath = `/organizations/{organizationId}/alliances/gcp/applications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAlliancesGcpApplicationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {PostAlliancesGwsApplicationsRequest} postAlliancesGwsApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlliancesGwsApplications: async (organizationId: string, postAlliancesGwsApplicationsRequest: PostAlliancesGwsApplicationsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postAlliancesGwsApplications', 'organizationId', organizationId)
            // verify required parameter 'postAlliancesGwsApplicationsRequest' is not null or undefined
            assertParamExists('postAlliancesGwsApplications', 'postAlliancesGwsApplicationsRequest', postAlliancesGwsApplicationsRequest)
            const localVarPath = `/organizations/{organizationId}/alliances/gws/applications`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAlliancesGwsApplicationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Bank Account Balances
         * @param {PostBalancesRequest} postBalancesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBalances: async (postBalancesRequest: PostBalancesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postBalancesRequest' is not null or undefined
            assertParamExists('postBalances', 'postBalancesRequest', postBalancesRequest)
            const localVarPath = `/mtbankaccounts/balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postBalancesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Bulk Addition Merchant Org Block Lists
         * @param {string} organizationId 
         * @param {Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>} postBulkAdditionMerchantOrgBlockListsRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBulkAdditionMerchantOrgBlockLists: async (organizationId: string, postBulkAdditionMerchantOrgBlockListsRequestInner: Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postBulkAdditionMerchantOrgBlockLists', 'organizationId', organizationId)
            // verify required parameter 'postBulkAdditionMerchantOrgBlockListsRequestInner' is not null or undefined
            assertParamExists('postBulkAdditionMerchantOrgBlockLists', 'postBulkAdditionMerchantOrgBlockListsRequestInner', postBulkAdditionMerchantOrgBlockListsRequestInner)
            const localVarPath = `/organizations/{organizationId}/merchant_org_block_lists`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postBulkAdditionMerchantOrgBlockListsRequestInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary freee認可コールバック
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {PostCallbackFreeeAuthForAccountingRequest} [postCallbackFreeeAuthForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCallbackFreeeAuthForAccounting: async (orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, postCallbackFreeeAuthForAccountingRequest?: PostCallbackFreeeAuthForAccountingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccountId' is not null or undefined
            assertParamExists('postCallbackFreeeAuthForAccounting', 'orgAccountId', orgAccountId)
            const localVarPath = `/org_accounts/{orgAccountId}/auth/freee/callback`
                .replace(`{${"orgAccountId"}}`, encodeURIComponent(String(orgAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upsidrPrivateClientApiInternal != null) {
                localVarHeaderParameter['upsidr-private-client-api-internal'] = typeof upsidrPrivateClientApiInternal === 'string' 
                    ? upsidrPrivateClientApiInternal 
                    : JSON.stringify(upsidrPrivateClientApiInternal);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCallbackFreeeAuthForAccountingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks whether the current user is eligible for canary routing and sets appropriate cookie
         * @summary Check if user is eligible for canary routing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCanaryRoutingCheck: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/canary/routing/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post a cancel request for a evidence request
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCancelRequestForEvidenceRequest: async (organizationId: string, paymentReferenceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postCancelRequestForEvidenceRequest', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('postCancelRequestForEvidenceRequest', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/request/cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostCardsVirtualIssueRequest} postCardsVirtualIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCardsVirtualIssue: async (postCardsVirtualIssueRequest: PostCardsVirtualIssueRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postCardsVirtualIssueRequest' is not null or undefined
            assertParamExists('postCardsVirtualIssue', 'postCardsVirtualIssueRequest', postCardsVirtualIssueRequest)
            const localVarPath = `/cards/virtual/issue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCardsVirtualIssueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCardsVirtualOndemandIssue: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/virtual/ondemand/issue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload identity document file with verification information.
         * @summary Upload Identity Document
         * @param {string} onboardingRequestId Onboarding request ID
         * @param {File} file Identity document file
         * @param {string} [personalDocumentType] Type of personal identification document
         * @param {string} [verifiedBy] Name of the person who verified the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFaceToFaceKycIdentityDocument: async (onboardingRequestId: string, file: File, personalDocumentType?: string, verifiedBy?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('postFaceToFaceKycIdentityDocument', 'onboardingRequestId', onboardingRequestId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('postFaceToFaceKycIdentityDocument', 'file', file)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/face_to_face_kyc/identity_document`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (personalDocumentType !== undefined) { 
                localVarFormParams.append('personalDocumentType', personalDocumentType as any);
            }
    
            if (verifiedBy !== undefined) { 
                localVarFormParams.append('verifiedBy', verifiedBy as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a face-to-face KYC request.
         * @summary Face-to-face KYC Request
         * @param {PostFaceToFaceKycRequestRequest} postFaceToFaceKycRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFaceToFaceKycRequest: async (postFaceToFaceKycRequestRequest: PostFaceToFaceKycRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postFaceToFaceKycRequestRequest' is not null or undefined
            assertParamExists('postFaceToFaceKycRequest', 'postFaceToFaceKycRequestRequest', postFaceToFaceKycRequestRequest)
            const localVarPath = `/zeus/onboarding_requests/face_to_face_kyc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFaceToFaceKycRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Freee Account for Points
         * @param {string} organizationId 
         * @param {PostFreeeAccountForPointsRequest} postFreeeAccountForPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFreeeAccountForPoints: async (organizationId: string, postFreeeAccountForPointsRequest: PostFreeeAccountForPointsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postFreeeAccountForPoints', 'organizationId', organizationId)
            // verify required parameter 'postFreeeAccountForPointsRequest' is not null or undefined
            assertParamExists('postFreeeAccountForPoints', 'postFreeeAccountForPointsRequest', postFreeeAccountForPointsRequest)
            const localVarPath = `/organizations/{organizationId}/freee/account_for_points`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFreeeAccountForPointsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKycconsultingWebhooks: async (requestBody: { [key: string]: string; }, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('postKycconsultingWebhooks', 'requestBody', requestBody)
            const localVarPath = `/kycconsulting/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMoneytreeRefreshRequest: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postMoneytreeRefreshRequest', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/request_refresh`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request for All Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMoneytreeRefreshRequestAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/moneytree/request_refresh_all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create organizations deals
         * @param {string} organizationId 
         * @param {PostOrganizationsDealsRequest} postOrganizationsDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrganizationsDeals: async (organizationId: string, postOrganizationsDealsRequest: PostOrganizationsDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postOrganizationsDeals', 'organizationId', organizationId)
            // verify required parameter 'postOrganizationsDealsRequest' is not null or undefined
            assertParamExists('postOrganizationsDeals', 'postOrganizationsDealsRequest', postOrganizationsDealsRequest)
            const localVarPath = `/organizations/{organizationId}/deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOrganizationsDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create point claw backs
         * @param {string} organizationId 
         * @param {PostOrganizationsPointClawBacksRequest} postOrganizationsPointClawBacksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrganizationsPointClawBacks: async (organizationId: string, postOrganizationsPointClawBacksRequest: PostOrganizationsPointClawBacksRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postOrganizationsPointClawBacks', 'organizationId', organizationId)
            // verify required parameter 'postOrganizationsPointClawBacksRequest' is not null or undefined
            assertParamExists('postOrganizationsPointClawBacks', 'postOrganizationsPointClawBacksRequest', postOrganizationsPointClawBacksRequest)
            const localVarPath = `/organizations/{organizationId}/point_claw_backs`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOrganizationsPointClawBacksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post payment requests bank account
         * @param {string} organizationId 
         * @param {PostPaymentRequestsBankAccountRequest} [postPaymentRequestsBankAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRequestsBankAccount: async (organizationId: string, postPaymentRequestsBankAccountRequest?: PostPaymentRequestsBankAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postPaymentRequestsBankAccount', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_accounts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPaymentRequestsBankAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post slack message to coworker
         * @param {string} organizationId 
         * @param {PostSlackMessageToCoworkerRequest} postSlackMessageToCoworkerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSlackMessageToCoworker: async (organizationId: string, postSlackMessageToCoworkerRequest: PostSlackMessageToCoworkerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('postSlackMessageToCoworker', 'organizationId', organizationId)
            // verify required parameter 'postSlackMessageToCoworkerRequest' is not null or undefined
            assertParamExists('postSlackMessageToCoworker', 'postSlackMessageToCoworkerRequest', postSlackMessageToCoworkerRequest)
            const localVarPath = `/organizations/{organizationId}/human_coworker/message`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSlackMessageToCoworkerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Bank Account Transactions
         * @param {PostTransactionsRequest} postTransactionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactions: async (postTransactionsRequest: PostTransactionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTransactionsRequest' is not null or undefined
            assertParamExists('postTransactions', 'postTransactionsRequest', postTransactionsRequest)
            const localVarPath = `/mtbankaccounts/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTransactionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostTrustdockWebhooksRequest} postTrustdockWebhooksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrustdockWebhooks: async (postTrustdockWebhooksRequest: PostTrustdockWebhooksRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTrustdockWebhooksRequest' is not null or undefined
            assertParamExists('postTrustdockWebhooks', 'postTrustdockWebhooksRequest', postTrustdockWebhooksRequest)
            const localVarPath = `/trustdock/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTrustdockWebhooksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostTrustdockWebhooksSnailMailRequest} postTrustdockWebhooksSnailMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrustdockWebhooksSnailMail: async (postTrustdockWebhooksSnailMailRequest: PostTrustdockWebhooksSnailMailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTrustdockWebhooksSnailMailRequest' is not null or undefined
            assertParamExists('postTrustdockWebhooksSnailMail', 'postTrustdockWebhooksSnailMailRequest', postTrustdockWebhooksSnailMailRequest)
            const localVarPath = `/trustdock/webhooks/snail-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTrustdockWebhooksSnailMailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put disable feature flag
         * @param {string} organizationId 
         * @param {string} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDisableFeatureFlag: async (organizationId: string, featureName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putDisableFeatureFlag', 'organizationId', organizationId)
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists('putDisableFeatureFlag', 'featureName', featureName)
            const localVarPath = `/organizations/{organizationId}/feature/{featureName}/disable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put enabled feature flag
         * @param {string} organizationId 
         * @param {string} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEnabledFeatureFlag: async (organizationId: string, featureName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putEnabledFeatureFlag', 'organizationId', organizationId)
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists('putEnabledFeatureFlag', 'featureName', featureName)
            const localVarPath = `/organizations/{organizationId}/feature/{featureName}/enable`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Freee End Journal Entry Transition Mode
         * @param {string} organizationId 
         * @param {PutFreeeEndJournalEntryTransitionModeRequest} putFreeeEndJournalEntryTransitionModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFreeeEndJournalEntryTransitionMode: async (organizationId: string, putFreeeEndJournalEntryTransitionModeRequest: PutFreeeEndJournalEntryTransitionModeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putFreeeEndJournalEntryTransitionMode', 'organizationId', organizationId)
            // verify required parameter 'putFreeeEndJournalEntryTransitionModeRequest' is not null or undefined
            assertParamExists('putFreeeEndJournalEntryTransitionMode', 'putFreeeEndJournalEntryTransitionModeRequest', putFreeeEndJournalEntryTransitionModeRequest)
            const localVarPath = `/organizations/{organizationId}/freee/end_journal_entry_transition_mode`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putFreeeEndJournalEntryTransitionModeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Organization Payment Method
         * @param {string} organizationId 
         * @param {PutOrganizationPaymentMethodRequest} putOrganizationPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrganizationPaymentMethod: async (organizationId: string, putOrganizationPaymentMethodRequest: PutOrganizationPaymentMethodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putOrganizationPaymentMethod', 'organizationId', organizationId)
            // verify required parameter 'putOrganizationPaymentMethodRequest' is not null or undefined
            assertParamExists('putOrganizationPaymentMethod', 'putOrganizationPaymentMethodRequest', putOrganizationPaymentMethodRequest)
            const localVarPath = `/organizations/{organizationId}/payment_method`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putOrganizationPaymentMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put organizations deals
         * @param {string} organizationId 
         * @param {PutOrganizationsDealsRequest} putOrganizationsDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrganizationsDeals: async (organizationId: string, putOrganizationsDealsRequest: PutOrganizationsDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putOrganizationsDeals', 'organizationId', organizationId)
            // verify required parameter 'putOrganizationsDealsRequest' is not null or undefined
            assertParamExists('putOrganizationsDeals', 'putOrganizationsDealsRequest', putOrganizationsDealsRequest)
            const localVarPath = `/organizations/{organizationId}/deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putOrganizationsDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update payment request
         * @param {string} organizationId 
         * @param {string} [paymentRequestId] 
         * @param {PutPaymentRequestRequest} [putPaymentRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPaymentRequest: async (organizationId: string, paymentRequestId?: string, putPaymentRequestRequest?: PutPaymentRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putPaymentRequest', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putPaymentRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put payment requests bank account
         * @param {string} organizationId 
         * @param {string} bankAccountId 
         * @param {PutPaymentRequestsBankAccountRequest} [putPaymentRequestsBankAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPaymentRequestsBankAccount: async (organizationId: string, bankAccountId: string, putPaymentRequestsBankAccountRequest?: PutPaymentRequestsBankAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putPaymentRequestsBankAccount', 'organizationId', organizationId)
            // verify required parameter 'bankAccountId' is not null or undefined
            assertParamExists('putPaymentRequestsBankAccount', 'bankAccountId', bankAccountId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_accounts/{bankAccountId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"bankAccountId"}}`, encodeURIComponent(String(bankAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putPaymentRequestsBankAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put transaction evidence emails link to transaction
         * @param {PutTransactionEvidenceEmailsLinkToTransactionRequest} putTransactionEvidenceEmailsLinkToTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsLinkToTransaction: async (putTransactionEvidenceEmailsLinkToTransactionRequest: PutTransactionEvidenceEmailsLinkToTransactionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putTransactionEvidenceEmailsLinkToTransactionRequest' is not null or undefined
            assertParamExists('putTransactionEvidenceEmailsLinkToTransaction', 'putTransactionEvidenceEmailsLinkToTransactionRequest', putTransactionEvidenceEmailsLinkToTransactionRequest)
            const localVarPath = `/transaction_evidence_emails/link_to_transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTransactionEvidenceEmailsLinkToTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put transaction evidence emails mark as read
         * @param {PutTransactionEvidenceEmailsMarkAsReadRequest} putTransactionEvidenceEmailsMarkAsReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsMarkAsRead: async (putTransactionEvidenceEmailsMarkAsReadRequest: PutTransactionEvidenceEmailsMarkAsReadRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putTransactionEvidenceEmailsMarkAsReadRequest' is not null or undefined
            assertParamExists('putTransactionEvidenceEmailsMarkAsRead', 'putTransactionEvidenceEmailsMarkAsReadRequest', putTransactionEvidenceEmailsMarkAsReadRequest)
            const localVarPath = `/transaction_evidence_emails/mark_as_read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTransactionEvidenceEmailsMarkAsReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put transaction evidence emails move to trash
         * @param {PutTransactionEvidenceEmailsMoveToTrashRequest} putTransactionEvidenceEmailsMoveToTrashRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsMoveToTrash: async (putTransactionEvidenceEmailsMoveToTrashRequest: PutTransactionEvidenceEmailsMoveToTrashRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putTransactionEvidenceEmailsMoveToTrashRequest' is not null or undefined
            assertParamExists('putTransactionEvidenceEmailsMoveToTrash', 'putTransactionEvidenceEmailsMoveToTrashRequest', putTransactionEvidenceEmailsMoveToTrashRequest)
            const localVarPath = `/transaction_evidence_emails/move_to_trash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTransactionEvidenceEmailsMoveToTrashRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Give reward point to organization
         * @param {string} organizationId 
         * @param {PutZeusGiveRewardPointsRequest} putZeusGiveRewardPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putZeusGiveRewardPoints: async (organizationId: string, putZeusGiveRewardPointsRequest: PutZeusGiveRewardPointsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('putZeusGiveRewardPoints', 'organizationId', organizationId)
            // verify required parameter 'putZeusGiveRewardPointsRequest' is not null or undefined
            assertParamExists('putZeusGiveRewardPoints', 'putZeusGiveRewardPointsRequest', putZeusGiveRewardPointsRequest)
            const localVarPath = `/zeus/organizations/{organizationId}/give_reward_points`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putZeusGiveRewardPointsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query by ids payment requests
         * @param {string} organizationId 
         * @param {QueryByIdsPaymentRequestsRequest} [queryByIdsPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryByIdsPaymentRequests: async (organizationId: string, queryByIdsPaymentRequestsRequest?: QueryByIdsPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('queryByIdsPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/query_by_ids`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryByIdsPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update read status of a message
         * @param {string} userMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUserMessage: async (userMessageId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMessageId' is not null or undefined
            assertParamExists('readUserMessage', 'userMessageId', userMessageId)
            const localVarPath = `/user_messages/{userMessageId}/read`
                .replace(`{${"userMessageId"}}`, encodeURIComponent(String(userMessageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary register note
         * @param {string} onboardingRequestId The ID of the onboarding request to retrieve
         * @param {RegisterNoteRequest} [registerNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNote: async (onboardingRequestId: string, registerNoteRequest?: RegisterNoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('registerNote', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/register_note`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register note for organization identity verification
         * @param {number} organizationIdentityVerificationId 
         * @param {RegisterNoteForOrganizationIdentityVerificationRequest} registerNoteForOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNoteForOrganizationIdentityVerification: async (organizationIdentityVerificationId: number, registerNoteForOrganizationIdentityVerificationRequest: RegisterNoteForOrganizationIdentityVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('registerNoteForOrganizationIdentityVerification', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            // verify required parameter 'registerNoteForOrganizationIdentityVerificationRequest' is not null or undefined
            assertParamExists('registerNoteForOrganizationIdentityVerification', 'registerNoteForOrganizationIdentityVerificationRequest', registerNoteForOrganizationIdentityVerificationRequest)
            const localVarPath = `/organization_identity_verifications/{organizationIdentityVerificationId}/register_note`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerNoteForOrganizationIdentityVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register an organization using the onboarding request ID
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerOrganization: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('registerOrganization', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/register_organization`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register organization chart for workflow
         * @param {string} organizationId 
         * @param {RegisterOrganizationChartForWorkflowRequest} [registerOrganizationChartForWorkflowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerOrganizationChartForWorkflow: async (organizationId: string, registerOrganizationChartForWorkflowRequest?: RegisterOrganizationChartForWorkflowRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('registerOrganizationChartForWorkflow', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/workflows/organization_charts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerOrganizationChartForWorkflowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register Tfa App Verification Code
         * @param {RegisterTfaAppVerificationCodeRequest} registerTfaAppVerificationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaAppVerificationCode: async (registerTfaAppVerificationCodeRequest: RegisterTfaAppVerificationCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerTfaAppVerificationCodeRequest' is not null or undefined
            assertParamExists('registerTfaAppVerificationCode', 'registerTfaAppVerificationCodeRequest', registerTfaAppVerificationCodeRequest)
            const localVarPath = `/two_factor_auth/app/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerTfaAppVerificationCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register Tfa SMS Auth
         * @param {RegisterTfaSmsAuthRequest} registerTfaSmsAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaSmsAuth: async (registerTfaSmsAuthRequest: RegisterTfaSmsAuthRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerTfaSmsAuthRequest' is not null or undefined
            assertParamExists('registerTfaSmsAuth', 'registerTfaSmsAuthRequest', registerTfaSmsAuthRequest)
            const localVarPath = `/two_factor_auth/sms/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerTfaSmsAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register transaction evidence email address
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTransactionEvidenceEmailAddress: async (userAccountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('registerTransactionEvidenceEmailAddress', 'userAccountId', userAccountId)
            const localVarPath = `/user_accounts/{userAccountId}/transaction_evidence_email_address`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reissue a card
         * @param {string} cardId 
         * @param {ReissueCardRequest} reissueCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueCard: async (cardId: string, reissueCardRequest: ReissueCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('reissueCard', 'cardId', cardId)
            // verify required parameter 'reissueCardRequest' is not null or undefined
            assertParamExists('reissueCard', 'reissueCardRequest', reissueCardRequest)
            const localVarPath = `/cards/{cardId}/reissue_request`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reissueCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject Organization Identity Verification
         * @param {number} organizationIdentityVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrganizationIdentityVerification: async (organizationIdentityVerificationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('rejectOrganizationIdentityVerification', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            const localVarPath = `/organization_identity_verifications/{organizationIdentityVerificationId}/reject`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {RejectPurchaseApplicationRequest} rejectPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectPurchaseApplication: async (organizationId: string, purchaseApplicationId: string, rejectPurchaseApplicationRequest: RejectPurchaseApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rejectPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('rejectPurchaseApplication', 'purchaseApplicationId', purchaseApplicationId)
            // verify required parameter 'rejectPurchaseApplicationRequest' is not null or undefined
            assertParamExists('rejectPurchaseApplication', 'rejectPurchaseApplicationRequest', rejectPurchaseApplicationRequest)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}/reject`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectPurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindCardTransactionEvidence: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/transactions/evidence/remind`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remind monthly payment notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindMonthlyPaymentNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments/remind_notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remind organization monthly payment notifications.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindOrganizationMonthlyPaymentNotification: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('remindOrganizationMonthlyPaymentNotification', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payments/remind_notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove fraud lock status
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFraudLockStatus: async (cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('removeFraudLockStatus', 'cardId', cardId)
            const localVarPath = `/cards/{cardId}/remove_fraud_lock_status`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename user account group
         * @param {number} userAccountGroupId 
         * @param {RenameUserAccountGroupRequest} renameUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameUserAccountGroup: async (userAccountGroupId: number, renameUserAccountGroupRequest: RenameUserAccountGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountGroupId' is not null or undefined
            assertParamExists('renameUserAccountGroup', 'userAccountGroupId', userAccountGroupId)
            // verify required parameter 'renameUserAccountGroupRequest' is not null or undefined
            assertParamExists('renameUserAccountGroup', 'renameUserAccountGroupRequest', renameUserAccountGroupRequest)
            const localVarPath = `/user_account_groups/{userAccountGroupId}/rename`
                .replace(`{${"userAccountGroupId"}}`, encodeURIComponent(String(userAccountGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameUserAccountGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace Virtual Card
         * @param {string} userAccountId 
         * @param {ReplaceVirtualCardRequest} replaceVirtualCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceVirtualCard: async (userAccountId: string, replaceVirtualCardRequest: ReplaceVirtualCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('replaceVirtualCard', 'userAccountId', userAccountId)
            // verify required parameter 'replaceVirtualCardRequest' is not null or undefined
            assertParamExists('replaceVirtualCard', 'replaceVirtualCardRequest', replaceVirtualCardRequest)
            const localVarPath = `/user_accounts/{userAccountId}/cards/virtual/replace`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceVirtualCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request add system admin role
         * @param {string} userId 
         * @param {RequestAddSystemAdminRoleRequest} requestAddSystemAdminRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAddSystemAdminRole: async (userId: string, requestAddSystemAdminRoleRequest: RequestAddSystemAdminRoleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('requestAddSystemAdminRole', 'userId', userId)
            // verify required parameter 'requestAddSystemAdminRoleRequest' is not null or undefined
            assertParamExists('requestAddSystemAdminRole', 'requestAddSystemAdminRoleRequest', requestAddSystemAdminRoleRequest)
            const localVarPath = `/users/{userId}/roles/system`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestAddSystemAdminRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request sending physical cards
         * @param {string} organizationId 
         * @param {RequestSendingRequest} requestSendingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSending: async (organizationId: string, requestSendingRequest: RequestSendingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('requestSending', 'organizationId', organizationId)
            // verify required parameter 'requestSendingRequest' is not null or undefined
            assertParamExists('requestSending', 'requestSendingRequest', requestSendingRequest)
            const localVarPath = `/organizations/{organizationId}/cards/request_sending`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSendingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request sending a metal card
         * @param {string} organizationId 
         * @param {RequestSendingMetalCardRequest} requestSendingMetalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSendingMetalCard: async (organizationId: string, requestSendingMetalCardRequest: RequestSendingMetalCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('requestSendingMetalCard', 'organizationId', organizationId)
            // verify required parameter 'requestSendingMetalCardRequest' is not null or undefined
            assertParamExists('requestSendingMetalCard', 'requestSendingMetalCardRequest', requestSendingMetalCardRequest)
            const localVarPath = `/organizations/{organizationId}/cards/metal/request_sending`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSendingMetalCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ポイント明細の同期リクエスト
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {RequestSyncBankTransactionsToFreeeForAccountingRequest} [requestSyncBankTransactionsToFreeeForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSyncBankTransactionsToFreeeForAccounting: async (orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, requestSyncBankTransactionsToFreeeForAccountingRequest?: RequestSyncBankTransactionsToFreeeForAccountingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccountId' is not null or undefined
            assertParamExists('requestSyncBankTransactionsToFreeeForAccounting', 'orgAccountId', orgAccountId)
            const localVarPath = `/org_accounts/{orgAccountId}/bank/transactions/freee/synchronization/requests`
                .replace(`{${"orgAccountId"}}`, encodeURIComponent(String(orgAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upsidrPrivateClientApiInternal != null) {
                localVarHeaderParameter['upsidr-private-client-api-internal'] = typeof upsidrPrivateClientApiInternal === 'string' 
                    ? upsidrPrivateClientApiInternal 
                    : JSON.stringify(upsidrPrivateClientApiInternal);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSyncBankTransactionsToFreeeForAccountingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 決済明細の同期リクエスト
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {RequestSyncCardTransactionsToFreeeForAccountingRequest} [requestSyncCardTransactionsToFreeeForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSyncCardTransactionsToFreeeForAccounting: async (orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, requestSyncCardTransactionsToFreeeForAccountingRequest?: RequestSyncCardTransactionsToFreeeForAccountingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccountId' is not null or undefined
            assertParamExists('requestSyncCardTransactionsToFreeeForAccounting', 'orgAccountId', orgAccountId)
            const localVarPath = `/org_accounts/{orgAccountId}/cards/transactions/freee/synchronization/requests`
                .replace(`{${"orgAccountId"}}`, encodeURIComponent(String(orgAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upsidrPrivateClientApiInternal != null) {
                localVarHeaderParameter['upsidr-private-client-api-internal'] = typeof upsidrPrivateClientApiInternal === 'string' 
                    ? upsidrPrivateClientApiInternal 
                    : JSON.stringify(upsidrPrivateClientApiInternal);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSyncCardTransactionsToFreeeForAccountingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSyncingClearedTransaction: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/request_syncing_cleared_transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request to Generate Organizations Accounting Csv in Background
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestToOrganizationsAccountingCsvInBackground: async (organizationId: string, yearMonth: string, isMergedFiles: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('requestToOrganizationsAccountingCsvInBackground', 'organizationId', organizationId)
            // verify required parameter 'yearMonth' is not null or undefined
            assertParamExists('requestToOrganizationsAccountingCsvInBackground', 'yearMonth', yearMonth)
            // verify required parameter 'isMergedFiles' is not null or undefined
            assertParamExists('requestToOrganizationsAccountingCsvInBackground', 'isMergedFiles', isMergedFiles)
            const localVarPath = `/organizations/{organizationId}/cards/accounting/download_csv/background_generate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (yearMonth !== undefined) {
                localVarQueryParameter['yearMonth'] = yearMonth;
            }

            if (isMergedFiles !== undefined) {
                localVarQueryParameter['isMergedFiles'] = isMergedFiles;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request update system admin role
         * @param {string} userId 
         * @param {RequestUpdateSystemAdminRoleRequest} requestUpdateSystemAdminRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUpdateSystemAdminRole: async (userId: string, requestUpdateSystemAdminRoleRequest: RequestUpdateSystemAdminRoleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('requestUpdateSystemAdminRole', 'userId', userId)
            // verify required parameter 'requestUpdateSystemAdminRoleRequest' is not null or undefined
            assertParamExists('requestUpdateSystemAdminRole', 'requestUpdateSystemAdminRoleRequest', requestUpdateSystemAdminRoleRequest)
            const localVarPath = `/users/{userId}/roles/system`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestUpdateSystemAdminRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend Snail Mail For Organization Identity Verification
         * @param {number} organizationIdentityVerificationId 
         * @param {ResendSnailMailForOrganizationIdentityVerificationRequest} resendSnailMailForOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendSnailMailForOrganizationIdentityVerification: async (organizationIdentityVerificationId: number, resendSnailMailForOrganizationIdentityVerificationRequest: ResendSnailMailForOrganizationIdentityVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('resendSnailMailForOrganizationIdentityVerification', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            // verify required parameter 'resendSnailMailForOrganizationIdentityVerificationRequest' is not null or undefined
            assertParamExists('resendSnailMailForOrganizationIdentityVerification', 'resendSnailMailForOrganizationIdentityVerificationRequest', resendSnailMailForOrganizationIdentityVerificationRequest)
            const localVarPath = `/organization_identity_verifications/{organizationIdentityVerificationId}/resend_snail_mail`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendSnailMailForOrganizationIdentityVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend an invitation to a new user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserInvite: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resendUserInvite', 'userId', userId)
            const localVarPath = `/users/{userId}/resend_invite`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resume a suspended card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeCard: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('resumeCard', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('resumeCard', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/resume`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resynchronize card transactions for freee
         * @param {string} organizationId 
         * @param {ResynchronizeCardTransactionsForFreeeRequest} resynchronizeCardTransactionsForFreeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resynchronizeCardTransactionsForFreee: async (organizationId: string, resynchronizeCardTransactionsForFreeeRequest: ResynchronizeCardTransactionsForFreeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('resynchronizeCardTransactionsForFreee', 'organizationId', organizationId)
            // verify required parameter 'resynchronizeCardTransactionsForFreeeRequest' is not null or undefined
            assertParamExists('resynchronizeCardTransactionsForFreee', 'resynchronizeCardTransactionsForFreeeRequest', resynchronizeCardTransactionsForFreeeRequest)
            const localVarPath = `/organizations/{organizationId}/cards/request_resynchronizing_all_transaction`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resynchronizeCardTransactionsForFreeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deal as draft
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {SaveDealAsDraftRequest} saveDealAsDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsDraft: async (organizationId: string, dealId: string, saveDealAsDraftRequest: SaveDealAsDraftRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealAsDraft', 'organizationId', organizationId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('saveDealAsDraft', 'dealId', dealId)
            // verify required parameter 'saveDealAsDraftRequest' is not null or undefined
            assertParamExists('saveDealAsDraft', 'saveDealAsDraftRequest', saveDealAsDraftRequest)
            const localVarPath = `/organizations/{organizationId}/deals/{dealId}/draft`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealAsDraftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save Deal As Ignore
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsIgnore: async (organizationId: string, dealId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealAsIgnore', 'organizationId', organizationId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('saveDealAsIgnore', 'dealId', dealId)
            const localVarPath = `/organizations/{organizationId}/deals/{dealId}/ignore`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deal as return to editing
         * @param {string} organizationId 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsReturnToEditing: async (organizationId: string, dealId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealAsReturnToEditing', 'organizationId', organizationId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('saveDealAsReturnToEditing', 'dealId', dealId)
            const localVarPath = `/organizations/{organizationId}/deals/{dealId}/return_to_editing`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deal with journalizing
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {SaveDealWithJournalizingRequest} saveDealWithJournalizingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealWithJournalizing: async (organizationId: string, dealId: string, saveDealWithJournalizingRequest: SaveDealWithJournalizingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealWithJournalizing', 'organizationId', organizationId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('saveDealWithJournalizing', 'dealId', dealId)
            // verify required parameter 'saveDealWithJournalizingRequest' is not null or undefined
            assertParamExists('saveDealWithJournalizing', 'saveDealWithJournalizingRequest', saveDealWithJournalizingRequest)
            const localVarPath = `/organizations/{organizationId}/deals/{dealId}/journalize`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealWithJournalizingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deals as ignore
         * @param {string} organizationId 
         * @param {SaveDealsAsIgnoreRequest} saveDealsAsIgnoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsIgnore: async (organizationId: string, saveDealsAsIgnoreRequest: SaveDealsAsIgnoreRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealsAsIgnore', 'organizationId', organizationId)
            // verify required parameter 'saveDealsAsIgnoreRequest' is not null or undefined
            assertParamExists('saveDealsAsIgnore', 'saveDealsAsIgnoreRequest', saveDealsAsIgnoreRequest)
            const localVarPath = `/organizations/{organizationId}/deals/ignore`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealsAsIgnoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deals as journalized
         * @param {string} organizationId 
         * @param {SaveDealsAsJournalizedRequest} saveDealsAsJournalizedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsJournalized: async (organizationId: string, saveDealsAsJournalizedRequest: SaveDealsAsJournalizedRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealsAsJournalized', 'organizationId', organizationId)
            // verify required parameter 'saveDealsAsJournalizedRequest' is not null or undefined
            assertParamExists('saveDealsAsJournalized', 'saveDealsAsJournalizedRequest', saveDealsAsJournalizedRequest)
            const localVarPath = `/organizations/{organizationId}/deals/journalized`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealsAsJournalizedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deals as return to editing
         * @param {number} organizationId 
         * @param {SaveDealsAsReturnToEditingRequest} saveDealsAsReturnToEditingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsReturnToEditing: async (organizationId: number, saveDealsAsReturnToEditingRequest: SaveDealsAsReturnToEditingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('saveDealsAsReturnToEditing', 'organizationId', organizationId)
            // verify required parameter 'saveDealsAsReturnToEditingRequest' is not null or undefined
            assertParamExists('saveDealsAsReturnToEditing', 'saveDealsAsReturnToEditingRequest', saveDealsAsReturnToEditingRequest)
            const localVarPath = `/organizations/{organizationId}/deals/return_to_editing`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveDealsAsReturnToEditingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search bank transfers
         * @param {string} organizationId 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankTransfers: async (organizationId: string, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchBankTransfers', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/bank_transfers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (transferDateJstFrom !== undefined) {
                localVarQueryParameter['transferDateJstFrom'] = transferDateJstFrom;
            }

            if (transferDateJstTo !== undefined) {
                localVarQueryParameter['transferDateJstTo'] = transferDateJstTo;
            }

            if (sourceBankAccountId !== undefined) {
                localVarQueryParameter['sourceBankAccountId'] = sourceBankAccountId;
            }

            if (downloaded !== undefined) {
                localVarQueryParameter['downloaded'] = downloaded;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Corporations In National Tax Agency
         * @param {string} [name] 
         * @param {'PREFIX_MATCH' | 'PARTIAL_MATCH' | ''} [searchMethod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorporationsInNationalTaxAgency: async (name?: string, searchMethod?: 'PREFIX_MATCH' | 'PARTIAL_MATCH' | '', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/corporation_provided_national_tax_agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (searchMethod !== undefined) {
                localVarQueryParameter['searchMethod'] = searchMethod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search deals
         * @param {string} organizationId 
         * @param {SearchDealsRequest} [searchDealsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeals: async (organizationId: string, searchDealsRequest?: SearchDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchDeals', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/search_deals`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search evidences
         * @param {string} organizationId 
         * @param {string} [issuer] This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
         * @param {number} [amountMin] 
         * @param {number} [amountMax] 
         * @param {string} [paidAtFrom] 
         * @param {string} [paidAtTo] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {string} [keyword] Specified keyword is searched from the issuer and the note by partial match.
         * @param {boolean} [includesDeleted] 
         * @param {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>} [legalValidities] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEvidences: async (organizationId: string, issuer?: string, amountMin?: number, amountMax?: number, paidAtFrom?: string, paidAtTo?: string, irrelevantToLedger?: boolean, keyword?: string, includesDeleted?: boolean, legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchEvidences', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/evidences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (issuer !== undefined) {
                localVarQueryParameter['issuer'] = issuer;
            }

            if (amountMin !== undefined) {
                localVarQueryParameter['amountMin'] = amountMin;
            }

            if (amountMax !== undefined) {
                localVarQueryParameter['amountMax'] = amountMax;
            }

            if (paidAtFrom !== undefined) {
                localVarQueryParameter['paidAtFrom'] = (paidAtFrom as any instanceof Date) ?
                    (paidAtFrom as any).toISOString() :
                    paidAtFrom;
            }

            if (paidAtTo !== undefined) {
                localVarQueryParameter['paidAtTo'] = (paidAtTo as any instanceof Date) ?
                    (paidAtTo as any).toISOString() :
                    paidAtTo;
            }

            if (irrelevantToLedger !== undefined) {
                localVarQueryParameter['irrelevantToLedger'] = irrelevantToLedger;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (includesDeleted !== undefined) {
                localVarQueryParameter['includesDeleted'] = includesDeleted;
            }

            if (legalValidities) {
                localVarQueryParameter['legalValidities'] = legalValidities;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search my payment requests
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {string} [requestedDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
         * @param {string} [requestedDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMyPaymentRequests: async (organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, requestedDateJstFrom?: string, requestedDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', freeWord?: string, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchMyPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/self`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dueDateJstFrom !== undefined) {
                localVarQueryParameter['dueDateJstFrom'] = dueDateJstFrom;
            }

            if (dueDateJstTo !== undefined) {
                localVarQueryParameter['dueDateJstTo'] = dueDateJstTo;
            }

            if (requestedDateJstFrom !== undefined) {
                localVarQueryParameter['requestedDateJstFrom'] = requestedDateJstFrom;
            }

            if (requestedDateJstTo !== undefined) {
                localVarQueryParameter['requestedDateJstTo'] = requestedDateJstTo;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (transferDataCreated !== undefined) {
                localVarQueryParameter['transferDataCreated'] = transferDataCreated;
            }

            if (withholdingApplied !== undefined) {
                localVarQueryParameter['withholdingApplied'] = withholdingApplied;
            }

            if (transferFeeResponsibility !== undefined) {
                localVarQueryParameter['transferFeeResponsibility'] = transferFeeResponsibility;
            }

            if (freeWord !== undefined) {
                localVarQueryParameter['freeWord'] = freeWord;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Organizations
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizations: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('searchOrganizations', 'key', key)
            const localVarPath = `/organizations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search payment requests
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {string} [requestedDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
         * @param {string} [requestedDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [requestorId] Filter the payment requests by the specified requestor id.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPaymentRequests: async (organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, requestedDateJstFrom?: string, requestedDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', requestorId?: string, freeWord?: string, limit?: number, offset?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('searchPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dueDateJstFrom !== undefined) {
                localVarQueryParameter['dueDateJstFrom'] = dueDateJstFrom;
            }

            if (dueDateJstTo !== undefined) {
                localVarQueryParameter['dueDateJstTo'] = dueDateJstTo;
            }

            if (requestedDateJstFrom !== undefined) {
                localVarQueryParameter['requestedDateJstFrom'] = requestedDateJstFrom;
            }

            if (requestedDateJstTo !== undefined) {
                localVarQueryParameter['requestedDateJstTo'] = requestedDateJstTo;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (transferDataCreated !== undefined) {
                localVarQueryParameter['transferDataCreated'] = transferDataCreated;
            }

            if (withholdingApplied !== undefined) {
                localVarQueryParameter['withholdingApplied'] = withholdingApplied;
            }

            if (transferFeeResponsibility !== undefined) {
                localVarQueryParameter['transferFeeResponsibility'] = transferFeeResponsibility;
            }

            if (requestorId !== undefined) {
                localVarQueryParameter['requestorId'] = requestorId;
            }

            if (freeWord !== undefined) {
                localVarQueryParameter['freeWord'] = freeWord;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send back onboarding request
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBackOnboardingRequest: async (onboardingRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingRequestId' is not null or undefined
            assertParamExists('sendBackOnboardingRequest', 'onboardingRequestId', onboardingRequestId)
            const localVarPath = `/zeus/onboarding_requests/{onboardingRequestId}/send_back`
                .replace(`{${"onboardingRequestId"}}`, encodeURIComponent(String(onboardingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send changed credit notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChangedCreditNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/send_changed_credit_notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Organization Identity Verification
         * @param {string} organizationId 
         * @param {SendOrganizationIdentityVerificationRequest} sendOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOrganizationIdentityVerification: async (organizationId: string, sendOrganizationIdentityVerificationRequest: SendOrganizationIdentityVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sendOrganizationIdentityVerification', 'organizationId', organizationId)
            // verify required parameter 'sendOrganizationIdentityVerificationRequest' is not null or undefined
            assertParamExists('sendOrganizationIdentityVerification', 'sendOrganizationIdentityVerificationRequest', sendOrganizationIdentityVerificationRequest)
            const localVarPath = `/organizations/{organizationId}/apply_identity_verification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOrganizationIdentityVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send two-factor authentication reset link as admin
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTfaResetLinkAsAdmin: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('sendTfaResetLinkAsAdmin', 'userId', userId)
            const localVarPath = `/users/{userId}/two_factor_auth/send_reset_link_as_admin`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send Transaction Authorization Request
         * @param {string} organizationId 
         * @param {SendTransactionAuthorizationRequestRequest} sendTransactionAuthorizationRequestRequest 
         * @param {string} [cardId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTransactionAuthorizationRequest: async (organizationId: string, sendTransactionAuthorizationRequestRequest: SendTransactionAuthorizationRequestRequest, cardId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('sendTransactionAuthorizationRequest', 'organizationId', organizationId)
            // verify required parameter 'sendTransactionAuthorizationRequestRequest' is not null or undefined
            assertParamExists('sendTransactionAuthorizationRequest', 'sendTransactionAuthorizationRequestRequest', sendTransactionAuthorizationRequestRequest)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/transaction_authorization_request`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendTransactionAuthorizationRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable or disable accounting integration
         * @param {string} organizationId 
         * @param {SetAccountingActivationRequest} setAccountingActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAccountingActivation: async (organizationId: string, setAccountingActivationRequest: SetAccountingActivationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('setAccountingActivation', 'organizationId', organizationId)
            // verify required parameter 'setAccountingActivationRequest' is not null or undefined
            assertParamExists('setAccountingActivation', 'setAccountingActivationRequest', setAccountingActivationRequest)
            const localVarPath = `/organizations/{organizationId}/accounting`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAccountingActivationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sign Up For Slack
         * @param {SignUpForSlackRequest} signUpForSlackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpForSlack: async (signUpForSlackRequest: SignUpForSlackRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signUpForSlackRequest' is not null or undefined
            assertParamExists('signUpForSlack', 'signUpForSlackRequest', signUpForSlackRequest)
            const localVarPath = `/slack/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signUpForSlackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit completed workflow of draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {SubmitCompletedWorkflowOfDraftPaymentRequestsRequest} [submitCompletedWorkflowOfDraftPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompletedWorkflowOfDraftPaymentRequests: async (organizationId: string, draftPaymentRequestId: string, xUpsidrSwitchUser?: string, submitCompletedWorkflowOfDraftPaymentRequestsRequest?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('submitCompletedWorkflowOfDraftPaymentRequests', 'organizationId', organizationId)
            // verify required parameter 'draftPaymentRequestId' is not null or undefined
            assertParamExists('submitCompletedWorkflowOfDraftPaymentRequests', 'draftPaymentRequestId', draftPaymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/drafts/{draftPaymentRequestId}/submit_completed`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"draftPaymentRequestId"}}`, encodeURIComponent(String(draftPaymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitCompletedWorkflowOfDraftPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit completed workflow of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {SubmitCompletedWorkflowOfPaymentRequestsRequest} [submitCompletedWorkflowOfPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompletedWorkflowOfPaymentRequests: async (organizationId: string, xUpsidrSwitchUser?: string, submitCompletedWorkflowOfPaymentRequestsRequest?: SubmitCompletedWorkflowOfPaymentRequestsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('submitCompletedWorkflowOfPaymentRequests', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/submit_completed`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitCompletedWorkflowOfPaymentRequestsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit workflow
         * @param {string} organizationId 
         * @param {string} workflowInstanceId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWorkflow: async (organizationId: string, workflowInstanceId: string, xUpsidrSwitchUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('submitWorkflow', 'organizationId', organizationId)
            // verify required parameter 'workflowInstanceId' is not null or undefined
            assertParamExists('submitWorkflow', 'workflowInstanceId', workflowInstanceId)
            const localVarPath = `/organizations/{organizationId}/workflows/instances/{workflowInstanceId}/submit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"workflowInstanceId"}}`, encodeURIComponent(String(workflowInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xUpsidrSwitchUser != null) {
                localVarHeaderParameter['X-Upsidr-Switch-User'] = String(xUpsidrSwitchUser);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Suspend a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendCard: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('suspendCard', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('suspendCard', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/suspend`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllCardStatuses: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cards/sync_card_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync all users to each marketing tools
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllUsersToEachMarketingTools: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/marketing/sync_all_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync freee account items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeeAccountItems: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncFreeeAccountItems', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('syncFreeeAccountItems', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/account_items/sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync freee partners
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeePartners: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncFreeePartners', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('syncFreeePartners', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/partners/sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync freee segment tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeeSegmentTags: async (organizationId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncFreeeSegmentTags', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('syncFreeeSegmentTags', 'companyId', companyId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/segment_tags/sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Moneytree access token
         * @param {string} code Authorization code received from Moneytree after successful authentication.
         * @param {string} state OAuth state parameter to ensure request consistency.
         * @param {string} [nextTo] URL to redirect to after syncing access token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMoneytreeAccessToken: async (code: string, state: string, nextTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('syncMoneytreeAccessToken', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('syncMoneytreeAccessToken', 'state', state)
            const localVarPath = `/moneytree/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (nextTo !== undefined) {
                localVarQueryParameter['next_to'] = nextTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync point usage to accounting service
         * @param {string} organizationId 
         * @param {SyncPointUsageToAccountingServiceRequest} syncPointUsageToAccountingServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPointUsageToAccountingService: async (organizationId: string, syncPointUsageToAccountingServiceRequest: SyncPointUsageToAccountingServiceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncPointUsageToAccountingService', 'organizationId', organizationId)
            // verify required parameter 'syncPointUsageToAccountingServiceRequest' is not null or undefined
            assertParamExists('syncPointUsageToAccountingService', 'syncPointUsageToAccountingServiceRequest', syncPointUsageToAccountingServiceRequest)
            const localVarPath = `/organizations/{organizationId}/accounting/points/sync`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncPointUsageToAccountingServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Request for Freee Deals
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {SyncRequestForFreeeDealsRequest} syncRequestForFreeeDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestForFreeeDeals: async (organizationId: string, companyId: string, syncRequestForFreeeDealsRequest: SyncRequestForFreeeDealsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('syncRequestForFreeeDeals', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('syncRequestForFreeeDeals', 'companyId', companyId)
            // verify required parameter 'syncRequestForFreeeDealsRequest' is not null or undefined
            assertParamExists('syncRequestForFreeeDeals', 'syncRequestForFreeeDealsRequest', syncRequestForFreeeDealsRequest)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/deals/request_sync_to_freee`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRequestForFreeeDealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Two Factor Auth Reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthReset: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/two_factor_auth/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Two Factor Auth Reset As Token
         * @param {TwoFactorAuthResetAsTokenRequest} twoFactorAuthResetAsTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthResetAsToken: async (twoFactorAuthResetAsTokenRequest: TwoFactorAuthResetAsTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'twoFactorAuthResetAsTokenRequest' is not null or undefined
            assertParamExists('twoFactorAuthResetAsToken', 'twoFactorAuthResetAsTokenRequest', twoFactorAuthResetAsTokenRequest)
            const localVarPath = `/users/two_factor_auth/reset_as_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(twoFactorAuthResetAsTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlinking purchase to transaction.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkingPurchaseToTransaction: async (organizationId: string, purchaseApplicationId: string, visaTransactionReferenceId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unlinkingPurchaseToTransaction', 'organizationId', organizationId)
            // verify required parameter 'purchaseApplicationId' is not null or undefined
            assertParamExists('unlinkingPurchaseToTransaction', 'purchaseApplicationId', purchaseApplicationId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/{purchaseApplicationId}/unlink`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseApplicationId"}}`, encodeURIComponent(String(purchaseApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (visaTransactionReferenceId !== undefined) {
                localVarQueryParameter['visaTransactionReferenceId'] = visaTransactionReferenceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlock a card due to no potential fraud
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockCardForNotPotentialFraud: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unlockCardForNotPotentialFraud', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('unlockCardForNotPotentialFraud', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/unlock_for_potential_fraud`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlock a card due to fraud cleared
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {string} triggeredTransactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockCardOnFraudCleared: async (organizationId: string, cardId: string, triggeredTransactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('unlockCardOnFraudCleared', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('unlockCardOnFraudCleared', 'cardId', cardId)
            // verify required parameter 'triggeredTransactionId' is not null or undefined
            assertParamExists('unlockCardOnFraudCleared', 'triggeredTransactionId', triggeredTransactionId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/unlock_on_fraud_cleared`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (triggeredTransactionId !== undefined) {
                localVarQueryParameter['triggeredTransactionId'] = triggeredTransactionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Available Currencies
         * @param {string} userAccountId 
         * @param {UpdateAvailableCurrenciesRequest} updateAvailableCurrenciesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableCurrencies: async (userAccountId: string, updateAvailableCurrenciesRequest: UpdateAvailableCurrenciesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateAvailableCurrencies', 'userAccountId', userAccountId)
            // verify required parameter 'updateAvailableCurrenciesRequest' is not null or undefined
            assertParamExists('updateAvailableCurrencies', 'updateAvailableCurrenciesRequest', updateAvailableCurrenciesRequest)
            const localVarPath = `/user_accounts/{userAccountId}/available_currencies`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvailableCurrenciesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Available Merchant Categories
         * @param {string} userAccountId 
         * @param {UpdateAvailableMerchantCategoriesRequest} updateAvailableMerchantCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableMerchantCategories: async (userAccountId: string, updateAvailableMerchantCategoriesRequest: UpdateAvailableMerchantCategoriesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateAvailableMerchantCategories', 'userAccountId', userAccountId)
            // verify required parameter 'updateAvailableMerchantCategoriesRequest' is not null or undefined
            assertParamExists('updateAvailableMerchantCategories', 'updateAvailableMerchantCategoriesRequest', updateAvailableMerchantCategoriesRequest)
            const localVarPath = `/user_accounts/{userAccountId}/available_merchant_categories`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvailableMerchantCategoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update card account unit
         * @param {string} organizationId 
         * @param {UpdateCardAccountUnitRequest} updateCardAccountUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardAccountUnit: async (organizationId: string, updateCardAccountUnitRequest: UpdateCardAccountUnitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCardAccountUnit', 'organizationId', organizationId)
            // verify required parameter 'updateCardAccountUnitRequest' is not null or undefined
            assertParamExists('updateCardAccountUnit', 'updateCardAccountUnitRequest', updateCardAccountUnitRequest)
            const localVarPath = `/organizations/{organizationId}/freee/set_card_account_unit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCardAccountUnitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Card Count Limit
         * @param {string} organizationId 
         * @param {UpdateCardCountLimitRequest} updateCardCountLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardCountLimit: async (organizationId: string, updateCardCountLimitRequest: UpdateCardCountLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCardCountLimit', 'organizationId', organizationId)
            // verify required parameter 'updateCardCountLimitRequest' is not null or undefined
            assertParamExists('updateCardCountLimit', 'updateCardCountLimitRequest', updateCardCountLimitRequest)
            const localVarPath = `/organizations/{organizationId}/card_count_limit`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCardCountLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update card holder for the user account
         * @param {string} userAccountId 
         * @param {UpdateCardHolderRequest} updateCardHolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardHolder: async (userAccountId: string, updateCardHolderRequest: UpdateCardHolderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateCardHolder', 'userAccountId', userAccountId)
            // verify required parameter 'updateCardHolderRequest' is not null or undefined
            assertParamExists('updateCardHolder', 'updateCardHolderRequest', updateCardHolderRequest)
            const localVarPath = `/user_accounts/{userAccountId}/update_card_holder`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCardHolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lock a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardLock: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCardLock', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('updateCardLock', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/lock`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlock a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardUnlock: async (organizationId: string, cardId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCardUnlock', 'organizationId', organizationId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('updateCardUnlock', 'cardId', cardId)
            const localVarPath = `/organizations/{organizationId}/cards/{cardId}/unlock`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionCommentId 
         * @param {UpdateCommentRequest} updateCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment: async (organizationId: string, paymentReferenceId: string, cardTransactionCommentId: string, updateCommentRequest: UpdateCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateComment', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('updateComment', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionCommentId' is not null or undefined
            assertParamExists('updateComment', 'cardTransactionCommentId', cardTransactionCommentId)
            // verify required parameter 'updateCommentRequest' is not null or undefined
            assertParamExists('updateComment', 'updateCommentRequest', updateCommentRequest)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/comment/{cardTransactionCommentId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionCommentId"}}`, encodeURIComponent(String(cardTransactionCommentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {UpdateCommentTemplateRequest} updateCommentTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentTemplate: async (organizationId: string, templateId: string, updateCommentTemplateRequest: UpdateCommentTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateCommentTemplate', 'organizationId', organizationId)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateCommentTemplate', 'templateId', templateId)
            // verify required parameter 'updateCommentTemplateRequest' is not null or undefined
            assertParamExists('updateCommentTemplate', 'updateCommentTemplateRequest', updateCommentTemplateRequest)
            const localVarPath = `/organizations/{organizationId}/user_accounts/comment_templates/{templateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update corporate document verification result
         * @param {string} organizationIdentityVerificationId 
         * @param {UpdateCorporateDocumentResultRequest} updateCorporateDocumentResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorporateDocumentResult: async (organizationIdentityVerificationId: string, updateCorporateDocumentResultRequest: UpdateCorporateDocumentResultRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('updateCorporateDocumentResult', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            // verify required parameter 'updateCorporateDocumentResultRequest' is not null or undefined
            assertParamExists('updateCorporateDocumentResult', 'updateCorporateDocumentResultRequest', updateCorporateDocumentResultRequest)
            const localVarPath = `/zeus/organization_identity_verifications/{organizationIdentityVerificationId}/corporate_document/result`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCorporateDocumentResultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update daily usage limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateDailyUserUsageLimitRequest} updateDailyUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDailyUserUsageLimit: async (userAccountId: string, updateDailyUserUsageLimitRequest: UpdateDailyUserUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateDailyUserUsageLimit', 'userAccountId', userAccountId)
            // verify required parameter 'updateDailyUserUsageLimitRequest' is not null or undefined
            assertParamExists('updateDailyUserUsageLimit', 'updateDailyUserUsageLimitRequest', updateDailyUserUsageLimitRequest)
            const localVarPath = `/user_accounts/{userAccountId}/update_daily_usage_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDailyUserUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {UpdateDepositRestrictionForOrganizationRequest} updateDepositRestrictionForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepositRestrictionForOrganization: async (organizationId: string, depositRestrictionId: string, updateDepositRestrictionForOrganizationRequest: UpdateDepositRestrictionForOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateDepositRestrictionForOrganization', 'organizationId', organizationId)
            // verify required parameter 'depositRestrictionId' is not null or undefined
            assertParamExists('updateDepositRestrictionForOrganization', 'depositRestrictionId', depositRestrictionId)
            // verify required parameter 'updateDepositRestrictionForOrganizationRequest' is not null or undefined
            assertParamExists('updateDepositRestrictionForOrganization', 'updateDepositRestrictionForOrganizationRequest', updateDepositRestrictionForOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}/deposit_restrictions/{depositRestrictionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"depositRestrictionId"}}`, encodeURIComponent(String(depositRestrictionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepositRestrictionForOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle on/off email notification settings per user
         * @param {string} userId 
         * @param {string} emailNotificationId 
         * @param {UpdateEmailNotificationRequest} updateEmailNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailNotification: async (userId: string, emailNotificationId: string, updateEmailNotificationRequest: UpdateEmailNotificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateEmailNotification', 'userId', userId)
            // verify required parameter 'emailNotificationId' is not null or undefined
            assertParamExists('updateEmailNotification', 'emailNotificationId', emailNotificationId)
            // verify required parameter 'updateEmailNotificationRequest' is not null or undefined
            assertParamExists('updateEmailNotification', 'updateEmailNotificationRequest', updateEmailNotificationRequest)
            const localVarPath = `/users/{userId}/email_notifications/{emailNotificationId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"emailNotificationId"}}`, encodeURIComponent(String(emailNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update embed url method
         * @param {string} organizationId 
         * @param {UpdateEmbedUrlMethodRequest} updateEmbedUrlMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmbedUrlMethod: async (organizationId: string, updateEmbedUrlMethodRequest: UpdateEmbedUrlMethodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateEmbedUrlMethod', 'organizationId', organizationId)
            // verify required parameter 'updateEmbedUrlMethodRequest' is not null or undefined
            assertParamExists('updateEmbedUrlMethod', 'updateEmbedUrlMethodRequest', updateEmbedUrlMethodRequest)
            const localVarPath = `/organizations/{organizationId}/freee/embed_url_method`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmbedUrlMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the card holder. Only accessible by administrators.  Note: When the holder is changed, the new holder will be able to view all previous transaction history.  Error codes: - SYSTEM_ERROR: System error occurred 
         * @summary Update ETC card holder
         * @param {string} userAccountId 
         * @param {UpdateEtcCardHolderRequest} updateEtcCardHolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEtcCardHolder: async (userAccountId: string, updateEtcCardHolderRequest: UpdateEtcCardHolderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateEtcCardHolder', 'userAccountId', userAccountId)
            // verify required parameter 'updateEtcCardHolderRequest' is not null or undefined
            assertParamExists('updateEtcCardHolder', 'updateEtcCardHolderRequest', updateEtcCardHolderRequest)
            const localVarPath = `/user_accounts/{userAccountId}/etc_card/holder`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEtcCardHolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the card label. Only accessible by administrators.  Validation: - Required: Card label must not be empty - Max length: 64 characters  Error codes: - CARD_LABEL_DUPLICATE: Same card label already exists - SYSTEM_ERROR: System error occurred 
         * @summary Update ETC card label
         * @param {string} userAccountId 
         * @param {UpdateEtcCardLabelRequest} updateEtcCardLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEtcCardLabel: async (userAccountId: string, updateEtcCardLabelRequest: UpdateEtcCardLabelRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateEtcCardLabel', 'userAccountId', userAccountId)
            // verify required parameter 'updateEtcCardLabelRequest' is not null or undefined
            assertParamExists('updateEtcCardLabel', 'updateEtcCardLabelRequest', updateEtcCardLabelRequest)
            const localVarPath = `/user_accounts/{userAccountId}/etc_card/card_label`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEtcCardLabelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update evidence image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [dpiForciblyValid] 
         * @param {boolean} [colorGradationForciblyValid] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidenceImage: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, dpiForciblyValid?: boolean, colorGradationForciblyValid?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateEvidenceImage', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('updateEvidenceImage', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('updateEvidenceImage', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (electronicMethod !== undefined) { 
                localVarFormParams.append('electronicMethod', electronicMethod as any);
            }
    
            if (documentSize !== undefined) { 
                localVarFormParams.append('documentSize', documentSize as any);
            }
    
            if (heightMillis !== undefined) { 
                localVarFormParams.append('heightMillis', heightMillis as any);
            }
    
            if (widthMillis !== undefined) { 
                localVarFormParams.append('widthMillis', widthMillis as any);
            }
    
            if (note !== undefined) { 
                localVarFormParams.append('note', note as any);
            }
    
            if (irrelevantToLedger !== undefined) { 
                localVarFormParams.append('irrelevantToLedger', irrelevantToLedger as any);
            }
    
            if (dpiForciblyValid !== undefined) { 
                localVarFormParams.append('dpiForciblyValid', dpiForciblyValid as any);
            }
    
            if (colorGradationForciblyValid !== undefined) { 
                localVarFormParams.append('colorGradationForciblyValid', colorGradationForciblyValid as any);
            }
    
            if (uploadedByRecipient !== undefined) { 
                localVarFormParams.append('uploadedByRecipient', uploadedByRecipient as any);
            }
    
            if (uploadedFrom !== undefined) { 
                localVarFormParams.append('uploadedFrom', uploadedFrom as any);
            }
    
            if (invoiceIssuerName !== undefined) { 
                localVarFormParams.append('invoiceIssuerName', invoiceIssuerName as any);
            }
    
            if (invoiceIssuerRegistrationNumber !== undefined) { 
                localVarFormParams.append('invoiceIssuerRegistrationNumber', invoiceIssuerRegistrationNumber as any);
            }
    
            if (asQualified !== undefined) { 
                localVarFormParams.append('asQualified', asQualified as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update evidence info
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {UpdateEvidenceInfoRequest} updateEvidenceInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidenceInfo: async (organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, updateEvidenceInfoRequest: UpdateEvidenceInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateEvidenceInfo', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('updateEvidenceInfo', 'paymentReferenceId', paymentReferenceId)
            // verify required parameter 'cardTransactionEvidenceId' is not null or undefined
            assertParamExists('updateEvidenceInfo', 'cardTransactionEvidenceId', cardTransactionEvidenceId)
            // verify required parameter 'updateEvidenceInfoRequest' is not null or undefined
            assertParamExists('updateEvidenceInfo', 'updateEvidenceInfoRequest', updateEvidenceInfoRequest)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence/{cardTransactionEvidenceId}/info`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)))
                .replace(`{${"cardTransactionEvidenceId"}}`, encodeURIComponent(String(cardTransactionEvidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEvidenceInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update freee connect
         * @param {string} organizationId 
         * @param {string} code 
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeConnect: async (organizationId: string, code: string, state: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateFreeeConnect', 'organizationId', organizationId)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('updateFreeeConnect', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('updateFreeeConnect', 'state', state)
            const localVarPath = `/organizations/{organizationId}/freee/connect`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary freee設定変更
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {UpdateFreeeConnectionSettingsForAccountingRequest} [updateFreeeConnectionSettingsForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeConnectionSettingsForAccounting: async (orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, updateFreeeConnectionSettingsForAccountingRequest?: UpdateFreeeConnectionSettingsForAccountingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAccountId' is not null or undefined
            assertParamExists('updateFreeeConnectionSettingsForAccounting', 'orgAccountId', orgAccountId)
            const localVarPath = `/org_accounts/{orgAccountId}/freee/connection/settings`
                .replace(`{${"orgAccountId"}}`, encodeURIComponent(String(orgAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upsidrPrivateClientApiInternal != null) {
                localVarHeaderParameter['upsidr-private-client-api-internal'] = typeof upsidrPrivateClientApiInternal === 'string' 
                    ? upsidrPrivateClientApiInternal 
                    : JSON.stringify(upsidrPrivateClientApiInternal);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFreeeConnectionSettingsForAccountingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turn on/off freee journaling
         * @param {string} organizationId 
         * @param {UpdateFreeeJournalingRequest} updateFreeeJournalingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeJournaling: async (organizationId: string, updateFreeeJournalingRequest: UpdateFreeeJournalingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateFreeeJournaling', 'organizationId', organizationId)
            // verify required parameter 'updateFreeeJournalingRequest' is not null or undefined
            assertParamExists('updateFreeeJournaling', 'updateFreeeJournalingRequest', updateFreeeJournalingRequest)
            const localVarPath = `/organizations/{organizationId}/freee/journaling`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFreeeJournalingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update freee select company
         * @param {string} organizationId 
         * @param {UpdateFreeeSelectCompanyRequest} updateFreeeSelectCompanyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeSelectCompany: async (organizationId: string, updateFreeeSelectCompanyRequest: UpdateFreeeSelectCompanyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateFreeeSelectCompany', 'organizationId', organizationId)
            // verify required parameter 'updateFreeeSelectCompanyRequest' is not null or undefined
            assertParamExists('updateFreeeSelectCompany', 'updateFreeeSelectCompanyRequest', updateFreeeSelectCompanyRequest)
            const localVarPath = `/organizations/{organizationId}/freee/select_company`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFreeeSelectCompanyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update lock status of evidences
         * @param {string} organizationId 
         * @param {UpdateLockStatusOfEvidencesRequest} updateLockStatusOfEvidencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLockStatusOfEvidences: async (organizationId: string, updateLockStatusOfEvidencesRequest: UpdateLockStatusOfEvidencesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateLockStatusOfEvidences', 'organizationId', organizationId)
            // verify required parameter 'updateLockStatusOfEvidencesRequest' is not null or undefined
            assertParamExists('updateLockStatusOfEvidences', 'updateLockStatusOfEvidencesRequest', updateLockStatusOfEvidencesRequest)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/evidence/lock`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLockStatusOfEvidencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update merchant general block allowed organization ids
         * @param {string} merchantGeneralBlockListId 
         * @param {UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest} updateMerchantGeneralBlockAllowedOrganizationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantGeneralBlockAllowedOrganizationIds: async (merchantGeneralBlockListId: string, updateMerchantGeneralBlockAllowedOrganizationIdsRequest: UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('updateMerchantGeneralBlockAllowedOrganizationIds', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            // verify required parameter 'updateMerchantGeneralBlockAllowedOrganizationIdsRequest' is not null or undefined
            assertParamExists('updateMerchantGeneralBlockAllowedOrganizationIds', 'updateMerchantGeneralBlockAllowedOrganizationIdsRequest', updateMerchantGeneralBlockAllowedOrganizationIdsRequest)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}/allowed_organizations`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantGeneralBlockAllowedOrganizationIdsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update merchant general block list
         * @param {string} merchantGeneralBlockListId 
         * @param {UpdateMerchantGeneralBlockListRequest} updateMerchantGeneralBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantGeneralBlockList: async (merchantGeneralBlockListId: string, updateMerchantGeneralBlockListRequest: UpdateMerchantGeneralBlockListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantGeneralBlockListId' is not null or undefined
            assertParamExists('updateMerchantGeneralBlockList', 'merchantGeneralBlockListId', merchantGeneralBlockListId)
            // verify required parameter 'updateMerchantGeneralBlockListRequest' is not null or undefined
            assertParamExists('updateMerchantGeneralBlockList', 'updateMerchantGeneralBlockListRequest', updateMerchantGeneralBlockListRequest)
            const localVarPath = `/merchant_general_block_lists/{merchantGeneralBlockListId}`
                .replace(`{${"merchantGeneralBlockListId"}}`, encodeURIComponent(String(merchantGeneralBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantGeneralBlockListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update merchant org block list
         * @param {string} merchantOrgBlockListId 
         * @param {UpdateMerchantOrgBlockListRequest} updateMerchantOrgBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOrgBlockList: async (merchantOrgBlockListId: string, updateMerchantOrgBlockListRequest: UpdateMerchantOrgBlockListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantOrgBlockListId' is not null or undefined
            assertParamExists('updateMerchantOrgBlockList', 'merchantOrgBlockListId', merchantOrgBlockListId)
            // verify required parameter 'updateMerchantOrgBlockListRequest' is not null or undefined
            assertParamExists('updateMerchantOrgBlockList', 'updateMerchantOrgBlockListRequest', updateMerchantOrgBlockListRequest)
            const localVarPath = `/merchant_org_block_lists/{merchantOrgBlockListId}`
                .replace(`{${"merchantOrgBlockListId"}}`, encodeURIComponent(String(merchantOrgBlockListId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantOrgBlockListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Merchant Organization Comment
         * @param {string} organizationId 
         * @param {string} merchantId 
         * @param {string} userAccountId 
         * @param {UpdateMerchantOrganizationCommentRequest} updateMerchantOrganizationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOrganizationComment: async (organizationId: string, merchantId: string, userAccountId: string, updateMerchantOrganizationCommentRequest: UpdateMerchantOrganizationCommentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateMerchantOrganizationComment', 'organizationId', organizationId)
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateMerchantOrganizationComment', 'merchantId', merchantId)
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateMerchantOrganizationComment', 'userAccountId', userAccountId)
            // verify required parameter 'updateMerchantOrganizationCommentRequest' is not null or undefined
            assertParamExists('updateMerchantOrganizationComment', 'updateMerchantOrganizationCommentRequest', updateMerchantOrganizationCommentRequest)
            const localVarPath = `/organizations/{organizationId}/merchants/{merchantId}/user_accounts/{userAccountId}/comment`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantOrganizationCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization: async (organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganization', 'organizationId', organizationId)
            // verify required parameter 'updateOrganizationRequest' is not null or undefined
            assertParamExists('updateOrganization', 'updateOrganizationRequest', updateOrganizationRequest)
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Organizations Accounting Csv Export Fields
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationsAccountingCsvExportFields: async (organizationId: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganizationsAccountingCsvExportFields', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateOrganizationsAccountingCsvExportFields', 'requestBody', requestBody)
            const localVarPath = `/organizations/{organizationId}/cards/accounting/csv_export_fields`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the payment request evidence specified by evidenceId.
         * @summary Update the specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {UpdatePaymentRequestEvidenceRequest} updatePaymentRequestEvidenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequestEvidence: async (organizationId: string, paymentRequestId: string, evidenceId: string, updatePaymentRequestEvidenceRequest: UpdatePaymentRequestEvidenceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidence', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidence', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidence', 'evidenceId', evidenceId)
            // verify required parameter 'updatePaymentRequestEvidenceRequest' is not null or undefined
            assertParamExists('updatePaymentRequestEvidence', 'updatePaymentRequestEvidenceRequest', updatePaymentRequestEvidenceRequest)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentRequestEvidenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the payment request evidence file specified by evidenceId. This also accept properties other than a file binary.
         * @summary Update the specific payment request evidence file.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {boolean} [dpiForciblyValid] 
         * @param {boolean} [colorGradationForciblyValid] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {string} [invoiceIssuerName] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequestEvidenceFile: async (organizationId: string, paymentRequestId: string, evidenceId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, dpiForciblyValid?: boolean, colorGradationForciblyValid?: boolean, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerRegistrationNumber?: string, invoiceIssuerName?: string, asQualified?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidenceFile', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidenceFile', 'paymentRequestId', paymentRequestId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('updatePaymentRequestEvidenceFile', 'evidenceId', evidenceId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences/{evidenceId}/file`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)))
                .replace(`{${"evidenceId"}}`, encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (electronicMethod !== undefined) { 
                localVarFormParams.append('electronicMethod', electronicMethod as any);
            }
    
            if (documentSize !== undefined) { 
                localVarFormParams.append('documentSize', documentSize as any);
            }
    
            if (heightMillis !== undefined) { 
                localVarFormParams.append('heightMillis', heightMillis as any);
            }
    
            if (widthMillis !== undefined) { 
                localVarFormParams.append('widthMillis', widthMillis as any);
            }
    
            if (dpiForciblyValid !== undefined) { 
                localVarFormParams.append('dpiForciblyValid', dpiForciblyValid as any);
            }
    
            if (colorGradationForciblyValid !== undefined) { 
                localVarFormParams.append('colorGradationForciblyValid', colorGradationForciblyValid as any);
            }
    
            if (note !== undefined) { 
                localVarFormParams.append('note', note as any);
            }
    
            if (irrelevantToLedger !== undefined) { 
                localVarFormParams.append('irrelevantToLedger', irrelevantToLedger as any);
            }
    
            if (uploadedByRecipient !== undefined) { 
                localVarFormParams.append('uploadedByRecipient', uploadedByRecipient as any);
            }
    
            if (uploadedFrom !== undefined) { 
                localVarFormParams.append('uploadedFrom', uploadedFrom as any);
            }
    
            if (invoiceIssuerRegistrationNumber !== undefined) { 
                localVarFormParams.append('invoiceIssuerRegistrationNumber', invoiceIssuerRegistrationNumber as any);
            }
    
            if (invoiceIssuerName !== undefined) { 
                localVarFormParams.append('invoiceIssuerName', invoiceIssuerName as any);
            }
    
            if (asQualified !== undefined) { 
                localVarFormParams.append('asQualified', asQualified as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update purchase application template.
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {UpdatePurchaseApplicationTemplateRequest} [updatePurchaseApplicationTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseApplicationTemplate: async (organizationId: string, purchaseTemplateId: string, updatePurchaseApplicationTemplateRequest?: UpdatePurchaseApplicationTemplateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePurchaseApplicationTemplate', 'organizationId', organizationId)
            // verify required parameter 'purchaseTemplateId' is not null or undefined
            assertParamExists('updatePurchaseApplicationTemplate', 'purchaseTemplateId', purchaseTemplateId)
            const localVarPath = `/organizations/{organizationId}/purchase_applications/templates/{purchaseTemplateId}/update`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"purchaseTemplateId"}}`, encodeURIComponent(String(purchaseTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePurchaseApplicationTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update remove user account group
         * @param {string} userAccountId 
         * @param {UpdateRemoveUserAccountGroupRequest} updateRemoveUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRemoveUserAccountGroup: async (userAccountId: string, updateRemoveUserAccountGroupRequest: UpdateRemoveUserAccountGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateRemoveUserAccountGroup', 'userAccountId', userAccountId)
            // verify required parameter 'updateRemoveUserAccountGroupRequest' is not null or undefined
            assertParamExists('updateRemoveUserAccountGroup', 'updateRemoveUserAccountGroupRequest', updateRemoveUserAccountGroupRequest)
            const localVarPath = `/user_accounts/{userAccountId}/remove_user_account_group`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRemoveUserAccountGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update role resource for user
         * @param {string} userId 
         * @param {UpdateRoleResourceForUserRequest} updateRoleResourceForUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleResourceForUser: async (userId: string, updateRoleResourceForUserRequest: UpdateRoleResourceForUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateRoleResourceForUser', 'userId', userId)
            // verify required parameter 'updateRoleResourceForUserRequest' is not null or undefined
            assertParamExists('updateRoleResourceForUser', 'updateRoleResourceForUserRequest', updateRoleResourceForUserRequest)
            const localVarPath = `/roles/user_account/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleResourceForUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Roles by Resource Id
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {UpdateRolesByResourceIdRequest} updateRolesByResourceIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRolesByResourceId: async (resourceScope: string, resourceId: string, updateRolesByResourceIdRequest: UpdateRolesByResourceIdRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceScope' is not null or undefined
            assertParamExists('updateRolesByResourceId', 'resourceScope', resourceScope)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('updateRolesByResourceId', 'resourceId', resourceId)
            // verify required parameter 'updateRolesByResourceIdRequest' is not null or undefined
            assertParamExists('updateRolesByResourceId', 'updateRolesByResourceIdRequest', updateRolesByResourceIdRequest)
            const localVarPath = `/roles/user_account/{resourceScope}/{resourceId}`
                .replace(`{${"resourceScope"}}`, encodeURIComponent(String(resourceScope)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRolesByResourceIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Slack evidence remind settings of an slack channel
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackEvidenceReminderPerChannelRequest} updateSlackEvidenceReminderPerChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackEvidenceReminderPerChannel: async (organizationId: string, channelId: string, updateSlackEvidenceReminderPerChannelRequest: UpdateSlackEvidenceReminderPerChannelRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSlackEvidenceReminderPerChannel', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateSlackEvidenceReminderPerChannel', 'channelId', channelId)
            // verify required parameter 'updateSlackEvidenceReminderPerChannelRequest' is not null or undefined
            assertParamExists('updateSlackEvidenceReminderPerChannel', 'updateSlackEvidenceReminderPerChannelRequest', updateSlackEvidenceReminderPerChannelRequest)
            const localVarPath = `/slack/organizations/{organizationId}/cards/evidence_reminders/{channelId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSlackEvidenceReminderPerChannelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackNotificationSettingForCardRequest} updateSlackNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackNotificationSettingForCard: async (organizationId: string, channelId: string, updateSlackNotificationSettingForCardRequest: UpdateSlackNotificationSettingForCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForCard', 'channelId', channelId)
            // verify required parameter 'updateSlackNotificationSettingForCardRequest' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForCard', 'updateSlackNotificationSettingForCardRequest', updateSlackNotificationSettingForCardRequest)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/cards/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSlackNotificationSettingForCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackNotificationSettingForPurchaseApplicationRequest} updateSlackNotificationSettingForPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackNotificationSettingForPurchaseApplication: async (organizationId: string, channelId: string, updateSlackNotificationSettingForPurchaseApplicationRequest: UpdateSlackNotificationSettingForPurchaseApplicationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForPurchaseApplication', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForPurchaseApplication', 'channelId', channelId)
            // verify required parameter 'updateSlackNotificationSettingForPurchaseApplicationRequest' is not null or undefined
            assertParamExists('updateSlackNotificationSettingForPurchaseApplication', 'updateSlackNotificationSettingForPurchaseApplicationRequest', updateSlackNotificationSettingForPurchaseApplicationRequest)
            const localVarPath = `/slack/organizations/{organizationId}/channels/{channelId}/purchase_applications/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSlackNotificationSettingForPurchaseApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update sync to freee from deal
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncToFreeeFromDeal: async (organizationId: string, companyId: string, dealId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSyncToFreeeFromDeal', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateSyncToFreeeFromDeal', 'companyId', companyId)
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('updateSyncToFreeeFromDeal', 'dealId', dealId)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/deals/{dealId}/sync_to_freee`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update synchronize to freee log confirm
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {UpdateSynchronizeToFreeeLogConfirmRequest} updateSynchronizeToFreeeLogConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynchronizeToFreeeLogConfirm: async (organizationId: string, companyId: string, updateSynchronizeToFreeeLogConfirmRequest: UpdateSynchronizeToFreeeLogConfirmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSynchronizeToFreeeLogConfirm', 'organizationId', organizationId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('updateSynchronizeToFreeeLogConfirm', 'companyId', companyId)
            // verify required parameter 'updateSynchronizeToFreeeLogConfirmRequest' is not null or undefined
            assertParamExists('updateSynchronizeToFreeeLogConfirm', 'updateSynchronizeToFreeeLogConfirmRequest', updateSynchronizeToFreeeLogConfirmRequest)
            const localVarPath = `/organizations/{organizationId}/freee/{companyId}/synchronize_to_freee_log/confirm`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSynchronizeToFreeeLogConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateTeamsNotificationSettingForCardRequest} updateTeamsNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamsNotificationSettingForCard: async (organizationId: string, channelId: string, updateTeamsNotificationSettingForCardRequest: UpdateTeamsNotificationSettingForCardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateTeamsNotificationSettingForCard', 'organizationId', organizationId)
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateTeamsNotificationSettingForCard', 'channelId', channelId)
            // verify required parameter 'updateTeamsNotificationSettingForCardRequest' is not null or undefined
            assertParamExists('updateTeamsNotificationSettingForCard', 'updateTeamsNotificationSettingForCardRequest', updateTeamsNotificationSettingForCardRequest)
            const localVarPath = `/teams/organizations/{organizationId}/channels/{channelId}/cards/notification`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTeamsNotificationSettingForCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update transaction upper limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateTransactionUpperLimitForTheUserAccountRequest} updateTransactionUpperLimitForTheUserAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransactionUpperLimitForTheUserAccount: async (userAccountId: string, updateTransactionUpperLimitForTheUserAccountRequest: UpdateTransactionUpperLimitForTheUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateTransactionUpperLimitForTheUserAccount', 'userAccountId', userAccountId)
            // verify required parameter 'updateTransactionUpperLimitForTheUserAccountRequest' is not null or undefined
            assertParamExists('updateTransactionUpperLimitForTheUserAccount', 'updateTransactionUpperLimitForTheUserAccountRequest', updateTransactionUpperLimitForTheUserAccountRequest)
            const localVarPath = `/user_accounts/{userAccountId}/update_transaction_upper_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTransactionUpperLimitForTheUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user account group
         * @param {string} userAccountId 
         * @param {UpdateUserAccountGroupRequest} updateUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountGroup: async (userAccountId: string, updateUserAccountGroupRequest: UpdateUserAccountGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateUserAccountGroup', 'userAccountId', userAccountId)
            // verify required parameter 'updateUserAccountGroupRequest' is not null or undefined
            assertParamExists('updateUserAccountGroup', 'updateUserAccountGroupRequest', updateUserAccountGroupRequest)
            const localVarPath = `/user_accounts/{userAccountId}/set_user_account_group`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserAccountGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user account name
         * @param {string} userAccountId 
         * @param {UpdateUserAccountNameRequest} updateUserAccountNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountName: async (userAccountId: string, updateUserAccountNameRequest: UpdateUserAccountNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateUserAccountName', 'userAccountId', userAccountId)
            // verify required parameter 'updateUserAccountNameRequest' is not null or undefined
            assertParamExists('updateUserAccountName', 'updateUserAccountNameRequest', updateUserAccountNameRequest)
            const localVarPath = `/user_accounts/{userAccountId}/rename`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserAccountNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update user email, settings per user
         * @param {string} userId 
         * @param {UpdateUserEmailRequest} updateUserEmailRequest 
         * @param {string} [xChallengeSuccessToken] sudo-mode challenge 検証成功時に発行される token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEmail: async (userId: string, updateUserEmailRequest: UpdateUserEmailRequest, xChallengeSuccessToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserEmail', 'userId', userId)
            // verify required parameter 'updateUserEmailRequest' is not null or undefined
            assertParamExists('updateUserEmail', 'updateUserEmailRequest', updateUserEmailRequest)
            const localVarPath = `/users/{userId}/email`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xChallengeSuccessToken != null) {
                localVarHeaderParameter['x-challenge-success-token'] = String(xChallengeSuccessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update user name, settings per user
         * @param {string} userId 
         * @param {UpdateUserNameRequest} updateUserNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserName: async (userId: string, updateUserNameRequest: UpdateUserNameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserName', 'userId', userId)
            // verify required parameter 'updateUserNameRequest' is not null or undefined
            assertParamExists('updateUserName', 'updateUserNameRequest', updateUserNameRequest)
            const localVarPath = `/users/{userId}/name`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update user organization
         * @param {string} userId 
         * @param {UpdateUserOrganizationRequest} updateUserOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrganization: async (userId: string, updateUserOrganizationRequest: UpdateUserOrganizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserOrganization', 'userId', userId)
            // verify required parameter 'updateUserOrganizationRequest' is not null or undefined
            assertParamExists('updateUserOrganization', 'updateUserOrganizationRequest', updateUserOrganizationRequest)
            const localVarPath = `/users/{userId}/organization`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update user password
         * @param {string} userId 
         * @param {UpdateUserPasswordRequest} updateUserPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword: async (userId: string, updateUserPasswordRequest: UpdateUserPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserPassword', 'userId', userId)
            // verify required parameter 'updateUserPasswordRequest' is not null or undefined
            assertParamExists('updateUserPassword', 'updateUserPasswordRequest', updateUserPasswordRequest)
            const localVarPath = `/users/{userId}/password`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update User Privilege
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {UpdateUserPrivilegeRequest} updateUserPrivilegeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPrivilege: async (organizationId: string, userId: string, updateUserPrivilegeRequest: UpdateUserPrivilegeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateUserPrivilege', 'organizationId', organizationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserPrivilege', 'userId', userId)
            // verify required parameter 'updateUserPrivilegeRequest' is not null or undefined
            assertParamExists('updateUserPrivilege', 'updateUserPrivilegeRequest', updateUserPrivilegeRequest)
            const localVarPath = `/organizations/user_privilege/{organizationId}/{userId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPrivilegeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update usage limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateUserUsageLimitRequest} updateUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserUsageLimit: async (userAccountId: string, updateUserUsageLimitRequest: UpdateUserUsageLimitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('updateUserUsageLimit', 'userAccountId', userAccountId)
            // verify required parameter 'updateUserUsageLimitRequest' is not null or undefined
            assertParamExists('updateUserUsageLimit', 'updateUserUsageLimitRequest', updateUserUsageLimitRequest)
            const localVarPath = `/user_accounts/{userAccountId}/update_usage_limit`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserUsageLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload card transaction evidence images
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {Array<File>} [files] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCardTransactionEvidenceImage: async (organizationId: string, paymentReferenceId: string, files?: Array<File>, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadCardTransactionEvidenceImage', 'organizationId', organizationId)
            // verify required parameter 'paymentReferenceId' is not null or undefined
            assertParamExists('uploadCardTransactionEvidenceImage', 'paymentReferenceId', paymentReferenceId)
            const localVarPath = `/organizations/{organizationId}/cards/transactions/{paymentReferenceId}/evidence`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentReferenceId"}}`, encodeURIComponent(String(paymentReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (electronicMethod !== undefined) { 
                localVarFormParams.append('electronicMethod', electronicMethod as any);
            }
    
            if (documentSize !== undefined) { 
                localVarFormParams.append('documentSize', documentSize as any);
            }
    
            if (heightMillis !== undefined) { 
                localVarFormParams.append('heightMillis', heightMillis as any);
            }
    
            if (widthMillis !== undefined) { 
                localVarFormParams.append('widthMillis', widthMillis as any);
            }
    
            if (note !== undefined) { 
                localVarFormParams.append('note', note as any);
            }
    
            if (irrelevantToLedger !== undefined) { 
                localVarFormParams.append('irrelevantToLedger', irrelevantToLedger as any);
            }
    
            if (uploadedByRecipient !== undefined) { 
                localVarFormParams.append('uploadedByRecipient', uploadedByRecipient as any);
            }
    
            if (uploadedFrom !== undefined) { 
                localVarFormParams.append('uploadedFrom', uploadedFrom as any);
            }
    
            if (invoiceIssuerName !== undefined) { 
                localVarFormParams.append('invoiceIssuerName', invoiceIssuerName as any);
            }
    
            if (invoiceIssuerRegistrationNumber !== undefined) { 
                localVarFormParams.append('invoiceIssuerRegistrationNumber', invoiceIssuerRegistrationNumber as any);
            }
    
            if (asQualified !== undefined) { 
                localVarFormParams.append('asQualified', asQualified as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload corporate document
         * @param {string} organizationIdentityVerificationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCorporateDocument: async (organizationIdentityVerificationId: string, file: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationIdentityVerificationId' is not null or undefined
            assertParamExists('uploadCorporateDocument', 'organizationIdentityVerificationId', organizationIdentityVerificationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadCorporateDocument', 'file', file)
            const localVarPath = `/zeus/organization_identity_verifications/{organizationIdentityVerificationId}/corporate_document`
                .replace(`{${"organizationIdentityVerificationId"}}`, encodeURIComponent(String(organizationIdentityVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload payment request evidence image
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPaymentRequestEvidenceImage: async (organizationId: string, paymentRequestId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('uploadPaymentRequestEvidenceImage', 'organizationId', organizationId)
            // verify required parameter 'paymentRequestId' is not null or undefined
            assertParamExists('uploadPaymentRequestEvidenceImage', 'paymentRequestId', paymentRequestId)
            const localVarPath = `/organizations/{organizationId}/payment_requests/{paymentRequestId}/evidences`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"paymentRequestId"}}`, encodeURIComponent(String(paymentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (electronicMethod !== undefined) { 
                localVarFormParams.append('electronicMethod', electronicMethod as any);
            }
    
            if (documentSize !== undefined) { 
                localVarFormParams.append('documentSize', documentSize as any);
            }
    
            if (heightMillis !== undefined) { 
                localVarFormParams.append('heightMillis', heightMillis as any);
            }
    
            if (widthMillis !== undefined) { 
                localVarFormParams.append('widthMillis', widthMillis as any);
            }
    
            if (note !== undefined) { 
                localVarFormParams.append('note', note as any);
            }
    
            if (irrelevantToLedger !== undefined) { 
                localVarFormParams.append('irrelevantToLedger', irrelevantToLedger as any);
            }
    
            if (uploadedByRecipient !== undefined) { 
                localVarFormParams.append('uploadedByRecipient', uploadedByRecipient as any);
            }
    
            if (uploadedFrom !== undefined) { 
                localVarFormParams.append('uploadedFrom', uploadedFrom as any);
            }
    
            if (invoiceIssuerName !== undefined) { 
                localVarFormParams.append('invoiceIssuerName', invoiceIssuerName as any);
            }
    
            if (invoiceIssuerRegistrationNumber !== undefined) { 
                localVarFormParams.append('invoiceIssuerRegistrationNumber', invoiceIssuerRegistrationNumber as any);
            }
    
            if (asQualified !== undefined) { 
                localVarFormParams.append('asQualified', asQualified as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Users email confirm
         * @param {UsersEmailConfirmRequest} usersEmailConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersEmailConfirm: async (usersEmailConfirmRequest: UsersEmailConfirmRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'usersEmailConfirmRequest' is not null or undefined
            assertParamExists('usersEmailConfirm', 'usersEmailConfirmRequest', usersEmailConfirmRequest)
            const localVarPath = `/users/email/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersEmailConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定した scope の現在有効なチャレンジに対して6桁コードを検証し、成功時に短命 JWT (challengeSuccessToken) を発行する。 チャレンジは (userId, scope) ごとに独立しているため、scope の指定が必須。 
         * @summary sudo-mode チャレンジの検証
         * @param {string} userId 
         * @param {VerifyChallengeRequest} verifyChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyChallenge: async (userId: string, verifyChallengeRequest: VerifyChallengeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('verifyChallenge', 'userId', userId)
            // verify required parameter 'verifyChallengeRequest' is not null or undefined
            assertParamExists('verifyChallenge', 'verifyChallengeRequest', verifyChallengeRequest)
            const localVarPath = `/users/{userId}/challenge/verify`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyChallengeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify moneytree connections
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyMoneytreeConnections: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('verifyMoneytreeConnections', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/moneytree/connections/verify`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows system administrators to directly update a user\'s email address without email verification. This is a Zeus admin API that bypasses the standard email change flow. 
         * @summary Update user email address (Admin only)
         * @param {string} userId The ID of the user whose email address will be updated
         * @param {ZeusUpdateUserEmailRequest} zeusUpdateUserEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zeusUpdateUserEmail: async (userId: string, zeusUpdateUserEmailRequest: ZeusUpdateUserEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('zeusUpdateUserEmail', 'userId', userId)
            // verify required parameter 'zeusUpdateUserEmailRequest' is not null or undefined
            assertParamExists('zeusUpdateUserEmail', 'zeusUpdateUserEmailRequest', zeusUpdateUserEmailRequest)
            const localVarPath = `/zeus/users/{userId}/email`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zeusUpdateUserEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addComment(organizationId: string, paymentReferenceId: string, addCommentRequest: AddCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addComment(organizationId, paymentReferenceId, addCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add Organization Create Request
         * @param {AddOrganizationCreateRequestRequest} addOrganizationCreateRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganizationCreateRequest(addOrganizationCreateRequestRequest: AddOrganizationCreateRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddOrganizationCreateRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganizationCreateRequest(addOrganizationCreateRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary add point to organization
         * @param {string} organizationId 
         * @param {AddPointToOrganizationRequest} addPointToOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPointToOrganization(organizationId: string, addPointToOrganizationRequest: AddPointToOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPointToOrganization(organizationId, addPointToOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Agree to the agreement request
         * @param {string} organizationId 
         * @param {string} agreementRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreeToAgreementRequest(organizationId: string, agreementRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreeToAgreementRequest(organizationId, agreementRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Agree to OL info sharing consent
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreeToOlInfoSharingConsent(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreeToOlInfoSharingConsent200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreeToOlInfoSharingConsent(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Analyze evidence
         * @param {string} organizationId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeEvidence(organizationId: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyzeEvidence200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeEvidence(organizationId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Analyze invoice of payment requests
         * @param {string} organizationId 
         * @param {File} file 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeInvoiceOfPaymentRequests(organizationId: string, file: File, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyzeInvoiceOfPaymentRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeInvoiceOfPaymentRequests(organizationId, file, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply fraud lock status
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyFraudLockStatus(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplyFraudLockStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyFraudLockStatus(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Approve organization identity verification
         * @param {number} organizationIdentityVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveOrganizationIdentityVerification(organizationIdentityVerificationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApproveOrganizationIdentityVerification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveOrganizationIdentityVerification(organizationIdentityVerificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Approve purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {ApprovePurchaseApplicationRequest} approvePurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approvePurchaseApplication(organizationId: string, purchaseApplicationId: string, approvePurchaseApplicationRequest: ApprovePurchaseApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approvePurchaseApplication(organizationId, purchaseApplicationId, approvePurchaseApplicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Approve workflow step of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {ApproveWorkflowStepPaymentRequestsRequest} [approveWorkflowStepPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveWorkflowStepPaymentRequests(organizationId: string, xUpsidrSwitchUser?: string, approveWorkflowStepPaymentRequestsRequest?: ApproveWorkflowStepPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveWorkflowStepPaymentRequests(organizationId, xUpsidrSwitchUser, approveWorkflowStepPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Automatically journalize deals from rules
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {AutomaticallyJournalizeDealsFromRulesRequest} automaticallyJournalizeDealsFromRulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async automaticallyJournalizeDealsFromRules(organizationId: string, companyId: string, automaticallyJournalizeDealsFromRulesRequest: AutomaticallyJournalizeDealsFromRulesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.automaticallyJournalizeDealsFromRules(organizationId, companyId, automaticallyJournalizeDealsFromRulesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bank Account Activities Withdrawal Reserve
         * @param {BankAccountActivitiesWithdrawalReserveRequest} bankAccountActivitiesWithdrawalReserveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankAccountActivitiesWithdrawalReserve(bankAccountActivitiesWithdrawalReserveRequest: BankAccountActivitiesWithdrawalReserveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankAccountActivitiesWithdrawalReserve200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountActivitiesWithdrawalReserve(bankAccountActivitiesWithdrawalReserveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {BulkDisableDailyUserUsageLimitRequest} bulkDisableDailyUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDisableDailyUserUsageLimit(bulkDisableDailyUserUsageLimitRequest: BulkDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkDisableDailyUserUsageLimit200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDisableDailyUserUsageLimit(bulkDisableDailyUserUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk disable monthly usage limit
         * @param {BulkDisableMonthlyUsageLimitRequest} bulkDisableMonthlyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDisableMonthlyUsageLimit(bulkDisableMonthlyUsageLimitRequest: BulkDisableMonthlyUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkDisableMonthlyUsageLimit200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDisableMonthlyUsageLimit(bulkDisableMonthlyUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows organization administrators to invite multiple users at once by providing user details (email, name, and role). This endpoint accepts up to 300 users per request. 
         * @summary Bulk invite users to organization
         * @param {string} organizationId The ID of the organization
         * @param {BulkInviteUsersAdminRequest} bulkInviteUsersAdminRequest 
         * @param {string} [xChallengeSuccessToken] sudo-mode challenge 検証成功時に発行される token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkInviteUsersAdmin(organizationId: string, bulkInviteUsersAdminRequest: BulkInviteUsersAdminRequest, xChallengeSuccessToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkInviteUsersAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkInviteUsersAdmin(organizationId, bulkInviteUsersAdminRequest, xChallengeSuccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk update daily usage limit
         * @param {BulkUpdateDailyUsageLimitRequest} bulkUpdateDailyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateDailyUsageLimit(bulkUpdateDailyUsageLimitRequest: BulkUpdateDailyUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkUpdateDailyUsageLimit200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateDailyUsageLimit(bulkUpdateDailyUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk update monthly usage limit
         * @param {BulkUpdateMonthlyUsageLimitRequest} bulkUpdateMonthlyUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateMonthlyUsageLimit(bulkUpdateMonthlyUsageLimitRequest: BulkUpdateMonthlyUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkUpdateMonthlyUsageLimit200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateMonthlyUsageLimit(bulkUpdateMonthlyUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bulk Update Organization User Privileges
         * @param {string} organizationId 
         * @param {BulkUpdateOrganizationUserPrivilegesRequest} bulkUpdateOrganizationUserPrivilegesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateOrganizationUserPrivileges(organizationId: string, bulkUpdateOrganizationUserPrivilegesRequest: BulkUpdateOrganizationUserPrivilegesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateOrganizationUserPrivileges(organizationId, bulkUpdateOrganizationUserPrivilegesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDraftPaymentRequest(organizationId: string, draftPaymentRequestId: string, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDraftPaymentRequest(organizationId, draftPaymentRequestId, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel payment request
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelPaymentRequest(organizationId: string, paymentRequestId: string, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelPaymentRequest(organizationId, paymentRequestId, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change Identity Verification Scheduled Date
         * @param {string} organizationId 
         * @param {ChangeIdentityVerificationScheduledDateRequest} changeIdentityVerificationScheduledDateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeIdentityVerificationScheduledDate(organizationId: string, changeIdentityVerificationScheduledDateRequest: ChangeIdentityVerificationScheduledDateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeIdentityVerificationScheduledDate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeIdentityVerificationScheduledDate(organizationId, changeIdentityVerificationScheduledDateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change Invoice Email
         * @param {string} organizationId 
         * @param {ChangeInvoiceEmailRequest} changeInvoiceEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeInvoiceEmail(organizationId: string, changeInvoiceEmailRequest: ChangeInvoiceEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeInvoiceEmail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeInvoiceEmail(organizationId, changeInvoiceEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change to the specified ekyc result
         * @param {string} identificationId 
         * @param {ChangeToTheSpecifiedEkycResultRequest} changeToTheSpecifiedEkycResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeToTheSpecifiedEkycResult(identificationId: string, changeToTheSpecifiedEkycResultRequest: ChangeToTheSpecifiedEkycResultRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeToTheSpecifiedEkycResult(identificationId, changeToTheSpecifiedEkycResultRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check Already Registered Phone Number
         * @param {CheckAlreadyRegisteredPhoneNumberRequest} checkAlreadyRegisteredPhoneNumberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAlreadyRegisteredPhoneNumber(checkAlreadyRegisteredPhoneNumberRequest: CheckAlreadyRegisteredPhoneNumberRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAlreadyRegisteredPhoneNumber200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAlreadyRegisteredPhoneNumber(checkAlreadyRegisteredPhoneNumberRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check All Organization Available Limit And Notify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAvailableLimit(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAvailableLimit(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check duplicate email addresses
         * @param {Array<string>} [emailAddresses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkDuplicateEmailAddresses(emailAddresses?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CheckDuplicateEmailAddresses200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkDuplicateEmailAddresses(emailAddresses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkMonthlyUsageLimit(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkMonthlyUsageLimit(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * It is an API that waits for a redirect after the payment request fix button is pressed in the Slack App. This API does three things:   - Slack message modification - remove each button attached to the original message   - Post messages to Slack - communicate the fact that the edit button was pressed   - Create payment request for draft data
         * @summary Complete redirect from slack
         * @param {string} organizationId 
         * @param {CompleteRedirectFromSlackRequest} [completeRedirectFromSlackRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeRedirectFromSlack(organizationId: string, completeRedirectFromSlackRequest?: CompleteRedirectFromSlackRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteRedirectFromSlack200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeRedirectFromSlack(organizationId, completeRedirectFromSlackRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Confirm Fufu hotel reservation
         * @param {ConfirmFufuHotelReservationRequest} confirmFufuHotelReservationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmFufuHotelReservation(confirmFufuHotelReservationRequest: ConfirmFufuHotelReservationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmFufuHotelReservation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmFufuHotelReservation(confirmFufuHotelReservationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary freee接続
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {ConnectFreeeForAccountingRequest} [connectFreeeForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectFreeeForAccounting(orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, connectFreeeForAccountingRequest?: ConnectFreeeForAccountingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectFreeeForAccounting(orgAccountId, upsidrPrivateClientApiInternal, connectFreeeForAccountingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Count deals
         * @param {string} organizationId 
         * @param {CountDealsRequest} [countDealsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countDeals(organizationId: string, countDealsRequest?: CountDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countDeals(organizationId, countDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create bank transfers for the specified payment requests.
         * @summary Create bank transfers
         * @param {string} organizationId 
         * @param {CreateBankTransfersRequest} createBankTransfersRequest 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankTransfers(organizationId: string, createBankTransfersRequest: CreateBankTransfersRequest, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBankTransfers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankTransfers(organizationId, createBankTransfersRequest, transferDateJstFrom, transferDateJstTo, sourceBankAccountId, downloaded, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create category of the purchase application template.
         * @param {string} organizationId 
         * @param {CreateCategoryOfThePurchaseApplicationTemplateRequest} createCategoryOfThePurchaseApplicationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategoryOfThePurchaseApplicationTemplate(organizationId: string, createCategoryOfThePurchaseApplicationTemplateRequest: CreateCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategoryOfThePurchaseApplicationTemplate(organizationId, createCategoryOfThePurchaseApplicationTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create comment template
         * @param {string} organizationId 
         * @param {CreateCommentTemplateRequest} createCommentTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommentTemplate(organizationId: string, createCommentTemplateRequest: CreateCommentTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommentTemplate(organizationId, createCommentTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create deposit restriction for organization
         * @param {string} organizationId 
         * @param {CreateDepositRestrictionForOrganizationRequest} createDepositRestrictionForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDepositRestrictionForOrganization(organizationId: string, createDepositRestrictionForOrganizationRequest: CreateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDepositRestrictionForOrganization(organizationId, createDepositRestrictionForOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create draft of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {CreateDraftOfPaymentRequestsRequest} [createDraftOfPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDraftOfPaymentRequests(organizationId: string, xUpsidrSwitchUser?: string, createDraftOfPaymentRequestsRequest?: CreateDraftOfPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDraftOfPaymentRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDraftOfPaymentRequests(organizationId, xUpsidrSwitchUser, createDraftOfPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create ETC card issuance request
         * @param {string} organizationId 
         * @param {CreateEtcCardIssuanceRequestRequest} createEtcCardIssuanceRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEtcCardIssuanceRequest(organizationId: string, createEtcCardIssuanceRequestRequest: CreateEtcCardIssuanceRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEtcCardIssuanceRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEtcCardIssuanceRequest(organizationId, createEtcCardIssuanceRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create evidence request
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvidenceRequest(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEvidenceRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEvidenceRequest(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary freee認可URL作成
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFreeeAuthForAccounting(orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFreeeAuthForAccounting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFreeeAuthForAccounting(orgAccountId, upsidrPrivateClientApiInternal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create freee partner
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {CreateFreeePartnerRequest} createFreeePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFreeePartner(organizationId: string, companyId: string, createFreeePartnerRequest: CreateFreeePartnerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFreeePartner200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFreeePartner(organizationId, companyId, createFreeePartnerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create past deals
         * @param {string} organizationId 
         * @param {CreatePastDealsRequest} createPastDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPastDeals(organizationId: string, createPastDealsRequest: CreatePastDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPastDeals(organizationId, createPastDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create purchase application.
         * @param {string} organizationId 
         * @param {CreatePurchaseApplicationRequest} createPurchaseApplicationRequest 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseApplication(organizationId: string, createPurchaseApplicationRequest: CreatePurchaseApplicationRequest, visaTransactionReferenceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseApplication(organizationId, createPurchaseApplicationRequest, visaTransactionReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create purchase application template.
         * @param {string} organizationId 
         * @param {CreatePurchaseApplicationTemplateRequest} createPurchaseApplicationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPurchaseApplicationTemplate(organizationId: string, createPurchaseApplicationTemplateRequest: CreatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPurchaseApplicationTemplate(organizationId, createPurchaseApplicationTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Slack card notification settings of an organization
         * @param {string} organizationId 
         * @param {CreateSlackCardNotificationsRequest} createSlackCardNotificationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSlackCardNotifications(organizationId: string, createSlackCardNotificationsRequest: CreateSlackCardNotificationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSlackCardNotifications(organizationId, createSlackCardNotificationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create slack notification settings for purchase-application
         * @param {string} organizationId 
         * @param {CreateSlackNotificationSettingsForPurchaseApplicationRequest} createSlackNotificationSettingsForPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSlackNotificationSettingsForPurchaseApplication(organizationId: string, createSlackNotificationSettingsForPurchaseApplicationRequest: CreateSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSlackNotificationSettingsForPurchaseApplication(organizationId, createSlackNotificationSettingsForPurchaseApplicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Teams card notification settings of an organization
         * @param {string} organizationId 
         * @param {CreateTeamsCardNotificationsRequest} createTeamsCardNotificationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamsCardNotifications(organizationId: string, createTeamsCardNotificationsRequest: CreateTeamsCardNotificationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamsCardNotifications(organizationId, createTeamsCardNotificationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create user account groups
         * @param {string} organizationId 
         * @param {CreateUserAccountGroupsRequest} [createUserAccountGroupsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserAccountGroups(organizationId: string, createUserAccountGroupsRequest?: CreateUserAccountGroupsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateUserAccountGroups200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserAccountGroups(organizationId, createUserAccountGroupsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deactivate a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateCard(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeactivateCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateCard(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deactivate ETC card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateEtcCard(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeactivateEtcCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateEtcCard(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deactivate a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Defrost a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async defrostCard(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefrostCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.defrostCard(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Card Points Rate Configs
         * @param {string} rateConfigId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCardPointsRateConfig(rateConfigId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCardPointsRateConfig(rateConfigId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete category of the purchase application template.
         * @param {string} organizationId 
         * @param {string} purchaseTemplateCategoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategoryOfThePurchaseApplicationTemplate(organizationId: string, purchaseTemplateCategoryId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategoryOfThePurchaseApplicationTemplate(organizationId, purchaseTemplateCategoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionCommentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComment(organizationId: string, paymentReferenceId: string, cardTransactionCommentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComment(organizationId, paymentReferenceId, cardTransactionCommentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommentTemplate(organizationId: string, templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommentTemplate(organizationId, templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDepositRestrictionForOrganization(organizationId: string, depositRestrictionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDepositRestrictionForOrganization(organizationId, depositRestrictionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete evidence
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvidence(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvidence(organizationId, paymentReferenceId, cardTransactionEvidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete freee connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFreeeConnected(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFreeeConnected200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFreeeConnected(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Freee End Journal Entry Transition Mode
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFreeeEndJournalEntryTransitionMode(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFreeeEndJournalEntryTransitionMode(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete merchant general block allowed organization ids
         * @param {string} merchantGeneralBlockListId 
         * @param {string} allowedOrganizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMerchantGeneralBlockAllowedOrganizationIds(merchantGeneralBlockListId: string, allowedOrganizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMerchantGeneralBlockAllowedOrganizationIds(merchantGeneralBlockListId, allowedOrganizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete merchant general block list
         * @param {string} merchantGeneralBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMerchantGeneralBlockList(merchantGeneralBlockListId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMerchantGeneralBlockList(merchantGeneralBlockListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete merchant org block list
         * @param {string} merchantOrgBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMerchantOrgBlockList(merchantOrgBlockListId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMerchantOrgBlockList(merchantOrgBlockListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an onboarding request
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOnboardingRequest(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOnboardingRequest(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Organization Create Request
         * @param {string} organizationCreateRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationCreateRequest(organizationCreateRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationCreateRequest(organizationCreateRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a payment request evidence specified by evidenceId.
         * @summary Delete the specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePaymentRequestEvidence(organizationId: string, paymentRequestId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePaymentRequestEvidence(organizationId, paymentRequestId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseApplication(organizationId: string, purchaseApplicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseApplication(organizationId, purchaseApplicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete purchase application templates detail
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePurchaseApplicationTemplatesDetail(organizationId: string, purchaseTemplateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePurchaseApplicationTemplatesDetail(organizationId, purchaseTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSlackNotificationChannelSettingForPurchaseApplication(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSlackNotificationChannelSettingForPurchaseApplication(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSlackNotificationSettingForCard(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSlackNotificationSettingForCard(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete system admin role
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSystemAdminRole(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSystemAdminRole(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamsNotificationSettingForCard(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamsNotificationSettingForCard(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user account group
         * @param {number} userAccountGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserAccountGroup(userAccountGroupId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeleteUserAccountGroup200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserAccountGroup(userAccountGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deposit Guarantee Money Balance
         * @param {string} organizationId 
         * @param {DepositGuaranteeMoneyBalanceRequest} depositGuaranteeMoneyBalanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async depositGuaranteeMoneyBalance(organizationId: string, depositGuaranteeMoneyBalanceRequest: DepositGuaranteeMoneyBalanceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.depositGuaranteeMoneyBalance(organizationId, depositGuaranteeMoneyBalanceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable Approval
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableApproval(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableApproval200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableApproval(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableDailyUserUsageLimit(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableDailyUserUsageLimit200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableDailyUserUsageLimit(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable physical store payment for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disablePhysicalStorePaymentForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisablePhysicalStorePaymentForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disablePhysicalStorePaymentForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable transaction upper limit for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableTransactionUpperLimitForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableTransactionUpperLimitForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableTransactionUpperLimitForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disable usage limit for an user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableUserUsageLimit(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisableUserUsageLimit200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableUserUsageLimit(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disagree to the agreement request
         * @param {string} organizationId 
         * @param {string} agreementRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disagreeToAgreementRequest(organizationId: string, agreementRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disagreeToAgreementRequest(organizationId, agreementRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary freee接続解除
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectFreeeForAccounting(orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectFreeeForAccounting(orgAccountId, upsidrPrivateClientApiInternal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download bank transfer file
         * @param {string} organizationId 
         * @param {string} bankTransferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBankTransferFile(organizationId: string, bankTransferId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBankTransferFile(organizationId, bankTransferId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download bank transfers csv
         * @param {string} organizationId 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBankTransfersCsv(organizationId: string, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBankTransfersCsv(organizationId, transferDateJstFrom, transferDateJstTo, sourceBankAccountId, downloaded, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download ETC accounting CSV
         * @param {string} organizationId 
         * @param {string} yearMonth Target year-month in YYYYMM format
         * @param {'USAGE_MONTH' | 'BILLING_MONTH'} dateType Date aggregation basis (USAGE_MONTH &#x3D; by usage month, BILLING_MONTH &#x3D; by billing month)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEtcAccountingCsv(organizationId: string, yearMonth: string, dateType: 'USAGE_MONTH' | 'BILLING_MONTH', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEtcAccountingCsv(organizationId, yearMonth, dateType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download journal entry for freee csv
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadJournalEntryForFreeeCsv(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadJournalEntryForFreeeCsv(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download Organizations Accounting Csv
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOrganizationsAccountingCsv(organizationId: string, yearMonth: string, isMergedFiles: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOrganizationsAccountingCsv(organizationId, yearMonth, isMergedFiles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download payment requests csv
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified status.
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPaymentRequestsCsv(organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', freeWord?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPaymentRequestsCsv(organizationId, dueDateJstFrom, dueDateJstTo, statuses, supplierId, transferDataCreated, withholdingApplied, transferFeeResponsibility, freeWord, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download payment requests csv for payment request ids specification
         * @param {string} organizationId 
         * @param {DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest} [downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(organizationId: string, downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest?: DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(organizationId, downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enable physical store payment for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enablePhysicalStorePaymentForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnablePhysicalStorePaymentForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enablePhysicalStorePaymentForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Freeze a card
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freezeCard(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreezeCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freezeCard(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Freeze Organization
         * @param {string} organizationId 
         * @param {FreezeOrganizationRequest} freezeOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async freezeOrganization(organizationId: string, freezeOrganizationRequest: FreezeOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FreezeOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.freezeOrganization(organizationId, freezeOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate Annual Fees Invoice
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAnnualFeesInvoice(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAnnualFeesInvoice(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate Create Account Token
         * @param {GenerateCreateAccountTokenRequest} generateCreateAccountTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCreateAccountToken(generateCreateAccountTokenRequest: GenerateCreateAccountTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCreateAccountToken(generateCreateAccountTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate freee redirect url
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateFreeeRedirectUrl(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateFreeeRedirectUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFreeeRedirectUrl(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate org account ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOrgAccountIds(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOrgAccountIds(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a Card Detail as Admin
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getACardDetailAsAdmin(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetACardDetailAsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getACardDetailAsAdmin(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get accounting csv for the organization.
         * @param {string} organizationId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {'FREEE' | 'MONEY_FORWARD'} accountingSystemType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountingCsvForTheOrganization(organizationId: string, startYearMonth: string, endYearMonth: string, accountingSystemType: 'FREEE' | 'MONEY_FORWARD', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountingCsvForTheOrganization(organizationId, startYearMonth, endYearMonth, accountingSystemType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get accounting csv for the user account.
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountingCsvForTheUserAccount(userAccountId: string, yearMonth: string, isMergedFiles: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountingCsvForTheUserAccount(userAccountId, yearMonth, isMergedFiles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get admin users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminUsers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get admins
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdmins(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAdmins200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdmins(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get agreement requests
         * @param {string} organizationId 
         * @param {boolean} waitingForAgreement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreementRequests(organizationId: string, waitingForAgreement: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAgreementRequests200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreementRequests(organizationId, waitingForAgreement, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all banks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBanks(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAllBanks200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBanks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get analysis invoice of payment request
         * @param {string} organizationId 
         * @param {string} fileId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalysisInvoiceOfPaymentRequest(organizationId: string, fileId: string, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnalysisInvoiceOfPaymentRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalysisInvoiceOfPaymentRequest(organizationId, fileId, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get annual fees eligibility
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnualFeesEligibility(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnnualFeesEligibility200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnualFeesEligibility(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get approvers
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApprovers(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetApprovers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApprovers(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get available currency options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableCurrencyOptions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableCurrencyOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * <p>   Return a list of feature names that are available for the organization.   Most features are unconditionally available to all organizations and   are not included in the response of this API, while some new features are not   available for the organization unless their names are included in this response. </p> <p>   The response schema are designed to ensure that information about new features   is not disclosed to organizations that cannot use them. </p>
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableFeatures(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableFeatures(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Available merchant category options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableMerchantCategoryOptions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAvailableMerchantCategoryOptions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableMerchantCategoryOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get balance state
         * @param {string} organizationId 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceState(organizationId: string, targetDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBalanceState200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceState(organizationId, targetDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get bank account activities
         * @param {number} bankAccountActivityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccountActivities(bankAccountActivityId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBankAccountActivities200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccountActivities(bankAccountActivityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a bank account confirmed activities
         * @param {string} organizationId 
         * @param {'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY' | 'SERVICE_CHARGE'} [type] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccountConfirmedActivities(organizationId: string, type?: 'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY' | 'SERVICE_CHARGE', limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBankAccountConfirmedActivities200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccountConfirmedActivities(organizationId, type, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get bank by name
         * @param {string} bankName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankByName(bankName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBankByName200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankByName(bankName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a bank transfer
         * @param {string} organizationId 
         * @param {string} bankTransferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankTransfer(organizationId: string, bankTransferId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBankTransfer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankTransfer(organizationId, bankTransferId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the specified bank\'s all branches
         * @param {string} bankCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBanksAllBranches(bankCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBanksAllBranches200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBanksAllBranches(bankCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get bookkeepers
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookkeepers(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBookkeepers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookkeepers(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get branch
         * @param {string} bankCode 
         * @param {string} branchName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranch(bankCode: string, branchName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBranch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranch(bankCode, branchName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all business descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBusinessDescriptions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetBusinessDescriptions200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBusinessDescriptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get if an organization can activate cards
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanActivateCard(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanActivateCard(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the status of whether the organization can close
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanCloseStatuses(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCanCloseStatuses200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanCloseStatuses(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get can deactivate
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanDeactivate(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCanDeactivate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanDeactivate(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get if the user can read card\'s sensitive info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanReadCardSensitive(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanReadCardSensitive(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get if an organization can request a real card to be issued.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanRequestSendingCard(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanRequestSendingCard(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns whether the current user is eligible for canary routing (read-only, no cookie side-effect)
         * @summary Get canary routing eligibility status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanaryRoutingStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCanaryRoutingStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanaryRoutingStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Card Bill
         * @param {string} cardBillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardBill(cardBillId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardBill200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardBill(cardBillId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Card Detail
         * @param {string} cardId 
         * @param {string} [xChallengeSuccessToken] sudo-mode challenge 検証成功時に発行される token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardDetail(cardId: string, xChallengeSuccessToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardDetail(cardId, xChallengeSuccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get card monthly transactions
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardMonthlyTransactions(userAccountId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardMonthlyTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardMonthlyTransactions(userAccountId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Card Points Rate Configs By OrganizationId
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardPointsRateConfigsByOrganizationId(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCardPointsRateConfigsByOrganizationId200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardPointsRateConfigsByOrganizationId(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get card transaction details
         * @param {string} organizationId 
         * @param {string} visaTransactionReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardTransactionDetails(organizationId: string, visaTransactionReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardTransactionDetails200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardTransactionDetails(organizationId, visaTransactionReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get card transaction evidence record image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {string} id 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardTransactionEvidenceRecordImage(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, id: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardTransactionEvidenceRecordImage(organizationId, paymentReferenceId, cardTransactionEvidenceId, id, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get card transaction evidence records
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardTransactionEvidenceRecords(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCardTransactionEvidenceRecords200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardTransactionEvidenceRecords(organizationId, paymentReferenceId, cardTransactionEvidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Card Transactions
         * @param {string} userAccountId 
         * @param {string} merchantId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardTransactions(userAccountId: string, merchantId: string, toYearMonth: string, fromYearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCardTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardTransactions(userAccountId, merchantId, toYearMonth, fromYearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get cards
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCards(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCards200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCards(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get cards transactions with purchase application unlinked
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardsTransactionsWithPurchaseApplicationUnlinked(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardsTransactionsWithPurchaseApplicationUnlinked(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the category of the purchase application template for use.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryOfThePurchaseApplicationTemplate(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCategoryOfThePurchaseApplicationTemplate200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryOfThePurchaseApplicationTemplate(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComment(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetComment200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComment(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get comment templates
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentTemplates(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCommentTemplates200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentTemplates(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommentTemplatesCommentTemplateId(organizationId: string, templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCommentTemplatesCommentTemplateId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommentTemplatesCommentTemplateId(organizationId, templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get current card associated with the user account
         * @param {string} userAccountId 
         * @param {boolean} [includeMerchantCategories] Whether to include available merchant categories in the response. Set to false to improve performance when merchant categories are not needed.
         * @param {Array<'reissue'>} [expand] Stripe-style expand parameter for opt-in property expansion. Specifies optional properties to include in the response; properties not listed are omitted from the response body entirely (the key is absent, not &#x60;null&#x60;).  Multiple values can be specified by repeating the parameter, e.g. &#x60;/current_card?expand&#x3D;reissue&amp;expand&#x3D;foo&#x60;.  Currently supported values:  - &#x60;reissue&#x60;: includes the &#x60;reissue&#x60; object describing the previous card    that was replaced by automatic reissuance. &#x60;null&#x60; if this card is not    a reissued card.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentCardAssociatedWithTheUserAccount(userAccountId: string, includeMerchantCategories?: boolean, expand?: Array<'reissue'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentCardAssociatedWithTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentCardAssociatedWithTheUserAccount(userAccountId, includeMerchantCategories, expand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get current ETC card associated with the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentEtcCard(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentEtcCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentEtcCard(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get deals total amount
         * @param {number} organizationId 
         * @param {GetDealsTotalAmountRequest} [getDealsTotalAmountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDealsTotalAmount(organizationId: number, getDealsTotalAmountRequest?: GetDealsTotalAmountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDealsTotalAmount(organizationId, getDealsTotalAmountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get default comment template for user account
         * @param {string} organizationId 
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultCommentTemplate(organizationId: string, userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDefaultCommentTemplate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultCommentTemplate(organizationId, userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deposit bank account
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepositBankAccount(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDepositBankAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepositBankAccount(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepositRestrictionForOrganization(organizationId: string, depositRestrictionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDepositRestrictionForOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepositRestrictionForOrganization(organizationId, depositRestrictionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deposit restriction list for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepositRestrictionListForOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDepositRestrictionListForOrganization200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepositRestrictionListForOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all deposit restrictions for the organization of the currently authenticated user
         * @summary Get deposit restrictions for current user\'s organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepositRestrictions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDepositRestrictions200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepositRestrictions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftPaymentRequest(organizationId: string, draftPaymentRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDraftPaymentRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftPaymentRequest(organizationId, draftPaymentRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get draft payment request evidence file
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftPaymentRequestEvidenceFile(organizationId: string, draftPaymentRequestId: string, evidenceId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftPaymentRequestEvidenceFile(organizationId, draftPaymentRequestId, evidenceId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get draft payment requests only created own
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftPaymentRequestsOnlyCreatedOwn(organizationId: string, xUpsidrSwitchUser?: string, freeWord?: string, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftPaymentRequestsOnlyCreatedOwn(organizationId, xUpsidrSwitchUser, freeWord, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get earliest expiring guarantee money for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEarliestExpiringGuaranteeMoneyForOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEarliestExpiringGuaranteeMoneyForOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEarliestExpiringGuaranteeMoneyForOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtain email notification configuration information for each user.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailNotifications(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEmailNotifications200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailNotifications(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get error bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErrorBills(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetErrorBills200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErrorBills(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Checks if an ETC account exists for the specified organization. This is used to determine if ETC service has been initiated for the organization.
         * @summary Get ETC account status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtcAccount(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEtcAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtcAccount(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get ETC card billing amounts per card for specified yearMonth
         * @param {string} organizationId 
         * @param {string} yearMonth Settlement year-month in YYYYMM format (e.g., \&quot;202603\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtcAmounts(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEtcAmounts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtcAmounts(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get ETC card count for organization
         * @param {string} organizationId 
         * @param {string} [searchWord] Search by card label or holder name (partial match)
         * @param {Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>} [statuses] Filter by card status
         * @param {Array<string>} [groups] Filter by user account group IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtcCardCount(organizationId: string, searchWord?: string, statuses?: Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>, groups?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEtcCardCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtcCardCount(organizationId, searchWord, statuses, groups, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns sensitive card information. Only accessible by the card holder. - Card number: 16 digits, displayed with spaces (e.g., \"1234 5678 9012 3456\") - Expiry: Year and month separately - Cardholder name: Copyable 
         * @summary Get ETC card personal information (card number, expiry, cardholder name)
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtcCardDetail(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEtcCardDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtcCardDetail(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns ETC card usage history with pagination. - Amount: Negative for normal transactions, positive for cancellations - Display format for usedAt: \"12月9日\" (without zero padding) 
         * @summary Get ETC card transactions
         * @param {string} userAccountId 
         * @param {string} yearMonth Target year and month (format: yyyyMM)
         * @param {string} [search] Search query (filter by highway name)
         * @param {number} [limit] Number of items to return (default 50, max 200)
         * @param {string} [nextCursor] Cursor for pagination. Pass the &#x60;nextCursor&#x60; value returned in the previous response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtcCardTransactions(userAccountId: string, yearMonth: string, search?: string, limit?: number, nextCursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEtcCardTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtcCardTransactions(userAccountId, yearMonth, search, limit, nextCursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get ETC cards
         * @param {string} organizationId 
         * @param {string} [searchWord] Search by card label or holder name (partial match)
         * @param {Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>} [statuses] Filter by card status
         * @param {Array<string>} [groups] Filter by user account group IDs
         * @param {number} [limit] Number of items to return (default 50, max 200)
         * @param {string} [nextCursor] Cursor for pagination. Pass the &#x60;nextCursor&#x60; value returned in the previous response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEtcCards(organizationId: string, searchWord?: string, statuses?: Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>, groups?: Array<string>, limit?: number, nextCursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEtcCards200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEtcCards(organizationId, searchWord, statuses, groups, limit, nextCursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the evidence specified by evidenceId.
         * @summary Get a specific evidence.
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidence(organizationId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEvidence200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidence(organizationId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence file
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceFile(organizationId: string, evidenceId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceFile(organizationId, evidenceId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceImage(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceImage(organizationId, paymentReferenceId, cardTransactionEvidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence information for card transactions
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceInformationForCardTransactions(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEvidenceInformationForCardTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceInformationForCardTransactions(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence record image
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {string} recordId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceRecordImage(organizationId: string, evidenceId: string, recordId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceRecordImage(organizationId, evidenceId, recordId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence records
         * @param {string} organizationId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceRecords(organizationId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEvidenceRecords200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceRecords(organizationId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidence zip for the organization.
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceZipForTheOrganization(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceZipForTheOrganization(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get evidences
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidences(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEvidences200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidences(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Count evidences
         * @param {string} organizationId 
         * @param {string} [issuer] This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
         * @param {number} [amountMin] 
         * @param {number} [amountMax] 
         * @param {string} [paidAtFrom] 
         * @param {string} [paidAtTo] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {string} [keyword] Specified keyword is searched from the issuer and the note by partial match.
         * @param {boolean} [includesDeleted] 
         * @param {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>} [legalValidities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidencesCount(organizationId: string, issuer?: string, amountMin?: number, amountMax?: number, paidAtFrom?: string, paidAtTo?: string, irrelevantToLedger?: boolean, keyword?: string, includesDeleted?: boolean, legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEvidencesCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidencesCount(organizationId, issuer, amountMin, amountMax, paidAtFrom, paidAtTo, irrelevantToLedger, keyword, includesDeleted, legalValidities, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the triggered transaction of a fraud locked card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFraudLockedCardTransaction(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFraudLockedCardTransaction200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFraudLockedCardTransaction(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee account items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeAccountItems(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeAccountItems200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeAccountItems(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee companies
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeCompanies(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeCompanies200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeCompanies(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeConnected(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeConnected200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeConnected(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Freee Connected User
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeConnectedUser(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeConnectedUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeConnectedUser(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary freee接続中のユーザー取得
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeConnectionLinkedAccountForAccounting(orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeConnectionLinkedAccountForAccounting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeConnectionLinkedAccountForAccounting(orgAccountId, upsidrPrivateClientApiInternal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary freee設定取得
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeConnectionSettingsForAccounting(orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeConnectionSettingsForAccounting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeConnectionSettingsForAccounting(orgAccountId, upsidrPrivateClientApiInternal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeItems(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeItems200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeItems(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee memo tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeMemoTags(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeMemoTags200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeMemoTags(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee partners
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeePartners(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeePartners200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeePartners(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee sections
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeSections(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeSections200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeSections(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee segment tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeSegmentTags(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeSegmentTags200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeSegmentTags(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee sync status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeSyncStatus(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeSyncStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeSyncStatus(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {string} tagName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeTags(organizationId: string, companyId: string, tagName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeTags200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeTags(organizationId, companyId, tagName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee taxes
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeTaxes(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetFreeeTaxes200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeTaxes(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get freee token
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreeeToken(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFreeeToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreeeToken(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a guarantee money balance history
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGuaranteeMoneyBalanceHistory(organizationId: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetGuaranteeMoneyBalanceHistory200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGuaranteeMoneyBalanceHistory(organizationId, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a guarantee money balance information for a organization
         * @param {string} organizationId 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGuaranteeMoneyBalanceInformationForOrganization(organizationId: string, targetDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGuaranteeMoneyBalanceInformationForOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGuaranteeMoneyBalanceInformationForOrganization(organizationId, targetDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get guarantee money deposits for organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGuaranteeMoneyDepositsForOrganization(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetGuaranteeMoneyDepositsForOrganization200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGuaranteeMoneyDepositsForOrganization(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [from] yyyy-MM-dd format date in JST.
         * @param {string} [to] yyyy-MM-dd format date in JST.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHolidays(from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHolidays(from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentifyVerificationsLatest(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIdentifyVerificationsLatest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentifyVerificationsLatest(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdentityVerifications(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetIdentityVerifications200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdentityVerifications(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Invoice List
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceList(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInvoiceList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceList(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Invoice Pdf
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicePdf(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicePdf(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get issuable status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssuableStatus(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssuableStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssuableStatus(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get jwt for SSO
         * @param {string} nonce 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJwtSso(nonce: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJwtSso200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJwtSso(nonce, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of KYC reader users ordered by creation date in descending order.
         * @summary Get KYC Reader Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKycReaderUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetKycReaderUsers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKycReaderUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get latest time of sync to freee
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestTimeOfSyncToFreee(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLatestTimeOfSyncToFreee200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestTimeOfSyncToFreee(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get lock status of evidences
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLockStatusOfEvidences(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLockStatusOfEvidences200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLockStatusOfEvidences(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant general blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantGeneralBlock(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMerchantGeneralBlock200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantGeneralBlock(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant general block detail
         * @param {string} merchantGeneralBlockListId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantGeneralBlockDetail(merchantGeneralBlockListId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMerchantGeneralBlockDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantGeneralBlockDetail(merchantGeneralBlockListId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant org blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantOrgBlock(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMerchantOrgBlock200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantOrgBlock(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant org block list
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantOrgBlockList(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMerchantOrgBlockList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantOrgBlockList(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get merchant organization user account year month summary
         * @param {string} organizationId 
         * @param {string} merchantId 
         * @param {string} userAccountId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantOrganizationUserAccountYearMonthSummary(organizationId: string, merchantId: string, userAccountId: string, toYearMonth: string, fromYearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMerchantOrganizationUserAccountYearMonthSummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantOrganizationUserAccountYearMonthSummary(organizationId, merchantId, userAccountId, toYearMonth, fromYearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a list of MerchantCategoryKind
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantsCategoryKinds(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMerchantsCategoryKinds200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantsCategoryKinds(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Modifiable Daily Limits For The User Account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModifiableDailyLimitsForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModifiableDailyLimitsForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModifiableDailyLimitsForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get modifiable monthly limits for the user account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModifiableMonthlyLimitsForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModifiableMonthlyLimitsForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModifiableMonthlyLimitsForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Modifiable Transaction Limits For The User Account
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModifiableTransactionLimitsForTheUserAccount(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModifiableTransactionLimitsForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModifiableTransactionLimitsForTheUserAccount(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get moneytree connected
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoneytreeConnected(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMoneytreeConnected200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoneytreeConnected(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get moneytree oauth url
         * @param {string} organizationId 
         * @param {string} [nextTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoneytreeOauthUrl(organizationId: string, nextTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMoneytreeOauthUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoneytreeOauthUrl(organizationId, nextTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get moneytree status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoneytreeStatus(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMoneytreeStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoneytreeStatus(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get monthly card bills for specified yearMonths
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {string} [startYearMonth] 
         * @param {string} [endYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyCardBill(organizationId: string, yearMonth?: string, startYearMonth?: string, endYearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMonthlyCardBill200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyCardBill(organizationId, yearMonth, startYearMonth, endYearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get monthly card transactions for the organization.
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyCardTransactionsForTheOrganization(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMonthlyCardTransactionsForTheOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyCardTransactionsForTheOrganization(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get monthly card transactions for the user
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyCardTransactionsForTheUser(yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMonthlyCardTransactionsForTheUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyCardTransactionsForTheUser(yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定された組織・年月のFlora課金情報（サービス料金）を取得します。 年会費、ラウンジ利用料などのFlora課金明細を返却します。  **注意**: このAPIはFlora課金情報のみを返します。カード決済情報は `/cards/monthly_card_bill` APIを使用してください。 
         * @summary Get Monthly Service Charges
         * @param {string} organizationId 
         * @param {string} yearMonth Year and month in yyyyMM format (e.g., 202506)
         * @param {number} [limit] Maximum number of items to return (1-100, default: 100)
         * @param {number} [offset] Number of items to skip (default: 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyServiceCharges(organizationId: string, yearMonth: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMonthlyServiceCharges200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyServiceCharges(organizationId, yearMonth, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get monthly user card summaries
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMonthlyUserCardSummaries(organizationId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetMonthlyUserCardSummaries200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMonthlyUserCardSummaries(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get OL info sharing consent status
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOlInfoSharingConsent(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOlInfoSharingConsent200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOlInfoSharingConsent(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a specific onboarding request for zeus
         * @param {string} onboardingRequestId The ID of the onboarding request to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingRequestById(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOnboardingRequestById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingRequestById(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get personal information of the onboarding request.
         * @summary Get Personal Information
         * @param {string} onboardingRequestId Onboarding request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingRequestPersonalInfo(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOnboardingRequestPersonalInfo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingRequestPersonalInfo(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get onboarding requests for zeus
         * @param {string} [key] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'id' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingRequests(key?: string, createdAtFrom?: string, createdAtTo?: string, limit?: number, offset?: number, sort?: 'id' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOnboardingRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingRequests(key, createdAtFrom, createdAtTo, limit, offset, sort, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get org account state
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgAccountState(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrgAccountState200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgAccountState(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organization
         * @param {string} organizationId 
         * @param {boolean} [underContractOnly] 
         * @param {boolean} [withCredit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(organizationId: string, underContractOnly?: boolean, withCredit?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(organizationId, underContractOnly, withCredit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organization Accounting Csv Fields Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationAccountingCsvFieldsTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationAccountingCsvFieldsTypes200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationAccountingCsvFieldsTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization cards extended
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCardsExtended(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationCardsExtended200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCardsExtended(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization cards light
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCardsLight(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationCardsLight200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCardsLight(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization chart departments
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationChartDepartments(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationChartDepartments200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationChartDepartments(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization chart employees
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationChartEmployees(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationChartEmployees200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationChartEmployees(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization chart roles
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationChartRoles(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationChartRoles200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationChartRoles(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organizations create requests for zeus
         * @param {string} [key] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'id' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCreateRequests(key?: string, createdAtFrom?: string, createdAtTo?: string, limit?: number, offset?: number, sort?: 'id' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationCreateRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCreateRequests(key, createdAtFrom, createdAtTo, limit, offset, sort, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organization Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationMe200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization payment schemes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationPaymentSchemes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Array<GetOrganizationPaymentSchemes200ResponseInnerInner>>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationPaymentSchemes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 請求画面トップのサマリー表示に必要な情報を、組織レベルで取得する。 個別の請求実体（CardBill / ServiceCharge）に依存せず、組織に設定されている 支払スキームと、対象支払予定日に紐づく合算情報を返す。  ## 用途 - UPSIDER 請求画面トップ（`/payments/`）のサマリーカード表示 - ETC-only 組織（CARD 請求が発生しない組織）でもサマリーを描画可能にする  ## 関連 - 個別請求の詳細取得は引き続き以下を使用：   - カード請求: `/cards/{cardBillId}`   - サービス利用料明細: `/organizations/{organizationId}/service_charges/{yearMonth}` - 請求一覧（履歴全件）の取得: `/organizations/{organizationId}/payments` 
         * @summary Get payment summary for organization
         * @param {string} organizationId 
         * @param {string} [yearMonth] 対象利用月（yyyyMM 形式、例: 202604）。 指定された月に対応する MonthlyPayment のサマリーを返す。 未指定の場合は組織の「最新の MonthlyPayment（直近の支払予定日のもの）」のサマリーを返す。 ※「最新」の具体定義はバックエンド実装時に確定。 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationPaymentSummary(organizationId: string, yearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationPaymentSummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationPaymentSummary(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization payments
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationPayments(organizationId: string, yearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationPayments200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationPayments(organizationId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizations200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organizations Accounting Csv Export Fields
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsAccountingCsvExportFields(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsAccountingCsvExportFields(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a organization\'s bill
         * @param {string} organizationId 
         * @param {boolean} [beforeReservationOnly] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsBills(organizationId: string, beforeReservationOnly?: boolean, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationsBills200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsBills(organizationId, beforeReservationOnly, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organizations deals
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsDeals(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationsDeals200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsDeals(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment request detail
         * @param {string} organizationId 
         * @param {string} [paymentRequestId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestDetail(organizationId: string, paymentRequestId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaymentRequestDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestDetail(organizationId, paymentRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a payment request evidence specified by evidenceId.
         * @summary Get a specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidence(organizationId: string, paymentRequestId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaymentRequestEvidence200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidence(organizationId, paymentRequestId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment request evidence file
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidenceFile(organizationId: string, paymentRequestId: string, evidenceId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidenceFile(organizationId, paymentRequestId, evidenceId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment request evidence record file
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {string} recordId 
         * @param {boolean} [inPdf] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidenceRecordFile(organizationId: string, paymentRequestId: string, evidenceId: string, recordId: string, inPdf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidenceRecordFile(organizationId, paymentRequestId, evidenceId, recordId, inPdf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment request evidence records
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidenceRecords(organizationId: string, paymentRequestId: string, evidenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPaymentRequestEvidenceRecords200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidenceRecords(organizationId, paymentRequestId, evidenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get all evidences for a specific payment request
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestEvidences(organizationId: string, paymentRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPaymentRequestEvidences200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestEvidences(organizationId, paymentRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment requests bank accounts list
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestsBankAccountsList(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPaymentRequestsBankAccountsList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestsBankAccountsList(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment requests count linked bank transfer
         * @param {string} organizationId 
         * @param {string} paymentRequestIds When specifying more than one, separate them by commas.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentRequestsCountLinkedBankTransfer(organizationId: string, paymentRequestIds: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentRequestsCountLinkedBankTransfer(organizationId, paymentRequestIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get pinretriever decrypt pin block
         * @param {GetPinretrieverDecryptPinBlockRequest} getPinretrieverDecryptPinBlockRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPinretrieverDecryptPinBlock(getPinretrieverDecryptPinBlockRequest: GetPinretrieverDecryptPinBlockRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPinretrieverDecryptPinBlock200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPinretrieverDecryptPinBlock(getPinretrieverDecryptPinBlockRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get pinretriever encrypt pin
         * @param {GetPinretrieverEncryptPinRequest} getPinretrieverEncryptPinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPinretrieverEncryptPin(getPinretrieverEncryptPinRequest: GetPinretrieverEncryptPinRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPinretrieverEncryptPin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPinretrieverEncryptPin(getPinretrieverEncryptPinRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get pinretriever hsm publickey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPinretrieverHsmPublickey(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPinretrieverHsmPublickey200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPinretrieverHsmPublickey(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get purchase application
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplication(organizationId: string, purchaseApplicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPurchaseApplication200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplication(organizationId, purchaseApplicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get purchase application templates
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationTemplates(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPurchaseApplicationTemplates200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationTemplates(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get purchase application templates detail
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationTemplatesDetail(organizationId: string, purchaseTemplateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPurchaseApplicationTemplatesDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationTemplatesDetail(organizationId, purchaseTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get purchase applications
         * @param {string} organizationId 
         * @param {string} [yearMonth] 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplications(organizationId: string, yearMonth?: string, visaTransactionReferenceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPurchaseApplications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplications(organizationId, yearMonth, visaTransactionReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationsRequestedCount(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPurchaseApplicationsRequestedCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationsRequestedCount(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the purchase applications requested list
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationsRequestedList(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPurchaseApplicationsRequestedList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationsRequestedList(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the purchase applications submitted self
         * @param {string} userId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPurchaseApplicationsSubmittedSelf(userId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPurchaseApplicationsSubmittedSelf200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPurchaseApplicationsSubmittedSelf(userId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get(search) qualified invoice issuer
         * @param {string} registrationNumber 
         * @param {string} [issuerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQualifiedInvoiceIssuer(registrationNumber: string, issuerName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQualifiedInvoiceIssuer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQualifiedInvoiceIssuer(registrationNumber, issuerName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Redirect URL from Tiny URL
         * @param {string} tinyUrlParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRedirectUrlFromTinyUrl(tinyUrlParam: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRedirectUrlFromTinyUrl(tinyUrlParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the reward points balance for the specified organization.
         * @summary Get reward points balance
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardPointBalance(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRewardPointBalance200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardPointBalance(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get reward point transactions for the specified organization
         * @summary Get reward point transactions
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardPointTransactions(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRewardPointTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardPointTransactions(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Rewards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewards(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRewards200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewards(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get role resource for user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoleResourceForUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRoleResourceForUser200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoleResourceForUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get roles
         * @param {string} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(category: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRoles200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesWithTopRelatedResources(resourceScope: string, resourceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRolesWithTopRelatedResources200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesWithTopRelatedResources(resourceScope, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources by Organization id
         * @param {string} organizationId 
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesWithTopRelatedResourcesByOrganizationId(organizationId: string, resourceScope: string, resourceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesWithTopRelatedResourcesByOrganizationId(organizationId, resourceScope, resourceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack card notification settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackCardNotificationSettings(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSlackCardNotificationSettings200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackCardNotificationSettings(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a Slack channels of an organization by SlackChannelID
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackChannel(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackChannel200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackChannel(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack channels of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackChannels(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSlackChannels200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackChannels(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack channels with cursor of an organization
         * @param {string} organizationId 
         * @param {string} [cursor] This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackChannelsWithCursor(organizationId: string, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackChannelsWithCursor200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackChannelsWithCursor(organizationId, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackEvidenceReminder(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSlackEvidenceReminder200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackEvidenceReminder(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an slack channel
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackEvidenceReminderPerChannel(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackEvidenceReminderPerChannel200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackEvidenceReminderPerChannel(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackNotificationChannelSettingForPurchaseApplication(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackNotificationChannelSettingForPurchaseApplication200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackNotificationChannelSettingForPurchaseApplication(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get slack notification settings for purchase-application
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackNotificationSettingsForPurchaseApplication(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackNotificationSettingsForPurchaseApplication(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack team
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackTeam(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackTeam200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackTeam(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Slack version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSlackVersion(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSlackVersion200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSlackVersion(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get submitted trustdock data
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmittedTrustdockData(trustdockIdentificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubmittedTrustdockData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubmittedTrustdockData(trustdockIdentificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get suspicious transaction detail list
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuspiciousTransactions(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSuspiciousTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuspiciousTransactions(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams card notification settings of an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsCardNotificationSettings(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTeamsCardNotificationSettings200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsCardNotificationSettings(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams channels of an organization by TeamsChannelID
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsChannel(organizationId: string, channelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTeamsChannel200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsChannel(organizationId, channelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams channels with cursor of an organization
         * @param {string} organizationId 
         * @param {string} [cursor] This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsChannelsWithCursor(organizationId: string, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTeamsChannelsWithCursor200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsChannelsWithCursor(organizationId, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams team
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsTeam(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTeamsTeam200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsTeam(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Teams version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamsVersion(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTeamsVersion200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamsVersion(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Technical Support Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnicalSupportUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTechnicalSupportUsers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTechnicalSupportUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Tfa App QR Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTfaAppQrCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTfaAppQrCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTfaAppRecoveryCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTfaAppRecoveryCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get TFA SMS Recovery Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTfaSmsRecoveryCode(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTfaSmsRecoveryCode(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the count of monthly transactions for the user account
         * @param {string} userAccountId 
         * @param {string} yearMonth 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTheCountOfMonthlyTransactionsForTheUserAccount(userAccountId: string, yearMonth: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTheCountOfMonthlyTransactionsForTheUserAccount(userAccountId, yearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the user account information
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTheUserAccountInformation(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTheUserAccountInformation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTheUserAccountInformation(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get transaction evidence email address
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionEvidenceEmailAddress(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactionEvidenceEmailAddress200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionEvidenceEmailAddress(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Transaction Evidence Email File
         * @param {string} userAccountId 
         * @param {number} transactionEvidenceEmailFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionEvidenceEmailFile(userAccountId: string, transactionEvidenceEmailFileId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionEvidenceEmailFile(userAccountId, transactionEvidenceEmailFileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get transaction evidence emails
         * @param {string} userAccountId 
         * @param {string} startYearMonth 
         * @param {string} endYearMonth 
         * @param {boolean} [isTrash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionEvidenceEmails(userAccountId: string, startYearMonth: string, endYearMonth: string, isTrash?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTransactionEvidenceEmails200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionEvidenceEmails(userAccountId, startYearMonth, endYearMonth, isTrash, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Trustdock Identity Verifications
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrustdockIdentityVerifications(trustdockIdentificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrustdockIdentityVerifications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrustdockIdentityVerifications(trustdockIdentificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Trustdock Submit Identification Document Publish URL
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrustdockSubmitIdentificationDocumentPublishUrl(trustdockIdentificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrustdockSubmitIdentificationDocumentPublishUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrustdockSubmitIdentificationDocumentPublishUrl(trustdockIdentificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Trustdock Verifications
         * @param {string} trustdockIdentificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrustdockVerifications(trustdockIdentificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrustdockVerifications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrustdockVerifications(trustdockIdentificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get unread message count for a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadMessageCount(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnreadMessageCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadMessageCount(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an usage fee
         * @param {number} usageFeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsageFee(usageFeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUsageFee200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageFee(usageFeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user account groups
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAccountGroups(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserAccountGroups200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAccountGroups(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user account year month summary
         * @param {string} organizationId 
         * @param {string} toYearMonth 
         * @param {string} [fromYearMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAccountYearMonthSummary(organizationId: string, toYearMonth: string, fromYearMonth?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserAccountYearMonthSummary200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAccountYearMonthSummary(organizationId, toYearMonth, fromYearMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user accounts with default comment template
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAccountsWithDefaultCommentTemplate(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserAccountsWithDefaultCommentTemplate200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAccountsWithDefaultCommentTemplate(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCards(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCards200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCards(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards extended
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCardsExtended(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCardsExtended200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCardsExtended(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards extended for role resources
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCardsExtendedForRoleResources(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCardsExtendedForRoleResources200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCardsExtendedForRoleResources(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards light
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCardsLight(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCardsLight200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCardsLight(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user cards light for role resources
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCardsLightForRoleResources(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserCardsLightForRoleResources200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCardsLightForRoleResources(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get ETC card count for a user
         * @param {string} userId 
         * @param {string} [searchWord] Search by card label or holder name (partial match)
         * @param {Array<string>} [groups] Filter by user account group IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserEtcCardCount(userId: string, searchWord?: string, groups?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserEtcCardCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserEtcCardCount(userId, searchWord, groups, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get ETC cards for a user
         * @param {string} userId 
         * @param {string} [searchWord] Search by card label or holder name (partial match)
         * @param {Array<string>} [groups] Filter by user account group IDs
         * @param {number} [limit] Number of items to return (default 50, min 1, max 200)
         * @param {string} [nextCursor] Cursor for pagination. Pass the &#x60;nextCursor&#x60; or &#x60;prevCursor&#x60; value returned in the previous response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserEtcCards(userId: string, searchWord?: string, groups?: Array<string>, limit?: number, nextCursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserEtcCards200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserEtcCards(userId, searchWord, groups, limit, nextCursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get message detail
         * @param {string} userMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserMessageDetail(userMessageId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserMessageDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserMessageDetail(userMessageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get messages for a user
         * @param {string} userId 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserMessages(userId: string, offset: number, limit: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserMessages200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserMessages(userId, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get users
         * @param {string} organizationId 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(organizationId: string, email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUsers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(organizationId, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get information on login user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUsersMe200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get venture capitals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVentureCapitals(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVentureCapitals200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVentureCapitals(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定された組織の取引時確認詳細情報を取得します。 createdAtの降順で返却されます。 
         * @summary 取引時確認詳細取得（ZEUS)(PRESIDENT)
         * @param {string} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZeusOrganizationIdentityVerificationsForPresident(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZeusOrganizationIdentityVerificationsForPresident(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organizations for zeus
         * @param {string} [key] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {'ASC' | 'DESC'} [sort] 
         * @param {boolean} [connectedMoneytree] 
         * @param {'UPSIDER' | 'PRESIDENT_CARD'} [brandType] 
         * @param {boolean} [isSuspended] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZeusOrganizations(key?: string, limit?: number, offset?: number, sort?: 'ASC' | 'DESC', connectedMoneytree?: boolean, brandType?: 'UPSIDER' | 'PRESIDENT_CARD', isSuspended?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZeusOrganizations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZeusOrganizations(key, limit, offset, sort, connectedMoneytree, brandType, isSuspended, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * give points to organizations in bulk
         * @param {GivePointsToOrganizationsRequest} givePointsToOrganizationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async givePointsToOrganizations(givePointsToOrganizationsRequest: GivePointsToOrganizationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GivePointsToOrganizations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.givePointsToOrganizations(givePointsToOrganizationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Initialize Modifiable Limit For The User Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initializeModifiableLimitForTheUserAccounts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initializeModifiableLimitForTheUserAccounts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Initiates ETC card service for the specified organization. This creates an ETC account on the yachi microservice that will manage ETC cards. The orgAccountId is derived internally from the organizationId.
         * @summary Initiate ETC service for an organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateEtcService(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitiateEtcService200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateEtcService(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 保持している challengeSuccessToken がまだ有効かどうかを確認する。 保護対象エンドポイントを実際に叩く前に、フロントがチャレンジモーダルを 表示すべきか判断する用途を想定。 
         * @summary challengeSuccessToken の有効性確認
         * @param {string} userId 
         * @param {IntrospectChallengeSuccessTokenRequest} introspectChallengeSuccessTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async introspectChallengeSuccessToken(userId: string, introspectChallengeSuccessTokenRequest: IntrospectChallengeSuccessTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntrospectChallengeSuccessToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.introspectChallengeSuccessToken(userId, introspectChallengeSuccessTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Invite a new user from user
         * @param {InviteUserFromUserRequest} inviteUserFromUserRequest 
         * @param {string} [xChallengeSuccessToken] sudo-mode challenge 検証成功時に発行される token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUserFromUser(inviteUserFromUserRequest: InviteUserFromUserRequest, xChallengeSuccessToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteUserFromUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUserFromUser(inviteUserFromUserRequest, xChallengeSuccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 6桁コードを生成し、登録済みメールアドレスへ送信する。 同一 (userId, scope) の組に既に有効なチャレンジが存在する場合は置き換える （異なる scope のチャレンジは互いに影響せず並行して有効）。 
         * @summary sudo-mode チャレンジの発行
         * @param {string} userId 
         * @param {IssueChallengeRequest} issueChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueChallenge(userId: string, issueChallengeRequest: IssueChallengeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssueChallenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueChallenge(userId, issueChallengeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Linking purchase to transaction.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {string} [visaTransactionReferenceId] 
         * @param {string} [userAccountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkingPurchaseToTransaction(organizationId: string, purchaseApplicationId: string, visaTransactionReferenceId?: string, userAccountId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkingPurchaseToTransaction(organizationId, purchaseApplicationId, visaTransactionReferenceId, userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lock a card due to potential fraud
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {LockCardForPotentialFraudRequest} lockCardForPotentialFraudRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockCardForPotentialFraud(organizationId: string, cardId: string, lockCardForPotentialFraudRequest: LockCardForPotentialFraudRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockCardForPotentialFraud200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockCardForPotentialFraud(organizationId, cardId, lockCardForPotentialFraudRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lock a card due to fraud detected
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {LockCardOnFraudDetectedRequest} lockCardOnFraudDetectedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockCardOnFraudDetected(organizationId: string, cardId: string, lockCardOnFraudDetectedRequest: LockCardOnFraudDetectedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LockCardOnFraudDetected200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockCardOnFraudDetected(organizationId, cardId, lockCardOnFraudDetectedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Login200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with APP two factor auth
         * @param {LoginAppRequest} loginAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginApp(loginAppRequest: LoginAppRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginApp200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginApp(loginAppRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with recovery code of two factor auth
         * @param {LoginRecoveryCodeRequest} loginRecoveryCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginRecoveryCode(loginRecoveryCodeRequest: LoginRecoveryCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginRecoveryCode200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginRecoveryCode(loginRecoveryCodeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login with SMS two factor auth
         * @param {LoginSmsRequest} loginSmsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginSms(loginSmsRequest: LoginSmsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginSms200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginSms(loginSmsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Move slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} currentChannelId 
         * @param {MoveSlackNotificationSettingForCardRequest} moveSlackNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveSlackNotificationSettingForCard(organizationId: string, currentChannelId: string, moveSlackNotificationSettingForCardRequest: MoveSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveSlackNotificationSettingForCard(organizationId, currentChannelId, moveSlackNotificationSettingForCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Move teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} currentChannelId 
         * @param {MoveTeamsNotificationSettingForCardRequest} moveTeamsNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveTeamsNotificationSettingForCard(organizationId: string, currentChannelId: string, moveTeamsNotificationSettingForCardRequest: MoveTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveTeamsNotificationSettingForCard(organizationId, currentChannelId, moveTeamsNotificationSettingForCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Organization Create Pre Request
         * @param {OrganizationCreatePreRequestRequest} organizationCreatePreRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationCreatePreRequest(organizationCreatePreRequestRequest: OrganizationCreatePreRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationCreatePreRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationCreatePreRequest(organizationCreatePreRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Parse organization chart for workflow
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseOrganizationChartForWorkflow(file: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParseOrganizationChartForWorkflow200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseOrganizationChartForWorkflow(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Addition Merchant General Block List
         * @param {PostAdditionMerchantGeneralBlockListRequest} postAdditionMerchantGeneralBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdditionMerchantGeneralBlockList(postAdditionMerchantGeneralBlockListRequest: PostAdditionMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAdditionMerchantGeneralBlockList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdditionMerchantGeneralBlockList(postAdditionMerchantGeneralBlockListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {PostAlliancesGcpApplicationsRequest} postAlliancesGcpApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAlliancesGcpApplications(organizationId: string, postAlliancesGcpApplicationsRequest: PostAlliancesGcpApplicationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAlliancesGcpApplications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAlliancesGcpApplications(organizationId, postAlliancesGcpApplicationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} organizationId 
         * @param {PostAlliancesGwsApplicationsRequest} postAlliancesGwsApplicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAlliancesGwsApplications(organizationId: string, postAlliancesGwsApplicationsRequest: PostAlliancesGwsApplicationsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAlliancesGwsApplications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAlliancesGwsApplications(organizationId, postAlliancesGwsApplicationsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search Bank Account Balances
         * @param {PostBalancesRequest} postBalancesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBalances(postBalancesRequest: PostBalancesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostBalances200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBalances(postBalancesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Bulk Addition Merchant Org Block Lists
         * @param {string} organizationId 
         * @param {Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>} postBulkAdditionMerchantOrgBlockListsRequestInner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBulkAdditionMerchantOrgBlockLists(organizationId: string, postBulkAdditionMerchantOrgBlockListsRequestInner: Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBulkAdditionMerchantOrgBlockLists(organizationId, postBulkAdditionMerchantOrgBlockListsRequestInner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary freee認可コールバック
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {PostCallbackFreeeAuthForAccountingRequest} [postCallbackFreeeAuthForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCallbackFreeeAuthForAccounting(orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, postCallbackFreeeAuthForAccountingRequest?: PostCallbackFreeeAuthForAccountingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCallbackFreeeAuthForAccounting(orgAccountId, upsidrPrivateClientApiInternal, postCallbackFreeeAuthForAccountingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Checks whether the current user is eligible for canary routing and sets appropriate cookie
         * @summary Check if user is eligible for canary routing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCanaryRoutingCheck(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCanaryRoutingCheck200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCanaryRoutingCheck(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post a cancel request for a evidence request
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCancelRequestForEvidenceRequest(organizationId: string, paymentReferenceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCancelRequestForEvidenceRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCancelRequestForEvidenceRequest(organizationId, paymentReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostCardsVirtualIssueRequest} postCardsVirtualIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCardsVirtualIssue(postCardsVirtualIssueRequest: PostCardsVirtualIssueRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCardsVirtualIssue200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCardsVirtualIssue(postCardsVirtualIssueRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCardsVirtualOndemandIssue(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCardsVirtualOndemandIssue200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCardsVirtualOndemandIssue(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload identity document file with verification information.
         * @summary Upload Identity Document
         * @param {string} onboardingRequestId Onboarding request ID
         * @param {File} file Identity document file
         * @param {string} [personalDocumentType] Type of personal identification document
         * @param {string} [verifiedBy] Name of the person who verified the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFaceToFaceKycIdentityDocument(onboardingRequestId: string, file: File, personalDocumentType?: string, verifiedBy?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFaceToFaceKycIdentityDocument(onboardingRequestId, file, personalDocumentType, verifiedBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Submit a face-to-face KYC request.
         * @summary Face-to-face KYC Request
         * @param {PostFaceToFaceKycRequestRequest} postFaceToFaceKycRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFaceToFaceKycRequest(postFaceToFaceKycRequestRequest: PostFaceToFaceKycRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostFaceToFaceKycRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFaceToFaceKycRequest(postFaceToFaceKycRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Freee Account for Points
         * @param {string} organizationId 
         * @param {PostFreeeAccountForPointsRequest} postFreeeAccountForPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFreeeAccountForPoints(organizationId: string, postFreeeAccountForPointsRequest: PostFreeeAccountForPointsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFreeeAccountForPoints(organizationId, postFreeeAccountForPointsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postKycconsultingWebhooks(requestBody: { [key: string]: string; }, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postKycconsultingWebhooks(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMoneytreeRefreshRequest(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMoneytreeRefreshRequest(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request for All Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMoneytreeRefreshRequestAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMoneytreeRefreshRequestAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create organizations deals
         * @param {string} organizationId 
         * @param {PostOrganizationsDealsRequest} postOrganizationsDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOrganizationsDeals(organizationId: string, postOrganizationsDealsRequest: PostOrganizationsDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOrganizationsDeals(organizationId, postOrganizationsDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create point claw backs
         * @param {string} organizationId 
         * @param {PostOrganizationsPointClawBacksRequest} postOrganizationsPointClawBacksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOrganizationsPointClawBacks(organizationId: string, postOrganizationsPointClawBacksRequest: PostOrganizationsPointClawBacksRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOrganizationsPointClawBacks200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOrganizationsPointClawBacks(organizationId, postOrganizationsPointClawBacksRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post payment requests bank account
         * @param {string} organizationId 
         * @param {PostPaymentRequestsBankAccountRequest} [postPaymentRequestsBankAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPaymentRequestsBankAccount(organizationId: string, postPaymentRequestsBankAccountRequest?: PostPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostPaymentRequestsBankAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPaymentRequestsBankAccount(organizationId, postPaymentRequestsBankAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post slack message to coworker
         * @param {string} organizationId 
         * @param {PostSlackMessageToCoworkerRequest} postSlackMessageToCoworkerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSlackMessageToCoworker(organizationId: string, postSlackMessageToCoworkerRequest: PostSlackMessageToCoworkerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSlackMessageToCoworker200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSlackMessageToCoworker(organizationId, postSlackMessageToCoworkerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search Bank Account Transactions
         * @param {PostTransactionsRequest} postTransactionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTransactions(postTransactionsRequest: PostTransactionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostTransactions200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTransactions(postTransactionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostTrustdockWebhooksRequest} postTrustdockWebhooksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTrustdockWebhooks(postTrustdockWebhooksRequest: PostTrustdockWebhooksRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTrustdockWebhooks(postTrustdockWebhooksRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostTrustdockWebhooksSnailMailRequest} postTrustdockWebhooksSnailMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTrustdockWebhooksSnailMail(postTrustdockWebhooksSnailMailRequest: PostTrustdockWebhooksSnailMailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTrustdockWebhooksSnailMail(postTrustdockWebhooksSnailMailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put disable feature flag
         * @param {string} organizationId 
         * @param {string} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDisableFeatureFlag(organizationId: string, featureName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDisableFeatureFlag(organizationId, featureName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put enabled feature flag
         * @param {string} organizationId 
         * @param {string} featureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putEnabledFeatureFlag(organizationId: string, featureName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putEnabledFeatureFlag(organizationId, featureName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put Freee End Journal Entry Transition Mode
         * @param {string} organizationId 
         * @param {PutFreeeEndJournalEntryTransitionModeRequest} putFreeeEndJournalEntryTransitionModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putFreeeEndJournalEntryTransitionMode(organizationId: string, putFreeeEndJournalEntryTransitionModeRequest: PutFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putFreeeEndJournalEntryTransitionMode(organizationId, putFreeeEndJournalEntryTransitionModeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put Organization Payment Method
         * @param {string} organizationId 
         * @param {PutOrganizationPaymentMethodRequest} putOrganizationPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOrganizationPaymentMethod(organizationId: string, putOrganizationPaymentMethodRequest: PutOrganizationPaymentMethodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOrganizationPaymentMethod(organizationId, putOrganizationPaymentMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put organizations deals
         * @param {string} organizationId 
         * @param {PutOrganizationsDealsRequest} putOrganizationsDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOrganizationsDeals(organizationId: string, putOrganizationsDealsRequest: PutOrganizationsDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOrganizationsDeals(organizationId, putOrganizationsDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update payment request
         * @param {string} organizationId 
         * @param {string} [paymentRequestId] 
         * @param {PutPaymentRequestRequest} [putPaymentRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPaymentRequest(organizationId: string, paymentRequestId?: string, putPaymentRequestRequest?: PutPaymentRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPaymentRequest(organizationId, paymentRequestId, putPaymentRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put payment requests bank account
         * @param {string} organizationId 
         * @param {string} bankAccountId 
         * @param {PutPaymentRequestsBankAccountRequest} [putPaymentRequestsBankAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPaymentRequestsBankAccount(organizationId: string, bankAccountId: string, putPaymentRequestsBankAccountRequest?: PutPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutPaymentRequestsBankAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPaymentRequestsBankAccount(organizationId, bankAccountId, putPaymentRequestsBankAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put transaction evidence emails link to transaction
         * @param {PutTransactionEvidenceEmailsLinkToTransactionRequest} putTransactionEvidenceEmailsLinkToTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putTransactionEvidenceEmailsLinkToTransaction(putTransactionEvidenceEmailsLinkToTransactionRequest: PutTransactionEvidenceEmailsLinkToTransactionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putTransactionEvidenceEmailsLinkToTransaction(putTransactionEvidenceEmailsLinkToTransactionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put transaction evidence emails mark as read
         * @param {PutTransactionEvidenceEmailsMarkAsReadRequest} putTransactionEvidenceEmailsMarkAsReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putTransactionEvidenceEmailsMarkAsRead(putTransactionEvidenceEmailsMarkAsReadRequest: PutTransactionEvidenceEmailsMarkAsReadRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutTransactionEvidenceEmailsMarkAsRead200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putTransactionEvidenceEmailsMarkAsRead(putTransactionEvidenceEmailsMarkAsReadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put transaction evidence emails move to trash
         * @param {PutTransactionEvidenceEmailsMoveToTrashRequest} putTransactionEvidenceEmailsMoveToTrashRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putTransactionEvidenceEmailsMoveToTrash(putTransactionEvidenceEmailsMoveToTrashRequest: PutTransactionEvidenceEmailsMoveToTrashRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putTransactionEvidenceEmailsMoveToTrash(putTransactionEvidenceEmailsMoveToTrashRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Give reward point to organization
         * @param {string} organizationId 
         * @param {PutZeusGiveRewardPointsRequest} putZeusGiveRewardPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putZeusGiveRewardPoints(organizationId: string, putZeusGiveRewardPointsRequest: PutZeusGiveRewardPointsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putZeusGiveRewardPoints(organizationId, putZeusGiveRewardPointsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query by ids payment requests
         * @param {string} organizationId 
         * @param {QueryByIdsPaymentRequestsRequest} [queryByIdsPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryByIdsPaymentRequests(organizationId: string, queryByIdsPaymentRequestsRequest?: QueryByIdsPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueryByIdsPaymentRequests200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryByIdsPaymentRequests(organizationId, queryByIdsPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update read status of a message
         * @param {string} userMessageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readUserMessage(userMessageId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readUserMessage(userMessageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary register note
         * @param {string} onboardingRequestId The ID of the onboarding request to retrieve
         * @param {RegisterNoteRequest} [registerNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerNote(onboardingRequestId: string, registerNoteRequest?: RegisterNoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerNote(onboardingRequestId, registerNoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register note for organization identity verification
         * @param {number} organizationIdentityVerificationId 
         * @param {RegisterNoteForOrganizationIdentityVerificationRequest} registerNoteForOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerNoteForOrganizationIdentityVerification(organizationIdentityVerificationId: number, registerNoteForOrganizationIdentityVerificationRequest: RegisterNoteForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterNoteForOrganizationIdentityVerification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerNoteForOrganizationIdentityVerification(organizationIdentityVerificationId, registerNoteForOrganizationIdentityVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register an organization using the onboarding request ID
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerOrganization(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerOrganization(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register organization chart for workflow
         * @param {string} organizationId 
         * @param {RegisterOrganizationChartForWorkflowRequest} [registerOrganizationChartForWorkflowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerOrganizationChartForWorkflow(organizationId: string, registerOrganizationChartForWorkflowRequest?: RegisterOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerOrganizationChartForWorkflow(organizationId, registerOrganizationChartForWorkflowRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register Tfa App Verification Code
         * @param {RegisterTfaAppVerificationCodeRequest} registerTfaAppVerificationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTfaAppVerificationCode(registerTfaAppVerificationCodeRequest: RegisterTfaAppVerificationCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterTfaAppVerificationCode200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTfaAppVerificationCode(registerTfaAppVerificationCodeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register Tfa SMS Auth
         * @param {RegisterTfaSmsAuthRequest} registerTfaSmsAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTfaSmsAuth(registerTfaSmsAuthRequest: RegisterTfaSmsAuthRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterTfaSmsAuth200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTfaSmsAuth(registerTfaSmsAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register transaction evidence email address
         * @param {string} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTransactionEvidenceEmailAddress(userAccountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTransactionEvidenceEmailAddress(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reissue a card
         * @param {string} cardId 
         * @param {ReissueCardRequest} reissueCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reissueCard(cardId: string, reissueCardRequest: ReissueCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReissueCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reissueCard(cardId, reissueCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject Organization Identity Verification
         * @param {number} organizationIdentityVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectOrganizationIdentityVerification(organizationIdentityVerificationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RejectOrganizationIdentityVerification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectOrganizationIdentityVerification(organizationIdentityVerificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject purchase application.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {RejectPurchaseApplicationRequest} rejectPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectPurchaseApplication(organizationId: string, purchaseApplicationId: string, rejectPurchaseApplicationRequest: RejectPurchaseApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectPurchaseApplication(organizationId, purchaseApplicationId, rejectPurchaseApplicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remindCardTransactionEvidence(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remindCardTransactionEvidence(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remind monthly payment notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remindMonthlyPaymentNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remindMonthlyPaymentNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remind organization monthly payment notifications.
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remindOrganizationMonthlyPaymentNotification(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remindOrganizationMonthlyPaymentNotification(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove fraud lock status
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFraudLockStatus(cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveFraudLockStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFraudLockStatus(cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Rename user account group
         * @param {number} userAccountGroupId 
         * @param {RenameUserAccountGroupRequest} renameUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameUserAccountGroup(userAccountGroupId: number, renameUserAccountGroupRequest: RenameUserAccountGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RenameUserAccountGroup200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameUserAccountGroup(userAccountGroupId, renameUserAccountGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace Virtual Card
         * @param {string} userAccountId 
         * @param {ReplaceVirtualCardRequest} replaceVirtualCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceVirtualCard(userAccountId: string, replaceVirtualCardRequest: ReplaceVirtualCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplaceVirtualCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceVirtualCard(userAccountId, replaceVirtualCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary request add system admin role
         * @param {string} userId 
         * @param {RequestAddSystemAdminRoleRequest} requestAddSystemAdminRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAddSystemAdminRole(userId: string, requestAddSystemAdminRoleRequest: RequestAddSystemAdminRoleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAddSystemAdminRole(userId, requestAddSystemAdminRoleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request sending physical cards
         * @param {string} organizationId 
         * @param {RequestSendingRequest} requestSendingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSending(organizationId: string, requestSendingRequest: RequestSendingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSending(organizationId, requestSendingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request sending a metal card
         * @param {string} organizationId 
         * @param {RequestSendingMetalCardRequest} requestSendingMetalCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSendingMetalCard(organizationId: string, requestSendingMetalCardRequest: RequestSendingMetalCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSendingMetalCard(organizationId, requestSendingMetalCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ポイント明細の同期リクエスト
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {RequestSyncBankTransactionsToFreeeForAccountingRequest} [requestSyncBankTransactionsToFreeeForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSyncBankTransactionsToFreeeForAccounting(orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, requestSyncBankTransactionsToFreeeForAccountingRequest?: RequestSyncBankTransactionsToFreeeForAccountingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSyncBankTransactionsToFreeeForAccounting(orgAccountId, upsidrPrivateClientApiInternal, requestSyncBankTransactionsToFreeeForAccountingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 決済明細の同期リクエスト
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {RequestSyncCardTransactionsToFreeeForAccountingRequest} [requestSyncCardTransactionsToFreeeForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSyncCardTransactionsToFreeeForAccounting(orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, requestSyncCardTransactionsToFreeeForAccountingRequest?: RequestSyncCardTransactionsToFreeeForAccountingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSyncCardTransactionsToFreeeForAccounting(orgAccountId, upsidrPrivateClientApiInternal, requestSyncCardTransactionsToFreeeForAccountingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSyncingClearedTransaction(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSyncingClearedTransaction(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request to Generate Organizations Accounting Csv in Background
         * @param {string} organizationId 
         * @param {string} yearMonth 
         * @param {boolean} isMergedFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestToOrganizationsAccountingCsvInBackground(organizationId: string, yearMonth: string, isMergedFiles: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestToOrganizationsAccountingCsvInBackground(organizationId, yearMonth, isMergedFiles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary request update system admin role
         * @param {string} userId 
         * @param {RequestUpdateSystemAdminRoleRequest} requestUpdateSystemAdminRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestUpdateSystemAdminRole(userId: string, requestUpdateSystemAdminRoleRequest: RequestUpdateSystemAdminRoleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestUpdateSystemAdminRole(userId, requestUpdateSystemAdminRoleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resend Snail Mail For Organization Identity Verification
         * @param {number} organizationIdentityVerificationId 
         * @param {ResendSnailMailForOrganizationIdentityVerificationRequest} resendSnailMailForOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendSnailMailForOrganizationIdentityVerification(organizationIdentityVerificationId: number, resendSnailMailForOrganizationIdentityVerificationRequest: ResendSnailMailForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendSnailMailForOrganizationIdentityVerification(organizationIdentityVerificationId, resendSnailMailForOrganizationIdentityVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resend an invitation to a new user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendUserInvite(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendUserInvite200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendUserInvite(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resume a suspended card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeCard(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeCard(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resynchronize card transactions for freee
         * @param {string} organizationId 
         * @param {ResynchronizeCardTransactionsForFreeeRequest} resynchronizeCardTransactionsForFreeeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resynchronizeCardTransactionsForFreee(organizationId: string, resynchronizeCardTransactionsForFreeeRequest: ResynchronizeCardTransactionsForFreeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resynchronizeCardTransactionsForFreee(organizationId, resynchronizeCardTransactionsForFreeeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deal as draft
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {SaveDealAsDraftRequest} saveDealAsDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealAsDraft(organizationId: string, dealId: string, saveDealAsDraftRequest: SaveDealAsDraftRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveDealAsDraft200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealAsDraft(organizationId, dealId, saveDealAsDraftRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save Deal As Ignore
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealAsIgnore(organizationId: string, dealId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveDealAsIgnore200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealAsIgnore(organizationId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deal as return to editing
         * @param {string} organizationId 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealAsReturnToEditing(organizationId: string, dealId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveDealAsReturnToEditing200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealAsReturnToEditing(organizationId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deal with journalizing
         * @param {string} organizationId 
         * @param {string} dealId 
         * @param {SaveDealWithJournalizingRequest} saveDealWithJournalizingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealWithJournalizing(organizationId: string, dealId: string, saveDealWithJournalizingRequest: SaveDealWithJournalizingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveDealWithJournalizing200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealWithJournalizing(organizationId, dealId, saveDealWithJournalizingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deals as ignore
         * @param {string} organizationId 
         * @param {SaveDealsAsIgnoreRequest} saveDealsAsIgnoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealsAsIgnore(organizationId: string, saveDealsAsIgnoreRequest: SaveDealsAsIgnoreRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealsAsIgnore(organizationId, saveDealsAsIgnoreRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deals as journalized
         * @param {string} organizationId 
         * @param {SaveDealsAsJournalizedRequest} saveDealsAsJournalizedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealsAsJournalized(organizationId: string, saveDealsAsJournalizedRequest: SaveDealsAsJournalizedRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealsAsJournalized(organizationId, saveDealsAsJournalizedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save deals as return to editing
         * @param {number} organizationId 
         * @param {SaveDealsAsReturnToEditingRequest} saveDealsAsReturnToEditingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDealsAsReturnToEditing(organizationId: number, saveDealsAsReturnToEditingRequest: SaveDealsAsReturnToEditingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDealsAsReturnToEditing(organizationId, saveDealsAsReturnToEditingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search bank transfers
         * @param {string} organizationId 
         * @param {string} [transferDateJstFrom] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
         * @param {string} [transferDateJstTo] yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
         * @param {string} [sourceBankAccountId] Filter the bank transfers by the specified source bank account id.
         * @param {boolean} [downloaded] Filter the bank transfers by whether the corresponding transfer data has been downloaded.
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBankTransfers(organizationId: string, transferDateJstFrom?: string, transferDateJstTo?: string, sourceBankAccountId?: string, downloaded?: boolean, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchBankTransfers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBankTransfers(organizationId, transferDateJstFrom, transferDateJstTo, sourceBankAccountId, downloaded, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search Corporations In National Tax Agency
         * @param {string} [name] 
         * @param {'PREFIX_MATCH' | 'PARTIAL_MATCH' | ''} [searchMethod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCorporationsInNationalTaxAgency(name?: string, searchMethod?: 'PREFIX_MATCH' | 'PARTIAL_MATCH' | '', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchCorporationsInNationalTaxAgency200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCorporationsInNationalTaxAgency(name, searchMethod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search deals
         * @param {string} organizationId 
         * @param {SearchDealsRequest} [searchDealsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDeals(organizationId: string, searchDealsRequest?: SearchDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchDeals200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDeals(organizationId, searchDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search evidences
         * @param {string} organizationId 
         * @param {string} [issuer] This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
         * @param {number} [amountMin] 
         * @param {number} [amountMax] 
         * @param {string} [paidAtFrom] 
         * @param {string} [paidAtTo] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {string} [keyword] Specified keyword is searched from the issuer and the note by partial match.
         * @param {boolean} [includesDeleted] 
         * @param {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>} [legalValidities] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEvidences(organizationId: string, issuer?: string, amountMin?: number, amountMax?: number, paidAtFrom?: string, paidAtTo?: string, irrelevantToLedger?: boolean, keyword?: string, includesDeleted?: boolean, legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchEvidences200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEvidences(organizationId, issuer, amountMin, amountMax, paidAtFrom, paidAtTo, irrelevantToLedger, keyword, includesDeleted, legalValidities, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search my payment requests
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {string} [requestedDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
         * @param {string} [requestedDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMyPaymentRequests(organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, requestedDateJstFrom?: string, requestedDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', freeWord?: string, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchMyPaymentRequests200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMyPaymentRequests(organizationId, dueDateJstFrom, dueDateJstTo, requestedDateJstFrom, requestedDateJstTo, statuses, supplierId, transferDataCreated, withholdingApplied, transferFeeResponsibility, freeWord, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search Organizations
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOrganizations(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchOrganizations200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOrganizations(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search payment requests
         * @param {string} organizationId 
         * @param {string} [dueDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
         * @param {string} [dueDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
         * @param {string} [requestedDateJstFrom] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
         * @param {string} [requestedDateJstTo] yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
         * @param {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>} [statuses] Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
         * @param {string} [supplierId] Filter the payment requests by the specified supplier id.
         * @param {boolean} [transferDataCreated] Filter the payment requests by whether the corresponding transaction data has been created.
         * @param {boolean} [withholdingApplied] Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
         * @param {'SELF' | 'SUPPLIER'} [transferFeeResponsibility] Filter the payment requests by the specified transfer fee responsibility.
         * @param {string} [requestorId] Filter the payment requests by the specified requestor id.
         * @param {string} [freeWord] A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
         * @param {number} [limit] 
         * @param {number} [offset] See the description of &#x60;cursor&#x60; section Pagination
         * @param {string} [cursor] Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPaymentRequests(organizationId: string, dueDateJstFrom?: string, dueDateJstTo?: string, requestedDateJstFrom?: string, requestedDateJstTo?: string, statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>, supplierId?: string, transferDataCreated?: boolean, withholdingApplied?: boolean, transferFeeResponsibility?: 'SELF' | 'SUPPLIER', requestorId?: string, freeWord?: string, limit?: number, offset?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchPaymentRequests200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPaymentRequests(organizationId, dueDateJstFrom, dueDateJstTo, requestedDateJstFrom, requestedDateJstTo, statuses, supplierId, transferDataCreated, withholdingApplied, transferFeeResponsibility, requestorId, freeWord, limit, offset, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary send back onboarding request
         * @param {string} onboardingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBackOnboardingRequest(onboardingRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBackOnboardingRequest(onboardingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary send changed credit notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendChangedCreditNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendChangedCreditNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send Organization Identity Verification
         * @param {string} organizationId 
         * @param {SendOrganizationIdentityVerificationRequest} sendOrganizationIdentityVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOrganizationIdentityVerification(organizationId: string, sendOrganizationIdentityVerificationRequest: SendOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOrganizationIdentityVerification(organizationId, sendOrganizationIdentityVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send two-factor authentication reset link as admin
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTfaResetLinkAsAdmin(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTfaResetLinkAsAdmin(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send Transaction Authorization Request
         * @param {string} organizationId 
         * @param {SendTransactionAuthorizationRequestRequest} sendTransactionAuthorizationRequestRequest 
         * @param {string} [cardId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTransactionAuthorizationRequest(organizationId: string, sendTransactionAuthorizationRequestRequest: SendTransactionAuthorizationRequestRequest, cardId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTransactionAuthorizationRequest(organizationId, sendTransactionAuthorizationRequestRequest, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enable or disable accounting integration
         * @param {string} organizationId 
         * @param {SetAccountingActivationRequest} setAccountingActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAccountingActivation(organizationId: string, setAccountingActivationRequest: SetAccountingActivationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAccountingActivation(organizationId, setAccountingActivationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sign Up For Slack
         * @param {SignUpForSlackRequest} signUpForSlackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpForSlack(signUpForSlackRequest: SignUpForSlackRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUpForSlack(signUpForSlackRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit completed workflow of draft payment request
         * @param {string} organizationId 
         * @param {string} draftPaymentRequestId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {SubmitCompletedWorkflowOfDraftPaymentRequestsRequest} [submitCompletedWorkflowOfDraftPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitCompletedWorkflowOfDraftPaymentRequests(organizationId: string, draftPaymentRequestId: string, xUpsidrSwitchUser?: string, submitCompletedWorkflowOfDraftPaymentRequestsRequest?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitCompletedWorkflowOfDraftPaymentRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitCompletedWorkflowOfDraftPaymentRequests(organizationId, draftPaymentRequestId, xUpsidrSwitchUser, submitCompletedWorkflowOfDraftPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit completed workflow of payment request
         * @param {string} organizationId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {SubmitCompletedWorkflowOfPaymentRequestsRequest} [submitCompletedWorkflowOfPaymentRequestsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitCompletedWorkflowOfPaymentRequests(organizationId: string, xUpsidrSwitchUser?: string, submitCompletedWorkflowOfPaymentRequestsRequest?: SubmitCompletedWorkflowOfPaymentRequestsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitCompletedWorkflowOfPaymentRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitCompletedWorkflowOfPaymentRequests(organizationId, xUpsidrSwitchUser, submitCompletedWorkflowOfPaymentRequestsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit workflow
         * @param {string} organizationId 
         * @param {string} workflowInstanceId 
         * @param {string} [xUpsidrSwitchUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitWorkflow(organizationId: string, workflowInstanceId: string, xUpsidrSwitchUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitWorkflow(organizationId, workflowInstanceId, xUpsidrSwitchUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Suspend a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendCard(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuspendCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendCard(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAllCardStatuses(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAllCardStatuses(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync all users to each marketing tools
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAllUsersToEachMarketingTools(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAllUsersToEachMarketingTools(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync freee account items
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFreeeAccountItems(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFreeeAccountItems(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync freee partners
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFreeePartners(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFreeePartners(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync freee segment tags
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFreeeSegmentTags(organizationId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFreeeSegmentTags(organizationId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync Moneytree access token
         * @param {string} code Authorization code received from Moneytree after successful authentication.
         * @param {string} state OAuth state parameter to ensure request consistency.
         * @param {string} [nextTo] URL to redirect to after syncing access token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncMoneytreeAccessToken(code: string, state: string, nextTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncMoneytreeAccessToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncMoneytreeAccessToken(code, state, nextTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync point usage to accounting service
         * @param {string} organizationId 
         * @param {SyncPointUsageToAccountingServiceRequest} syncPointUsageToAccountingServiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPointUsageToAccountingService(organizationId: string, syncPointUsageToAccountingServiceRequest: SyncPointUsageToAccountingServiceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPointUsageToAccountingService(organizationId, syncPointUsageToAccountingServiceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync Request for Freee Deals
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {SyncRequestForFreeeDealsRequest} syncRequestForFreeeDealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRequestForFreeeDeals(organizationId: string, companyId: string, syncRequestForFreeeDealsRequest: SyncRequestForFreeeDealsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRequestForFreeeDeals(organizationId, companyId, syncRequestForFreeeDealsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Two Factor Auth Reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorAuthReset(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorAuthReset(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Two Factor Auth Reset As Token
         * @param {TwoFactorAuthResetAsTokenRequest} twoFactorAuthResetAsTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorAuthResetAsToken(twoFactorAuthResetAsTokenRequest: TwoFactorAuthResetAsTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorAuthResetAsToken(twoFactorAuthResetAsTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlinking purchase to transaction.
         * @param {string} organizationId 
         * @param {string} purchaseApplicationId 
         * @param {string} [visaTransactionReferenceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkingPurchaseToTransaction(organizationId: string, purchaseApplicationId: string, visaTransactionReferenceId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkingPurchaseToTransaction(organizationId, purchaseApplicationId, visaTransactionReferenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlock a card due to no potential fraud
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockCardForNotPotentialFraud(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockCardForNotPotentialFraud200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockCardForNotPotentialFraud(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlock a card due to fraud cleared
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {string} triggeredTransactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockCardOnFraudCleared(organizationId: string, cardId: string, triggeredTransactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockCardOnFraudCleared200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockCardOnFraudCleared(organizationId, cardId, triggeredTransactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Available Currencies
         * @param {string} userAccountId 
         * @param {UpdateAvailableCurrenciesRequest} updateAvailableCurrenciesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvailableCurrencies(userAccountId: string, updateAvailableCurrenciesRequest: UpdateAvailableCurrenciesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAvailableCurrencies200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvailableCurrencies(userAccountId, updateAvailableCurrenciesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Available Merchant Categories
         * @param {string} userAccountId 
         * @param {UpdateAvailableMerchantCategoriesRequest} updateAvailableMerchantCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvailableMerchantCategories(userAccountId: string, updateAvailableMerchantCategoriesRequest: UpdateAvailableMerchantCategoriesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAvailableMerchantCategories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvailableMerchantCategories(userAccountId, updateAvailableMerchantCategoriesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update card account unit
         * @param {string} organizationId 
         * @param {UpdateCardAccountUnitRequest} updateCardAccountUnitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardAccountUnit(organizationId: string, updateCardAccountUnitRequest: UpdateCardAccountUnitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardAccountUnit(organizationId, updateCardAccountUnitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Card Count Limit
         * @param {string} organizationId 
         * @param {UpdateCardCountLimitRequest} updateCardCountLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardCountLimit(organizationId: string, updateCardCountLimitRequest: UpdateCardCountLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardCountLimit(organizationId, updateCardCountLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update card holder for the user account
         * @param {string} userAccountId 
         * @param {UpdateCardHolderRequest} updateCardHolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardHolder(userAccountId: string, updateCardHolderRequest: UpdateCardHolderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCardHolder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardHolder(userAccountId, updateCardHolderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lock a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardLock(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCardLock200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardLock(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unlock a card
         * @param {string} organizationId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardUnlock(organizationId: string, cardId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCardUnlock200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardUnlock(organizationId, cardId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update comment for card transaction
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionCommentId 
         * @param {UpdateCommentRequest} updateCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComment(organizationId: string, paymentReferenceId: string, cardTransactionCommentId: string, updateCommentRequest: UpdateCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComment(organizationId, paymentReferenceId, cardTransactionCommentId, updateCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update comment template
         * @param {string} organizationId 
         * @param {string} templateId 
         * @param {UpdateCommentTemplateRequest} updateCommentTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommentTemplate(organizationId: string, templateId: string, updateCommentTemplateRequest: UpdateCommentTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommentTemplate(organizationId, templateId, updateCommentTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update corporate document verification result
         * @param {string} organizationIdentityVerificationId 
         * @param {UpdateCorporateDocumentResultRequest} updateCorporateDocumentResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCorporateDocumentResult(organizationIdentityVerificationId: string, updateCorporateDocumentResultRequest: UpdateCorporateDocumentResultRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCorporateDocumentResult(organizationIdentityVerificationId, updateCorporateDocumentResultRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update daily usage limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateDailyUserUsageLimitRequest} updateDailyUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDailyUserUsageLimit(userAccountId: string, updateDailyUserUsageLimitRequest: UpdateDailyUserUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDailyUserUsageLimit200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDailyUserUsageLimit(userAccountId, updateDailyUserUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update deposit restriction for organization
         * @param {string} organizationId 
         * @param {string} depositRestrictionId 
         * @param {UpdateDepositRestrictionForOrganizationRequest} updateDepositRestrictionForOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDepositRestrictionForOrganization(organizationId: string, depositRestrictionId: string, updateDepositRestrictionForOrganizationRequest: UpdateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDepositRestrictionForOrganization(organizationId, depositRestrictionId, updateDepositRestrictionForOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Toggle on/off email notification settings per user
         * @param {string} userId 
         * @param {string} emailNotificationId 
         * @param {UpdateEmailNotificationRequest} updateEmailNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailNotification(userId: string, emailNotificationId: string, updateEmailNotificationRequest: UpdateEmailNotificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailNotification(userId, emailNotificationId, updateEmailNotificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update embed url method
         * @param {string} organizationId 
         * @param {UpdateEmbedUrlMethodRequest} updateEmbedUrlMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmbedUrlMethod(organizationId: string, updateEmbedUrlMethodRequest: UpdateEmbedUrlMethodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmbedUrlMethod(organizationId, updateEmbedUrlMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the card holder. Only accessible by administrators.  Note: When the holder is changed, the new holder will be able to view all previous transaction history.  Error codes: - SYSTEM_ERROR: System error occurred 
         * @summary Update ETC card holder
         * @param {string} userAccountId 
         * @param {UpdateEtcCardHolderRequest} updateEtcCardHolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEtcCardHolder(userAccountId: string, updateEtcCardHolderRequest: UpdateEtcCardHolderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateEtcCardHolder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEtcCardHolder(userAccountId, updateEtcCardHolderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the card label. Only accessible by administrators.  Validation: - Required: Card label must not be empty - Max length: 64 characters  Error codes: - CARD_LABEL_DUPLICATE: Same card label already exists - SYSTEM_ERROR: System error occurred 
         * @summary Update ETC card label
         * @param {string} userAccountId 
         * @param {UpdateEtcCardLabelRequest} updateEtcCardLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEtcCardLabel(userAccountId: string, updateEtcCardLabelRequest: UpdateEtcCardLabelRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateEtcCardLabel200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEtcCardLabel(userAccountId, updateEtcCardLabelRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update evidence image
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [dpiForciblyValid] 
         * @param {boolean} [colorGradationForciblyValid] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEvidenceImage(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, dpiForciblyValid?: boolean, colorGradationForciblyValid?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvidenceImage(organizationId, paymentReferenceId, cardTransactionEvidenceId, file, electronicMethod, documentSize, heightMillis, widthMillis, note, irrelevantToLedger, dpiForciblyValid, colorGradationForciblyValid, uploadedByRecipient, uploadedFrom, invoiceIssuerName, invoiceIssuerRegistrationNumber, asQualified, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update evidence info
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {string} cardTransactionEvidenceId 
         * @param {UpdateEvidenceInfoRequest} updateEvidenceInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEvidenceInfo(organizationId: string, paymentReferenceId: string, cardTransactionEvidenceId: string, updateEvidenceInfoRequest: UpdateEvidenceInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvidenceInfo(organizationId, paymentReferenceId, cardTransactionEvidenceId, updateEvidenceInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update freee connect
         * @param {string} organizationId 
         * @param {string} code 
         * @param {string} state 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFreeeConnect(organizationId: string, code: string, state: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateFreeeConnect200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFreeeConnect(organizationId, code, state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary freee設定変更
         * @param {string} orgAccountId 
         * @param {boolean} [upsidrPrivateClientApiInternal] 
         * @param {UpdateFreeeConnectionSettingsForAccountingRequest} [updateFreeeConnectionSettingsForAccountingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFreeeConnectionSettingsForAccounting(orgAccountId: string, upsidrPrivateClientApiInternal?: boolean, updateFreeeConnectionSettingsForAccountingRequest?: UpdateFreeeConnectionSettingsForAccountingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFreeeConnectionSettingsForAccounting(orgAccountId, upsidrPrivateClientApiInternal, updateFreeeConnectionSettingsForAccountingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Turn on/off freee journaling
         * @param {string} organizationId 
         * @param {UpdateFreeeJournalingRequest} updateFreeeJournalingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFreeeJournaling(organizationId: string, updateFreeeJournalingRequest: UpdateFreeeJournalingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFreeeJournaling(organizationId, updateFreeeJournalingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update freee select company
         * @param {string} organizationId 
         * @param {UpdateFreeeSelectCompanyRequest} updateFreeeSelectCompanyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFreeeSelectCompany(organizationId: string, updateFreeeSelectCompanyRequest: UpdateFreeeSelectCompanyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateFreeeSelectCompany200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFreeeSelectCompany(organizationId, updateFreeeSelectCompanyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update lock status of evidences
         * @param {string} organizationId 
         * @param {UpdateLockStatusOfEvidencesRequest} updateLockStatusOfEvidencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLockStatusOfEvidences(organizationId: string, updateLockStatusOfEvidencesRequest: UpdateLockStatusOfEvidencesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLockStatusOfEvidences(organizationId, updateLockStatusOfEvidencesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update merchant general block allowed organization ids
         * @param {string} merchantGeneralBlockListId 
         * @param {UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest} updateMerchantGeneralBlockAllowedOrganizationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantGeneralBlockAllowedOrganizationIds(merchantGeneralBlockListId: string, updateMerchantGeneralBlockAllowedOrganizationIdsRequest: UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantGeneralBlockAllowedOrganizationIds(merchantGeneralBlockListId, updateMerchantGeneralBlockAllowedOrganizationIdsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update merchant general block list
         * @param {string} merchantGeneralBlockListId 
         * @param {UpdateMerchantGeneralBlockListRequest} updateMerchantGeneralBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantGeneralBlockList(merchantGeneralBlockListId: string, updateMerchantGeneralBlockListRequest: UpdateMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantGeneralBlockList(merchantGeneralBlockListId, updateMerchantGeneralBlockListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update merchant org block list
         * @param {string} merchantOrgBlockListId 
         * @param {UpdateMerchantOrgBlockListRequest} updateMerchantOrgBlockListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantOrgBlockList(merchantOrgBlockListId: string, updateMerchantOrgBlockListRequest: UpdateMerchantOrgBlockListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantOrgBlockList(merchantOrgBlockListId, updateMerchantOrgBlockListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Merchant Organization Comment
         * @param {string} organizationId 
         * @param {string} merchantId 
         * @param {string} userAccountId 
         * @param {UpdateMerchantOrganizationCommentRequest} updateMerchantOrganizationCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantOrganizationComment(organizationId: string, merchantId: string, userAccountId: string, updateMerchantOrganizationCommentRequest: UpdateMerchantOrganizationCommentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantOrganizationComment(organizationId, merchantId, userAccountId, updateMerchantOrganizationCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganization(organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOrganization200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganization(organizationId, updateOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Organizations Accounting Csv Export Fields
         * @param {string} organizationId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationsAccountingCsvExportFields(organizationId: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationsAccountingCsvExportFields(organizationId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the payment request evidence specified by evidenceId.
         * @summary Update the specific payment request evidence.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {UpdatePaymentRequestEvidenceRequest} updatePaymentRequestEvidenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentRequestEvidence(organizationId: string, paymentRequestId: string, evidenceId: string, updatePaymentRequestEvidenceRequest: UpdatePaymentRequestEvidenceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentRequestEvidence(organizationId, paymentRequestId, evidenceId, updatePaymentRequestEvidenceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the payment request evidence file specified by evidenceId. This also accept properties other than a file binary.
         * @summary Update the specific payment request evidence file.
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {string} evidenceId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {boolean} [dpiForciblyValid] 
         * @param {boolean} [colorGradationForciblyValid] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {string} [invoiceIssuerName] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentRequestEvidenceFile(organizationId: string, paymentRequestId: string, evidenceId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, dpiForciblyValid?: boolean, colorGradationForciblyValid?: boolean, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerRegistrationNumber?: string, invoiceIssuerName?: string, asQualified?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentRequestEvidenceFile(organizationId, paymentRequestId, evidenceId, file, electronicMethod, documentSize, heightMillis, widthMillis, dpiForciblyValid, colorGradationForciblyValid, note, irrelevantToLedger, uploadedByRecipient, uploadedFrom, invoiceIssuerRegistrationNumber, invoiceIssuerName, asQualified, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update purchase application template.
         * @param {string} organizationId 
         * @param {string} purchaseTemplateId 
         * @param {UpdatePurchaseApplicationTemplateRequest} [updatePurchaseApplicationTemplateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePurchaseApplicationTemplate(organizationId: string, purchaseTemplateId: string, updatePurchaseApplicationTemplateRequest?: UpdatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePurchaseApplicationTemplate(organizationId, purchaseTemplateId, updatePurchaseApplicationTemplateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update remove user account group
         * @param {string} userAccountId 
         * @param {UpdateRemoveUserAccountGroupRequest} updateRemoveUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRemoveUserAccountGroup(userAccountId: string, updateRemoveUserAccountGroupRequest: UpdateRemoveUserAccountGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRemoveUserAccountGroup(userAccountId, updateRemoveUserAccountGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update role resource for user
         * @param {string} userId 
         * @param {UpdateRoleResourceForUserRequest} updateRoleResourceForUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoleResourceForUser(userId: string, updateRoleResourceForUserRequest: UpdateRoleResourceForUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoleResourceForUser(userId, updateRoleResourceForUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Roles by Resource Id
         * @param {string} resourceScope 
         * @param {string} resourceId 
         * @param {UpdateRolesByResourceIdRequest} updateRolesByResourceIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRolesByResourceId(resourceScope: string, resourceId: string, updateRolesByResourceIdRequest: UpdateRolesByResourceIdRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRolesByResourceId(resourceScope, resourceId, updateRolesByResourceIdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Slack evidence remind settings of an slack channel
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackEvidenceReminderPerChannelRequest} updateSlackEvidenceReminderPerChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlackEvidenceReminderPerChannel(organizationId: string, channelId: string, updateSlackEvidenceReminderPerChannelRequest: UpdateSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlackEvidenceReminderPerChannel(organizationId, channelId, updateSlackEvidenceReminderPerChannelRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update slack notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackNotificationSettingForCardRequest} updateSlackNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlackNotificationSettingForCard(organizationId: string, channelId: string, updateSlackNotificationSettingForCardRequest: UpdateSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlackNotificationSettingForCard(organizationId, channelId, updateSlackNotificationSettingForCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update slack notification channel setting for purchase-application
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateSlackNotificationSettingForPurchaseApplicationRequest} updateSlackNotificationSettingForPurchaseApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSlackNotificationSettingForPurchaseApplication(organizationId: string, channelId: string, updateSlackNotificationSettingForPurchaseApplicationRequest: UpdateSlackNotificationSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSlackNotificationSettingForPurchaseApplication(organizationId, channelId, updateSlackNotificationSettingForPurchaseApplicationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update sync to freee from deal
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSyncToFreeeFromDeal(organizationId: string, companyId: string, dealId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSyncToFreeeFromDeal(organizationId, companyId, dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update synchronize to freee log confirm
         * @param {string} organizationId 
         * @param {string} companyId 
         * @param {UpdateSynchronizeToFreeeLogConfirmRequest} updateSynchronizeToFreeeLogConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSynchronizeToFreeeLogConfirm(organizationId: string, companyId: string, updateSynchronizeToFreeeLogConfirmRequest: UpdateSynchronizeToFreeeLogConfirmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSynchronizeToFreeeLogConfirm(organizationId, companyId, updateSynchronizeToFreeeLogConfirmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Teams notification channel setting for card
         * @param {string} organizationId 
         * @param {string} channelId 
         * @param {UpdateTeamsNotificationSettingForCardRequest} updateTeamsNotificationSettingForCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamsNotificationSettingForCard(organizationId: string, channelId: string, updateTeamsNotificationSettingForCardRequest: UpdateTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamsNotificationSettingForCard(organizationId, channelId, updateTeamsNotificationSettingForCardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update transaction upper limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateTransactionUpperLimitForTheUserAccountRequest} updateTransactionUpperLimitForTheUserAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransactionUpperLimitForTheUserAccount(userAccountId: string, updateTransactionUpperLimitForTheUserAccountRequest: UpdateTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTransactionUpperLimitForTheUserAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransactionUpperLimitForTheUserAccount(userAccountId, updateTransactionUpperLimitForTheUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user account group
         * @param {string} userAccountId 
         * @param {UpdateUserAccountGroupRequest} updateUserAccountGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAccountGroup(userAccountId: string, updateUserAccountGroupRequest: UpdateUserAccountGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAccountGroup(userAccountId, updateUserAccountGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user account name
         * @param {string} userAccountId 
         * @param {UpdateUserAccountNameRequest} updateUserAccountNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserAccountName(userAccountId: string, updateUserAccountNameRequest: UpdateUserAccountNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserAccountName200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserAccountName(userAccountId, updateUserAccountNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update user email, settings per user
         * @param {string} userId 
         * @param {UpdateUserEmailRequest} updateUserEmailRequest 
         * @param {string} [xChallengeSuccessToken] sudo-mode challenge 検証成功時に発行される token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserEmail(userId: string, updateUserEmailRequest: UpdateUserEmailRequest, xChallengeSuccessToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserEmail(userId, updateUserEmailRequest, xChallengeSuccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update user name, settings per user
         * @param {string} userId 
         * @param {UpdateUserNameRequest} updateUserNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserName(userId: string, updateUserNameRequest: UpdateUserNameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserName(userId, updateUserNameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update user organization
         * @param {string} userId 
         * @param {UpdateUserOrganizationRequest} updateUserOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserOrganization(userId: string, updateUserOrganizationRequest: UpdateUserOrganizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserOrganization(userId, updateUserOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update user password
         * @param {string} userId 
         * @param {UpdateUserPasswordRequest} updateUserPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPassword(userId: string, updateUserPasswordRequest: UpdateUserPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPassword(userId, updateUserPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update User Privilege
         * @param {string} organizationId 
         * @param {string} userId 
         * @param {UpdateUserPrivilegeRequest} updateUserPrivilegeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPrivilege(organizationId: string, userId: string, updateUserPrivilegeRequest: UpdateUserPrivilegeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPrivilege(organizationId, userId, updateUserPrivilegeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update usage limit for the user account
         * @param {string} userAccountId 
         * @param {UpdateUserUsageLimitRequest} updateUserUsageLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserUsageLimit(userAccountId: string, updateUserUsageLimitRequest: UpdateUserUsageLimitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserUsageLimit200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserUsageLimit(userAccountId, updateUserUsageLimitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload card transaction evidence images
         * @param {string} organizationId 
         * @param {string} paymentReferenceId 
         * @param {Array<File>} [files] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCardTransactionEvidenceImage(organizationId: string, paymentReferenceId: string, files?: Array<File>, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCardTransactionEvidenceImage(organizationId, paymentReferenceId, files, electronicMethod, documentSize, heightMillis, widthMillis, note, irrelevantToLedger, uploadedByRecipient, uploadedFrom, invoiceIssuerName, invoiceIssuerRegistrationNumber, asQualified, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload corporate document
         * @param {string} organizationIdentityVerificationId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCorporateDocument(organizationIdentityVerificationId: string, file: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCorporateDocument(organizationIdentityVerificationId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload payment request evidence image
         * @param {string} organizationId 
         * @param {string} paymentRequestId 
         * @param {File} [file] 
         * @param {string} [electronicMethod] 
         * @param {string} [documentSize] 
         * @param {number} [heightMillis] 
         * @param {number} [widthMillis] 
         * @param {string} [note] 
         * @param {boolean} [irrelevantToLedger] 
         * @param {boolean} [uploadedByRecipient] 
         * @param {string} [uploadedFrom] 
         * @param {string} [invoiceIssuerName] 
         * @param {string} [invoiceIssuerRegistrationNumber] 
         * @param {boolean} [asQualified] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPaymentRequestEvidenceImage(organizationId: string, paymentRequestId: string, file?: File, electronicMethod?: string, documentSize?: string, heightMillis?: number, widthMillis?: number, note?: string, irrelevantToLedger?: boolean, uploadedByRecipient?: boolean, uploadedFrom?: string, invoiceIssuerName?: string, invoiceIssuerRegistrationNumber?: string, asQualified?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPaymentRequestEvidenceImage(organizationId, paymentRequestId, file, electronicMethod, documentSize, heightMillis, widthMillis, note, irrelevantToLedger, uploadedByRecipient, uploadedFrom, invoiceIssuerName, invoiceIssuerRegistrationNumber, asQualified, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Users email confirm
         * @param {UsersEmailConfirmRequest} usersEmailConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersEmailConfirm(usersEmailConfirmRequest: UsersEmailConfirmRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersEmailConfirm200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersEmailConfirm(usersEmailConfirmRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定した scope の現在有効なチャレンジに対して6桁コードを検証し、成功時に短命 JWT (challengeSuccessToken) を発行する。 チャレンジは (userId, scope) ごとに独立しているため、scope の指定が必須。 
         * @summary sudo-mode チャレンジの検証
         * @param {string} userId 
         * @param {VerifyChallengeRequest} verifyChallengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyChallenge(userId: string, verifyChallengeRequest: VerifyChallengeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyChallenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyChallenge(userId, verifyChallengeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify moneytree connections
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyMoneytreeConnections(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyMoneytreeConnections200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyMoneytreeConnections(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows system administrators to directly update a user\'s email address without email verification. This is a Zeus admin API that bypasses the standard email change flow. 
         * @summary Update user email address (Admin only)
         * @param {string} userId The ID of the user whose email address will be updated
         * @param {ZeusUpdateUserEmailRequest} zeusUpdateUserEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zeusUpdateUserEmail(userId: string, zeusUpdateUserEmailRequest: ZeusUpdateUserEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zeusUpdateUserEmail(userId, zeusUpdateUserEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Add comment for card transaction
         * @param {DefaultApiAddCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment(requestParameters: DefaultApiAddCommentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.addCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add Organization Create Request
         * @param {DefaultApiAddOrganizationCreateRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationCreateRequest(requestParameters: DefaultApiAddOrganizationCreateRequestRequest, options?: AxiosRequestConfig): AxiosPromise<AddOrganizationCreateRequest200Response> {
            return localVarFp.addOrganizationCreateRequest(requestParameters.addOrganizationCreateRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add point to organization
         * @param {DefaultApiAddPointToOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPointToOrganization(requestParameters: DefaultApiAddPointToOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addPointToOrganization(requestParameters.organizationId, requestParameters.addPointToOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Agree to the agreement request
         * @param {DefaultApiAgreeToAgreementRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToAgreementRequest(requestParameters: DefaultApiAgreeToAgreementRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.agreeToAgreementRequest(requestParameters.organizationId, requestParameters.agreementRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Agree to OL info sharing consent
         * @param {DefaultApiAgreeToOlInfoSharingConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToOlInfoSharingConsent(requestParameters: DefaultApiAgreeToOlInfoSharingConsentRequest, options?: AxiosRequestConfig): AxiosPromise<AgreeToOlInfoSharingConsent200Response> {
            return localVarFp.agreeToOlInfoSharingConsent(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Analyze evidence
         * @param {DefaultApiAnalyzeEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeEvidence(requestParameters: DefaultApiAnalyzeEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<AnalyzeEvidence200Response> {
            return localVarFp.analyzeEvidence(requestParameters.organizationId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Analyze invoice of payment requests
         * @param {DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeInvoiceOfPaymentRequests(requestParameters: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<AnalyzeInvoiceOfPaymentRequests200Response> {
            return localVarFp.analyzeInvoiceOfPaymentRequests(requestParameters.organizationId, requestParameters.file, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply fraud lock status
         * @param {DefaultApiApplyFraudLockStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyFraudLockStatus(requestParameters: DefaultApiApplyFraudLockStatusRequest, options?: AxiosRequestConfig): AxiosPromise<ApplyFraudLockStatus200Response> {
            return localVarFp.applyFraudLockStatus(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve organization identity verification
         * @param {DefaultApiApproveOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveOrganizationIdentityVerification(requestParameters: DefaultApiApproveOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<ApproveOrganizationIdentityVerification200Response> {
            return localVarFp.approveOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve purchase application.
         * @param {DefaultApiApprovePurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePurchaseApplication(requestParameters: DefaultApiApprovePurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approvePurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.approvePurchaseApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve workflow step of payment request
         * @param {DefaultApiApproveWorkflowStepPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveWorkflowStepPaymentRequests(requestParameters: DefaultApiApproveWorkflowStepPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveWorkflowStepPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.approveWorkflowStepPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Automatically journalize deals from rules
         * @param {DefaultApiAutomaticallyJournalizeDealsFromRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automaticallyJournalizeDealsFromRules(requestParameters: DefaultApiAutomaticallyJournalizeDealsFromRulesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.automaticallyJournalizeDealsFromRules(requestParameters.organizationId, requestParameters.companyId, requestParameters.automaticallyJournalizeDealsFromRulesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bank Account Activities Withdrawal Reserve
         * @param {DefaultApiBankAccountActivitiesWithdrawalReserveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankAccountActivitiesWithdrawalReserve(requestParameters: DefaultApiBankAccountActivitiesWithdrawalReserveRequest, options?: AxiosRequestConfig): AxiosPromise<BankAccountActivitiesWithdrawalReserve200Response> {
            return localVarFp.bankAccountActivitiesWithdrawalReserve(requestParameters.bankAccountActivitiesWithdrawalReserveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {DefaultApiBulkDisableDailyUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDisableDailyUserUsageLimit(requestParameters: DefaultApiBulkDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<Array<BulkDisableDailyUserUsageLimit200ResponseInner>> {
            return localVarFp.bulkDisableDailyUserUsageLimit(requestParameters.bulkDisableDailyUserUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk disable monthly usage limit
         * @param {DefaultApiBulkDisableMonthlyUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDisableMonthlyUsageLimit(requestParameters: DefaultApiBulkDisableMonthlyUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<Array<BulkDisableMonthlyUsageLimit200ResponseInner>> {
            return localVarFp.bulkDisableMonthlyUsageLimit(requestParameters.bulkDisableMonthlyUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows organization administrators to invite multiple users at once by providing user details (email, name, and role). This endpoint accepts up to 300 users per request. 
         * @summary Bulk invite users to organization
         * @param {DefaultApiBulkInviteUsersAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInviteUsersAdmin(requestParameters: DefaultApiBulkInviteUsersAdminRequest, options?: AxiosRequestConfig): AxiosPromise<BulkInviteUsersAdmin200Response> {
            return localVarFp.bulkInviteUsersAdmin(requestParameters.organizationId, requestParameters.bulkInviteUsersAdminRequest, requestParameters.xChallengeSuccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk update daily usage limit
         * @param {DefaultApiBulkUpdateDailyUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateDailyUsageLimit(requestParameters: DefaultApiBulkUpdateDailyUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<Array<BulkUpdateDailyUsageLimit200ResponseInner>> {
            return localVarFp.bulkUpdateDailyUsageLimit(requestParameters.bulkUpdateDailyUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk update monthly usage limit
         * @param {DefaultApiBulkUpdateMonthlyUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateMonthlyUsageLimit(requestParameters: DefaultApiBulkUpdateMonthlyUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<Array<BulkUpdateMonthlyUsageLimit200ResponseInner>> {
            return localVarFp.bulkUpdateMonthlyUsageLimit(requestParameters.bulkUpdateMonthlyUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Update Organization User Privileges
         * @param {DefaultApiBulkUpdateOrganizationUserPrivilegesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateOrganizationUserPrivileges(requestParameters: DefaultApiBulkUpdateOrganizationUserPrivilegesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkUpdateOrganizationUserPrivileges(requestParameters.organizationId, requestParameters.bulkUpdateOrganizationUserPrivilegesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel draft payment request
         * @param {DefaultApiCancelDraftPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDraftPaymentRequest(requestParameters: DefaultApiCancelDraftPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelDraftPaymentRequest(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel payment request
         * @param {DefaultApiCancelPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPaymentRequest(requestParameters: DefaultApiCancelPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelPaymentRequest(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Identity Verification Scheduled Date
         * @param {DefaultApiChangeIdentityVerificationScheduledDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIdentityVerificationScheduledDate(requestParameters: DefaultApiChangeIdentityVerificationScheduledDateRequest, options?: AxiosRequestConfig): AxiosPromise<ChangeIdentityVerificationScheduledDate200Response> {
            return localVarFp.changeIdentityVerificationScheduledDate(requestParameters.organizationId, requestParameters.changeIdentityVerificationScheduledDateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Invoice Email
         * @param {DefaultApiChangeInvoiceEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeInvoiceEmail(requestParameters: DefaultApiChangeInvoiceEmailRequest, options?: AxiosRequestConfig): AxiosPromise<ChangeInvoiceEmail200Response> {
            return localVarFp.changeInvoiceEmail(requestParameters.organizationId, requestParameters.changeInvoiceEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change to the specified ekyc result
         * @param {DefaultApiChangeToTheSpecifiedEkycResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeToTheSpecifiedEkycResult(requestParameters: DefaultApiChangeToTheSpecifiedEkycResultRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeToTheSpecifiedEkycResult(requestParameters.identificationId, requestParameters.changeToTheSpecifiedEkycResultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check Already Registered Phone Number
         * @param {DefaultApiCheckAlreadyRegisteredPhoneNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAlreadyRegisteredPhoneNumber(requestParameters: DefaultApiCheckAlreadyRegisteredPhoneNumberRequest, options?: AxiosRequestConfig): AxiosPromise<CheckAlreadyRegisteredPhoneNumber200Response> {
            return localVarFp.checkAlreadyRegisteredPhoneNumber(requestParameters.checkAlreadyRegisteredPhoneNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check All Organization Available Limit And Notify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAvailableLimit(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkAvailableLimit(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check duplicate email addresses
         * @param {DefaultApiCheckDuplicateEmailAddressesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDuplicateEmailAddresses(requestParameters: DefaultApiCheckDuplicateEmailAddressesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<CheckDuplicateEmailAddresses200ResponseInner>> {
            return localVarFp.checkDuplicateEmailAddresses(requestParameters.emailAddresses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkMonthlyUsageLimit(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkMonthlyUsageLimit(options).then((request) => request(axios, basePath));
        },
        /**
         * It is an API that waits for a redirect after the payment request fix button is pressed in the Slack App. This API does three things:   - Slack message modification - remove each button attached to the original message   - Post messages to Slack - communicate the fact that the edit button was pressed   - Create payment request for draft data
         * @summary Complete redirect from slack
         * @param {DefaultApiCompleteRedirectFromSlackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRedirectFromSlack(requestParameters: DefaultApiCompleteRedirectFromSlackRequest, options?: AxiosRequestConfig): AxiosPromise<CompleteRedirectFromSlack200Response> {
            return localVarFp.completeRedirectFromSlack(requestParameters.organizationId, requestParameters.completeRedirectFromSlackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm Fufu hotel reservation
         * @param {DefaultApiConfirmFufuHotelReservationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmFufuHotelReservation(requestParameters: DefaultApiConfirmFufuHotelReservationRequest, options?: AxiosRequestConfig): AxiosPromise<ConfirmFufuHotelReservation200Response> {
            return localVarFp.confirmFufuHotelReservation(requestParameters.confirmFufuHotelReservationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary freee接続
         * @param {DefaultApiConnectFreeeForAccountingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectFreeeForAccounting(requestParameters: DefaultApiConnectFreeeForAccountingRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.connectFreeeForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.connectFreeeForAccountingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count deals
         * @param {DefaultApiCountDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countDeals(requestParameters: DefaultApiCountDealsRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.countDeals(requestParameters.organizationId, requestParameters.countDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create bank transfers for the specified payment requests.
         * @summary Create bank transfers
         * @param {DefaultApiCreateBankTransfersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankTransfers(requestParameters: DefaultApiCreateBankTransfersRequest, options?: AxiosRequestConfig): AxiosPromise<CreateBankTransfers200Response> {
            return localVarFp.createBankTransfers(requestParameters.organizationId, requestParameters.createBankTransfersRequest, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create category of the purchase application template.
         * @param {DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.createCategoryOfThePurchaseApplicationTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create comment template
         * @param {DefaultApiCreateCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommentTemplate(requestParameters: DefaultApiCreateCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCommentTemplate(requestParameters.organizationId, requestParameters.createCommentTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create deposit restriction for organization
         * @param {DefaultApiCreateDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDepositRestrictionForOrganization(requestParameters: DefaultApiCreateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.createDepositRestrictionForOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create draft of payment request
         * @param {DefaultApiCreateDraftOfPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftOfPaymentRequests(requestParameters: DefaultApiCreateDraftOfPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<CreateDraftOfPaymentRequests200Response> {
            return localVarFp.createDraftOfPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.createDraftOfPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create ETC card issuance request
         * @param {DefaultApiCreateEtcCardIssuanceRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEtcCardIssuanceRequest(requestParameters: DefaultApiCreateEtcCardIssuanceRequestRequest, options?: AxiosRequestConfig): AxiosPromise<CreateEtcCardIssuanceRequest200Response> {
            return localVarFp.createEtcCardIssuanceRequest(requestParameters.organizationId, requestParameters.createEtcCardIssuanceRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create evidence request
         * @param {DefaultApiCreateEvidenceRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidenceRequest(requestParameters: DefaultApiCreateEvidenceRequestRequest, options?: AxiosRequestConfig): AxiosPromise<CreateEvidenceRequest200Response> {
            return localVarFp.createEvidenceRequest(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary freee認可URL作成
         * @param {DefaultApiCreateFreeeAuthForAccountingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreeeAuthForAccounting(requestParameters: DefaultApiCreateFreeeAuthForAccountingRequest, options?: AxiosRequestConfig): AxiosPromise<CreateFreeeAuthForAccounting200Response> {
            return localVarFp.createFreeeAuthForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create freee partner
         * @param {DefaultApiCreateFreeePartnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFreeePartner(requestParameters: DefaultApiCreateFreeePartnerRequest, options?: AxiosRequestConfig): AxiosPromise<CreateFreeePartner200Response> {
            return localVarFp.createFreeePartner(requestParameters.organizationId, requestParameters.companyId, requestParameters.createFreeePartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create past deals
         * @param {DefaultApiCreatePastDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPastDeals(requestParameters: DefaultApiCreatePastDealsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPastDeals(requestParameters.organizationId, requestParameters.createPastDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create purchase application.
         * @param {DefaultApiCreatePurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseApplication(requestParameters: DefaultApiCreatePurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPurchaseApplication(requestParameters.organizationId, requestParameters.createPurchaseApplicationRequest, requestParameters.visaTransactionReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create purchase application template.
         * @param {DefaultApiCreatePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPurchaseApplicationTemplate(requestParameters: DefaultApiCreatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createPurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.createPurchaseApplicationTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Slack card notification settings of an organization
         * @param {DefaultApiCreateSlackCardNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlackCardNotifications(requestParameters: DefaultApiCreateSlackCardNotificationsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createSlackCardNotifications(requestParameters.organizationId, requestParameters.createSlackCardNotificationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create slack notification settings for purchase-application
         * @param {DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSlackNotificationSettingsForPurchaseApplication(requestParameters: DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createSlackNotificationSettingsForPurchaseApplication(requestParameters.organizationId, requestParameters.createSlackNotificationSettingsForPurchaseApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Teams card notification settings of an organization
         * @param {DefaultApiCreateTeamsCardNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamsCardNotifications(requestParameters: DefaultApiCreateTeamsCardNotificationsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createTeamsCardNotifications(requestParameters.organizationId, requestParameters.createTeamsCardNotificationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create user account groups
         * @param {DefaultApiCreateUserAccountGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserAccountGroups(requestParameters: DefaultApiCreateUserAccountGroupsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<CreateUserAccountGroups200ResponseInner>> {
            return localVarFp.createUserAccountGroups(requestParameters.organizationId, requestParameters.createUserAccountGroupsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate a card
         * @param {DefaultApiDeactivateCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCard(requestParameters: DefaultApiDeactivateCardRequest, options?: AxiosRequestConfig): AxiosPromise<DeactivateCard200Response> {
            return localVarFp.deactivateCard(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate ETC card
         * @param {DefaultApiDeactivateEtcCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateEtcCard(requestParameters: DefaultApiDeactivateEtcCardRequest, options?: AxiosRequestConfig): AxiosPromise<DeactivateEtcCard200Response> {
            return localVarFp.deactivateEtcCard(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate a user
         * @param {DefaultApiDeactivateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUser(requestParameters: DefaultApiDeactivateUserRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deactivateUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Defrost a card
         * @param {DefaultApiDefrostCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        defrostCard(requestParameters: DefaultApiDefrostCardRequest, options?: AxiosRequestConfig): AxiosPromise<DefrostCard200Response> {
            return localVarFp.defrostCard(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Card Points Rate Configs
         * @param {DefaultApiDeleteCardPointsRateConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCardPointsRateConfig(requestParameters: DefaultApiDeleteCardPointsRateConfigRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCardPointsRateConfig(requestParameters.rateConfigId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete category of the purchase application template.
         * @param {DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.purchaseTemplateCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete comment for card transaction
         * @param {DefaultApiDeleteCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(requestParameters: DefaultApiDeleteCommentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionCommentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete comment template
         * @param {DefaultApiDeleteCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommentTemplate(requestParameters: DefaultApiDeleteCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCommentTemplate(requestParameters.organizationId, requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete deposit restriction for organization
         * @param {DefaultApiDeleteDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDepositRestrictionForOrganization(requestParameters: DefaultApiDeleteDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete evidence
         * @param {DefaultApiDeleteEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvidence(requestParameters: DefaultApiDeleteEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEvidence(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete freee connected
         * @param {DefaultApiDeleteFreeeConnectedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFreeeConnected(requestParameters: DefaultApiDeleteFreeeConnectedRequest, options?: AxiosRequestConfig): AxiosPromise<DeleteFreeeConnected200Response> {
            return localVarFp.deleteFreeeConnected(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Freee End Journal Entry Transition Mode
         * @param {DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFreeeEndJournalEntryTransitionMode(requestParameters: DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFreeeEndJournalEntryTransitionMode(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete merchant general block allowed organization ids
         * @param {DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantGeneralBlockAllowedOrganizationIds(requestParameters: DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMerchantGeneralBlockAllowedOrganizationIds(requestParameters.merchantGeneralBlockListId, requestParameters.allowedOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete merchant general block list
         * @param {DefaultApiDeleteMerchantGeneralBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantGeneralBlockList(requestParameters: DefaultApiDeleteMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMerchantGeneralBlockList(requestParameters.merchantGeneralBlockListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete merchant org block list
         * @param {DefaultApiDeleteMerchantOrgBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchantOrgBlockList(requestParameters: DefaultApiDeleteMerchantOrgBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMerchantOrgBlockList(requestParameters.merchantOrgBlockListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an onboarding request
         * @param {DefaultApiDeleteOnboardingRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOnboardingRequest(requestParameters: DefaultApiDeleteOnboardingRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOnboardingRequest(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Organization Create Request
         * @param {DefaultApiDeleteOrganizationCreateRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationCreateRequest(requestParameters: DefaultApiDeleteOrganizationCreateRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrganizationCreateRequest(requestParameters.organizationCreateRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a payment request evidence specified by evidenceId.
         * @summary Delete the specific payment request evidence.
         * @param {DefaultApiDeletePaymentRequestEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentRequestEvidence(requestParameters: DefaultApiDeletePaymentRequestEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete purchase application.
         * @param {DefaultApiDeletePurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseApplication(requestParameters: DefaultApiDeletePurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete purchase application templates detail
         * @param {DefaultApiDeletePurchaseApplicationTemplatesDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePurchaseApplicationTemplatesDetail(requestParameters: DefaultApiDeletePurchaseApplicationTemplatesDetailRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePurchaseApplicationTemplatesDetail(requestParameters.organizationId, requestParameters.purchaseTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete slack notification channel setting for purchase-application
         * @param {DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlackNotificationChannelSettingForPurchaseApplication(requestParameters: DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSlackNotificationChannelSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete slack notification channel setting for card
         * @param {DefaultApiDeleteSlackNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSlackNotificationSettingForCard(requestParameters: DefaultApiDeleteSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete system admin role
         * @param {DefaultApiDeleteSystemAdminRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSystemAdminRole(requestParameters: DefaultApiDeleteSystemAdminRoleRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSystemAdminRole(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete teams notification channel setting for card
         * @param {DefaultApiDeleteTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamsNotificationSettingForCard(requestParameters: DefaultApiDeleteTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user account group
         * @param {DefaultApiDeleteUserAccountGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAccountGroup(requestParameters: DefaultApiDeleteUserAccountGroupRequest, options?: AxiosRequestConfig): AxiosPromise<Array<DeleteUserAccountGroup200ResponseInner>> {
            return localVarFp.deleteUserAccountGroup(requestParameters.userAccountGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deposit Guarantee Money Balance
         * @param {DefaultApiDepositGuaranteeMoneyBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        depositGuaranteeMoneyBalance(requestParameters: DefaultApiDepositGuaranteeMoneyBalanceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.depositGuaranteeMoneyBalance(requestParameters.organizationId, requestParameters.depositGuaranteeMoneyBalanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable Approval
         * @param {DefaultApiDisableApprovalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableApproval(requestParameters: DefaultApiDisableApprovalRequest, options?: AxiosRequestConfig): AxiosPromise<DisableApproval200Response> {
            return localVarFp.disableApproval(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable daily usage limit for an user account
         * @param {DefaultApiDisableDailyUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableDailyUserUsageLimit(requestParameters: DefaultApiDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<DisableDailyUserUsageLimit200Response> {
            return localVarFp.disableDailyUserUsageLimit(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable physical store payment for the user account
         * @param {DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disablePhysicalStorePaymentForTheUserAccount(requestParameters: DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<DisablePhysicalStorePaymentForTheUserAccount200Response> {
            return localVarFp.disablePhysicalStorePaymentForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable transaction upper limit for the user account
         * @param {DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTransactionUpperLimitForTheUserAccount(requestParameters: DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<DisableTransactionUpperLimitForTheUserAccount200Response> {
            return localVarFp.disableTransactionUpperLimitForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable usage limit for an user account
         * @param {DefaultApiDisableUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUserUsageLimit(requestParameters: DefaultApiDisableUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<DisableUserUsageLimit200Response> {
            return localVarFp.disableUserUsageLimit(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disagree to the agreement request
         * @param {DefaultApiDisagreeToAgreementRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disagreeToAgreementRequest(requestParameters: DefaultApiDisagreeToAgreementRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disagreeToAgreementRequest(requestParameters.organizationId, requestParameters.agreementRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary freee接続解除
         * @param {DefaultApiDisconnectFreeeForAccountingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectFreeeForAccounting(requestParameters: DefaultApiDisconnectFreeeForAccountingRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.disconnectFreeeForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download bank transfer file
         * @param {DefaultApiDownloadBankTransferFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBankTransferFile(requestParameters: DefaultApiDownloadBankTransferFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadBankTransferFile(requestParameters.organizationId, requestParameters.bankTransferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download bank transfers csv
         * @param {DefaultApiDownloadBankTransfersCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBankTransfersCsv(requestParameters: DefaultApiDownloadBankTransfersCsvRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadBankTransfersCsv(requestParameters.organizationId, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download ETC accounting CSV
         * @param {DefaultApiDownloadEtcAccountingCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEtcAccountingCsv(requestParameters: DefaultApiDownloadEtcAccountingCsvRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadEtcAccountingCsv(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.dateType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download journal entry for freee csv
         * @param {DefaultApiDownloadJournalEntryForFreeeCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadJournalEntryForFreeeCsv(requestParameters: DefaultApiDownloadJournalEntryForFreeeCsvRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadJournalEntryForFreeeCsv(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download Organizations Accounting Csv
         * @param {DefaultApiDownloadOrganizationsAccountingCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrganizationsAccountingCsv(requestParameters: DefaultApiDownloadOrganizationsAccountingCsvRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadOrganizationsAccountingCsv(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download payment requests csv
         * @param {DefaultApiDownloadPaymentRequestsCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPaymentRequestsCsv(requestParameters: DefaultApiDownloadPaymentRequestsCsvRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadPaymentRequestsCsv(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.freeWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download payment requests csv for payment request ids specification
         * @param {DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(requestParameters: DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(requestParameters.organizationId, requestParameters.downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable physical store payment for the user account
         * @param {DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enablePhysicalStorePaymentForTheUserAccount(requestParameters: DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<EnablePhysicalStorePaymentForTheUserAccount200Response> {
            return localVarFp.enablePhysicalStorePaymentForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Freeze a card
         * @param {DefaultApiFreezeCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeCard(requestParameters: DefaultApiFreezeCardRequest, options?: AxiosRequestConfig): AxiosPromise<FreezeCard200Response> {
            return localVarFp.freezeCard(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Freeze Organization
         * @param {DefaultApiFreezeOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freezeOrganization(requestParameters: DefaultApiFreezeOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<FreezeOrganization200Response> {
            return localVarFp.freezeOrganization(requestParameters.organizationId, requestParameters.freezeOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Annual Fees Invoice
         * @param {DefaultApiGenerateAnnualFeesInvoiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAnnualFeesInvoice(requestParameters: DefaultApiGenerateAnnualFeesInvoiceRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.generateAnnualFeesInvoice(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate Create Account Token
         * @param {DefaultApiGenerateCreateAccountTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCreateAccountToken(requestParameters: DefaultApiGenerateCreateAccountTokenRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateCreateAccountToken(requestParameters.generateCreateAccountTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate freee redirect url
         * @param {DefaultApiGenerateFreeeRedirectUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFreeeRedirectUrl(requestParameters: DefaultApiGenerateFreeeRedirectUrlRequest, options?: AxiosRequestConfig): AxiosPromise<GenerateFreeeRedirectUrl200Response> {
            return localVarFp.generateFreeeRedirectUrl(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate org account ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOrgAccountIds(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generateOrgAccountIds(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Card Detail as Admin
         * @param {DefaultApiGetACardDetailAsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACardDetailAsAdmin(requestParameters: DefaultApiGetACardDetailAsAdminRequest, options?: AxiosRequestConfig): AxiosPromise<GetACardDetailAsAdmin200Response> {
            return localVarFp.getACardDetailAsAdmin(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get accounting csv for the organization.
         * @param {DefaultApiGetAccountingCsvForTheOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingCsvForTheOrganization(requestParameters: DefaultApiGetAccountingCsvForTheOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getAccountingCsvForTheOrganization(requestParameters.organizationId, requestParameters.startYearMonth, requestParameters.endYearMonth, requestParameters.accountingSystemType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get accounting csv for the user account.
         * @param {DefaultApiGetAccountingCsvForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingCsvForTheUserAccount(requestParameters: DefaultApiGetAccountingCsvForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getAccountingCsvForTheUserAccount(requestParameters.userAccountId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admin users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUsers(options?: AxiosRequestConfig): AxiosPromise<GetAdminUsers200Response> {
            return localVarFp.getAdminUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admins
         * @param {DefaultApiGetAdminsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins(requestParameters: DefaultApiGetAdminsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetAdmins200ResponseInner>> {
            return localVarFp.getAdmins(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get agreement requests
         * @param {DefaultApiGetAgreementRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementRequests(requestParameters: DefaultApiGetAgreementRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetAgreementRequests200ResponseInner>> {
            return localVarFp.getAgreementRequests(requestParameters.organizationId, requestParameters.waitingForAgreement, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all banks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBanks(options?: AxiosRequestConfig): AxiosPromise<Array<GetAllBanks200ResponseInner>> {
            return localVarFp.getAllBanks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get analysis invoice of payment request
         * @param {DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisInvoiceOfPaymentRequest(requestParameters: DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<GetAnalysisInvoiceOfPaymentRequest200Response> {
            return localVarFp.getAnalysisInvoiceOfPaymentRequest(requestParameters.organizationId, requestParameters.fileId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get annual fees eligibility
         * @param {DefaultApiGetAnnualFeesEligibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnualFeesEligibility(requestParameters: DefaultApiGetAnnualFeesEligibilityRequest, options?: AxiosRequestConfig): AxiosPromise<GetAnnualFeesEligibility200Response> {
            return localVarFp.getAnnualFeesEligibility(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get approvers
         * @param {DefaultApiGetApproversRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApprovers(requestParameters: DefaultApiGetApproversRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetApprovers200ResponseInner>> {
            return localVarFp.getApprovers(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get available currency options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableCurrencyOptions(options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAvailableCurrencyOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * <p>   Return a list of feature names that are available for the organization.   Most features are unconditionally available to all organizations and   are not included in the response of this API, while some new features are not   available for the organization unless their names are included in this response. </p> <p>   The response schema are designed to ensure that information about new features   is not disclosed to organizations that cannot use them. </p>
         * @param {DefaultApiGetAvailableFeaturesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFeatures(requestParameters: DefaultApiGetAvailableFeaturesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAvailableFeatures(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Available merchant category options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableMerchantCategoryOptions(options?: AxiosRequestConfig): AxiosPromise<GetAvailableMerchantCategoryOptions200Response> {
            return localVarFp.getAvailableMerchantCategoryOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get balance state
         * @param {DefaultApiGetBalanceStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceState(requestParameters: DefaultApiGetBalanceStateRequest, options?: AxiosRequestConfig): AxiosPromise<GetBalanceState200Response> {
            return localVarFp.getBalanceState(requestParameters.organizationId, requestParameters.targetDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get bank account activities
         * @param {DefaultApiGetBankAccountActivitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountActivities(requestParameters: DefaultApiGetBankAccountActivitiesRequest, options?: AxiosRequestConfig): AxiosPromise<GetBankAccountActivities200Response> {
            return localVarFp.getBankAccountActivities(requestParameters.bankAccountActivityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a bank account confirmed activities
         * @param {DefaultApiGetBankAccountConfirmedActivitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountConfirmedActivities(requestParameters: DefaultApiGetBankAccountConfirmedActivitiesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetBankAccountConfirmedActivities200ResponseInner>> {
            return localVarFp.getBankAccountConfirmedActivities(requestParameters.organizationId, requestParameters.type, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get bank by name
         * @param {DefaultApiGetBankByNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankByName(requestParameters: DefaultApiGetBankByNameRequest, options?: AxiosRequestConfig): AxiosPromise<GetBankByName200Response> {
            return localVarFp.getBankByName(requestParameters.bankName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a bank transfer
         * @param {DefaultApiGetBankTransferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransfer(requestParameters: DefaultApiGetBankTransferRequest, options?: AxiosRequestConfig): AxiosPromise<GetBankTransfer200Response> {
            return localVarFp.getBankTransfer(requestParameters.organizationId, requestParameters.bankTransferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the specified bank\'s all branches
         * @param {DefaultApiGetBanksAllBranchesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanksAllBranches(requestParameters: DefaultApiGetBanksAllBranchesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetBanksAllBranches200ResponseInner>> {
            return localVarFp.getBanksAllBranches(requestParameters.bankCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get bookkeepers
         * @param {DefaultApiGetBookkeepersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookkeepers(requestParameters: DefaultApiGetBookkeepersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetBookkeepers200ResponseInner>> {
            return localVarFp.getBookkeepers(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get branch
         * @param {DefaultApiGetBranchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranch(requestParameters: DefaultApiGetBranchRequest, options?: AxiosRequestConfig): AxiosPromise<GetBranch200Response> {
            return localVarFp.getBranch(requestParameters.bankCode, requestParameters.branchName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all business descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessDescriptions(options?: AxiosRequestConfig): AxiosPromise<Array<GetBusinessDescriptions200ResponseInner>> {
            return localVarFp.getBusinessDescriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get if an organization can activate cards
         * @param {DefaultApiGetCanActivateCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanActivateCard(requestParameters: DefaultApiGetCanActivateCardRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getCanActivateCard(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the status of whether the organization can close
         * @param {DefaultApiGetCanCloseStatusesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanCloseStatuses(requestParameters: DefaultApiGetCanCloseStatusesRequest, options?: AxiosRequestConfig): AxiosPromise<GetCanCloseStatuses200Response> {
            return localVarFp.getCanCloseStatuses(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get can deactivate
         * @param {DefaultApiGetCanDeactivateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanDeactivate(requestParameters: DefaultApiGetCanDeactivateRequest, options?: AxiosRequestConfig): AxiosPromise<GetCanDeactivate200Response> {
            return localVarFp.getCanDeactivate(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get if the user can read card\'s sensitive info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanReadCardSensitive(options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getCanReadCardSensitive(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get if an organization can request a real card to be issued.
         * @param {DefaultApiGetCanRequestSendingCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanRequestSendingCard(requestParameters: DefaultApiGetCanRequestSendingCardRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getCanRequestSendingCard(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns whether the current user is eligible for canary routing (read-only, no cookie side-effect)
         * @summary Get canary routing eligibility status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanaryRoutingStatus(options?: AxiosRequestConfig): AxiosPromise<GetCanaryRoutingStatus200Response> {
            return localVarFp.getCanaryRoutingStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Card Bill
         * @param {DefaultApiGetCardBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardBill(requestParameters: DefaultApiGetCardBillRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardBill200Response> {
            return localVarFp.getCardBill(requestParameters.cardBillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Card Detail
         * @param {DefaultApiGetCardDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardDetail(requestParameters: DefaultApiGetCardDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardDetail200Response> {
            return localVarFp.getCardDetail(requestParameters.cardId, requestParameters.xChallengeSuccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get card monthly transactions
         * @param {DefaultApiGetCardMonthlyTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardMonthlyTransactions(requestParameters: DefaultApiGetCardMonthlyTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardMonthlyTransactions200Response> {
            return localVarFp.getCardMonthlyTransactions(requestParameters.userAccountId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Card Points Rate Configs By OrganizationId
         * @param {DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardPointsRateConfigsByOrganizationId(requestParameters: DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCardPointsRateConfigsByOrganizationId200ResponseInner>> {
            return localVarFp.getCardPointsRateConfigsByOrganizationId(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get card transaction details
         * @param {DefaultApiGetCardTransactionDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionDetails(requestParameters: DefaultApiGetCardTransactionDetailsRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardTransactionDetails200Response> {
            return localVarFp.getCardTransactionDetails(requestParameters.organizationId, requestParameters.visaTransactionReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get card transaction evidence record image
         * @param {DefaultApiGetCardTransactionEvidenceRecordImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionEvidenceRecordImage(requestParameters: DefaultApiGetCardTransactionEvidenceRecordImageRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getCardTransactionEvidenceRecordImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.id, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get card transaction evidence records
         * @param {DefaultApiGetCardTransactionEvidenceRecordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactionEvidenceRecords(requestParameters: DefaultApiGetCardTransactionEvidenceRecordsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCardTransactionEvidenceRecords200ResponseInner>> {
            return localVarFp.getCardTransactionEvidenceRecords(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Card Transactions
         * @param {DefaultApiGetCardTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardTransactions(requestParameters: DefaultApiGetCardTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetCardTransactions200Response> {
            return localVarFp.getCardTransactions(requestParameters.userAccountId, requestParameters.merchantId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get cards
         * @param {DefaultApiGetCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCards(requestParameters: DefaultApiGetCardsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCards200ResponseInner>> {
            return localVarFp.getCards(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get cards transactions with purchase application unlinked
         * @param {DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsTransactionsWithPurchaseApplicationUnlinked(requestParameters: DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInner>> {
            return localVarFp.getCardsTransactionsWithPurchaseApplicationUnlinked(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the category of the purchase application template for use.
         * @param {DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCategoryOfThePurchaseApplicationTemplate200ResponseInner>> {
            return localVarFp.getCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comment for card transaction
         * @param {DefaultApiGetCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComment(requestParameters: DefaultApiGetCommentRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetComment200ResponseInner>> {
            return localVarFp.getComment(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comment templates
         * @param {DefaultApiGetCommentTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentTemplates(requestParameters: DefaultApiGetCommentTemplatesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetCommentTemplates200ResponseInner>> {
            return localVarFp.getCommentTemplates(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comment template
         * @param {DefaultApiGetCommentTemplatesCommentTemplateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommentTemplatesCommentTemplateId(requestParameters: DefaultApiGetCommentTemplatesCommentTemplateIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetCommentTemplatesCommentTemplateId200Response> {
            return localVarFp.getCommentTemplatesCommentTemplateId(requestParameters.organizationId, requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current card associated with the user account
         * @param {DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCardAssociatedWithTheUserAccount(requestParameters: DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetCurrentCardAssociatedWithTheUserAccount200Response> {
            return localVarFp.getCurrentCardAssociatedWithTheUserAccount(requestParameters.userAccountId, requestParameters.includeMerchantCategories, requestParameters.expand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current ETC card associated with the user account
         * @param {DefaultApiGetCurrentEtcCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentEtcCard(requestParameters: DefaultApiGetCurrentEtcCardRequest, options?: AxiosRequestConfig): AxiosPromise<GetCurrentEtcCard200Response> {
            return localVarFp.getCurrentEtcCard(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get deals total amount
         * @param {DefaultApiGetDealsTotalAmountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealsTotalAmount(requestParameters: DefaultApiGetDealsTotalAmountRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getDealsTotalAmount(requestParameters.organizationId, requestParameters.getDealsTotalAmountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get default comment template for user account
         * @param {DefaultApiGetDefaultCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultCommentTemplate(requestParameters: DefaultApiGetDefaultCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<GetDefaultCommentTemplate200Response> {
            return localVarFp.getDefaultCommentTemplate(requestParameters.organizationId, requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deposit bank account
         * @param {DefaultApiGetDepositBankAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositBankAccount(requestParameters: DefaultApiGetDepositBankAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetDepositBankAccount200Response> {
            return localVarFp.getDepositBankAccount(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deposit restriction for organization
         * @param {DefaultApiGetDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictionForOrganization(requestParameters: DefaultApiGetDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetDepositRestrictionForOrganization200Response> {
            return localVarFp.getDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deposit restriction list for organization
         * @param {DefaultApiGetDepositRestrictionListForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictionListForOrganization(requestParameters: DefaultApiGetDepositRestrictionListForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetDepositRestrictionListForOrganization200ResponseInner>> {
            return localVarFp.getDepositRestrictionListForOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all deposit restrictions for the organization of the currently authenticated user
         * @summary Get deposit restrictions for current user\'s organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositRestrictions(options?: AxiosRequestConfig): AxiosPromise<Array<GetDepositRestrictions200ResponseInner>> {
            return localVarFp.getDepositRestrictions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get draft payment request
         * @param {DefaultApiGetDraftPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequest(requestParameters: DefaultApiGetDraftPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<GetDraftPaymentRequest200Response> {
            return localVarFp.getDraftPaymentRequest(requestParameters.organizationId, requestParameters.draftPaymentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get draft payment request evidence file
         * @param {DefaultApiGetDraftPaymentRequestEvidenceFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequestEvidenceFile(requestParameters: DefaultApiGetDraftPaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getDraftPaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get draft payment requests only created own
         * @param {DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftPaymentRequestsOnlyCreatedOwn(requestParameters: DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetDraftPaymentRequestsOnlyCreatedOwn200ResponseInner>> {
            return localVarFp.getDraftPaymentRequestsOnlyCreatedOwn(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get earliest expiring guarantee money for organization
         * @param {DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarliestExpiringGuaranteeMoneyForOrganization(requestParameters: DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetEarliestExpiringGuaranteeMoneyForOrganization200Response> {
            return localVarFp.getEarliestExpiringGuaranteeMoneyForOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtain email notification configuration information for each user.
         * @param {DefaultApiGetEmailNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailNotifications(requestParameters: DefaultApiGetEmailNotificationsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetEmailNotifications200ResponseInner>> {
            return localVarFp.getEmailNotifications(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get error bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorBills(options?: AxiosRequestConfig): AxiosPromise<Array<GetErrorBills200ResponseInner>> {
            return localVarFp.getErrorBills(options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if an ETC account exists for the specified organization. This is used to determine if ETC service has been initiated for the organization.
         * @summary Get ETC account status
         * @param {DefaultApiGetEtcAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcAccount(requestParameters: DefaultApiGetEtcAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetEtcAccount200Response> {
            return localVarFp.getEtcAccount(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get ETC card billing amounts per card for specified yearMonth
         * @param {DefaultApiGetEtcAmountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcAmounts(requestParameters: DefaultApiGetEtcAmountsRequest, options?: AxiosRequestConfig): AxiosPromise<GetEtcAmounts200Response> {
            return localVarFp.getEtcAmounts(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get ETC card count for organization
         * @param {DefaultApiGetEtcCardCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcCardCount(requestParameters: DefaultApiGetEtcCardCountRequest, options?: AxiosRequestConfig): AxiosPromise<GetEtcCardCount200Response> {
            return localVarFp.getEtcCardCount(requestParameters.organizationId, requestParameters.searchWord, requestParameters.statuses, requestParameters.groups, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns sensitive card information. Only accessible by the card holder. - Card number: 16 digits, displayed with spaces (e.g., \"1234 5678 9012 3456\") - Expiry: Year and month separately - Cardholder name: Copyable 
         * @summary Get ETC card personal information (card number, expiry, cardholder name)
         * @param {DefaultApiGetEtcCardDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcCardDetail(requestParameters: DefaultApiGetEtcCardDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetEtcCardDetail200Response> {
            return localVarFp.getEtcCardDetail(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns ETC card usage history with pagination. - Amount: Negative for normal transactions, positive for cancellations - Display format for usedAt: \"12月9日\" (without zero padding) 
         * @summary Get ETC card transactions
         * @param {DefaultApiGetEtcCardTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcCardTransactions(requestParameters: DefaultApiGetEtcCardTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetEtcCardTransactions200Response> {
            return localVarFp.getEtcCardTransactions(requestParameters.userAccountId, requestParameters.yearMonth, requestParameters.search, requestParameters.limit, requestParameters.nextCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get ETC cards
         * @param {DefaultApiGetEtcCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEtcCards(requestParameters: DefaultApiGetEtcCardsRequest, options?: AxiosRequestConfig): AxiosPromise<GetEtcCards200Response> {
            return localVarFp.getEtcCards(requestParameters.organizationId, requestParameters.searchWord, requestParameters.statuses, requestParameters.groups, requestParameters.limit, requestParameters.nextCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the evidence specified by evidenceId.
         * @summary Get a specific evidence.
         * @param {DefaultApiGetEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidence(requestParameters: DefaultApiGetEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<GetEvidence200Response> {
            return localVarFp.getEvidence(requestParameters.organizationId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence file
         * @param {DefaultApiGetEvidenceFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceFile(requestParameters: DefaultApiGetEvidenceFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getEvidenceFile(requestParameters.organizationId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence image
         * @param {DefaultApiGetEvidenceImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceImage(requestParameters: DefaultApiGetEvidenceImageRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence information for card transactions
         * @param {DefaultApiGetEvidenceInformationForCardTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceInformationForCardTransactions(requestParameters: DefaultApiGetEvidenceInformationForCardTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetEvidenceInformationForCardTransactions200Response> {
            return localVarFp.getEvidenceInformationForCardTransactions(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence record image
         * @param {DefaultApiGetEvidenceRecordImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceRecordImage(requestParameters: DefaultApiGetEvidenceRecordImageRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getEvidenceRecordImage(requestParameters.organizationId, requestParameters.evidenceId, requestParameters.recordId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence records
         * @param {DefaultApiGetEvidenceRecordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceRecords(requestParameters: DefaultApiGetEvidenceRecordsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetEvidenceRecords200ResponseInner>> {
            return localVarFp.getEvidenceRecords(requestParameters.organizationId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidence zip for the organization.
         * @param {DefaultApiGetEvidenceZipForTheOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceZipForTheOrganization(requestParameters: DefaultApiGetEvidenceZipForTheOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getEvidenceZipForTheOrganization(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get evidences
         * @param {DefaultApiGetEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidences(requestParameters: DefaultApiGetEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetEvidences200ResponseInner>> {
            return localVarFp.getEvidences(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count evidences
         * @param {DefaultApiGetEvidencesCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidencesCount(requestParameters: DefaultApiGetEvidencesCountRequest, options?: AxiosRequestConfig): AxiosPromise<GetEvidencesCount200Response> {
            return localVarFp.getEvidencesCount(requestParameters.organizationId, requestParameters.issuer, requestParameters.amountMin, requestParameters.amountMax, requestParameters.paidAtFrom, requestParameters.paidAtTo, requestParameters.irrelevantToLedger, requestParameters.keyword, requestParameters.includesDeleted, requestParameters.legalValidities, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the triggered transaction of a fraud locked card
         * @param {DefaultApiGetFraudLockedCardTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFraudLockedCardTransaction(requestParameters: DefaultApiGetFraudLockedCardTransactionRequest, options?: AxiosRequestConfig): AxiosPromise<GetFraudLockedCardTransaction200Response> {
            return localVarFp.getFraudLockedCardTransaction(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee account items
         * @param {DefaultApiGetFreeeAccountItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeAccountItems(requestParameters: DefaultApiGetFreeeAccountItemsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeAccountItems200ResponseInner>> {
            return localVarFp.getFreeeAccountItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee companies
         * @param {DefaultApiGetFreeeCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeCompanies(requestParameters: DefaultApiGetFreeeCompaniesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeCompanies200ResponseInner>> {
            return localVarFp.getFreeeCompanies(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee connected
         * @param {DefaultApiGetFreeeConnectedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnected(requestParameters: DefaultApiGetFreeeConnectedRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeConnected200Response> {
            return localVarFp.getFreeeConnected(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Freee Connected User
         * @param {DefaultApiGetFreeeConnectedUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnectedUser(requestParameters: DefaultApiGetFreeeConnectedUserRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeConnectedUser200Response> {
            return localVarFp.getFreeeConnectedUser(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary freee接続中のユーザー取得
         * @param {DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnectionLinkedAccountForAccounting(requestParameters: DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeConnectionLinkedAccountForAccounting200Response> {
            return localVarFp.getFreeeConnectionLinkedAccountForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary freee設定取得
         * @param {DefaultApiGetFreeeConnectionSettingsForAccountingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeConnectionSettingsForAccounting(requestParameters: DefaultApiGetFreeeConnectionSettingsForAccountingRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeConnectionSettingsForAccounting200Response> {
            return localVarFp.getFreeeConnectionSettingsForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee items
         * @param {DefaultApiGetFreeeItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeItems(requestParameters: DefaultApiGetFreeeItemsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeItems200ResponseInner>> {
            return localVarFp.getFreeeItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee memo tags
         * @param {DefaultApiGetFreeeMemoTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeMemoTags(requestParameters: DefaultApiGetFreeeMemoTagsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeMemoTags200ResponseInner>> {
            return localVarFp.getFreeeMemoTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee partners
         * @param {DefaultApiGetFreeePartnersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeePartners(requestParameters: DefaultApiGetFreeePartnersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeePartners200ResponseInner>> {
            return localVarFp.getFreeePartners(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee sections
         * @param {DefaultApiGetFreeeSectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSections(requestParameters: DefaultApiGetFreeeSectionsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeSections200ResponseInner>> {
            return localVarFp.getFreeeSections(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee segment tags
         * @param {DefaultApiGetFreeeSegmentTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSegmentTags(requestParameters: DefaultApiGetFreeeSegmentTagsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeSegmentTags200ResponseInner>> {
            return localVarFp.getFreeeSegmentTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee sync status
         * @param {DefaultApiGetFreeeSyncStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeSyncStatus(requestParameters: DefaultApiGetFreeeSyncStatusRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeSyncStatus200Response> {
            return localVarFp.getFreeeSyncStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee tags
         * @param {DefaultApiGetFreeeTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeTags(requestParameters: DefaultApiGetFreeeTagsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeTags200ResponseInner>> {
            return localVarFp.getFreeeTags(requestParameters.organizationId, requestParameters.companyId, requestParameters.tagName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee taxes
         * @param {DefaultApiGetFreeeTaxesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeTaxes(requestParameters: DefaultApiGetFreeeTaxesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetFreeeTaxes200ResponseInner>> {
            return localVarFp.getFreeeTaxes(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get freee token
         * @param {DefaultApiGetFreeeTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreeeToken(requestParameters: DefaultApiGetFreeeTokenRequest, options?: AxiosRequestConfig): AxiosPromise<GetFreeeToken200Response> {
            return localVarFp.getFreeeToken(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a guarantee money balance history
         * @param {DefaultApiGetGuaranteeMoneyBalanceHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyBalanceHistory(requestParameters: DefaultApiGetGuaranteeMoneyBalanceHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetGuaranteeMoneyBalanceHistory200ResponseInner>> {
            return localVarFp.getGuaranteeMoneyBalanceHistory(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a guarantee money balance information for a organization
         * @param {DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyBalanceInformationForOrganization(requestParameters: DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetGuaranteeMoneyBalanceInformationForOrganization200Response> {
            return localVarFp.getGuaranteeMoneyBalanceInformationForOrganization(requestParameters.organizationId, requestParameters.targetDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get guarantee money deposits for organization
         * @param {DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGuaranteeMoneyDepositsForOrganization(requestParameters: DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetGuaranteeMoneyDepositsForOrganization200ResponseInner>> {
            return localVarFp.getGuaranteeMoneyDepositsForOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetHolidaysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidays(requestParameters: DefaultApiGetHolidaysRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getHolidays(requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetIdentifyVerificationsLatestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentifyVerificationsLatest(requestParameters: DefaultApiGetIdentifyVerificationsLatestRequest, options?: AxiosRequestConfig): AxiosPromise<GetIdentifyVerificationsLatest200Response> {
            return localVarFp.getIdentifyVerificationsLatest(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetIdentityVerificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentityVerifications(requestParameters: DefaultApiGetIdentityVerificationsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetIdentityVerifications200ResponseInner>> {
            return localVarFp.getIdentityVerifications(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Invoice List
         * @param {DefaultApiGetInvoiceListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceList(requestParameters: DefaultApiGetInvoiceListRequest, options?: AxiosRequestConfig): AxiosPromise<GetInvoiceList200Response> {
            return localVarFp.getInvoiceList(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Invoice Pdf
         * @param {DefaultApiGetInvoicePdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicePdf(requestParameters: DefaultApiGetInvoicePdfRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getInvoicePdf(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get issuable status
         * @param {DefaultApiGetIssuableStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssuableStatus(requestParameters: DefaultApiGetIssuableStatusRequest, options?: AxiosRequestConfig): AxiosPromise<GetIssuableStatus200Response> {
            return localVarFp.getIssuableStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get jwt for SSO
         * @param {DefaultApiGetJwtSsoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJwtSso(requestParameters: DefaultApiGetJwtSsoRequest, options?: AxiosRequestConfig): AxiosPromise<GetJwtSso200Response> {
            return localVarFp.getJwtSso(requestParameters.nonce, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of KYC reader users ordered by creation date in descending order.
         * @summary Get KYC Reader Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKycReaderUsers(options?: AxiosRequestConfig): AxiosPromise<Array<GetKycReaderUsers200ResponseInner>> {
            return localVarFp.getKycReaderUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get latest time of sync to freee
         * @param {DefaultApiGetLatestTimeOfSyncToFreeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTimeOfSyncToFreee(requestParameters: DefaultApiGetLatestTimeOfSyncToFreeeRequest, options?: AxiosRequestConfig): AxiosPromise<GetLatestTimeOfSyncToFreee200Response> {
            return localVarFp.getLatestTimeOfSyncToFreee(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get lock status of evidences
         * @param {DefaultApiGetLockStatusOfEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLockStatusOfEvidences(requestParameters: DefaultApiGetLockStatusOfEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<GetLockStatusOfEvidences200Response> {
            return localVarFp.getLockStatusOfEvidences(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant general blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantGeneralBlock(options?: AxiosRequestConfig): AxiosPromise<Array<GetMerchantGeneralBlock200ResponseInner>> {
            return localVarFp.getMerchantGeneralBlock(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant general block detail
         * @param {DefaultApiGetMerchantGeneralBlockDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantGeneralBlockDetail(requestParameters: DefaultApiGetMerchantGeneralBlockDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetMerchantGeneralBlockDetail200Response> {
            return localVarFp.getMerchantGeneralBlockDetail(requestParameters.merchantGeneralBlockListId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant org blocks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrgBlock(options?: AxiosRequestConfig): AxiosPromise<Array<GetMerchantOrgBlock200ResponseInner>> {
            return localVarFp.getMerchantOrgBlock(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant org block list
         * @param {DefaultApiGetMerchantOrgBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrgBlockList(requestParameters: DefaultApiGetMerchantOrgBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetMerchantOrgBlockList200ResponseInner>> {
            return localVarFp.getMerchantOrgBlockList(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant organization user account year month summary
         * @param {DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOrganizationUserAccountYearMonthSummary(requestParameters: DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<GetMerchantOrganizationUserAccountYearMonthSummary200Response> {
            return localVarFp.getMerchantOrganizationUserAccountYearMonthSummary(requestParameters.organizationId, requestParameters.merchantId, requestParameters.userAccountId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of MerchantCategoryKind
         * @param {DefaultApiGetMerchantsCategoryKindsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantsCategoryKinds(requestParameters: DefaultApiGetMerchantsCategoryKindsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetMerchantsCategoryKinds200ResponseInner>> {
            return localVarFp.getMerchantsCategoryKinds(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Modifiable Daily Limits For The User Account
         * @param {DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableDailyLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetModifiableDailyLimitsForTheUserAccount200Response> {
            return localVarFp.getModifiableDailyLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get modifiable monthly limits for the user account
         * @param {DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableMonthlyLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetModifiableMonthlyLimitsForTheUserAccount200Response> {
            return localVarFp.getModifiableMonthlyLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Modifiable Transaction Limits For The User Account
         * @param {DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiableTransactionLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<GetModifiableTransactionLimitsForTheUserAccount200Response> {
            return localVarFp.getModifiableTransactionLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get moneytree connected
         * @param {DefaultApiGetMoneytreeConnectedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeConnected(requestParameters: DefaultApiGetMoneytreeConnectedRequest, options?: AxiosRequestConfig): AxiosPromise<GetMoneytreeConnected200Response> {
            return localVarFp.getMoneytreeConnected(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get moneytree oauth url
         * @param {DefaultApiGetMoneytreeOauthUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeOauthUrl(requestParameters: DefaultApiGetMoneytreeOauthUrlRequest, options?: AxiosRequestConfig): AxiosPromise<GetMoneytreeOauthUrl200Response> {
            return localVarFp.getMoneytreeOauthUrl(requestParameters.organizationId, requestParameters.nextTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get moneytree status
         * @param {DefaultApiGetMoneytreeStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoneytreeStatus(requestParameters: DefaultApiGetMoneytreeStatusRequest, options?: AxiosRequestConfig): AxiosPromise<GetMoneytreeStatus200Response> {
            return localVarFp.getMoneytreeStatus(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get monthly card bills for specified yearMonths
         * @param {DefaultApiGetMonthlyCardBillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardBill(requestParameters: DefaultApiGetMonthlyCardBillRequest, options?: AxiosRequestConfig): AxiosPromise<GetMonthlyCardBill200Response> {
            return localVarFp.getMonthlyCardBill(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.startYearMonth, requestParameters.endYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get monthly card transactions for the organization.
         * @param {DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardTransactionsForTheOrganization(requestParameters: DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetMonthlyCardTransactionsForTheOrganization200Response> {
            return localVarFp.getMonthlyCardTransactionsForTheOrganization(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get monthly card transactions for the user
         * @param {DefaultApiGetMonthlyCardTransactionsForTheUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyCardTransactionsForTheUser(requestParameters: DefaultApiGetMonthlyCardTransactionsForTheUserRequest, options?: AxiosRequestConfig): AxiosPromise<GetMonthlyCardTransactionsForTheUser200Response> {
            return localVarFp.getMonthlyCardTransactionsForTheUser(requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定された組織・年月のFlora課金情報（サービス料金）を取得します。 年会費、ラウンジ利用料などのFlora課金明細を返却します。  **注意**: このAPIはFlora課金情報のみを返します。カード決済情報は `/cards/monthly_card_bill` APIを使用してください。 
         * @summary Get Monthly Service Charges
         * @param {DefaultApiGetMonthlyServiceChargesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyServiceCharges(requestParameters: DefaultApiGetMonthlyServiceChargesRequest, options?: AxiosRequestConfig): AxiosPromise<GetMonthlyServiceCharges200Response> {
            return localVarFp.getMonthlyServiceCharges(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get monthly user card summaries
         * @param {DefaultApiGetMonthlyUserCardSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMonthlyUserCardSummaries(requestParameters: DefaultApiGetMonthlyUserCardSummariesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetMonthlyUserCardSummaries200ResponseInner>> {
            return localVarFp.getMonthlyUserCardSummaries(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get OL info sharing consent status
         * @param {DefaultApiGetOlInfoSharingConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOlInfoSharingConsent(requestParameters: DefaultApiGetOlInfoSharingConsentRequest, options?: AxiosRequestConfig): AxiosPromise<GetOlInfoSharingConsent200Response> {
            return localVarFp.getOlInfoSharingConsent(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific onboarding request for zeus
         * @param {DefaultApiGetOnboardingRequestByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequestById(requestParameters: DefaultApiGetOnboardingRequestByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetOnboardingRequestById200Response> {
            return localVarFp.getOnboardingRequestById(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get personal information of the onboarding request.
         * @summary Get Personal Information
         * @param {DefaultApiGetOnboardingRequestPersonalInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequestPersonalInfo(requestParameters: DefaultApiGetOnboardingRequestPersonalInfoRequest, options?: AxiosRequestConfig): AxiosPromise<GetOnboardingRequestPersonalInfo200Response> {
            return localVarFp.getOnboardingRequestPersonalInfo(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get onboarding requests for zeus
         * @param {DefaultApiGetOnboardingRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingRequests(requestParameters: DefaultApiGetOnboardingRequestsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetOnboardingRequests200Response> {
            return localVarFp.getOnboardingRequests(requestParameters.key, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get org account state
         * @param {DefaultApiGetOrgAccountStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgAccountState(requestParameters: DefaultApiGetOrgAccountStateRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrgAccountState200Response> {
            return localVarFp.getOrgAccountState(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization
         * @param {DefaultApiGetOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(requestParameters: DefaultApiGetOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganization200Response> {
            return localVarFp.getOrganization(requestParameters.organizationId, requestParameters.underContractOnly, requestParameters.withCredit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Accounting Csv Fields Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAccountingCsvFieldsTypes(options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationAccountingCsvFieldsTypes200ResponseInner>> {
            return localVarFp.getOrganizationAccountingCsvFieldsTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization cards extended
         * @param {DefaultApiGetOrganizationCardsExtendedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCardsExtended(requestParameters: DefaultApiGetOrganizationCardsExtendedRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationCardsExtended200ResponseInner>> {
            return localVarFp.getOrganizationCardsExtended(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization cards light
         * @param {DefaultApiGetOrganizationCardsLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCardsLight(requestParameters: DefaultApiGetOrganizationCardsLightRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationCardsLight200ResponseInner>> {
            return localVarFp.getOrganizationCardsLight(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization chart departments
         * @param {DefaultApiGetOrganizationChartDepartmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartDepartments(requestParameters: DefaultApiGetOrganizationChartDepartmentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationChartDepartments200ResponseInner>> {
            return localVarFp.getOrganizationChartDepartments(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization chart employees
         * @param {DefaultApiGetOrganizationChartEmployeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartEmployees(requestParameters: DefaultApiGetOrganizationChartEmployeesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationChartEmployees200ResponseInner>> {
            return localVarFp.getOrganizationChartEmployees(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization chart roles
         * @param {DefaultApiGetOrganizationChartRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationChartRoles(requestParameters: DefaultApiGetOrganizationChartRolesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationChartRoles200ResponseInner>> {
            return localVarFp.getOrganizationChartRoles(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organizations create requests for zeus
         * @param {DefaultApiGetOrganizationCreateRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCreateRequests(requestParameters: DefaultApiGetOrganizationCreateRequestsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationCreateRequests200Response> {
            return localVarFp.getOrganizationCreateRequests(requestParameters.key, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMe(options?: AxiosRequestConfig): AxiosPromise<GetOrganizationMe200Response> {
            return localVarFp.getOrganizationMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization payment schemes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPaymentSchemes(options?: AxiosRequestConfig): AxiosPromise<Array<Array<GetOrganizationPaymentSchemes200ResponseInnerInner>>> {
            return localVarFp.getOrganizationPaymentSchemes(options).then((request) => request(axios, basePath));
        },
        /**
         * 請求画面トップのサマリー表示に必要な情報を、組織レベルで取得する。 個別の請求実体（CardBill / ServiceCharge）に依存せず、組織に設定されている 支払スキームと、対象支払予定日に紐づく合算情報を返す。  ## 用途 - UPSIDER 請求画面トップ（`/payments/`）のサマリーカード表示 - ETC-only 組織（CARD 請求が発生しない組織）でもサマリーを描画可能にする  ## 関連 - 個別請求の詳細取得は引き続き以下を使用：   - カード請求: `/cards/{cardBillId}`   - サービス利用料明細: `/organizations/{organizationId}/service_charges/{yearMonth}` - 請求一覧（履歴全件）の取得: `/organizations/{organizationId}/payments` 
         * @summary Get payment summary for organization
         * @param {DefaultApiGetOrganizationPaymentSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPaymentSummary(requestParameters: DefaultApiGetOrganizationPaymentSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationPaymentSummary200Response> {
            return localVarFp.getOrganizationPaymentSummary(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization payments
         * @param {DefaultApiGetOrganizationPaymentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationPayments(requestParameters: DefaultApiGetOrganizationPaymentsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationPayments200ResponseInner>> {
            return localVarFp.getOrganizationPayments(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations(options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizations200ResponseInner>> {
            return localVarFp.getOrganizations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organizations Accounting Csv Export Fields
         * @param {DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsAccountingCsvExportFields(requestParameters: DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getOrganizationsAccountingCsvExportFields(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a organization\'s bill
         * @param {DefaultApiGetOrganizationsBillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsBills(requestParameters: DefaultApiGetOrganizationsBillsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationsBills200ResponseInner>> {
            return localVarFp.getOrganizationsBills(requestParameters.organizationId, requestParameters.beforeReservationOnly, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organizations deals
         * @param {DefaultApiGetOrganizationsDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsDeals(requestParameters: DefaultApiGetOrganizationsDealsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationsDeals200ResponseInner>> {
            return localVarFp.getOrganizationsDeals(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment request detail
         * @param {DefaultApiGetPaymentRequestDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestDetail(requestParameters: DefaultApiGetPaymentRequestDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetPaymentRequestDetail200Response> {
            return localVarFp.getPaymentRequestDetail(requestParameters.organizationId, requestParameters.paymentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a payment request evidence specified by evidenceId.
         * @summary Get a specific payment request evidence.
         * @param {DefaultApiGetPaymentRequestEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidence(requestParameters: DefaultApiGetPaymentRequestEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<GetPaymentRequestEvidence200Response> {
            return localVarFp.getPaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment request evidence file
         * @param {DefaultApiGetPaymentRequestEvidenceFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceFile(requestParameters: DefaultApiGetPaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getPaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment request evidence record file
         * @param {DefaultApiGetPaymentRequestEvidenceRecordFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceRecordFile(requestParameters: DefaultApiGetPaymentRequestEvidenceRecordFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getPaymentRequestEvidenceRecordFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.recordId, requestParameters.inPdf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment request evidence records
         * @param {DefaultApiGetPaymentRequestEvidenceRecordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidenceRecords(requestParameters: DefaultApiGetPaymentRequestEvidenceRecordsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPaymentRequestEvidenceRecords200ResponseInner>> {
            return localVarFp.getPaymentRequestEvidenceRecords(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all evidences for a specific payment request
         * @param {DefaultApiGetPaymentRequestEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestEvidences(requestParameters: DefaultApiGetPaymentRequestEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPaymentRequestEvidences200ResponseInner>> {
            return localVarFp.getPaymentRequestEvidences(requestParameters.organizationId, requestParameters.paymentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment requests bank accounts list
         * @param {DefaultApiGetPaymentRequestsBankAccountsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsBankAccountsList(requestParameters: DefaultApiGetPaymentRequestsBankAccountsListRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPaymentRequestsBankAccountsList200ResponseInner>> {
            return localVarFp.getPaymentRequestsBankAccountsList(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment requests count linked bank transfer
         * @param {DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentRequestsCountLinkedBankTransfer(requestParameters: DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getPaymentRequestsCountLinkedBankTransfer(requestParameters.organizationId, requestParameters.paymentRequestIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get pinretriever decrypt pin block
         * @param {DefaultApiGetPinretrieverDecryptPinBlockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverDecryptPinBlock(requestParameters: DefaultApiGetPinretrieverDecryptPinBlockRequest, options?: AxiosRequestConfig): AxiosPromise<GetPinretrieverDecryptPinBlock200Response> {
            return localVarFp.getPinretrieverDecryptPinBlock(requestParameters.getPinretrieverDecryptPinBlockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get pinretriever encrypt pin
         * @param {DefaultApiGetPinretrieverEncryptPinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverEncryptPin(requestParameters: DefaultApiGetPinretrieverEncryptPinRequest, options?: AxiosRequestConfig): AxiosPromise<GetPinretrieverEncryptPin200Response> {
            return localVarFp.getPinretrieverEncryptPin(requestParameters.getPinretrieverEncryptPinRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get pinretriever hsm publickey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinretrieverHsmPublickey(options?: AxiosRequestConfig): AxiosPromise<GetPinretrieverHsmPublickey200Response> {
            return localVarFp.getPinretrieverHsmPublickey(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchase application
         * @param {DefaultApiGetPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplication(requestParameters: DefaultApiGetPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<GetPurchaseApplication200Response> {
            return localVarFp.getPurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchase application templates
         * @param {DefaultApiGetPurchaseApplicationTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationTemplates(requestParameters: DefaultApiGetPurchaseApplicationTemplatesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPurchaseApplicationTemplates200ResponseInner>> {
            return localVarFp.getPurchaseApplicationTemplates(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchase application templates detail
         * @param {DefaultApiGetPurchaseApplicationTemplatesDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationTemplatesDetail(requestParameters: DefaultApiGetPurchaseApplicationTemplatesDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetPurchaseApplicationTemplatesDetail200Response> {
            return localVarFp.getPurchaseApplicationTemplatesDetail(requestParameters.organizationId, requestParameters.purchaseTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get purchase applications
         * @param {DefaultApiGetPurchaseApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplications(requestParameters: DefaultApiGetPurchaseApplicationsRequest, options?: AxiosRequestConfig): AxiosPromise<GetPurchaseApplications200Response> {
            return localVarFp.getPurchaseApplications(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.visaTransactionReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiGetPurchaseApplicationsRequestedCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsRequestedCount(requestParameters: DefaultApiGetPurchaseApplicationsRequestedCountRequest, options?: AxiosRequestConfig): AxiosPromise<GetPurchaseApplicationsRequestedCount200Response> {
            return localVarFp.getPurchaseApplicationsRequestedCount(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the purchase applications requested list
         * @param {DefaultApiGetPurchaseApplicationsRequestedListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsRequestedList(requestParameters: DefaultApiGetPurchaseApplicationsRequestedListRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPurchaseApplicationsRequestedList200ResponseInner>> {
            return localVarFp.getPurchaseApplicationsRequestedList(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the purchase applications submitted self
         * @param {DefaultApiGetPurchaseApplicationsSubmittedSelfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPurchaseApplicationsSubmittedSelf(requestParameters: DefaultApiGetPurchaseApplicationsSubmittedSelfRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetPurchaseApplicationsSubmittedSelf200ResponseInner>> {
            return localVarFp.getPurchaseApplicationsSubmittedSelf(requestParameters.userId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get(search) qualified invoice issuer
         * @param {DefaultApiGetQualifiedInvoiceIssuerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQualifiedInvoiceIssuer(requestParameters: DefaultApiGetQualifiedInvoiceIssuerRequest, options?: AxiosRequestConfig): AxiosPromise<GetQualifiedInvoiceIssuer200Response> {
            return localVarFp.getQualifiedInvoiceIssuer(requestParameters.registrationNumber, requestParameters.issuerName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Redirect URL from Tiny URL
         * @param {DefaultApiGetRedirectUrlFromTinyUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedirectUrlFromTinyUrl(requestParameters: DefaultApiGetRedirectUrlFromTinyUrlRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getRedirectUrlFromTinyUrl(requestParameters.tinyUrlParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the reward points balance for the specified organization.
         * @summary Get reward points balance
         * @param {DefaultApiGetRewardPointBalanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardPointBalance(requestParameters: DefaultApiGetRewardPointBalanceRequest, options?: AxiosRequestConfig): AxiosPromise<GetRewardPointBalance200Response> {
            return localVarFp.getRewardPointBalance(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get reward point transactions for the specified organization
         * @summary Get reward point transactions
         * @param {DefaultApiGetRewardPointTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardPointTransactions(requestParameters: DefaultApiGetRewardPointTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetRewardPointTransactions200Response> {
            return localVarFp.getRewardPointTransactions(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Rewards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewards(options?: AxiosRequestConfig): AxiosPromise<Array<GetRewards200ResponseInner>> {
            return localVarFp.getRewards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get role resource for user
         * @param {DefaultApiGetRoleResourceForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleResourceForUser(requestParameters: DefaultApiGetRoleResourceForUserRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRoleResourceForUser200ResponseInner>> {
            return localVarFp.getRoleResourceForUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get roles
         * @param {DefaultApiGetRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(requestParameters: DefaultApiGetRolesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRoles200ResponseInner>> {
            return localVarFp.getRoles(requestParameters.category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources
         * @param {DefaultApiGetRolesWithTopRelatedResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithTopRelatedResources(requestParameters: DefaultApiGetRolesWithTopRelatedResourcesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRolesWithTopRelatedResources200ResponseInner>> {
            return localVarFp.getRolesWithTopRelatedResources(requestParameters.resourceScope, requestParameters.resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Roles with Top Related Resources by Organization id
         * @param {DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesWithTopRelatedResourcesByOrganizationId(requestParameters: DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner>> {
            return localVarFp.getRolesWithTopRelatedResourcesByOrganizationId(requestParameters.organizationId, requestParameters.resourceScope, requestParameters.resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack card notification settings of an organization
         * @param {DefaultApiGetSlackCardNotificationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackCardNotificationSettings(requestParameters: DefaultApiGetSlackCardNotificationSettingsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetSlackCardNotificationSettings200ResponseInner>> {
            return localVarFp.getSlackCardNotificationSettings(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Slack channels of an organization by SlackChannelID
         * @param {DefaultApiGetSlackChannelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannel(requestParameters: DefaultApiGetSlackChannelRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackChannel200Response> {
            return localVarFp.getSlackChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack channels of an organization
         * @param {DefaultApiGetSlackChannelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannels(requestParameters: DefaultApiGetSlackChannelsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetSlackChannels200ResponseInner>> {
            return localVarFp.getSlackChannels(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack channels with cursor of an organization
         * @param {DefaultApiGetSlackChannelsWithCursorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackChannelsWithCursor(requestParameters: DefaultApiGetSlackChannelsWithCursorRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackChannelsWithCursor200Response> {
            return localVarFp.getSlackChannelsWithCursor(requestParameters.organizationId, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an organization
         * @param {DefaultApiGetSlackEvidenceReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackEvidenceReminder(requestParameters: DefaultApiGetSlackEvidenceReminderRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetSlackEvidenceReminder200ResponseInner>> {
            return localVarFp.getSlackEvidenceReminder(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack evidence remind settings of an slack channel
         * @param {DefaultApiGetSlackEvidenceReminderPerChannelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackEvidenceReminderPerChannel(requestParameters: DefaultApiGetSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackEvidenceReminderPerChannel200Response> {
            return localVarFp.getSlackEvidenceReminderPerChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get slack notification channel setting for purchase-application
         * @param {DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackNotificationChannelSettingForPurchaseApplication(requestParameters: DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackNotificationChannelSettingForPurchaseApplication200Response> {
            return localVarFp.getSlackNotificationChannelSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get slack notification settings for purchase-application
         * @param {DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackNotificationSettingsForPurchaseApplication(requestParameters: DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetSlackNotificationSettingsForPurchaseApplication200ResponseInner>> {
            return localVarFp.getSlackNotificationSettingsForPurchaseApplication(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack team
         * @param {DefaultApiGetSlackTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackTeam(requestParameters: DefaultApiGetSlackTeamRequest, options?: AxiosRequestConfig): AxiosPromise<GetSlackTeam200Response> {
            return localVarFp.getSlackTeam(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Slack version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSlackVersion(options?: AxiosRequestConfig): AxiosPromise<GetSlackVersion200Response> {
            return localVarFp.getSlackVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get submitted trustdock data
         * @param {DefaultApiGetSubmittedTrustdockDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmittedTrustdockData(requestParameters: DefaultApiGetSubmittedTrustdockDataRequest, options?: AxiosRequestConfig): AxiosPromise<GetSubmittedTrustdockData200Response> {
            return localVarFp.getSubmittedTrustdockData(requestParameters.trustdockIdentificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get suspicious transaction detail list
         * @param {DefaultApiGetSuspiciousTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuspiciousTransactions(requestParameters: DefaultApiGetSuspiciousTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<GetSuspiciousTransactions200Response> {
            return localVarFp.getSuspiciousTransactions(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams card notification settings of an organization
         * @param {DefaultApiGetTeamsCardNotificationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsCardNotificationSettings(requestParameters: DefaultApiGetTeamsCardNotificationSettingsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetTeamsCardNotificationSettings200ResponseInner>> {
            return localVarFp.getTeamsCardNotificationSettings(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams channels of an organization by TeamsChannelID
         * @param {DefaultApiGetTeamsChannelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsChannel(requestParameters: DefaultApiGetTeamsChannelRequest, options?: AxiosRequestConfig): AxiosPromise<GetTeamsChannel200Response> {
            return localVarFp.getTeamsChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams channels with cursor of an organization
         * @param {DefaultApiGetTeamsChannelsWithCursorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsChannelsWithCursor(requestParameters: DefaultApiGetTeamsChannelsWithCursorRequest, options?: AxiosRequestConfig): AxiosPromise<GetTeamsChannelsWithCursor200Response> {
            return localVarFp.getTeamsChannelsWithCursor(requestParameters.organizationId, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams team
         * @param {DefaultApiGetTeamsTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsTeam(requestParameters: DefaultApiGetTeamsTeamRequest, options?: AxiosRequestConfig): AxiosPromise<GetTeamsTeam200Response> {
            return localVarFp.getTeamsTeam(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Teams version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamsVersion(options?: AxiosRequestConfig): AxiosPromise<GetTeamsVersion200Response> {
            return localVarFp.getTeamsVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Technical Support Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnicalSupportUsers(options?: AxiosRequestConfig): AxiosPromise<Array<GetTechnicalSupportUsers200ResponseInner>> {
            return localVarFp.getTechnicalSupportUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Tfa App QR Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppQrCode(options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getTfaAppQrCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaAppRecoveryCode(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTfaAppRecoveryCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get TFA SMS Recovery Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTfaSmsRecoveryCode(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTfaSmsRecoveryCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the count of monthly transactions for the user account
         * @param {DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheCountOfMonthlyTransactionsForTheUserAccount(requestParameters: DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getTheCountOfMonthlyTransactionsForTheUserAccount(requestParameters.userAccountId, requestParameters.yearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the user account information
         * @param {DefaultApiGetTheUserAccountInformationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheUserAccountInformation(requestParameters: DefaultApiGetTheUserAccountInformationRequest, options?: AxiosRequestConfig): AxiosPromise<GetTheUserAccountInformation200Response> {
            return localVarFp.getTheUserAccountInformation(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transaction evidence email address
         * @param {DefaultApiGetTransactionEvidenceEmailAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmailAddress(requestParameters: DefaultApiGetTransactionEvidenceEmailAddressRequest, options?: AxiosRequestConfig): AxiosPromise<GetTransactionEvidenceEmailAddress200Response> {
            return localVarFp.getTransactionEvidenceEmailAddress(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Transaction Evidence Email File
         * @param {DefaultApiGetTransactionEvidenceEmailFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmailFile(requestParameters: DefaultApiGetTransactionEvidenceEmailFileRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getTransactionEvidenceEmailFile(requestParameters.userAccountId, requestParameters.transactionEvidenceEmailFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transaction evidence emails
         * @param {DefaultApiGetTransactionEvidenceEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionEvidenceEmails(requestParameters: DefaultApiGetTransactionEvidenceEmailsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetTransactionEvidenceEmails200ResponseInner>> {
            return localVarFp.getTransactionEvidenceEmails(requestParameters.userAccountId, requestParameters.startYearMonth, requestParameters.endYearMonth, requestParameters.isTrash, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Trustdock Identity Verifications
         * @param {DefaultApiGetTrustdockIdentityVerificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockIdentityVerifications(requestParameters: DefaultApiGetTrustdockIdentityVerificationsRequest, options?: AxiosRequestConfig): AxiosPromise<GetTrustdockIdentityVerifications200Response> {
            return localVarFp.getTrustdockIdentityVerifications(requestParameters.trustdockIdentificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Trustdock Submit Identification Document Publish URL
         * @param {DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockSubmitIdentificationDocumentPublishUrl(requestParameters: DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest, options?: AxiosRequestConfig): AxiosPromise<GetTrustdockSubmitIdentificationDocumentPublishUrl200Response> {
            return localVarFp.getTrustdockSubmitIdentificationDocumentPublishUrl(requestParameters.trustdockIdentificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Trustdock Verifications
         * @param {DefaultApiGetTrustdockVerificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrustdockVerifications(requestParameters: DefaultApiGetTrustdockVerificationsRequest, options?: AxiosRequestConfig): AxiosPromise<GetTrustdockVerifications200Response> {
            return localVarFp.getTrustdockVerifications(requestParameters.trustdockIdentificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get unread message count for a user
         * @param {DefaultApiGetUnreadMessageCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadMessageCount(requestParameters: DefaultApiGetUnreadMessageCountRequest, options?: AxiosRequestConfig): AxiosPromise<GetUnreadMessageCount200Response> {
            return localVarFp.getUnreadMessageCount(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an usage fee
         * @param {DefaultApiGetUsageFeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageFee(requestParameters: DefaultApiGetUsageFeeRequest, options?: AxiosRequestConfig): AxiosPromise<GetUsageFee200Response> {
            return localVarFp.getUsageFee(requestParameters.usageFeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user account groups
         * @param {DefaultApiGetUserAccountGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountGroups(requestParameters: DefaultApiGetUserAccountGroupsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserAccountGroups200ResponseInner>> {
            return localVarFp.getUserAccountGroups(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user account year month summary
         * @param {DefaultApiGetUserAccountYearMonthSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountYearMonthSummary(requestParameters: DefaultApiGetUserAccountYearMonthSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserAccountYearMonthSummary200ResponseInner>> {
            return localVarFp.getUserAccountYearMonthSummary(requestParameters.organizationId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user accounts with default comment template
         * @param {DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccountsWithDefaultCommentTemplate(requestParameters: DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserAccountsWithDefaultCommentTemplate200ResponseInner>> {
            return localVarFp.getUserAccountsWithDefaultCommentTemplate(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards
         * @param {DefaultApiGetUserCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCards(requestParameters: DefaultApiGetUserCardsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCards200ResponseInner>> {
            return localVarFp.getUserCards(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards extended
         * @param {DefaultApiGetUserCardsExtendedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsExtended(requestParameters: DefaultApiGetUserCardsExtendedRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCardsExtended200ResponseInner>> {
            return localVarFp.getUserCardsExtended(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards extended for role resources
         * @param {DefaultApiGetUserCardsExtendedForRoleResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsExtendedForRoleResources(requestParameters: DefaultApiGetUserCardsExtendedForRoleResourcesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCardsExtendedForRoleResources200ResponseInner>> {
            return localVarFp.getUserCardsExtendedForRoleResources(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards light
         * @param {DefaultApiGetUserCardsLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsLight(requestParameters: DefaultApiGetUserCardsLightRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCardsLight200ResponseInner>> {
            return localVarFp.getUserCardsLight(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user cards light for role resources
         * @param {DefaultApiGetUserCardsLightForRoleResourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCardsLightForRoleResources(requestParameters: DefaultApiGetUserCardsLightForRoleResourcesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUserCardsLightForRoleResources200ResponseInner>> {
            return localVarFp.getUserCardsLightForRoleResources(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get ETC card count for a user
         * @param {DefaultApiGetUserEtcCardCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEtcCardCount(requestParameters: DefaultApiGetUserEtcCardCountRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserEtcCardCount200Response> {
            return localVarFp.getUserEtcCardCount(requestParameters.userId, requestParameters.searchWord, requestParameters.groups, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get ETC cards for a user
         * @param {DefaultApiGetUserEtcCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEtcCards(requestParameters: DefaultApiGetUserEtcCardsRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserEtcCards200Response> {
            return localVarFp.getUserEtcCards(requestParameters.userId, requestParameters.searchWord, requestParameters.groups, requestParameters.limit, requestParameters.nextCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get message detail
         * @param {DefaultApiGetUserMessageDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMessageDetail(requestParameters: DefaultApiGetUserMessageDetailRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserMessageDetail200Response> {
            return localVarFp.getUserMessageDetail(requestParameters.userMessageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get messages for a user
         * @param {DefaultApiGetUserMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMessages(requestParameters: DefaultApiGetUserMessagesRequest, options?: AxiosRequestConfig): AxiosPromise<GetUserMessages200Response> {
            return localVarFp.getUserMessages(requestParameters.userId, requestParameters.offset, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users
         * @param {DefaultApiGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(requestParameters: DefaultApiGetUsersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetUsers200ResponseInner>> {
            return localVarFp.getUsers(requestParameters.organizationId, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get information on login user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMe(options?: AxiosRequestConfig): AxiosPromise<GetUsersMe200Response> {
            return localVarFp.getUsersMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get venture capitals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVentureCapitals(options?: AxiosRequestConfig): AxiosPromise<Array<GetVentureCapitals200ResponseInner>> {
            return localVarFp.getVentureCapitals(options).then((request) => request(axios, basePath));
        },
        /**
         * 指定された組織の取引時確認詳細情報を取得します。 createdAtの降順で返却されます。 
         * @summary 取引時確認詳細取得（ZEUS)(PRESIDENT)
         * @param {DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeusOrganizationIdentityVerificationsForPresident(requestParameters: DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInner>> {
            return localVarFp.getZeusOrganizationIdentityVerificationsForPresident(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organizations for zeus
         * @param {DefaultApiGetZeusOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeusOrganizations(requestParameters: DefaultApiGetZeusOrganizationsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetZeusOrganizations200Response> {
            return localVarFp.getZeusOrganizations(requestParameters.key, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.connectedMoneytree, requestParameters.brandType, requestParameters.isSuspended, options).then((request) => request(axios, basePath));
        },
        /**
         * give points to organizations in bulk
         * @param {DefaultApiGivePointsToOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        givePointsToOrganizations(requestParameters: DefaultApiGivePointsToOrganizationsRequest, options?: AxiosRequestConfig): AxiosPromise<GivePointsToOrganizations200Response> {
            return localVarFp.givePointsToOrganizations(requestParameters.givePointsToOrganizationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initialize Modifiable Limit For The User Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initializeModifiableLimitForTheUserAccounts(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.initializeModifiableLimitForTheUserAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates ETC card service for the specified organization. This creates an ETC account on the yachi microservice that will manage ETC cards. The orgAccountId is derived internally from the organizationId.
         * @summary Initiate ETC service for an organization
         * @param {DefaultApiInitiateEtcServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEtcService(requestParameters: DefaultApiInitiateEtcServiceRequest, options?: AxiosRequestConfig): AxiosPromise<InitiateEtcService200Response> {
            return localVarFp.initiateEtcService(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 保持している challengeSuccessToken がまだ有効かどうかを確認する。 保護対象エンドポイントを実際に叩く前に、フロントがチャレンジモーダルを 表示すべきか判断する用途を想定。 
         * @summary challengeSuccessToken の有効性確認
         * @param {DefaultApiIntrospectChallengeSuccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introspectChallengeSuccessToken(requestParameters: DefaultApiIntrospectChallengeSuccessTokenRequest, options?: AxiosRequestConfig): AxiosPromise<IntrospectChallengeSuccessToken200Response> {
            return localVarFp.introspectChallengeSuccessToken(requestParameters.userId, requestParameters.introspectChallengeSuccessTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invite a new user from user
         * @param {DefaultApiInviteUserFromUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUserFromUser(requestParameters: DefaultApiInviteUserFromUserRequest, options?: AxiosRequestConfig): AxiosPromise<InviteUserFromUser200Response> {
            return localVarFp.inviteUserFromUser(requestParameters.inviteUserFromUserRequest, requestParameters.xChallengeSuccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 6桁コードを生成し、登録済みメールアドレスへ送信する。 同一 (userId, scope) の組に既に有効なチャレンジが存在する場合は置き換える （異なる scope のチャレンジは互いに影響せず並行して有効）。 
         * @summary sudo-mode チャレンジの発行
         * @param {DefaultApiIssueChallengeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueChallenge(requestParameters: DefaultApiIssueChallengeRequest, options?: AxiosRequestConfig): AxiosPromise<IssueChallenge200Response> {
            return localVarFp.issueChallenge(requestParameters.userId, requestParameters.issueChallengeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Linking purchase to transaction.
         * @param {DefaultApiLinkingPurchaseToTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkingPurchaseToTransaction(requestParameters: DefaultApiLinkingPurchaseToTransactionRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.linkingPurchaseToTransaction(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.visaTransactionReferenceId, requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lock a card due to potential fraud
         * @param {DefaultApiLockCardForPotentialFraudRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockCardForPotentialFraud(requestParameters: DefaultApiLockCardForPotentialFraudRequest, options?: AxiosRequestConfig): AxiosPromise<LockCardForPotentialFraud200Response> {
            return localVarFp.lockCardForPotentialFraud(requestParameters.organizationId, requestParameters.cardId, requestParameters.lockCardForPotentialFraudRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lock a card due to fraud detected
         * @param {DefaultApiLockCardOnFraudDetectedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockCardOnFraudDetected(requestParameters: DefaultApiLockCardOnFraudDetectedRequest, options?: AxiosRequestConfig): AxiosPromise<LockCardOnFraudDetected200Response> {
            return localVarFp.lockCardOnFraudDetected(requestParameters.organizationId, requestParameters.cardId, requestParameters.lockCardOnFraudDetectedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login
         * @param {DefaultApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: DefaultApiLoginRequest, options?: AxiosRequestConfig): AxiosPromise<Login200Response> {
            return localVarFp.login(requestParameters.loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with APP two factor auth
         * @param {DefaultApiLoginAppRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginApp(requestParameters: DefaultApiLoginAppRequest, options?: AxiosRequestConfig): AxiosPromise<LoginApp200Response> {
            return localVarFp.loginApp(requestParameters.loginAppRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with recovery code of two factor auth
         * @param {DefaultApiLoginRecoveryCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginRecoveryCode(requestParameters: DefaultApiLoginRecoveryCodeRequest, options?: AxiosRequestConfig): AxiosPromise<LoginRecoveryCode200Response> {
            return localVarFp.loginRecoveryCode(requestParameters.loginRecoveryCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with SMS two factor auth
         * @param {DefaultApiLoginSmsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSms(requestParameters: DefaultApiLoginSmsRequest, options?: AxiosRequestConfig): AxiosPromise<LoginSms200Response> {
            return localVarFp.loginSms(requestParameters.loginSmsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move slack notification channel setting for card
         * @param {DefaultApiMoveSlackNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSlackNotificationSettingForCard(requestParameters: DefaultApiMoveSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.currentChannelId, requestParameters.moveSlackNotificationSettingForCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move teams notification channel setting for card
         * @param {DefaultApiMoveTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTeamsNotificationSettingForCard(requestParameters: DefaultApiMoveTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.currentChannelId, requestParameters.moveTeamsNotificationSettingForCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Organization Create Pre Request
         * @param {DefaultApiOrganizationCreatePreRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationCreatePreRequest(requestParameters: DefaultApiOrganizationCreatePreRequestRequest, options?: AxiosRequestConfig): AxiosPromise<OrganizationCreatePreRequest200Response> {
            return localVarFp.organizationCreatePreRequest(requestParameters.organizationCreatePreRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Parse organization chart for workflow
         * @param {DefaultApiParseOrganizationChartForWorkflowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseOrganizationChartForWorkflow(requestParameters: DefaultApiParseOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig): AxiosPromise<ParseOrganizationChartForWorkflow200Response> {
            return localVarFp.parseOrganizationChartForWorkflow(requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Addition Merchant General Block List
         * @param {DefaultApiPostAdditionMerchantGeneralBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdditionMerchantGeneralBlockList(requestParameters: DefaultApiPostAdditionMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<PostAdditionMerchantGeneralBlockList200Response> {
            return localVarFp.postAdditionMerchantGeneralBlockList(requestParameters.postAdditionMerchantGeneralBlockListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostAlliancesGcpApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlliancesGcpApplications(requestParameters: DefaultApiPostAlliancesGcpApplicationsRequest, options?: AxiosRequestConfig): AxiosPromise<PostAlliancesGcpApplications200Response> {
            return localVarFp.postAlliancesGcpApplications(requestParameters.organizationId, requestParameters.postAlliancesGcpApplicationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostAlliancesGwsApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAlliancesGwsApplications(requestParameters: DefaultApiPostAlliancesGwsApplicationsRequest, options?: AxiosRequestConfig): AxiosPromise<PostAlliancesGwsApplications200Response> {
            return localVarFp.postAlliancesGwsApplications(requestParameters.organizationId, requestParameters.postAlliancesGwsApplicationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Bank Account Balances
         * @param {DefaultApiPostBalancesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBalances(requestParameters: DefaultApiPostBalancesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<PostBalances200ResponseInner>> {
            return localVarFp.postBalances(requestParameters.postBalancesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Bulk Addition Merchant Org Block Lists
         * @param {DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBulkAdditionMerchantOrgBlockLists(requestParameters: DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postBulkAdditionMerchantOrgBlockLists(requestParameters.organizationId, requestParameters.postBulkAdditionMerchantOrgBlockListsRequestInner, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary freee認可コールバック
         * @param {DefaultApiPostCallbackFreeeAuthForAccountingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCallbackFreeeAuthForAccounting(requestParameters: DefaultApiPostCallbackFreeeAuthForAccountingRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.postCallbackFreeeAuthForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.postCallbackFreeeAuthForAccountingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks whether the current user is eligible for canary routing and sets appropriate cookie
         * @summary Check if user is eligible for canary routing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCanaryRoutingCheck(options?: AxiosRequestConfig): AxiosPromise<PostCanaryRoutingCheck200Response> {
            return localVarFp.postCanaryRoutingCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post a cancel request for a evidence request
         * @param {DefaultApiPostCancelRequestForEvidenceRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCancelRequestForEvidenceRequest(requestParameters: DefaultApiPostCancelRequestForEvidenceRequestRequest, options?: AxiosRequestConfig): AxiosPromise<PostCancelRequestForEvidenceRequest200Response> {
            return localVarFp.postCancelRequestForEvidenceRequest(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostCardsVirtualIssueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCardsVirtualIssue(requestParameters: DefaultApiPostCardsVirtualIssueRequest, options?: AxiosRequestConfig): AxiosPromise<PostCardsVirtualIssue200Response> {
            return localVarFp.postCardsVirtualIssue(requestParameters.postCardsVirtualIssueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCardsVirtualOndemandIssue(options?: AxiosRequestConfig): AxiosPromise<PostCardsVirtualOndemandIssue200Response> {
            return localVarFp.postCardsVirtualOndemandIssue(options).then((request) => request(axios, basePath));
        },
        /**
         * Upload identity document file with verification information.
         * @summary Upload Identity Document
         * @param {DefaultApiPostFaceToFaceKycIdentityDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFaceToFaceKycIdentityDocument(requestParameters: DefaultApiPostFaceToFaceKycIdentityDocumentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFaceToFaceKycIdentityDocument(requestParameters.onboardingRequestId, requestParameters.file, requestParameters.personalDocumentType, requestParameters.verifiedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a face-to-face KYC request.
         * @summary Face-to-face KYC Request
         * @param {DefaultApiPostFaceToFaceKycRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFaceToFaceKycRequest(requestParameters: DefaultApiPostFaceToFaceKycRequestRequest, options?: AxiosRequestConfig): AxiosPromise<PostFaceToFaceKycRequest200Response> {
            return localVarFp.postFaceToFaceKycRequest(requestParameters.postFaceToFaceKycRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Freee Account for Points
         * @param {DefaultApiPostFreeeAccountForPointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFreeeAccountForPoints(requestParameters: DefaultApiPostFreeeAccountForPointsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFreeeAccountForPoints(requestParameters.organizationId, requestParameters.postFreeeAccountForPointsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostKycconsultingWebhooksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postKycconsultingWebhooks(requestParameters: DefaultApiPostKycconsultingWebhooksRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postKycconsultingWebhooks(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request
         * @param {DefaultApiPostMoneytreeRefreshRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMoneytreeRefreshRequest(requestParameters: DefaultApiPostMoneytreeRefreshRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMoneytreeRefreshRequest(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post Moneytree Refresh Request for All Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMoneytreeRefreshRequestAll(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postMoneytreeRefreshRequestAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create organizations deals
         * @param {DefaultApiPostOrganizationsDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrganizationsDeals(requestParameters: DefaultApiPostOrganizationsDealsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postOrganizationsDeals(requestParameters.organizationId, requestParameters.postOrganizationsDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create point claw backs
         * @param {DefaultApiPostOrganizationsPointClawBacksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrganizationsPointClawBacks(requestParameters: DefaultApiPostOrganizationsPointClawBacksRequest, options?: AxiosRequestConfig): AxiosPromise<PostOrganizationsPointClawBacks200Response> {
            return localVarFp.postOrganizationsPointClawBacks(requestParameters.organizationId, requestParameters.postOrganizationsPointClawBacksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post payment requests bank account
         * @param {DefaultApiPostPaymentRequestsBankAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPaymentRequestsBankAccount(requestParameters: DefaultApiPostPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig): AxiosPromise<PostPaymentRequestsBankAccount200Response> {
            return localVarFp.postPaymentRequestsBankAccount(requestParameters.organizationId, requestParameters.postPaymentRequestsBankAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post slack message to coworker
         * @param {DefaultApiPostSlackMessageToCoworkerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSlackMessageToCoworker(requestParameters: DefaultApiPostSlackMessageToCoworkerRequest, options?: AxiosRequestConfig): AxiosPromise<PostSlackMessageToCoworker200Response> {
            return localVarFp.postSlackMessageToCoworker(requestParameters.organizationId, requestParameters.postSlackMessageToCoworkerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Bank Account Transactions
         * @param {DefaultApiPostTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTransactions(requestParameters: DefaultApiPostTransactionsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<PostTransactions200ResponseInner>> {
            return localVarFp.postTransactions(requestParameters.postTransactionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostTrustdockWebhooksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrustdockWebhooks(requestParameters: DefaultApiPostTrustdockWebhooksRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postTrustdockWebhooks(requestParameters.postTrustdockWebhooksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DefaultApiPostTrustdockWebhooksSnailMailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTrustdockWebhooksSnailMail(requestParameters: DefaultApiPostTrustdockWebhooksSnailMailRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postTrustdockWebhooksSnailMail(requestParameters.postTrustdockWebhooksSnailMailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put disable feature flag
         * @param {DefaultApiPutDisableFeatureFlagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDisableFeatureFlag(requestParameters: DefaultApiPutDisableFeatureFlagRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putDisableFeatureFlag(requestParameters.organizationId, requestParameters.featureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put enabled feature flag
         * @param {DefaultApiPutEnabledFeatureFlagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEnabledFeatureFlag(requestParameters: DefaultApiPutEnabledFeatureFlagRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putEnabledFeatureFlag(requestParameters.organizationId, requestParameters.featureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Freee End Journal Entry Transition Mode
         * @param {DefaultApiPutFreeeEndJournalEntryTransitionModeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFreeeEndJournalEntryTransitionMode(requestParameters: DefaultApiPutFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putFreeeEndJournalEntryTransitionMode(requestParameters.organizationId, requestParameters.putFreeeEndJournalEntryTransitionModeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Organization Payment Method
         * @param {DefaultApiPutOrganizationPaymentMethodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrganizationPaymentMethod(requestParameters: DefaultApiPutOrganizationPaymentMethodRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putOrganizationPaymentMethod(requestParameters.organizationId, requestParameters.putOrganizationPaymentMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put organizations deals
         * @param {DefaultApiPutOrganizationsDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrganizationsDeals(requestParameters: DefaultApiPutOrganizationsDealsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putOrganizationsDeals(requestParameters.organizationId, requestParameters.putOrganizationsDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update payment request
         * @param {DefaultApiPutPaymentRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPaymentRequest(requestParameters: DefaultApiPutPaymentRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putPaymentRequest(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.putPaymentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put payment requests bank account
         * @param {DefaultApiPutPaymentRequestsBankAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPaymentRequestsBankAccount(requestParameters: DefaultApiPutPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig): AxiosPromise<PutPaymentRequestsBankAccount200Response> {
            return localVarFp.putPaymentRequestsBankAccount(requestParameters.organizationId, requestParameters.bankAccountId, requestParameters.putPaymentRequestsBankAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put transaction evidence emails link to transaction
         * @param {DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsLinkToTransaction(requestParameters: DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putTransactionEvidenceEmailsLinkToTransaction(requestParameters.putTransactionEvidenceEmailsLinkToTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put transaction evidence emails mark as read
         * @param {DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsMarkAsRead(requestParameters: DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest, options?: AxiosRequestConfig): AxiosPromise<PutTransactionEvidenceEmailsMarkAsRead200Response> {
            return localVarFp.putTransactionEvidenceEmailsMarkAsRead(requestParameters.putTransactionEvidenceEmailsMarkAsReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put transaction evidence emails move to trash
         * @param {DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTransactionEvidenceEmailsMoveToTrash(requestParameters: DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putTransactionEvidenceEmailsMoveToTrash(requestParameters.putTransactionEvidenceEmailsMoveToTrashRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Give reward point to organization
         * @param {DefaultApiPutZeusGiveRewardPointsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putZeusGiveRewardPoints(requestParameters: DefaultApiPutZeusGiveRewardPointsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putZeusGiveRewardPoints(requestParameters.organizationId, requestParameters.putZeusGiveRewardPointsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query by ids payment requests
         * @param {DefaultApiQueryByIdsPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryByIdsPaymentRequests(requestParameters: DefaultApiQueryByIdsPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<QueryByIdsPaymentRequests200ResponseInner>> {
            return localVarFp.queryByIdsPaymentRequests(requestParameters.organizationId, requestParameters.queryByIdsPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update read status of a message
         * @param {DefaultApiReadUserMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUserMessage(requestParameters: DefaultApiReadUserMessageRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.readUserMessage(requestParameters.userMessageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary register note
         * @param {DefaultApiRegisterNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNote(requestParameters: DefaultApiRegisterNoteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerNote(requestParameters.onboardingRequestId, requestParameters.registerNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register note for organization identity verification
         * @param {DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNoteForOrganizationIdentityVerification(requestParameters: DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<RegisterNoteForOrganizationIdentityVerification200Response> {
            return localVarFp.registerNoteForOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, requestParameters.registerNoteForOrganizationIdentityVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register an organization using the onboarding request ID
         * @param {DefaultApiRegisterOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerOrganization(requestParameters: DefaultApiRegisterOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerOrganization(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register organization chart for workflow
         * @param {DefaultApiRegisterOrganizationChartForWorkflowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerOrganizationChartForWorkflow(requestParameters: DefaultApiRegisterOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerOrganizationChartForWorkflow(requestParameters.organizationId, requestParameters.registerOrganizationChartForWorkflowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register Tfa App Verification Code
         * @param {DefaultApiRegisterTfaAppVerificationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaAppVerificationCode(requestParameters: DefaultApiRegisterTfaAppVerificationCodeRequest, options?: AxiosRequestConfig): AxiosPromise<RegisterTfaAppVerificationCode200Response> {
            return localVarFp.registerTfaAppVerificationCode(requestParameters.registerTfaAppVerificationCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register Tfa SMS Auth
         * @param {DefaultApiRegisterTfaSmsAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTfaSmsAuth(requestParameters: DefaultApiRegisterTfaSmsAuthRequest, options?: AxiosRequestConfig): AxiosPromise<RegisterTfaSmsAuth200Response> {
            return localVarFp.registerTfaSmsAuth(requestParameters.registerTfaSmsAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register transaction evidence email address
         * @param {DefaultApiRegisterTransactionEvidenceEmailAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTransactionEvidenceEmailAddress(requestParameters: DefaultApiRegisterTransactionEvidenceEmailAddressRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerTransactionEvidenceEmailAddress(requestParameters.userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reissue a card
         * @param {DefaultApiReissueCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueCard(requestParameters: DefaultApiReissueCardRequest, options?: AxiosRequestConfig): AxiosPromise<ReissueCard200Response> {
            return localVarFp.reissueCard(requestParameters.cardId, requestParameters.reissueCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject Organization Identity Verification
         * @param {DefaultApiRejectOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectOrganizationIdentityVerification(requestParameters: DefaultApiRejectOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<RejectOrganizationIdentityVerification200Response> {
            return localVarFp.rejectOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject purchase application.
         * @param {DefaultApiRejectPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectPurchaseApplication(requestParameters: DefaultApiRejectPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectPurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.rejectPurchaseApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindCardTransactionEvidence(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.remindCardTransactionEvidence(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remind monthly payment notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindMonthlyPaymentNotifications(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.remindMonthlyPaymentNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remind organization monthly payment notifications.
         * @param {DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindOrganizationMonthlyPaymentNotification(requestParameters: DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.remindOrganizationMonthlyPaymentNotification(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove fraud lock status
         * @param {DefaultApiRemoveFraudLockStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFraudLockStatus(requestParameters: DefaultApiRemoveFraudLockStatusRequest, options?: AxiosRequestConfig): AxiosPromise<RemoveFraudLockStatus200Response> {
            return localVarFp.removeFraudLockStatus(requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename user account group
         * @param {DefaultApiRenameUserAccountGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameUserAccountGroup(requestParameters: DefaultApiRenameUserAccountGroupRequest, options?: AxiosRequestConfig): AxiosPromise<Array<RenameUserAccountGroup200ResponseInner>> {
            return localVarFp.renameUserAccountGroup(requestParameters.userAccountGroupId, requestParameters.renameUserAccountGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace Virtual Card
         * @param {DefaultApiReplaceVirtualCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceVirtualCard(requestParameters: DefaultApiReplaceVirtualCardRequest, options?: AxiosRequestConfig): AxiosPromise<ReplaceVirtualCard200Response> {
            return localVarFp.replaceVirtualCard(requestParameters.userAccountId, requestParameters.replaceVirtualCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary request add system admin role
         * @param {DefaultApiRequestAddSystemAdminRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAddSystemAdminRole(requestParameters: DefaultApiRequestAddSystemAdminRoleRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestAddSystemAdminRole(requestParameters.userId, requestParameters.requestAddSystemAdminRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request sending physical cards
         * @param {DefaultApiRequestSendingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSending(requestParameters: DefaultApiRequestSendingRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestSending(requestParameters.organizationId, requestParameters.requestSendingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request sending a metal card
         * @param {DefaultApiRequestSendingMetalCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSendingMetalCard(requestParameters: DefaultApiRequestSendingMetalCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestSendingMetalCard(requestParameters.organizationId, requestParameters.requestSendingMetalCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ポイント明細の同期リクエスト
         * @param {DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSyncBankTransactionsToFreeeForAccounting(requestParameters: DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.requestSyncBankTransactionsToFreeeForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.requestSyncBankTransactionsToFreeeForAccountingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 決済明細の同期リクエスト
         * @param {DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSyncCardTransactionsToFreeeForAccounting(requestParameters: DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.requestSyncCardTransactionsToFreeeForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.requestSyncCardTransactionsToFreeeForAccountingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSyncingClearedTransaction(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestSyncingClearedTransaction(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request to Generate Organizations Accounting Csv in Background
         * @param {DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestToOrganizationsAccountingCsvInBackground(requestParameters: DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestToOrganizationsAccountingCsvInBackground(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary request update system admin role
         * @param {DefaultApiRequestUpdateSystemAdminRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestUpdateSystemAdminRole(requestParameters: DefaultApiRequestUpdateSystemAdminRoleRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestUpdateSystemAdminRole(requestParameters.userId, requestParameters.requestUpdateSystemAdminRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend Snail Mail For Organization Identity Verification
         * @param {DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendSnailMailForOrganizationIdentityVerification(requestParameters: DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendSnailMailForOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, requestParameters.resendSnailMailForOrganizationIdentityVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend an invitation to a new user
         * @param {DefaultApiResendUserInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendUserInvite(requestParameters: DefaultApiResendUserInviteRequest, options?: AxiosRequestConfig): AxiosPromise<ResendUserInvite200Response> {
            return localVarFp.resendUserInvite(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resume a suspended card
         * @param {DefaultApiResumeCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeCard(requestParameters: DefaultApiResumeCardRequest, options?: AxiosRequestConfig): AxiosPromise<ResumeCard200Response> {
            return localVarFp.resumeCard(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resynchronize card transactions for freee
         * @param {DefaultApiResynchronizeCardTransactionsForFreeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resynchronizeCardTransactionsForFreee(requestParameters: DefaultApiResynchronizeCardTransactionsForFreeeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resynchronizeCardTransactionsForFreee(requestParameters.organizationId, requestParameters.resynchronizeCardTransactionsForFreeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deal as draft
         * @param {DefaultApiSaveDealAsDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsDraft(requestParameters: DefaultApiSaveDealAsDraftRequest, options?: AxiosRequestConfig): AxiosPromise<SaveDealAsDraft200Response> {
            return localVarFp.saveDealAsDraft(requestParameters.organizationId, requestParameters.dealId, requestParameters.saveDealAsDraftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save Deal As Ignore
         * @param {DefaultApiSaveDealAsIgnoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsIgnore(requestParameters: DefaultApiSaveDealAsIgnoreRequest, options?: AxiosRequestConfig): AxiosPromise<SaveDealAsIgnore200Response> {
            return localVarFp.saveDealAsIgnore(requestParameters.organizationId, requestParameters.dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deal as return to editing
         * @param {DefaultApiSaveDealAsReturnToEditingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealAsReturnToEditing(requestParameters: DefaultApiSaveDealAsReturnToEditingRequest, options?: AxiosRequestConfig): AxiosPromise<SaveDealAsReturnToEditing200Response> {
            return localVarFp.saveDealAsReturnToEditing(requestParameters.organizationId, requestParameters.dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deal with journalizing
         * @param {DefaultApiSaveDealWithJournalizingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealWithJournalizing(requestParameters: DefaultApiSaveDealWithJournalizingRequest, options?: AxiosRequestConfig): AxiosPromise<SaveDealWithJournalizing200Response> {
            return localVarFp.saveDealWithJournalizing(requestParameters.organizationId, requestParameters.dealId, requestParameters.saveDealWithJournalizingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deals as ignore
         * @param {DefaultApiSaveDealsAsIgnoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsIgnore(requestParameters: DefaultApiSaveDealsAsIgnoreRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveDealsAsIgnore(requestParameters.organizationId, requestParameters.saveDealsAsIgnoreRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deals as journalized
         * @param {DefaultApiSaveDealsAsJournalizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsJournalized(requestParameters: DefaultApiSaveDealsAsJournalizedRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveDealsAsJournalized(requestParameters.organizationId, requestParameters.saveDealsAsJournalizedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deals as return to editing
         * @param {DefaultApiSaveDealsAsReturnToEditingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDealsAsReturnToEditing(requestParameters: DefaultApiSaveDealsAsReturnToEditingRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveDealsAsReturnToEditing(requestParameters.organizationId, requestParameters.saveDealsAsReturnToEditingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search bank transfers
         * @param {DefaultApiSearchBankTransfersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBankTransfers(requestParameters: DefaultApiSearchBankTransfersRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchBankTransfers200ResponseInner>> {
            return localVarFp.searchBankTransfers(requestParameters.organizationId, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Corporations In National Tax Agency
         * @param {DefaultApiSearchCorporationsInNationalTaxAgencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorporationsInNationalTaxAgency(requestParameters: DefaultApiSearchCorporationsInNationalTaxAgencyRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<SearchCorporationsInNationalTaxAgency200ResponseInner>> {
            return localVarFp.searchCorporationsInNationalTaxAgency(requestParameters.name, requestParameters.searchMethod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search deals
         * @param {DefaultApiSearchDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeals(requestParameters: DefaultApiSearchDealsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchDeals200ResponseInner>> {
            return localVarFp.searchDeals(requestParameters.organizationId, requestParameters.searchDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search evidences
         * @param {DefaultApiSearchEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEvidences(requestParameters: DefaultApiSearchEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchEvidences200ResponseInner>> {
            return localVarFp.searchEvidences(requestParameters.organizationId, requestParameters.issuer, requestParameters.amountMin, requestParameters.amountMax, requestParameters.paidAtFrom, requestParameters.paidAtTo, requestParameters.irrelevantToLedger, requestParameters.keyword, requestParameters.includesDeleted, requestParameters.legalValidities, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search my payment requests
         * @param {DefaultApiSearchMyPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMyPaymentRequests(requestParameters: DefaultApiSearchMyPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchMyPaymentRequests200ResponseInner>> {
            return localVarFp.searchMyPaymentRequests(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.requestedDateJstFrom, requestParameters.requestedDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Organizations
         * @param {DefaultApiSearchOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizations(requestParameters: DefaultApiSearchOrganizationsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchOrganizations200ResponseInner>> {
            return localVarFp.searchOrganizations(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search payment requests
         * @param {DefaultApiSearchPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPaymentRequests(requestParameters: DefaultApiSearchPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<SearchPaymentRequests200ResponseInner>> {
            return localVarFp.searchPaymentRequests(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.requestedDateJstFrom, requestParameters.requestedDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.requestorId, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send back onboarding request
         * @param {DefaultApiSendBackOnboardingRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBackOnboardingRequest(requestParameters: DefaultApiSendBackOnboardingRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendBackOnboardingRequest(requestParameters.onboardingRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send changed credit notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendChangedCreditNotifications(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendChangedCreditNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Organization Identity Verification
         * @param {DefaultApiSendOrganizationIdentityVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOrganizationIdentityVerification(requestParameters: DefaultApiSendOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.sendOrganizationIdentityVerification(requestParameters.organizationId, requestParameters.sendOrganizationIdentityVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send two-factor authentication reset link as admin
         * @param {DefaultApiSendTfaResetLinkAsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTfaResetLinkAsAdmin(requestParameters: DefaultApiSendTfaResetLinkAsAdminRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendTfaResetLinkAsAdmin(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send Transaction Authorization Request
         * @param {DefaultApiSendTransactionAuthorizationRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTransactionAuthorizationRequest(requestParameters: DefaultApiSendTransactionAuthorizationRequestRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendTransactionAuthorizationRequest(requestParameters.organizationId, requestParameters.sendTransactionAuthorizationRequestRequest, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable or disable accounting integration
         * @param {DefaultApiSetAccountingActivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAccountingActivation(requestParameters: DefaultApiSetAccountingActivationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setAccountingActivation(requestParameters.organizationId, requestParameters.setAccountingActivationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sign Up For Slack
         * @param {DefaultApiSignUpForSlackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpForSlack(requestParameters: DefaultApiSignUpForSlackRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.signUpForSlack(requestParameters.signUpForSlackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit completed workflow of draft payment request
         * @param {DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompletedWorkflowOfDraftPaymentRequests(requestParameters: DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<SubmitCompletedWorkflowOfDraftPaymentRequests200Response> {
            return localVarFp.submitCompletedWorkflowOfDraftPaymentRequests(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.xUpsidrSwitchUser, requestParameters.submitCompletedWorkflowOfDraftPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit completed workflow of payment request
         * @param {DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompletedWorkflowOfPaymentRequests(requestParameters: DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest, options?: AxiosRequestConfig): AxiosPromise<SubmitCompletedWorkflowOfPaymentRequests200Response> {
            return localVarFp.submitCompletedWorkflowOfPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.submitCompletedWorkflowOfPaymentRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit workflow
         * @param {DefaultApiSubmitWorkflowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWorkflow(requestParameters: DefaultApiSubmitWorkflowRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitWorkflow(requestParameters.organizationId, requestParameters.workflowInstanceId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Suspend a card
         * @param {DefaultApiSuspendCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendCard(requestParameters: DefaultApiSuspendCardRequest, options?: AxiosRequestConfig): AxiosPromise<SuspendCard200Response> {
            return localVarFp.suspendCard(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllCardStatuses(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncAllCardStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync all users to each marketing tools
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllUsersToEachMarketingTools(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncAllUsersToEachMarketingTools(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync freee account items
         * @param {DefaultApiSyncFreeeAccountItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeeAccountItems(requestParameters: DefaultApiSyncFreeeAccountItemsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncFreeeAccountItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync freee partners
         * @param {DefaultApiSyncFreeePartnersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeePartners(requestParameters: DefaultApiSyncFreeePartnersRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncFreeePartners(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync freee segment tags
         * @param {DefaultApiSyncFreeeSegmentTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFreeeSegmentTags(requestParameters: DefaultApiSyncFreeeSegmentTagsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncFreeeSegmentTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Moneytree access token
         * @param {DefaultApiSyncMoneytreeAccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMoneytreeAccessToken(requestParameters: DefaultApiSyncMoneytreeAccessTokenRequest, options?: AxiosRequestConfig): AxiosPromise<SyncMoneytreeAccessToken200Response> {
            return localVarFp.syncMoneytreeAccessToken(requestParameters.code, requestParameters.state, requestParameters.nextTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync point usage to accounting service
         * @param {DefaultApiSyncPointUsageToAccountingServiceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPointUsageToAccountingService(requestParameters: DefaultApiSyncPointUsageToAccountingServiceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncPointUsageToAccountingService(requestParameters.organizationId, requestParameters.syncPointUsageToAccountingServiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Request for Freee Deals
         * @param {DefaultApiSyncRequestForFreeeDealsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRequestForFreeeDeals(requestParameters: DefaultApiSyncRequestForFreeeDealsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.syncRequestForFreeeDeals(requestParameters.organizationId, requestParameters.companyId, requestParameters.syncRequestForFreeeDealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Two Factor Auth Reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthReset(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.twoFactorAuthReset(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Two Factor Auth Reset As Token
         * @param {DefaultApiTwoFactorAuthResetAsTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorAuthResetAsToken(requestParameters: DefaultApiTwoFactorAuthResetAsTokenRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.twoFactorAuthResetAsToken(requestParameters.twoFactorAuthResetAsTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlinking purchase to transaction.
         * @param {DefaultApiUnlinkingPurchaseToTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkingPurchaseToTransaction(requestParameters: DefaultApiUnlinkingPurchaseToTransactionRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlinkingPurchaseToTransaction(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.visaTransactionReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlock a card due to no potential fraud
         * @param {DefaultApiUnlockCardForNotPotentialFraudRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockCardForNotPotentialFraud(requestParameters: DefaultApiUnlockCardForNotPotentialFraudRequest, options?: AxiosRequestConfig): AxiosPromise<UnlockCardForNotPotentialFraud200Response> {
            return localVarFp.unlockCardForNotPotentialFraud(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlock a card due to fraud cleared
         * @param {DefaultApiUnlockCardOnFraudClearedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockCardOnFraudCleared(requestParameters: DefaultApiUnlockCardOnFraudClearedRequest, options?: AxiosRequestConfig): AxiosPromise<UnlockCardOnFraudCleared200Response> {
            return localVarFp.unlockCardOnFraudCleared(requestParameters.organizationId, requestParameters.cardId, requestParameters.triggeredTransactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Available Currencies
         * @param {DefaultApiUpdateAvailableCurrenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableCurrencies(requestParameters: DefaultApiUpdateAvailableCurrenciesRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateAvailableCurrencies200Response> {
            return localVarFp.updateAvailableCurrencies(requestParameters.userAccountId, requestParameters.updateAvailableCurrenciesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Available Merchant Categories
         * @param {DefaultApiUpdateAvailableMerchantCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailableMerchantCategories(requestParameters: DefaultApiUpdateAvailableMerchantCategoriesRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateAvailableMerchantCategories200Response> {
            return localVarFp.updateAvailableMerchantCategories(requestParameters.userAccountId, requestParameters.updateAvailableMerchantCategoriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update card account unit
         * @param {DefaultApiUpdateCardAccountUnitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardAccountUnit(requestParameters: DefaultApiUpdateCardAccountUnitRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCardAccountUnit(requestParameters.organizationId, requestParameters.updateCardAccountUnitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Card Count Limit
         * @param {DefaultApiUpdateCardCountLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardCountLimit(requestParameters: DefaultApiUpdateCardCountLimitRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCardCountLimit(requestParameters.organizationId, requestParameters.updateCardCountLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update card holder for the user account
         * @param {DefaultApiUpdateCardHolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardHolder(requestParameters: DefaultApiUpdateCardHolderRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateCardHolder200Response> {
            return localVarFp.updateCardHolder(requestParameters.userAccountId, requestParameters.updateCardHolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lock a card
         * @param {DefaultApiUpdateCardLockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardLock(requestParameters: DefaultApiUpdateCardLockRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateCardLock200Response> {
            return localVarFp.updateCardLock(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlock a card
         * @param {DefaultApiUpdateCardUnlockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardUnlock(requestParameters: DefaultApiUpdateCardUnlockRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateCardUnlock200Response> {
            return localVarFp.updateCardUnlock(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update comment for card transaction
         * @param {DefaultApiUpdateCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment(requestParameters: DefaultApiUpdateCommentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionCommentId, requestParameters.updateCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update comment template
         * @param {DefaultApiUpdateCommentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommentTemplate(requestParameters: DefaultApiUpdateCommentTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCommentTemplate(requestParameters.organizationId, requestParameters.templateId, requestParameters.updateCommentTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update corporate document verification result
         * @param {DefaultApiUpdateCorporateDocumentResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorporateDocumentResult(requestParameters: DefaultApiUpdateCorporateDocumentResultRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCorporateDocumentResult(requestParameters.organizationIdentityVerificationId, requestParameters.updateCorporateDocumentResultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update daily usage limit for the user account
         * @param {DefaultApiUpdateDailyUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDailyUserUsageLimit(requestParameters: DefaultApiUpdateDailyUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateDailyUserUsageLimit200Response> {
            return localVarFp.updateDailyUserUsageLimit(requestParameters.userAccountId, requestParameters.updateDailyUserUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update deposit restriction for organization
         * @param {DefaultApiUpdateDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDepositRestrictionForOrganization(requestParameters: DefaultApiUpdateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, requestParameters.updateDepositRestrictionForOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle on/off email notification settings per user
         * @param {DefaultApiUpdateEmailNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailNotification(requestParameters: DefaultApiUpdateEmailNotificationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmailNotification(requestParameters.userId, requestParameters.emailNotificationId, requestParameters.updateEmailNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update embed url method
         * @param {DefaultApiUpdateEmbedUrlMethodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmbedUrlMethod(requestParameters: DefaultApiUpdateEmbedUrlMethodRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmbedUrlMethod(requestParameters.organizationId, requestParameters.updateEmbedUrlMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the card holder. Only accessible by administrators.  Note: When the holder is changed, the new holder will be able to view all previous transaction history.  Error codes: - SYSTEM_ERROR: System error occurred 
         * @summary Update ETC card holder
         * @param {DefaultApiUpdateEtcCardHolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEtcCardHolder(requestParameters: DefaultApiUpdateEtcCardHolderRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateEtcCardHolder200Response> {
            return localVarFp.updateEtcCardHolder(requestParameters.userAccountId, requestParameters.updateEtcCardHolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the card label. Only accessible by administrators.  Validation: - Required: Card label must not be empty - Max length: 64 characters  Error codes: - CARD_LABEL_DUPLICATE: Same card label already exists - SYSTEM_ERROR: System error occurred 
         * @summary Update ETC card label
         * @param {DefaultApiUpdateEtcCardLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEtcCardLabel(requestParameters: DefaultApiUpdateEtcCardLabelRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateEtcCardLabel200Response> {
            return localVarFp.updateEtcCardLabel(requestParameters.userAccountId, requestParameters.updateEtcCardLabelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update evidence image
         * @param {DefaultApiUpdateEvidenceImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidenceImage(requestParameters: DefaultApiUpdateEvidenceImageRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.dpiForciblyValid, requestParameters.colorGradationForciblyValid, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update evidence info
         * @param {DefaultApiUpdateEvidenceInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidenceInfo(requestParameters: DefaultApiUpdateEvidenceInfoRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEvidenceInfo(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.updateEvidenceInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update freee connect
         * @param {DefaultApiUpdateFreeeConnectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeConnect(requestParameters: DefaultApiUpdateFreeeConnectRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateFreeeConnect200Response> {
            return localVarFp.updateFreeeConnect(requestParameters.organizationId, requestParameters.code, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary freee設定変更
         * @param {DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeConnectionSettingsForAccounting(requestParameters: DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateFreeeConnectionSettingsForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.updateFreeeConnectionSettingsForAccountingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turn on/off freee journaling
         * @param {DefaultApiUpdateFreeeJournalingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeJournaling(requestParameters: DefaultApiUpdateFreeeJournalingRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateFreeeJournaling(requestParameters.organizationId, requestParameters.updateFreeeJournalingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update freee select company
         * @param {DefaultApiUpdateFreeeSelectCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFreeeSelectCompany(requestParameters: DefaultApiUpdateFreeeSelectCompanyRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateFreeeSelectCompany200Response> {
            return localVarFp.updateFreeeSelectCompany(requestParameters.organizationId, requestParameters.updateFreeeSelectCompanyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update lock status of evidences
         * @param {DefaultApiUpdateLockStatusOfEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLockStatusOfEvidences(requestParameters: DefaultApiUpdateLockStatusOfEvidencesRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLockStatusOfEvidences(requestParameters.organizationId, requestParameters.updateLockStatusOfEvidencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update merchant general block allowed organization ids
         * @param {DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantGeneralBlockAllowedOrganizationIds(requestParameters: DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantGeneralBlockAllowedOrganizationIds(requestParameters.merchantGeneralBlockListId, requestParameters.updateMerchantGeneralBlockAllowedOrganizationIdsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update merchant general block list
         * @param {DefaultApiUpdateMerchantGeneralBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantGeneralBlockList(requestParameters: DefaultApiUpdateMerchantGeneralBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantGeneralBlockList(requestParameters.merchantGeneralBlockListId, requestParameters.updateMerchantGeneralBlockListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update merchant org block list
         * @param {DefaultApiUpdateMerchantOrgBlockListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOrgBlockList(requestParameters: DefaultApiUpdateMerchantOrgBlockListRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantOrgBlockList(requestParameters.merchantOrgBlockListId, requestParameters.updateMerchantOrgBlockListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Merchant Organization Comment
         * @param {DefaultApiUpdateMerchantOrganizationCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOrganizationComment(requestParameters: DefaultApiUpdateMerchantOrganizationCommentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMerchantOrganizationComment(requestParameters.organizationId, requestParameters.merchantId, requestParameters.userAccountId, requestParameters.updateMerchantOrganizationCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Organization
         * @param {DefaultApiUpdateOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(requestParameters: DefaultApiUpdateOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateOrganization200Response> {
            return localVarFp.updateOrganization(requestParameters.organizationId, requestParameters.updateOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Organizations Accounting Csv Export Fields
         * @param {DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationsAccountingCsvExportFields(requestParameters: DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.updateOrganizationsAccountingCsvExportFields(requestParameters.organizationId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the payment request evidence specified by evidenceId.
         * @summary Update the specific payment request evidence.
         * @param {DefaultApiUpdatePaymentRequestEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequestEvidence(requestParameters: DefaultApiUpdatePaymentRequestEvidenceRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.updatePaymentRequestEvidenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the payment request evidence file specified by evidenceId. This also accept properties other than a file binary.
         * @summary Update the specific payment request evidence file.
         * @param {DefaultApiUpdatePaymentRequestEvidenceFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentRequestEvidenceFile(requestParameters: DefaultApiUpdatePaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.dpiForciblyValid, requestParameters.colorGradationForciblyValid, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.invoiceIssuerName, requestParameters.asQualified, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update purchase application template.
         * @param {DefaultApiUpdatePurchaseApplicationTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePurchaseApplicationTemplate(requestParameters: DefaultApiUpdatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.purchaseTemplateId, requestParameters.updatePurchaseApplicationTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update remove user account group
         * @param {DefaultApiUpdateRemoveUserAccountGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRemoveUserAccountGroup(requestParameters: DefaultApiUpdateRemoveUserAccountGroupRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRemoveUserAccountGroup(requestParameters.userAccountId, requestParameters.updateRemoveUserAccountGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update role resource for user
         * @param {DefaultApiUpdateRoleResourceForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleResourceForUser(requestParameters: DefaultApiUpdateRoleResourceForUserRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRoleResourceForUser(requestParameters.userId, requestParameters.updateRoleResourceForUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Roles by Resource Id
         * @param {DefaultApiUpdateRolesByResourceIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRolesByResourceId(requestParameters: DefaultApiUpdateRolesByResourceIdRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRolesByResourceId(requestParameters.resourceScope, requestParameters.resourceId, requestParameters.updateRolesByResourceIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Slack evidence remind settings of an slack channel
         * @param {DefaultApiUpdateSlackEvidenceReminderPerChannelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackEvidenceReminderPerChannel(requestParameters: DefaultApiUpdateSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSlackEvidenceReminderPerChannel(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackEvidenceReminderPerChannelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update slack notification channel setting for card
         * @param {DefaultApiUpdateSlackNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackNotificationSettingForCard(requestParameters: DefaultApiUpdateSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackNotificationSettingForCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update slack notification channel setting for purchase-application
         * @param {DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSlackNotificationSettingForPurchaseApplication(requestParameters: DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSlackNotificationSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackNotificationSettingForPurchaseApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update sync to freee from deal
         * @param {DefaultApiUpdateSyncToFreeeFromDealRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncToFreeeFromDeal(requestParameters: DefaultApiUpdateSyncToFreeeFromDealRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSyncToFreeeFromDeal(requestParameters.organizationId, requestParameters.companyId, requestParameters.dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update synchronize to freee log confirm
         * @param {DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynchronizeToFreeeLogConfirm(requestParameters: DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSynchronizeToFreeeLogConfirm(requestParameters.organizationId, requestParameters.companyId, requestParameters.updateSynchronizeToFreeeLogConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Teams notification channel setting for card
         * @param {DefaultApiUpdateTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamsNotificationSettingForCard(requestParameters: DefaultApiUpdateTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateTeamsNotificationSettingForCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update transaction upper limit for the user account
         * @param {DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransactionUpperLimitForTheUserAccount(requestParameters: DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateTransactionUpperLimitForTheUserAccount200Response> {
            return localVarFp.updateTransactionUpperLimitForTheUserAccount(requestParameters.userAccountId, requestParameters.updateTransactionUpperLimitForTheUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user account group
         * @param {DefaultApiUpdateUserAccountGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountGroup(requestParameters: DefaultApiUpdateUserAccountGroupRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserAccountGroup(requestParameters.userAccountId, requestParameters.updateUserAccountGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user account name
         * @param {DefaultApiUpdateUserAccountNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserAccountName(requestParameters: DefaultApiUpdateUserAccountNameRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateUserAccountName200Response> {
            return localVarFp.updateUserAccountName(requestParameters.userAccountId, requestParameters.updateUserAccountNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update user email, settings per user
         * @param {DefaultApiUpdateUserEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEmail(requestParameters: DefaultApiUpdateUserEmailRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserEmail(requestParameters.userId, requestParameters.updateUserEmailRequest, requestParameters.xChallengeSuccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update user name, settings per user
         * @param {DefaultApiUpdateUserNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserName(requestParameters: DefaultApiUpdateUserNameRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserName(requestParameters.userId, requestParameters.updateUserNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update user organization
         * @param {DefaultApiUpdateUserOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrganization(requestParameters: DefaultApiUpdateUserOrganizationRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserOrganization(requestParameters.userId, requestParameters.updateUserOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update user password
         * @param {DefaultApiUpdateUserPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword(requestParameters: DefaultApiUpdateUserPasswordRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserPassword(requestParameters.userId, requestParameters.updateUserPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update User Privilege
         * @param {DefaultApiUpdateUserPrivilegeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPrivilege(requestParameters: DefaultApiUpdateUserPrivilegeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserPrivilege(requestParameters.organizationId, requestParameters.userId, requestParameters.updateUserPrivilegeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update usage limit for the user account
         * @param {DefaultApiUpdateUserUsageLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserUsageLimit(requestParameters: DefaultApiUpdateUserUsageLimitRequest, options?: AxiosRequestConfig): AxiosPromise<UpdateUserUsageLimit200Response> {
            return localVarFp.updateUserUsageLimit(requestParameters.userAccountId, requestParameters.updateUserUsageLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload card transaction evidence images
         * @param {DefaultApiUploadCardTransactionEvidenceImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCardTransactionEvidenceImage(requestParameters: DefaultApiUploadCardTransactionEvidenceImageRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadCardTransactionEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.files, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload corporate document
         * @param {DefaultApiUploadCorporateDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCorporateDocument(requestParameters: DefaultApiUploadCorporateDocumentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadCorporateDocument(requestParameters.organizationIdentityVerificationId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload payment request evidence image
         * @param {DefaultApiUploadPaymentRequestEvidenceImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPaymentRequestEvidenceImage(requestParameters: DefaultApiUploadPaymentRequestEvidenceImageRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadPaymentRequestEvidenceImage(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Users email confirm
         * @param {DefaultApiUsersEmailConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersEmailConfirm(requestParameters: DefaultApiUsersEmailConfirmRequest, options?: AxiosRequestConfig): AxiosPromise<UsersEmailConfirm200Response> {
            return localVarFp.usersEmailConfirm(requestParameters.usersEmailConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定した scope の現在有効なチャレンジに対して6桁コードを検証し、成功時に短命 JWT (challengeSuccessToken) を発行する。 チャレンジは (userId, scope) ごとに独立しているため、scope の指定が必須。 
         * @summary sudo-mode チャレンジの検証
         * @param {DefaultApiVerifyChallengeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyChallenge(requestParameters: DefaultApiVerifyChallengeRequest, options?: AxiosRequestConfig): AxiosPromise<VerifyChallenge200Response> {
            return localVarFp.verifyChallenge(requestParameters.userId, requestParameters.verifyChallengeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify moneytree connections
         * @param {DefaultApiVerifyMoneytreeConnectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyMoneytreeConnections(requestParameters: DefaultApiVerifyMoneytreeConnectionsRequest, options?: AxiosRequestConfig): AxiosPromise<VerifyMoneytreeConnections200Response> {
            return localVarFp.verifyMoneytreeConnections(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows system administrators to directly update a user\'s email address without email verification. This is a Zeus admin API that bypasses the standard email change flow. 
         * @summary Update user email address (Admin only)
         * @param {DefaultApiZeusUpdateUserEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zeusUpdateUserEmail(requestParameters: DefaultApiZeusUpdateUserEmailRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.zeusUpdateUserEmail(requestParameters.userId, requestParameters.zeusUpdateUserEmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addComment operation in DefaultApi.
 * @export
 * @interface DefaultApiAddCommentRequest
 */
export interface DefaultApiAddCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAddComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAddComment
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {AddCommentRequest}
     * @memberof DefaultApiAddComment
     */
    readonly addCommentRequest: AddCommentRequest
}

/**
 * Request parameters for addOrganizationCreateRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiAddOrganizationCreateRequestRequest
 */
export interface DefaultApiAddOrganizationCreateRequestRequest {
    /**
     * 
     * @type {AddOrganizationCreateRequestRequest}
     * @memberof DefaultApiAddOrganizationCreateRequest
     */
    readonly addOrganizationCreateRequestRequest: AddOrganizationCreateRequestRequest
}

/**
 * Request parameters for addPointToOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiAddPointToOrganizationRequest
 */
export interface DefaultApiAddPointToOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAddPointToOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {AddPointToOrganizationRequest}
     * @memberof DefaultApiAddPointToOrganization
     */
    readonly addPointToOrganizationRequest: AddPointToOrganizationRequest
}

/**
 * Request parameters for agreeToAgreementRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiAgreeToAgreementRequestRequest
 */
export interface DefaultApiAgreeToAgreementRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAgreeToAgreementRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAgreeToAgreementRequest
     */
    readonly agreementRequestId: string
}

/**
 * Request parameters for agreeToOlInfoSharingConsent operation in DefaultApi.
 * @export
 * @interface DefaultApiAgreeToOlInfoSharingConsentRequest
 */
export interface DefaultApiAgreeToOlInfoSharingConsentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAgreeToOlInfoSharingConsent
     */
    readonly organizationId: string
}

/**
 * Request parameters for analyzeEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiAnalyzeEvidenceRequest
 */
export interface DefaultApiAnalyzeEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAnalyzeEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiAnalyzeEvidence
     */
    readonly file?: File
}

/**
 * Request parameters for analyzeInvoiceOfPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest
 */
export interface DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAnalyzeInvoiceOfPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiAnalyzeInvoiceOfPaymentRequests
     */
    readonly file: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAnalyzeInvoiceOfPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for applyFraudLockStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiApplyFraudLockStatusRequest
 */
export interface DefaultApiApplyFraudLockStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiApplyFraudLockStatus
     */
    readonly cardId: string
}

/**
 * Request parameters for approveOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiApproveOrganizationIdentityVerificationRequest
 */
export interface DefaultApiApproveOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiApproveOrganizationIdentityVerification
     */
    readonly organizationIdentityVerificationId: number
}

/**
 * Request parameters for approvePurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiApprovePurchaseApplicationRequest
 */
export interface DefaultApiApprovePurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiApprovePurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiApprovePurchaseApplication
     */
    readonly purchaseApplicationId: string

    /**
     * 
     * @type {ApprovePurchaseApplicationRequest}
     * @memberof DefaultApiApprovePurchaseApplication
     */
    readonly approvePurchaseApplicationRequest: ApprovePurchaseApplicationRequest
}

/**
 * Request parameters for approveWorkflowStepPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiApproveWorkflowStepPaymentRequestsRequest
 */
export interface DefaultApiApproveWorkflowStepPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiApproveWorkflowStepPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiApproveWorkflowStepPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * 
     * @type {ApproveWorkflowStepPaymentRequestsRequest}
     * @memberof DefaultApiApproveWorkflowStepPaymentRequests
     */
    readonly approveWorkflowStepPaymentRequestsRequest?: ApproveWorkflowStepPaymentRequestsRequest
}

/**
 * Request parameters for automaticallyJournalizeDealsFromRules operation in DefaultApi.
 * @export
 * @interface DefaultApiAutomaticallyJournalizeDealsFromRulesRequest
 */
export interface DefaultApiAutomaticallyJournalizeDealsFromRulesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiAutomaticallyJournalizeDealsFromRules
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiAutomaticallyJournalizeDealsFromRules
     */
    readonly companyId: string

    /**
     * 
     * @type {AutomaticallyJournalizeDealsFromRulesRequest}
     * @memberof DefaultApiAutomaticallyJournalizeDealsFromRules
     */
    readonly automaticallyJournalizeDealsFromRulesRequest: AutomaticallyJournalizeDealsFromRulesRequest
}

/**
 * Request parameters for bankAccountActivitiesWithdrawalReserve operation in DefaultApi.
 * @export
 * @interface DefaultApiBankAccountActivitiesWithdrawalReserveRequest
 */
export interface DefaultApiBankAccountActivitiesWithdrawalReserveRequest {
    /**
     * 
     * @type {BankAccountActivitiesWithdrawalReserveRequest}
     * @memberof DefaultApiBankAccountActivitiesWithdrawalReserve
     */
    readonly bankAccountActivitiesWithdrawalReserveRequest: BankAccountActivitiesWithdrawalReserveRequest
}

/**
 * Request parameters for bulkDisableDailyUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkDisableDailyUserUsageLimitRequest
 */
export interface DefaultApiBulkDisableDailyUserUsageLimitRequest {
    /**
     * 
     * @type {BulkDisableDailyUserUsageLimitRequest}
     * @memberof DefaultApiBulkDisableDailyUserUsageLimit
     */
    readonly bulkDisableDailyUserUsageLimitRequest: BulkDisableDailyUserUsageLimitRequest
}

/**
 * Request parameters for bulkDisableMonthlyUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkDisableMonthlyUsageLimitRequest
 */
export interface DefaultApiBulkDisableMonthlyUsageLimitRequest {
    /**
     * 
     * @type {BulkDisableMonthlyUsageLimitRequest}
     * @memberof DefaultApiBulkDisableMonthlyUsageLimit
     */
    readonly bulkDisableMonthlyUsageLimitRequest: BulkDisableMonthlyUsageLimitRequest
}

/**
 * Request parameters for bulkInviteUsersAdmin operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkInviteUsersAdminRequest
 */
export interface DefaultApiBulkInviteUsersAdminRequest {
    /**
     * The ID of the organization
     * @type {string}
     * @memberof DefaultApiBulkInviteUsersAdmin
     */
    readonly organizationId: string

    /**
     * 
     * @type {BulkInviteUsersAdminRequest}
     * @memberof DefaultApiBulkInviteUsersAdmin
     */
    readonly bulkInviteUsersAdminRequest: BulkInviteUsersAdminRequest

    /**
     * sudo-mode challenge 検証成功時に発行される token
     * @type {string}
     * @memberof DefaultApiBulkInviteUsersAdmin
     */
    readonly xChallengeSuccessToken?: string
}

/**
 * Request parameters for bulkUpdateDailyUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkUpdateDailyUsageLimitRequest
 */
export interface DefaultApiBulkUpdateDailyUsageLimitRequest {
    /**
     * 
     * @type {BulkUpdateDailyUsageLimitRequest}
     * @memberof DefaultApiBulkUpdateDailyUsageLimit
     */
    readonly bulkUpdateDailyUsageLimitRequest: BulkUpdateDailyUsageLimitRequest
}

/**
 * Request parameters for bulkUpdateMonthlyUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkUpdateMonthlyUsageLimitRequest
 */
export interface DefaultApiBulkUpdateMonthlyUsageLimitRequest {
    /**
     * 
     * @type {BulkUpdateMonthlyUsageLimitRequest}
     * @memberof DefaultApiBulkUpdateMonthlyUsageLimit
     */
    readonly bulkUpdateMonthlyUsageLimitRequest: BulkUpdateMonthlyUsageLimitRequest
}

/**
 * Request parameters for bulkUpdateOrganizationUserPrivileges operation in DefaultApi.
 * @export
 * @interface DefaultApiBulkUpdateOrganizationUserPrivilegesRequest
 */
export interface DefaultApiBulkUpdateOrganizationUserPrivilegesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiBulkUpdateOrganizationUserPrivileges
     */
    readonly organizationId: string

    /**
     * 
     * @type {BulkUpdateOrganizationUserPrivilegesRequest}
     * @memberof DefaultApiBulkUpdateOrganizationUserPrivileges
     */
    readonly bulkUpdateOrganizationUserPrivilegesRequest: BulkUpdateOrganizationUserPrivilegesRequest
}

/**
 * Request parameters for cancelDraftPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiCancelDraftPaymentRequestRequest
 */
export interface DefaultApiCancelDraftPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelDraftPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelDraftPaymentRequest
     */
    readonly draftPaymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelDraftPaymentRequest
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for cancelPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiCancelPaymentRequestRequest
 */
export interface DefaultApiCancelPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelPaymentRequest
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCancelPaymentRequest
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for changeIdentityVerificationScheduledDate operation in DefaultApi.
 * @export
 * @interface DefaultApiChangeIdentityVerificationScheduledDateRequest
 */
export interface DefaultApiChangeIdentityVerificationScheduledDateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiChangeIdentityVerificationScheduledDate
     */
    readonly organizationId: string

    /**
     * 
     * @type {ChangeIdentityVerificationScheduledDateRequest}
     * @memberof DefaultApiChangeIdentityVerificationScheduledDate
     */
    readonly changeIdentityVerificationScheduledDateRequest: ChangeIdentityVerificationScheduledDateRequest
}

/**
 * Request parameters for changeInvoiceEmail operation in DefaultApi.
 * @export
 * @interface DefaultApiChangeInvoiceEmailRequest
 */
export interface DefaultApiChangeInvoiceEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiChangeInvoiceEmail
     */
    readonly organizationId: string

    /**
     * 
     * @type {ChangeInvoiceEmailRequest}
     * @memberof DefaultApiChangeInvoiceEmail
     */
    readonly changeInvoiceEmailRequest: ChangeInvoiceEmailRequest
}

/**
 * Request parameters for changeToTheSpecifiedEkycResult operation in DefaultApi.
 * @export
 * @interface DefaultApiChangeToTheSpecifiedEkycResultRequest
 */
export interface DefaultApiChangeToTheSpecifiedEkycResultRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiChangeToTheSpecifiedEkycResult
     */
    readonly identificationId: string

    /**
     * 
     * @type {ChangeToTheSpecifiedEkycResultRequest}
     * @memberof DefaultApiChangeToTheSpecifiedEkycResult
     */
    readonly changeToTheSpecifiedEkycResultRequest: ChangeToTheSpecifiedEkycResultRequest
}

/**
 * Request parameters for checkAlreadyRegisteredPhoneNumber operation in DefaultApi.
 * @export
 * @interface DefaultApiCheckAlreadyRegisteredPhoneNumberRequest
 */
export interface DefaultApiCheckAlreadyRegisteredPhoneNumberRequest {
    /**
     * 
     * @type {CheckAlreadyRegisteredPhoneNumberRequest}
     * @memberof DefaultApiCheckAlreadyRegisteredPhoneNumber
     */
    readonly checkAlreadyRegisteredPhoneNumberRequest: CheckAlreadyRegisteredPhoneNumberRequest
}

/**
 * Request parameters for checkDuplicateEmailAddresses operation in DefaultApi.
 * @export
 * @interface DefaultApiCheckDuplicateEmailAddressesRequest
 */
export interface DefaultApiCheckDuplicateEmailAddressesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiCheckDuplicateEmailAddresses
     */
    readonly emailAddresses?: Array<string>
}

/**
 * Request parameters for completeRedirectFromSlack operation in DefaultApi.
 * @export
 * @interface DefaultApiCompleteRedirectFromSlackRequest
 */
export interface DefaultApiCompleteRedirectFromSlackRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCompleteRedirectFromSlack
     */
    readonly organizationId: string

    /**
     * 
     * @type {CompleteRedirectFromSlackRequest}
     * @memberof DefaultApiCompleteRedirectFromSlack
     */
    readonly completeRedirectFromSlackRequest?: CompleteRedirectFromSlackRequest
}

/**
 * Request parameters for confirmFufuHotelReservation operation in DefaultApi.
 * @export
 * @interface DefaultApiConfirmFufuHotelReservationRequest
 */
export interface DefaultApiConfirmFufuHotelReservationRequest {
    /**
     * 
     * @type {ConfirmFufuHotelReservationRequest}
     * @memberof DefaultApiConfirmFufuHotelReservation
     */
    readonly confirmFufuHotelReservationRequest: ConfirmFufuHotelReservationRequest
}

/**
 * Request parameters for connectFreeeForAccounting operation in DefaultApi.
 * @export
 * @interface DefaultApiConnectFreeeForAccountingRequest
 */
export interface DefaultApiConnectFreeeForAccountingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiConnectFreeeForAccounting
     */
    readonly orgAccountId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiConnectFreeeForAccounting
     */
    readonly upsidrPrivateClientApiInternal?: boolean

    /**
     * 
     * @type {ConnectFreeeForAccountingRequest}
     * @memberof DefaultApiConnectFreeeForAccounting
     */
    readonly connectFreeeForAccountingRequest?: ConnectFreeeForAccountingRequest
}

/**
 * Request parameters for countDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiCountDealsRequest
 */
export interface DefaultApiCountDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCountDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {CountDealsRequest}
     * @memberof DefaultApiCountDeals
     */
    readonly countDealsRequest?: CountDealsRequest
}

/**
 * Request parameters for createBankTransfers operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateBankTransfersRequest
 */
export interface DefaultApiCreateBankTransfersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateBankTransfersRequest}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly createBankTransfersRequest: CreateBankTransfersRequest

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly transferDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly transferDateJstTo?: string

    /**
     * Filter the bank transfers by the specified source bank account id.
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly sourceBankAccountId?: string

    /**
     * Filter the bank transfers by whether the corresponding transfer data has been downloaded.
     * @type {boolean}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly downloaded?: boolean

    /**
     * 
     * @type {number}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiCreateBankTransfers
     */
    readonly cursor?: string
}

/**
 * Request parameters for createCategoryOfThePurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest
 */
export interface DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateCategoryOfThePurchaseApplicationTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateCategoryOfThePurchaseApplicationTemplateRequest}
     * @memberof DefaultApiCreateCategoryOfThePurchaseApplicationTemplate
     */
    readonly createCategoryOfThePurchaseApplicationTemplateRequest: CreateCategoryOfThePurchaseApplicationTemplateRequest
}

/**
 * Request parameters for createCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateCommentTemplateRequest
 */
export interface DefaultApiCreateCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateCommentTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateCommentTemplateRequest}
     * @memberof DefaultApiCreateCommentTemplate
     */
    readonly createCommentTemplateRequest: CreateCommentTemplateRequest
}

/**
 * Request parameters for createDepositRestrictionForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateDepositRestrictionForOrganizationRequest
 */
export interface DefaultApiCreateDepositRestrictionForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateDepositRestrictionForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateDepositRestrictionForOrganizationRequest}
     * @memberof DefaultApiCreateDepositRestrictionForOrganization
     */
    readonly createDepositRestrictionForOrganizationRequest: CreateDepositRestrictionForOrganizationRequest
}

/**
 * Request parameters for createDraftOfPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateDraftOfPaymentRequestsRequest
 */
export interface DefaultApiCreateDraftOfPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateDraftOfPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateDraftOfPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * 
     * @type {CreateDraftOfPaymentRequestsRequest}
     * @memberof DefaultApiCreateDraftOfPaymentRequests
     */
    readonly createDraftOfPaymentRequestsRequest?: CreateDraftOfPaymentRequestsRequest
}

/**
 * Request parameters for createEtcCardIssuanceRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateEtcCardIssuanceRequestRequest
 */
export interface DefaultApiCreateEtcCardIssuanceRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateEtcCardIssuanceRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateEtcCardIssuanceRequestRequest}
     * @memberof DefaultApiCreateEtcCardIssuanceRequest
     */
    readonly createEtcCardIssuanceRequestRequest: CreateEtcCardIssuanceRequestRequest
}

/**
 * Request parameters for createEvidenceRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateEvidenceRequestRequest
 */
export interface DefaultApiCreateEvidenceRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateEvidenceRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateEvidenceRequest
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for createFreeeAuthForAccounting operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateFreeeAuthForAccountingRequest
 */
export interface DefaultApiCreateFreeeAuthForAccountingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateFreeeAuthForAccounting
     */
    readonly orgAccountId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiCreateFreeeAuthForAccounting
     */
    readonly upsidrPrivateClientApiInternal?: boolean
}

/**
 * Request parameters for createFreeePartner operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateFreeePartnerRequest
 */
export interface DefaultApiCreateFreeePartnerRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateFreeePartner
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateFreeePartner
     */
    readonly companyId: string

    /**
     * 
     * @type {CreateFreeePartnerRequest}
     * @memberof DefaultApiCreateFreeePartner
     */
    readonly createFreeePartnerRequest: CreateFreeePartnerRequest
}

/**
 * Request parameters for createPastDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiCreatePastDealsRequest
 */
export interface DefaultApiCreatePastDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreatePastDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreatePastDealsRequest}
     * @memberof DefaultApiCreatePastDeals
     */
    readonly createPastDealsRequest: CreatePastDealsRequest
}

/**
 * Request parameters for createPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiCreatePurchaseApplicationRequest
 */
export interface DefaultApiCreatePurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreatePurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreatePurchaseApplicationRequest}
     * @memberof DefaultApiCreatePurchaseApplication
     */
    readonly createPurchaseApplicationRequest: CreatePurchaseApplicationRequest

    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreatePurchaseApplication
     */
    readonly visaTransactionReferenceId?: string
}

/**
 * Request parameters for createPurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiCreatePurchaseApplicationTemplateRequest
 */
export interface DefaultApiCreatePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreatePurchaseApplicationTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreatePurchaseApplicationTemplateRequest}
     * @memberof DefaultApiCreatePurchaseApplicationTemplate
     */
    readonly createPurchaseApplicationTemplateRequest: CreatePurchaseApplicationTemplateRequest
}

/**
 * Request parameters for createSlackCardNotifications operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateSlackCardNotificationsRequest
 */
export interface DefaultApiCreateSlackCardNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateSlackCardNotifications
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateSlackCardNotificationsRequest}
     * @memberof DefaultApiCreateSlackCardNotifications
     */
    readonly createSlackCardNotificationsRequest: CreateSlackCardNotificationsRequest
}

/**
 * Request parameters for createSlackNotificationSettingsForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest
 */
export interface DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateSlackNotificationSettingsForPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateSlackNotificationSettingsForPurchaseApplicationRequest}
     * @memberof DefaultApiCreateSlackNotificationSettingsForPurchaseApplication
     */
    readonly createSlackNotificationSettingsForPurchaseApplicationRequest: CreateSlackNotificationSettingsForPurchaseApplicationRequest
}

/**
 * Request parameters for createTeamsCardNotifications operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateTeamsCardNotificationsRequest
 */
export interface DefaultApiCreateTeamsCardNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateTeamsCardNotifications
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateTeamsCardNotificationsRequest}
     * @memberof DefaultApiCreateTeamsCardNotifications
     */
    readonly createTeamsCardNotificationsRequest: CreateTeamsCardNotificationsRequest
}

/**
 * Request parameters for createUserAccountGroups operation in DefaultApi.
 * @export
 * @interface DefaultApiCreateUserAccountGroupsRequest
 */
export interface DefaultApiCreateUserAccountGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiCreateUserAccountGroups
     */
    readonly organizationId: string

    /**
     * 
     * @type {CreateUserAccountGroupsRequest}
     * @memberof DefaultApiCreateUserAccountGroups
     */
    readonly createUserAccountGroupsRequest?: CreateUserAccountGroupsRequest
}

/**
 * Request parameters for deactivateCard operation in DefaultApi.
 * @export
 * @interface DefaultApiDeactivateCardRequest
 */
export interface DefaultApiDeactivateCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeactivateCard
     */
    readonly cardId: string
}

/**
 * Request parameters for deactivateEtcCard operation in DefaultApi.
 * @export
 * @interface DefaultApiDeactivateEtcCardRequest
 */
export interface DefaultApiDeactivateEtcCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeactivateEtcCard
     */
    readonly cardId: string
}

/**
 * Request parameters for deactivateUser operation in DefaultApi.
 * @export
 * @interface DefaultApiDeactivateUserRequest
 */
export interface DefaultApiDeactivateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeactivateUser
     */
    readonly userId: string
}

/**
 * Request parameters for defrostCard operation in DefaultApi.
 * @export
 * @interface DefaultApiDefrostCardRequest
 */
export interface DefaultApiDefrostCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDefrostCard
     */
    readonly cardId: string
}

/**
 * Request parameters for deleteCardPointsRateConfig operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteCardPointsRateConfigRequest
 */
export interface DefaultApiDeleteCardPointsRateConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCardPointsRateConfig
     */
    readonly rateConfigId: string
}

/**
 * Request parameters for deleteCategoryOfThePurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest
 */
export interface DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCategoryOfThePurchaseApplicationTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCategoryOfThePurchaseApplicationTemplate
     */
    readonly purchaseTemplateCategoryId: string
}

/**
 * Request parameters for deleteComment operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteCommentRequest
 */
export interface DefaultApiDeleteCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteComment
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteComment
     */
    readonly cardTransactionCommentId: string
}

/**
 * Request parameters for deleteCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteCommentTemplateRequest
 */
export interface DefaultApiDeleteCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCommentTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteCommentTemplate
     */
    readonly templateId: string
}

/**
 * Request parameters for deleteDepositRestrictionForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteDepositRestrictionForOrganizationRequest
 */
export interface DefaultApiDeleteDepositRestrictionForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteDepositRestrictionForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteDepositRestrictionForOrganization
     */
    readonly depositRestrictionId: string
}

/**
 * Request parameters for deleteEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteEvidenceRequest
 */
export interface DefaultApiDeleteEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteEvidence
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteEvidence
     */
    readonly cardTransactionEvidenceId: string
}

/**
 * Request parameters for deleteFreeeConnected operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteFreeeConnectedRequest
 */
export interface DefaultApiDeleteFreeeConnectedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteFreeeConnected
     */
    readonly organizationId: string
}

/**
 * Request parameters for deleteFreeeEndJournalEntryTransitionMode operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest
 */
export interface DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteFreeeEndJournalEntryTransitionMode
     */
    readonly organizationId: string
}

/**
 * Request parameters for deleteMerchantGeneralBlockAllowedOrganizationIds operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest
 */
export interface DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIds
     */
    readonly merchantGeneralBlockListId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIds
     */
    readonly allowedOrganizationId: string
}

/**
 * Request parameters for deleteMerchantGeneralBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteMerchantGeneralBlockListRequest
 */
export interface DefaultApiDeleteMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteMerchantGeneralBlockList
     */
    readonly merchantGeneralBlockListId: string
}

/**
 * Request parameters for deleteMerchantOrgBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteMerchantOrgBlockListRequest
 */
export interface DefaultApiDeleteMerchantOrgBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteMerchantOrgBlockList
     */
    readonly merchantOrgBlockListId: string
}

/**
 * Request parameters for deleteOnboardingRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteOnboardingRequestRequest
 */
export interface DefaultApiDeleteOnboardingRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteOnboardingRequest
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for deleteOrganizationCreateRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteOrganizationCreateRequestRequest
 */
export interface DefaultApiDeleteOrganizationCreateRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteOrganizationCreateRequest
     */
    readonly organizationCreateRequestId: string
}

/**
 * Request parameters for deletePaymentRequestEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiDeletePaymentRequestEvidenceRequest
 */
export interface DefaultApiDeletePaymentRequestEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePaymentRequestEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePaymentRequestEvidence
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePaymentRequestEvidence
     */
    readonly evidenceId: string
}

/**
 * Request parameters for deletePurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiDeletePurchaseApplicationRequest
 */
export interface DefaultApiDeletePurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePurchaseApplication
     */
    readonly purchaseApplicationId: string
}

/**
 * Request parameters for deletePurchaseApplicationTemplatesDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiDeletePurchaseApplicationTemplatesDetailRequest
 */
export interface DefaultApiDeletePurchaseApplicationTemplatesDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePurchaseApplicationTemplatesDetail
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeletePurchaseApplicationTemplatesDetail
     */
    readonly purchaseTemplateId: string
}

/**
 * Request parameters for deleteSlackNotificationChannelSettingForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest
 */
export interface DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplication
     */
    readonly channelId: string
}

/**
 * Request parameters for deleteSlackNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteSlackNotificationSettingForCardRequest
 */
export interface DefaultApiDeleteSlackNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSlackNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSlackNotificationSettingForCard
     */
    readonly channelId: string
}

/**
 * Request parameters for deleteSystemAdminRole operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteSystemAdminRoleRequest
 */
export interface DefaultApiDeleteSystemAdminRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteSystemAdminRole
     */
    readonly userId: string
}

/**
 * Request parameters for deleteTeamsNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteTeamsNotificationSettingForCardRequest
 */
export interface DefaultApiDeleteTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteTeamsNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteTeamsNotificationSettingForCard
     */
    readonly channelId: string
}

/**
 * Request parameters for deleteUserAccountGroup operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteUserAccountGroupRequest
 */
export interface DefaultApiDeleteUserAccountGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiDeleteUserAccountGroup
     */
    readonly userAccountGroupId: number
}

/**
 * Request parameters for depositGuaranteeMoneyBalance operation in DefaultApi.
 * @export
 * @interface DefaultApiDepositGuaranteeMoneyBalanceRequest
 */
export interface DefaultApiDepositGuaranteeMoneyBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDepositGuaranteeMoneyBalance
     */
    readonly organizationId: string

    /**
     * 
     * @type {DepositGuaranteeMoneyBalanceRequest}
     * @memberof DefaultApiDepositGuaranteeMoneyBalance
     */
    readonly depositGuaranteeMoneyBalanceRequest: DepositGuaranteeMoneyBalanceRequest
}

/**
 * Request parameters for disableApproval operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableApprovalRequest
 */
export interface DefaultApiDisableApprovalRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisableApproval
     */
    readonly organizationId: string
}

/**
 * Request parameters for disableDailyUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableDailyUserUsageLimitRequest
 */
export interface DefaultApiDisableDailyUserUsageLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisableDailyUserUsageLimit
     */
    readonly userAccountId: string
}

/**
 * Request parameters for disablePhysicalStorePaymentForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest
 */
export interface DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisablePhysicalStorePaymentForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for disableTransactionUpperLimitForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest
 */
export interface DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisableTransactionUpperLimitForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for disableUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiDisableUserUsageLimitRequest
 */
export interface DefaultApiDisableUserUsageLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisableUserUsageLimit
     */
    readonly userAccountId: string
}

/**
 * Request parameters for disagreeToAgreementRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiDisagreeToAgreementRequestRequest
 */
export interface DefaultApiDisagreeToAgreementRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisagreeToAgreementRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisagreeToAgreementRequest
     */
    readonly agreementRequestId: string
}

/**
 * Request parameters for disconnectFreeeForAccounting operation in DefaultApi.
 * @export
 * @interface DefaultApiDisconnectFreeeForAccountingRequest
 */
export interface DefaultApiDisconnectFreeeForAccountingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDisconnectFreeeForAccounting
     */
    readonly orgAccountId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiDisconnectFreeeForAccounting
     */
    readonly upsidrPrivateClientApiInternal?: boolean
}

/**
 * Request parameters for downloadBankTransferFile operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadBankTransferFileRequest
 */
export interface DefaultApiDownloadBankTransferFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadBankTransferFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadBankTransferFile
     */
    readonly bankTransferId: string
}

/**
 * Request parameters for downloadBankTransfersCsv operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadBankTransfersCsvRequest
 */
export interface DefaultApiDownloadBankTransfersCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
     * @type {string}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly transferDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly transferDateJstTo?: string

    /**
     * Filter the bank transfers by the specified source bank account id.
     * @type {string}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly sourceBankAccountId?: string

    /**
     * Filter the bank transfers by whether the corresponding transfer data has been downloaded.
     * @type {boolean}
     * @memberof DefaultApiDownloadBankTransfersCsv
     */
    readonly downloaded?: boolean
}

/**
 * Request parameters for downloadEtcAccountingCsv operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadEtcAccountingCsvRequest
 */
export interface DefaultApiDownloadEtcAccountingCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadEtcAccountingCsv
     */
    readonly organizationId: string

    /**
     * Target year-month in YYYYMM format
     * @type {string}
     * @memberof DefaultApiDownloadEtcAccountingCsv
     */
    readonly yearMonth: string

    /**
     * Date aggregation basis (USAGE_MONTH &#x3D; by usage month, BILLING_MONTH &#x3D; by billing month)
     * @type {'USAGE_MONTH' | 'BILLING_MONTH'}
     * @memberof DefaultApiDownloadEtcAccountingCsv
     */
    readonly dateType: 'USAGE_MONTH' | 'BILLING_MONTH'
}

/**
 * Request parameters for downloadJournalEntryForFreeeCsv operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadJournalEntryForFreeeCsvRequest
 */
export interface DefaultApiDownloadJournalEntryForFreeeCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadJournalEntryForFreeeCsv
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadJournalEntryForFreeeCsv
     */
    readonly yearMonth: string
}

/**
 * Request parameters for downloadOrganizationsAccountingCsv operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadOrganizationsAccountingCsvRequest
 */
export interface DefaultApiDownloadOrganizationsAccountingCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadOrganizationsAccountingCsv
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadOrganizationsAccountingCsv
     */
    readonly yearMonth: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiDownloadOrganizationsAccountingCsv
     */
    readonly isMergedFiles: boolean
}

/**
 * Request parameters for downloadPaymentRequestsCsv operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadPaymentRequestsCsvRequest
 */
export interface DefaultApiDownloadPaymentRequestsCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly dueDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly dueDateJstTo?: string

    /**
     * Filter the payment requests by the specified status.
     * @type {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>

    /**
     * Filter the payment requests by the specified supplier id.
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly supplierId?: string

    /**
     * Filter the payment requests by whether the corresponding transaction data has been created.
     * @type {boolean}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly transferDataCreated?: boolean

    /**
     * Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
     * @type {boolean}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly withholdingApplied?: boolean

    /**
     * Filter the payment requests by the specified transfer fee responsibility.
     * @type {'SELF' | 'SUPPLIER'}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly transferFeeResponsibility?: 'SELF' | 'SUPPLIER'

    /**
     * A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsv
     */
    readonly freeWord?: string
}

/**
 * Request parameters for downloadPaymentRequestsCsvForPaymentRequestIdsSpecification operation in DefaultApi.
 * @export
 * @interface DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest
 */
export interface DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecification
     */
    readonly organizationId: string

    /**
     * 
     * @type {DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest}
     * @memberof DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecification
     */
    readonly downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest?: DownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest
}

/**
 * Request parameters for enablePhysicalStorePaymentForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest
 */
export interface DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiEnablePhysicalStorePaymentForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for freezeCard operation in DefaultApi.
 * @export
 * @interface DefaultApiFreezeCardRequest
 */
export interface DefaultApiFreezeCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiFreezeCard
     */
    readonly cardId: string
}

/**
 * Request parameters for freezeOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiFreezeOrganizationRequest
 */
export interface DefaultApiFreezeOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiFreezeOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {FreezeOrganizationRequest}
     * @memberof DefaultApiFreezeOrganization
     */
    readonly freezeOrganizationRequest: FreezeOrganizationRequest
}

/**
 * Request parameters for generateAnnualFeesInvoice operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateAnnualFeesInvoiceRequest
 */
export interface DefaultApiGenerateAnnualFeesInvoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGenerateAnnualFeesInvoice
     */
    readonly organizationId: string
}

/**
 * Request parameters for generateCreateAccountToken operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateCreateAccountTokenRequest
 */
export interface DefaultApiGenerateCreateAccountTokenRequest {
    /**
     * 
     * @type {GenerateCreateAccountTokenRequest}
     * @memberof DefaultApiGenerateCreateAccountToken
     */
    readonly generateCreateAccountTokenRequest: GenerateCreateAccountTokenRequest
}

/**
 * Request parameters for generateFreeeRedirectUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGenerateFreeeRedirectUrlRequest
 */
export interface DefaultApiGenerateFreeeRedirectUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGenerateFreeeRedirectUrl
     */
    readonly organizationId: string
}

/**
 * Request parameters for getACardDetailAsAdmin operation in DefaultApi.
 * @export
 * @interface DefaultApiGetACardDetailAsAdminRequest
 */
export interface DefaultApiGetACardDetailAsAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetACardDetailAsAdmin
     */
    readonly cardId: string
}

/**
 * Request parameters for getAccountingCsvForTheOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountingCsvForTheOrganizationRequest
 */
export interface DefaultApiGetAccountingCsvForTheOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheOrganization
     */
    readonly startYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheOrganization
     */
    readonly endYearMonth: string

    /**
     * 
     * @type {'FREEE' | 'MONEY_FORWARD'}
     * @memberof DefaultApiGetAccountingCsvForTheOrganization
     */
    readonly accountingSystemType: 'FREEE' | 'MONEY_FORWARD'
}

/**
 * Request parameters for getAccountingCsvForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAccountingCsvForTheUserAccountRequest
 */
export interface DefaultApiGetAccountingCsvForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheUserAccount
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAccountingCsvForTheUserAccount
     */
    readonly yearMonth: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetAccountingCsvForTheUserAccount
     */
    readonly isMergedFiles: boolean
}

/**
 * Request parameters for getAdmins operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAdminsRequest
 */
export interface DefaultApiGetAdminsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAdmins
     */
    readonly organizationId: string
}

/**
 * Request parameters for getAgreementRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAgreementRequestsRequest
 */
export interface DefaultApiGetAgreementRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAgreementRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetAgreementRequests
     */
    readonly waitingForAgreement: boolean
}

/**
 * Request parameters for getAnalysisInvoiceOfPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest
 */
export interface DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAnalysisInvoiceOfPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAnalysisInvoiceOfPaymentRequest
     */
    readonly fileId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAnalysisInvoiceOfPaymentRequest
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for getAnnualFeesEligibility operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAnnualFeesEligibilityRequest
 */
export interface DefaultApiGetAnnualFeesEligibilityRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAnnualFeesEligibility
     */
    readonly organizationId: string
}

/**
 * Request parameters for getApprovers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetApproversRequest
 */
export interface DefaultApiGetApproversRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetApprovers
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getAvailableFeatures operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAvailableFeaturesRequest
 */
export interface DefaultApiGetAvailableFeaturesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAvailableFeatures
     */
    readonly organizationId: string
}

/**
 * Request parameters for getBalanceState operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBalanceStateRequest
 */
export interface DefaultApiGetBalanceStateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBalanceState
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBalanceState
     */
    readonly targetDate?: string
}

/**
 * Request parameters for getBankAccountActivities operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBankAccountActivitiesRequest
 */
export interface DefaultApiGetBankAccountActivitiesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBankAccountActivities
     */
    readonly bankAccountActivityId: number
}

/**
 * Request parameters for getBankAccountConfirmedActivities operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBankAccountConfirmedActivitiesRequest
 */
export interface DefaultApiGetBankAccountConfirmedActivitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBankAccountConfirmedActivities
     */
    readonly organizationId: string

    /**
     * 
     * @type {'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY' | 'SERVICE_CHARGE'}
     * @memberof DefaultApiGetBankAccountConfirmedActivities
     */
    readonly type?: 'PAY_BILL' | 'DEPOSIT' | 'WITHDRAWAL' | 'REWARD' | 'USAGE_FEE' | 'POINT' | 'CARD_POINT' | 'CAMPAIGN_POINT' | 'CARD' | 'DEPOSIT_FROM_GUARANTEE_MONEY' | 'WITHDRAWAL_TO_GUARANTEE_MONEY' | 'SERVICE_CHARGE'

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBankAccountConfirmedActivities
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetBankAccountConfirmedActivities
     */
    readonly offset?: number
}

/**
 * Request parameters for getBankByName operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBankByNameRequest
 */
export interface DefaultApiGetBankByNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBankByName
     */
    readonly bankName: string
}

/**
 * Request parameters for getBankTransfer operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBankTransferRequest
 */
export interface DefaultApiGetBankTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBankTransfer
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBankTransfer
     */
    readonly bankTransferId: string
}

/**
 * Request parameters for getBanksAllBranches operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBanksAllBranchesRequest
 */
export interface DefaultApiGetBanksAllBranchesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBanksAllBranches
     */
    readonly bankCode: string
}

/**
 * Request parameters for getBookkeepers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBookkeepersRequest
 */
export interface DefaultApiGetBookkeepersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBookkeepers
     */
    readonly organizationId: string
}

/**
 * Request parameters for getBranch operation in DefaultApi.
 * @export
 * @interface DefaultApiGetBranchRequest
 */
export interface DefaultApiGetBranchRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBranch
     */
    readonly bankCode: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetBranch
     */
    readonly branchName: string
}

/**
 * Request parameters for getCanActivateCard operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCanActivateCardRequest
 */
export interface DefaultApiGetCanActivateCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCanActivateCard
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCanCloseStatuses operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCanCloseStatusesRequest
 */
export interface DefaultApiGetCanCloseStatusesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCanCloseStatuses
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCanDeactivate operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCanDeactivateRequest
 */
export interface DefaultApiGetCanDeactivateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCanDeactivate
     */
    readonly userId: string
}

/**
 * Request parameters for getCanRequestSendingCard operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCanRequestSendingCardRequest
 */
export interface DefaultApiGetCanRequestSendingCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCanRequestSendingCard
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCardBill operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardBillRequest
 */
export interface DefaultApiGetCardBillRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardBill
     */
    readonly cardBillId: string
}

/**
 * Request parameters for getCardDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardDetailRequest
 */
export interface DefaultApiGetCardDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardDetail
     */
    readonly cardId: string

    /**
     * sudo-mode challenge 検証成功時に発行される token
     * @type {string}
     * @memberof DefaultApiGetCardDetail
     */
    readonly xChallengeSuccessToken?: string
}

/**
 * Request parameters for getCardMonthlyTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardMonthlyTransactionsRequest
 */
export interface DefaultApiGetCardMonthlyTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardMonthlyTransactions
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardMonthlyTransactions
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getCardPointsRateConfigsByOrganizationId operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest
 */
export interface DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardPointsRateConfigsByOrganizationId
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCardTransactionDetails operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardTransactionDetailsRequest
 */
export interface DefaultApiGetCardTransactionDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionDetails
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionDetails
     */
    readonly visaTransactionReferenceId: string
}

/**
 * Request parameters for getCardTransactionEvidenceRecordImage operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardTransactionEvidenceRecordImageRequest
 */
export interface DefaultApiGetCardTransactionEvidenceRecordImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly cardTransactionEvidenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetCardTransactionEvidenceRecordImage
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getCardTransactionEvidenceRecords operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardTransactionEvidenceRecordsRequest
 */
export interface DefaultApiGetCardTransactionEvidenceRecordsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecords
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecords
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactionEvidenceRecords
     */
    readonly cardTransactionEvidenceId: string
}

/**
 * Request parameters for getCardTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardTransactionsRequest
 */
export interface DefaultApiGetCardTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactions
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactions
     */
    readonly merchantId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactions
     */
    readonly toYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardTransactions
     */
    readonly fromYearMonth?: string
}

/**
 * Request parameters for getCards operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardsRequest
 */
export interface DefaultApiGetCardsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCards
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCardsTransactionsWithPurchaseApplicationUnlinked operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest
 */
export interface DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinked
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinked
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getCategoryOfThePurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest
 */
export interface DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCategoryOfThePurchaseApplicationTemplate
     */
    readonly organizationId: string
}

/**
 * Request parameters for getComment operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommentRequest
 */
export interface DefaultApiGetCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetComment
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for getCommentTemplates operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommentTemplatesRequest
 */
export interface DefaultApiGetCommentTemplatesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommentTemplates
     */
    readonly organizationId: string
}

/**
 * Request parameters for getCommentTemplatesCommentTemplateId operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCommentTemplatesCommentTemplateIdRequest
 */
export interface DefaultApiGetCommentTemplatesCommentTemplateIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommentTemplatesCommentTemplateId
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCommentTemplatesCommentTemplateId
     */
    readonly templateId: string
}

/**
 * Request parameters for getCurrentCardAssociatedWithTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest
 */
export interface DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCurrentCardAssociatedWithTheUserAccount
     */
    readonly userAccountId: string

    /**
     * Whether to include available merchant categories in the response. Set to false to improve performance when merchant categories are not needed.
     * @type {boolean}
     * @memberof DefaultApiGetCurrentCardAssociatedWithTheUserAccount
     */
    readonly includeMerchantCategories?: boolean

    /**
     * Stripe-style expand parameter for opt-in property expansion. Specifies optional properties to include in the response; properties not listed are omitted from the response body entirely (the key is absent, not &#x60;null&#x60;).  Multiple values can be specified by repeating the parameter, e.g. &#x60;/current_card?expand&#x3D;reissue&amp;expand&#x3D;foo&#x60;.  Currently supported values:  - &#x60;reissue&#x60;: includes the &#x60;reissue&#x60; object describing the previous card    that was replaced by automatic reissuance. &#x60;null&#x60; if this card is not    a reissued card.
     * @type {Array<'reissue'>}
     * @memberof DefaultApiGetCurrentCardAssociatedWithTheUserAccount
     */
    readonly expand?: Array<'reissue'>
}

/**
 * Request parameters for getCurrentEtcCard operation in DefaultApi.
 * @export
 * @interface DefaultApiGetCurrentEtcCardRequest
 */
export interface DefaultApiGetCurrentEtcCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetCurrentEtcCard
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getDealsTotalAmount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDealsTotalAmountRequest
 */
export interface DefaultApiGetDealsTotalAmountRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetDealsTotalAmount
     */
    readonly organizationId: number

    /**
     * 
     * @type {GetDealsTotalAmountRequest}
     * @memberof DefaultApiGetDealsTotalAmount
     */
    readonly getDealsTotalAmountRequest?: GetDealsTotalAmountRequest
}

/**
 * Request parameters for getDefaultCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDefaultCommentTemplateRequest
 */
export interface DefaultApiGetDefaultCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDefaultCommentTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDefaultCommentTemplate
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getDepositBankAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDepositBankAccountRequest
 */
export interface DefaultApiGetDepositBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDepositBankAccount
     */
    readonly organizationId: string
}

/**
 * Request parameters for getDepositRestrictionForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDepositRestrictionForOrganizationRequest
 */
export interface DefaultApiGetDepositRestrictionForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDepositRestrictionForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDepositRestrictionForOrganization
     */
    readonly depositRestrictionId: string
}

/**
 * Request parameters for getDepositRestrictionListForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDepositRestrictionListForOrganizationRequest
 */
export interface DefaultApiGetDepositRestrictionListForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDepositRestrictionListForOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for getDraftPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDraftPaymentRequestRequest
 */
export interface DefaultApiGetDraftPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequest
     */
    readonly draftPaymentRequestId: string
}

/**
 * Request parameters for getDraftPaymentRequestEvidenceFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDraftPaymentRequestEvidenceFileRequest
 */
export interface DefaultApiGetDraftPaymentRequestEvidenceFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestEvidenceFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestEvidenceFile
     */
    readonly draftPaymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestEvidenceFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetDraftPaymentRequestEvidenceFile
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getDraftPaymentRequestsOnlyCreatedOwn operation in DefaultApi.
 * @export
 * @interface DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest
 */
export interface DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly freeWord?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiGetDraftPaymentRequestsOnlyCreatedOwn
     */
    readonly cursor?: string
}

/**
 * Request parameters for getEarliestExpiringGuaranteeMoneyForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest
 */
export interface DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for getEmailNotifications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEmailNotificationsRequest
 */
export interface DefaultApiGetEmailNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEmailNotifications
     */
    readonly userId: string
}

/**
 * Request parameters for getEtcAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEtcAccountRequest
 */
export interface DefaultApiGetEtcAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEtcAccount
     */
    readonly organizationId: string
}

/**
 * Request parameters for getEtcAmounts operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEtcAmountsRequest
 */
export interface DefaultApiGetEtcAmountsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEtcAmounts
     */
    readonly organizationId: string

    /**
     * Settlement year-month in YYYYMM format (e.g., \&quot;202603\&quot;)
     * @type {string}
     * @memberof DefaultApiGetEtcAmounts
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getEtcCardCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEtcCardCountRequest
 */
export interface DefaultApiGetEtcCardCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEtcCardCount
     */
    readonly organizationId: string

    /**
     * Search by card label or holder name (partial match)
     * @type {string}
     * @memberof DefaultApiGetEtcCardCount
     */
    readonly searchWord?: string

    /**
     * Filter by card status
     * @type {Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>}
     * @memberof DefaultApiGetEtcCardCount
     */
    readonly statuses?: Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>

    /**
     * Filter by user account group IDs
     * @type {Array<string>}
     * @memberof DefaultApiGetEtcCardCount
     */
    readonly groups?: Array<string>
}

/**
 * Request parameters for getEtcCardDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEtcCardDetailRequest
 */
export interface DefaultApiGetEtcCardDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEtcCardDetail
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getEtcCardTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEtcCardTransactionsRequest
 */
export interface DefaultApiGetEtcCardTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEtcCardTransactions
     */
    readonly userAccountId: string

    /**
     * Target year and month (format: yyyyMM)
     * @type {string}
     * @memberof DefaultApiGetEtcCardTransactions
     */
    readonly yearMonth: string

    /**
     * Search query (filter by highway name)
     * @type {string}
     * @memberof DefaultApiGetEtcCardTransactions
     */
    readonly search?: string

    /**
     * Number of items to return (default 50, max 200)
     * @type {number}
     * @memberof DefaultApiGetEtcCardTransactions
     */
    readonly limit?: number

    /**
     * Cursor for pagination. Pass the &#x60;nextCursor&#x60; value returned in the previous response.
     * @type {string}
     * @memberof DefaultApiGetEtcCardTransactions
     */
    readonly nextCursor?: string
}

/**
 * Request parameters for getEtcCards operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEtcCardsRequest
 */
export interface DefaultApiGetEtcCardsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEtcCards
     */
    readonly organizationId: string

    /**
     * Search by card label or holder name (partial match)
     * @type {string}
     * @memberof DefaultApiGetEtcCards
     */
    readonly searchWord?: string

    /**
     * Filter by card status
     * @type {Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>}
     * @memberof DefaultApiGetEtcCards
     */
    readonly statuses?: Array<'ISSUING' | 'ACTIVE' | 'DEACTIVATED'>

    /**
     * Filter by user account group IDs
     * @type {Array<string>}
     * @memberof DefaultApiGetEtcCards
     */
    readonly groups?: Array<string>

    /**
     * Number of items to return (default 50, max 200)
     * @type {number}
     * @memberof DefaultApiGetEtcCards
     */
    readonly limit?: number

    /**
     * Cursor for pagination. Pass the &#x60;nextCursor&#x60; value returned in the previous response.
     * @type {string}
     * @memberof DefaultApiGetEtcCards
     */
    readonly nextCursor?: string
}

/**
 * Request parameters for getEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceRequest
 */
export interface DefaultApiGetEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidence
     */
    readonly evidenceId: string
}

/**
 * Request parameters for getEvidenceFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceFileRequest
 */
export interface DefaultApiGetEvidenceFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetEvidenceFile
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getEvidenceImage operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceImageRequest
 */
export interface DefaultApiGetEvidenceImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceImage
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceImage
     */
    readonly cardTransactionEvidenceId: string
}

/**
 * Request parameters for getEvidenceInformationForCardTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceInformationForCardTransactionsRequest
 */
export interface DefaultApiGetEvidenceInformationForCardTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceInformationForCardTransactions
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceInformationForCardTransactions
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for getEvidenceRecordImage operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceRecordImageRequest
 */
export interface DefaultApiGetEvidenceRecordImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecordImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecordImage
     */
    readonly evidenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecordImage
     */
    readonly recordId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetEvidenceRecordImage
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getEvidenceRecords operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceRecordsRequest
 */
export interface DefaultApiGetEvidenceRecordsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecords
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceRecords
     */
    readonly evidenceId: string
}

/**
 * Request parameters for getEvidenceZipForTheOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidenceZipForTheOrganizationRequest
 */
export interface DefaultApiGetEvidenceZipForTheOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceZipForTheOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidenceZipForTheOrganization
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidencesRequest
 */
export interface DefaultApiGetEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidences
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidences
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for getEvidencesCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEvidencesCountRequest
 */
export interface DefaultApiGetEvidencesCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly organizationId: string

    /**
     * This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly issuer?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly amountMin?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly amountMax?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly paidAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly paidAtTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly irrelevantToLedger?: boolean

    /**
     * Specified keyword is searched from the issuer and the note by partial match.
     * @type {string}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly keyword?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly includesDeleted?: boolean

    /**
     * 
     * @type {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>}
     * @memberof DefaultApiGetEvidencesCount
     */
    readonly legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>
}

/**
 * Request parameters for getFraudLockedCardTransaction operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFraudLockedCardTransactionRequest
 */
export interface DefaultApiGetFraudLockedCardTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFraudLockedCardTransaction
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFraudLockedCardTransaction
     */
    readonly cardId: string
}

/**
 * Request parameters for getFreeeAccountItems operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeAccountItemsRequest
 */
export interface DefaultApiGetFreeeAccountItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeAccountItems
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeAccountItems
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeCompanies operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeCompaniesRequest
 */
export interface DefaultApiGetFreeeCompaniesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeCompanies
     */
    readonly organizationId: string
}

/**
 * Request parameters for getFreeeConnected operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeConnectedRequest
 */
export interface DefaultApiGetFreeeConnectedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeConnected
     */
    readonly organizationId: string
}

/**
 * Request parameters for getFreeeConnectedUser operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeConnectedUserRequest
 */
export interface DefaultApiGetFreeeConnectedUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeConnectedUser
     */
    readonly organizationId: string
}

/**
 * Request parameters for getFreeeConnectionLinkedAccountForAccounting operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest
 */
export interface DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeConnectionLinkedAccountForAccounting
     */
    readonly orgAccountId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetFreeeConnectionLinkedAccountForAccounting
     */
    readonly upsidrPrivateClientApiInternal?: boolean
}

/**
 * Request parameters for getFreeeConnectionSettingsForAccounting operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeConnectionSettingsForAccountingRequest
 */
export interface DefaultApiGetFreeeConnectionSettingsForAccountingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeConnectionSettingsForAccounting
     */
    readonly orgAccountId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetFreeeConnectionSettingsForAccounting
     */
    readonly upsidrPrivateClientApiInternal?: boolean
}

/**
 * Request parameters for getFreeeItems operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeItemsRequest
 */
export interface DefaultApiGetFreeeItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeItems
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeItems
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeMemoTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeMemoTagsRequest
 */
export interface DefaultApiGetFreeeMemoTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeMemoTags
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeMemoTags
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeePartners operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeePartnersRequest
 */
export interface DefaultApiGetFreeePartnersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeePartners
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeePartners
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeSections operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeSectionsRequest
 */
export interface DefaultApiGetFreeeSectionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSections
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSections
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeSegmentTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeSegmentTagsRequest
 */
export interface DefaultApiGetFreeeSegmentTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSegmentTags
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSegmentTags
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeSyncStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeSyncStatusRequest
 */
export interface DefaultApiGetFreeeSyncStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeSyncStatus
     */
    readonly organizationId: string
}

/**
 * Request parameters for getFreeeTags operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeTagsRequest
 */
export interface DefaultApiGetFreeeTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTags
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTags
     */
    readonly companyId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTags
     */
    readonly tagName: string
}

/**
 * Request parameters for getFreeeTaxes operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeTaxesRequest
 */
export interface DefaultApiGetFreeeTaxesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTaxes
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeTaxes
     */
    readonly companyId: string
}

/**
 * Request parameters for getFreeeToken operation in DefaultApi.
 * @export
 * @interface DefaultApiGetFreeeTokenRequest
 */
export interface DefaultApiGetFreeeTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetFreeeToken
     */
    readonly organizationId: string
}

/**
 * Request parameters for getGuaranteeMoneyBalanceHistory operation in DefaultApi.
 * @export
 * @interface DefaultApiGetGuaranteeMoneyBalanceHistoryRequest
 */
export interface DefaultApiGetGuaranteeMoneyBalanceHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceHistory
     */
    readonly organizationId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceHistory
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceHistory
     */
    readonly offset?: number
}

/**
 * Request parameters for getGuaranteeMoneyBalanceInformationForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest
 */
export interface DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceInformationForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetGuaranteeMoneyBalanceInformationForOrganization
     */
    readonly targetDate?: string
}

/**
 * Request parameters for getGuaranteeMoneyDepositsForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest
 */
export interface DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetGuaranteeMoneyDepositsForOrganization
     */
    readonly organizationId: string
}

/**
 * Request parameters for getHolidays operation in DefaultApi.
 * @export
 * @interface DefaultApiGetHolidaysRequest
 */
export interface DefaultApiGetHolidaysRequest {
    /**
     * yyyy-MM-dd format date in JST.
     * @type {string}
     * @memberof DefaultApiGetHolidays
     */
    readonly from?: string

    /**
     * yyyy-MM-dd format date in JST.
     * @type {string}
     * @memberof DefaultApiGetHolidays
     */
    readonly to?: string
}

/**
 * Request parameters for getIdentifyVerificationsLatest operation in DefaultApi.
 * @export
 * @interface DefaultApiGetIdentifyVerificationsLatestRequest
 */
export interface DefaultApiGetIdentifyVerificationsLatestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetIdentifyVerificationsLatest
     */
    readonly organizationId: string
}

/**
 * Request parameters for getIdentityVerifications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetIdentityVerificationsRequest
 */
export interface DefaultApiGetIdentityVerificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetIdentityVerifications
     */
    readonly organizationId: string
}

/**
 * Request parameters for getInvoiceList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetInvoiceListRequest
 */
export interface DefaultApiGetInvoiceListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetInvoiceList
     */
    readonly organizationId: string
}

/**
 * Request parameters for getInvoicePdf operation in DefaultApi.
 * @export
 * @interface DefaultApiGetInvoicePdfRequest
 */
export interface DefaultApiGetInvoicePdfRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetInvoicePdf
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetInvoicePdf
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getIssuableStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiGetIssuableStatusRequest
 */
export interface DefaultApiGetIssuableStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetIssuableStatus
     */
    readonly organizationId: string
}

/**
 * Request parameters for getJwtSso operation in DefaultApi.
 * @export
 * @interface DefaultApiGetJwtSsoRequest
 */
export interface DefaultApiGetJwtSsoRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetJwtSso
     */
    readonly nonce: string
}

/**
 * Request parameters for getLatestTimeOfSyncToFreee operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLatestTimeOfSyncToFreeeRequest
 */
export interface DefaultApiGetLatestTimeOfSyncToFreeeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLatestTimeOfSyncToFreee
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLatestTimeOfSyncToFreee
     */
    readonly companyId: string
}

/**
 * Request parameters for getLockStatusOfEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiGetLockStatusOfEvidencesRequest
 */
export interface DefaultApiGetLockStatusOfEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLockStatusOfEvidences
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetLockStatusOfEvidences
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getMerchantGeneralBlockDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMerchantGeneralBlockDetailRequest
 */
export interface DefaultApiGetMerchantGeneralBlockDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantGeneralBlockDetail
     */
    readonly merchantGeneralBlockListId: string
}

/**
 * Request parameters for getMerchantOrgBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMerchantOrgBlockListRequest
 */
export interface DefaultApiGetMerchantOrgBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrgBlockList
     */
    readonly organizationId: string
}

/**
 * Request parameters for getMerchantOrganizationUserAccountYearMonthSummary operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest
 */
export interface DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly merchantId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly toYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantOrganizationUserAccountYearMonthSummary
     */
    readonly fromYearMonth?: string
}

/**
 * Request parameters for getMerchantsCategoryKinds operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMerchantsCategoryKindsRequest
 */
export interface DefaultApiGetMerchantsCategoryKindsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMerchantsCategoryKinds
     */
    readonly organizationId: string
}

/**
 * Request parameters for getModifiableDailyLimitsForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest
 */
export interface DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetModifiableDailyLimitsForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getModifiableMonthlyLimitsForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest
 */
export interface DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetModifiableMonthlyLimitsForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getModifiableTransactionLimitsForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest
 */
export interface DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetModifiableTransactionLimitsForTheUserAccount
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getMoneytreeConnected operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMoneytreeConnectedRequest
 */
export interface DefaultApiGetMoneytreeConnectedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMoneytreeConnected
     */
    readonly organizationId: string
}

/**
 * Request parameters for getMoneytreeOauthUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMoneytreeOauthUrlRequest
 */
export interface DefaultApiGetMoneytreeOauthUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMoneytreeOauthUrl
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMoneytreeOauthUrl
     */
    readonly nextTo?: string
}

/**
 * Request parameters for getMoneytreeStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMoneytreeStatusRequest
 */
export interface DefaultApiGetMoneytreeStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMoneytreeStatus
     */
    readonly organizationId: string
}

/**
 * Request parameters for getMonthlyCardBill operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMonthlyCardBillRequest
 */
export interface DefaultApiGetMonthlyCardBillRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardBill
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardBill
     */
    readonly yearMonth?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardBill
     */
    readonly startYearMonth?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardBill
     */
    readonly endYearMonth?: string
}

/**
 * Request parameters for getMonthlyCardTransactionsForTheOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest
 */
export interface DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardTransactionsForTheOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardTransactionsForTheOrganization
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getMonthlyCardTransactionsForTheUser operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMonthlyCardTransactionsForTheUserRequest
 */
export interface DefaultApiGetMonthlyCardTransactionsForTheUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyCardTransactionsForTheUser
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getMonthlyServiceCharges operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMonthlyServiceChargesRequest
 */
export interface DefaultApiGetMonthlyServiceChargesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyServiceCharges
     */
    readonly organizationId: string

    /**
     * Year and month in yyyyMM format (e.g., 202506)
     * @type {string}
     * @memberof DefaultApiGetMonthlyServiceCharges
     */
    readonly yearMonth: string

    /**
     * Maximum number of items to return (1-100, default: 100)
     * @type {number}
     * @memberof DefaultApiGetMonthlyServiceCharges
     */
    readonly limit?: number

    /**
     * Number of items to skip (default: 0)
     * @type {number}
     * @memberof DefaultApiGetMonthlyServiceCharges
     */
    readonly offset?: number
}

/**
 * Request parameters for getMonthlyUserCardSummaries operation in DefaultApi.
 * @export
 * @interface DefaultApiGetMonthlyUserCardSummariesRequest
 */
export interface DefaultApiGetMonthlyUserCardSummariesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyUserCardSummaries
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetMonthlyUserCardSummaries
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getOlInfoSharingConsent operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOlInfoSharingConsentRequest
 */
export interface DefaultApiGetOlInfoSharingConsentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOlInfoSharingConsent
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOnboardingRequestById operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOnboardingRequestByIdRequest
 */
export interface DefaultApiGetOnboardingRequestByIdRequest {
    /**
     * The ID of the onboarding request to retrieve
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequestById
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for getOnboardingRequestPersonalInfo operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOnboardingRequestPersonalInfoRequest
 */
export interface DefaultApiGetOnboardingRequestPersonalInfoRequest {
    /**
     * Onboarding request ID
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequestPersonalInfo
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for getOnboardingRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOnboardingRequestsRequest
 */
export interface DefaultApiGetOnboardingRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly key?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly createdAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly createdAtTo?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly offset?: number

    /**
     * 
     * @type {'id' | 'createdAt' | 'updatedAt'}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly sort?: 'id' | 'createdAt' | 'updatedAt'

    /**
     * 
     * @type {'ASC' | 'DESC'}
     * @memberof DefaultApiGetOnboardingRequests
     */
    readonly order?: 'ASC' | 'DESC'
}

/**
 * Request parameters for getOrgAccountState operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrgAccountStateRequest
 */
export interface DefaultApiGetOrgAccountStateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrgAccountState
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationRequest
 */
export interface DefaultApiGetOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetOrganization
     */
    readonly underContractOnly?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetOrganization
     */
    readonly withCredit?: boolean
}

/**
 * Request parameters for getOrganizationCardsExtended operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationCardsExtendedRequest
 */
export interface DefaultApiGetOrganizationCardsExtendedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCardsExtended
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationCardsLight operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationCardsLightRequest
 */
export interface DefaultApiGetOrganizationCardsLightRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCardsLight
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationChartDepartments operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationChartDepartmentsRequest
 */
export interface DefaultApiGetOrganizationChartDepartmentsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationChartDepartments
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationChartEmployees operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationChartEmployeesRequest
 */
export interface DefaultApiGetOrganizationChartEmployeesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationChartEmployees
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationChartRoles operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationChartRolesRequest
 */
export interface DefaultApiGetOrganizationChartRolesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationChartRoles
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationCreateRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationCreateRequestsRequest
 */
export interface DefaultApiGetOrganizationCreateRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly key?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly createdAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly createdAtTo?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly offset?: number

    /**
     * 
     * @type {'id' | 'createdAt' | 'updatedAt'}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly sort?: 'id' | 'createdAt' | 'updatedAt'

    /**
     * 
     * @type {'ASC' | 'DESC'}
     * @memberof DefaultApiGetOrganizationCreateRequests
     */
    readonly order?: 'ASC' | 'DESC'
}

/**
 * Request parameters for getOrganizationPaymentSummary operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationPaymentSummaryRequest
 */
export interface DefaultApiGetOrganizationPaymentSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationPaymentSummary
     */
    readonly organizationId: string

    /**
     * 対象利用月（yyyyMM 形式、例: 202604）。 指定された月に対応する MonthlyPayment のサマリーを返す。 未指定の場合は組織の「最新の MonthlyPayment（直近の支払予定日のもの）」のサマリーを返す。 ※「最新」の具体定義はバックエンド実装時に確定。 
     * @type {string}
     * @memberof DefaultApiGetOrganizationPaymentSummary
     */
    readonly yearMonth?: string
}

/**
 * Request parameters for getOrganizationPayments operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationPaymentsRequest
 */
export interface DefaultApiGetOrganizationPaymentsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationPayments
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationPayments
     */
    readonly yearMonth?: string
}

/**
 * Request parameters for getOrganizationsAccountingCsvExportFields operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest
 */
export interface DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationsAccountingCsvExportFields
     */
    readonly organizationId: string
}

/**
 * Request parameters for getOrganizationsBills operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationsBillsRequest
 */
export interface DefaultApiGetOrganizationsBillsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationsBills
     */
    readonly organizationId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetOrganizationsBills
     */
    readonly beforeReservationOnly?: boolean

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOrganizationsBills
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetOrganizationsBills
     */
    readonly offset?: number
}

/**
 * Request parameters for getOrganizationsDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiGetOrganizationsDealsRequest
 */
export interface DefaultApiGetOrganizationsDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetOrganizationsDeals
     */
    readonly organizationId: string
}

/**
 * Request parameters for getPaymentRequestDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestDetailRequest
 */
export interface DefaultApiGetPaymentRequestDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestDetail
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestDetail
     */
    readonly paymentRequestId?: string
}

/**
 * Request parameters for getPaymentRequestEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidenceRequest
 */
export interface DefaultApiGetPaymentRequestEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidence
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidence
     */
    readonly evidenceId: string
}

/**
 * Request parameters for getPaymentRequestEvidenceFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidenceFileRequest
 */
export interface DefaultApiGetPaymentRequestEvidenceFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceFile
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetPaymentRequestEvidenceFile
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getPaymentRequestEvidenceRecordFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidenceRecordFileRequest
 */
export interface DefaultApiGetPaymentRequestEvidenceRecordFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly recordId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecordFile
     */
    readonly inPdf?: boolean
}

/**
 * Request parameters for getPaymentRequestEvidenceRecords operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidenceRecordsRequest
 */
export interface DefaultApiGetPaymentRequestEvidenceRecordsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecords
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecords
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidenceRecords
     */
    readonly evidenceId: string
}

/**
 * Request parameters for getPaymentRequestEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestEvidencesRequest
 */
export interface DefaultApiGetPaymentRequestEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidences
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestEvidences
     */
    readonly paymentRequestId: string
}

/**
 * Request parameters for getPaymentRequestsBankAccountsList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestsBankAccountsListRequest
 */
export interface DefaultApiGetPaymentRequestsBankAccountsListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestsBankAccountsList
     */
    readonly organizationId: string
}

/**
 * Request parameters for getPaymentRequestsCountLinkedBankTransfer operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest
 */
export interface DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestsCountLinkedBankTransfer
     */
    readonly organizationId: string

    /**
     * When specifying more than one, separate them by commas.
     * @type {string}
     * @memberof DefaultApiGetPaymentRequestsCountLinkedBankTransfer
     */
    readonly paymentRequestIds: string
}

/**
 * Request parameters for getPinretrieverDecryptPinBlock operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPinretrieverDecryptPinBlockRequest
 */
export interface DefaultApiGetPinretrieverDecryptPinBlockRequest {
    /**
     * 
     * @type {GetPinretrieverDecryptPinBlockRequest}
     * @memberof DefaultApiGetPinretrieverDecryptPinBlock
     */
    readonly getPinretrieverDecryptPinBlockRequest: GetPinretrieverDecryptPinBlockRequest
}

/**
 * Request parameters for getPinretrieverEncryptPin operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPinretrieverEncryptPinRequest
 */
export interface DefaultApiGetPinretrieverEncryptPinRequest {
    /**
     * 
     * @type {GetPinretrieverEncryptPinRequest}
     * @memberof DefaultApiGetPinretrieverEncryptPin
     */
    readonly getPinretrieverEncryptPinRequest: GetPinretrieverEncryptPinRequest
}

/**
 * Request parameters for getPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationRequest
 */
export interface DefaultApiGetPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplication
     */
    readonly purchaseApplicationId: string
}

/**
 * Request parameters for getPurchaseApplicationTemplates operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationTemplatesRequest
 */
export interface DefaultApiGetPurchaseApplicationTemplatesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationTemplates
     */
    readonly organizationId: string
}

/**
 * Request parameters for getPurchaseApplicationTemplatesDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationTemplatesDetailRequest
 */
export interface DefaultApiGetPurchaseApplicationTemplatesDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationTemplatesDetail
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationTemplatesDetail
     */
    readonly purchaseTemplateId: string
}

/**
 * Request parameters for getPurchaseApplications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationsRequest
 */
export interface DefaultApiGetPurchaseApplicationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplications
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplications
     */
    readonly yearMonth?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplications
     */
    readonly visaTransactionReferenceId?: string
}

/**
 * Request parameters for getPurchaseApplicationsRequestedCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationsRequestedCountRequest
 */
export interface DefaultApiGetPurchaseApplicationsRequestedCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationsRequestedCount
     */
    readonly userId: string
}

/**
 * Request parameters for getPurchaseApplicationsRequestedList operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationsRequestedListRequest
 */
export interface DefaultApiGetPurchaseApplicationsRequestedListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationsRequestedList
     */
    readonly userId: string
}

/**
 * Request parameters for getPurchaseApplicationsSubmittedSelf operation in DefaultApi.
 * @export
 * @interface DefaultApiGetPurchaseApplicationsSubmittedSelfRequest
 */
export interface DefaultApiGetPurchaseApplicationsSubmittedSelfRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationsSubmittedSelf
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetPurchaseApplicationsSubmittedSelf
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getQualifiedInvoiceIssuer operation in DefaultApi.
 * @export
 * @interface DefaultApiGetQualifiedInvoiceIssuerRequest
 */
export interface DefaultApiGetQualifiedInvoiceIssuerRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetQualifiedInvoiceIssuer
     */
    readonly registrationNumber: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetQualifiedInvoiceIssuer
     */
    readonly issuerName?: string
}

/**
 * Request parameters for getRedirectUrlFromTinyUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRedirectUrlFromTinyUrlRequest
 */
export interface DefaultApiGetRedirectUrlFromTinyUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRedirectUrlFromTinyUrl
     */
    readonly tinyUrlParam: string
}

/**
 * Request parameters for getRewardPointBalance operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRewardPointBalanceRequest
 */
export interface DefaultApiGetRewardPointBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRewardPointBalance
     */
    readonly organizationId: string
}

/**
 * Request parameters for getRewardPointTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRewardPointTransactionsRequest
 */
export interface DefaultApiGetRewardPointTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRewardPointTransactions
     */
    readonly organizationId: string
}

/**
 * Request parameters for getRoleResourceForUser operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRoleResourceForUserRequest
 */
export interface DefaultApiGetRoleResourceForUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRoleResourceForUser
     */
    readonly userId: string
}

/**
 * Request parameters for getRoles operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRolesRequest
 */
export interface DefaultApiGetRolesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRoles
     */
    readonly category: string
}

/**
 * Request parameters for getRolesWithTopRelatedResources operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRolesWithTopRelatedResourcesRequest
 */
export interface DefaultApiGetRolesWithTopRelatedResourcesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResources
     */
    readonly resourceScope: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResources
     */
    readonly resourceId: string
}

/**
 * Request parameters for getRolesWithTopRelatedResourcesByOrganizationId operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest
 */
export interface DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResourcesByOrganizationId
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResourcesByOrganizationId
     */
    readonly resourceScope: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRolesWithTopRelatedResourcesByOrganizationId
     */
    readonly resourceId: string
}

/**
 * Request parameters for getSlackCardNotificationSettings operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackCardNotificationSettingsRequest
 */
export interface DefaultApiGetSlackCardNotificationSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackCardNotificationSettings
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSlackChannel operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackChannelRequest
 */
export interface DefaultApiGetSlackChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackChannel
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackChannel
     */
    readonly channelId: string
}

/**
 * Request parameters for getSlackChannels operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackChannelsRequest
 */
export interface DefaultApiGetSlackChannelsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackChannels
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSlackChannelsWithCursor operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackChannelsWithCursorRequest
 */
export interface DefaultApiGetSlackChannelsWithCursorRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackChannelsWithCursor
     */
    readonly organizationId: string

    /**
     * This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
     * @type {string}
     * @memberof DefaultApiGetSlackChannelsWithCursor
     */
    readonly cursor?: string
}

/**
 * Request parameters for getSlackEvidenceReminder operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackEvidenceReminderRequest
 */
export interface DefaultApiGetSlackEvidenceReminderRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackEvidenceReminder
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSlackEvidenceReminderPerChannel operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackEvidenceReminderPerChannelRequest
 */
export interface DefaultApiGetSlackEvidenceReminderPerChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackEvidenceReminderPerChannel
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackEvidenceReminderPerChannel
     */
    readonly channelId: string
}

/**
 * Request parameters for getSlackNotificationChannelSettingForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest
 */
export interface DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackNotificationChannelSettingForPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackNotificationChannelSettingForPurchaseApplication
     */
    readonly channelId: string
}

/**
 * Request parameters for getSlackNotificationSettingsForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest
 */
export interface DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackNotificationSettingsForPurchaseApplication
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSlackTeam operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSlackTeamRequest
 */
export interface DefaultApiGetSlackTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSlackTeam
     */
    readonly organizationId: string
}

/**
 * Request parameters for getSubmittedTrustdockData operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSubmittedTrustdockDataRequest
 */
export interface DefaultApiGetSubmittedTrustdockDataRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSubmittedTrustdockData
     */
    readonly trustdockIdentificationId: string
}

/**
 * Request parameters for getSuspiciousTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSuspiciousTransactionsRequest
 */
export interface DefaultApiGetSuspiciousTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetSuspiciousTransactions
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getTeamsCardNotificationSettings operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamsCardNotificationSettingsRequest
 */
export interface DefaultApiGetTeamsCardNotificationSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsCardNotificationSettings
     */
    readonly organizationId: string
}

/**
 * Request parameters for getTeamsChannel operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamsChannelRequest
 */
export interface DefaultApiGetTeamsChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsChannel
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsChannel
     */
    readonly channelId: string
}

/**
 * Request parameters for getTeamsChannelsWithCursor operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamsChannelsWithCursorRequest
 */
export interface DefaultApiGetTeamsChannelsWithCursorRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsChannelsWithCursor
     */
    readonly organizationId: string

    /**
     * This is used to provide paging in a cursor mode. If any value is specified, the channel after the cursor is retrieved; if the value is null, the first page is returned.
     * @type {string}
     * @memberof DefaultApiGetTeamsChannelsWithCursor
     */
    readonly cursor?: string
}

/**
 * Request parameters for getTeamsTeam operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTeamsTeamRequest
 */
export interface DefaultApiGetTeamsTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTeamsTeam
     */
    readonly organizationId: string
}

/**
 * Request parameters for getTheCountOfMonthlyTransactionsForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest
 */
export interface DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccount
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccount
     */
    readonly yearMonth: string
}

/**
 * Request parameters for getTheUserAccountInformation operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTheUserAccountInformationRequest
 */
export interface DefaultApiGetTheUserAccountInformationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTheUserAccountInformation
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getTransactionEvidenceEmailAddress operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTransactionEvidenceEmailAddressRequest
 */
export interface DefaultApiGetTransactionEvidenceEmailAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmailAddress
     */
    readonly userAccountId: string
}

/**
 * Request parameters for getTransactionEvidenceEmailFile operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTransactionEvidenceEmailFileRequest
 */
export interface DefaultApiGetTransactionEvidenceEmailFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmailFile
     */
    readonly userAccountId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetTransactionEvidenceEmailFile
     */
    readonly transactionEvidenceEmailFileId: number
}

/**
 * Request parameters for getTransactionEvidenceEmails operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTransactionEvidenceEmailsRequest
 */
export interface DefaultApiGetTransactionEvidenceEmailsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmails
     */
    readonly userAccountId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmails
     */
    readonly startYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTransactionEvidenceEmails
     */
    readonly endYearMonth: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetTransactionEvidenceEmails
     */
    readonly isTrash?: boolean
}

/**
 * Request parameters for getTrustdockIdentityVerifications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrustdockIdentityVerificationsRequest
 */
export interface DefaultApiGetTrustdockIdentityVerificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrustdockIdentityVerifications
     */
    readonly trustdockIdentificationId: string
}

/**
 * Request parameters for getTrustdockSubmitIdentificationDocumentPublishUrl operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest
 */
export interface DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrl
     */
    readonly trustdockIdentificationId: string
}

/**
 * Request parameters for getTrustdockVerifications operation in DefaultApi.
 * @export
 * @interface DefaultApiGetTrustdockVerificationsRequest
 */
export interface DefaultApiGetTrustdockVerificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetTrustdockVerifications
     */
    readonly trustdockIdentificationId: string
}

/**
 * Request parameters for getUnreadMessageCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUnreadMessageCountRequest
 */
export interface DefaultApiGetUnreadMessageCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUnreadMessageCount
     */
    readonly userId: string
}

/**
 * Request parameters for getUsageFee operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUsageFeeRequest
 */
export interface DefaultApiGetUsageFeeRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUsageFee
     */
    readonly usageFeeId: number
}

/**
 * Request parameters for getUserAccountGroups operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserAccountGroupsRequest
 */
export interface DefaultApiGetUserAccountGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountGroups
     */
    readonly organizationId: string
}

/**
 * Request parameters for getUserAccountYearMonthSummary operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserAccountYearMonthSummaryRequest
 */
export interface DefaultApiGetUserAccountYearMonthSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountYearMonthSummary
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountYearMonthSummary
     */
    readonly toYearMonth: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountYearMonthSummary
     */
    readonly fromYearMonth?: string
}

/**
 * Request parameters for getUserAccountsWithDefaultCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest
 */
export interface DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserAccountsWithDefaultCommentTemplate
     */
    readonly organizationId: string
}

/**
 * Request parameters for getUserCards operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsRequest
 */
export interface DefaultApiGetUserCardsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCards
     */
    readonly userId: string
}

/**
 * Request parameters for getUserCardsExtended operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsExtendedRequest
 */
export interface DefaultApiGetUserCardsExtendedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCardsExtended
     */
    readonly userId: string
}

/**
 * Request parameters for getUserCardsExtendedForRoleResources operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsExtendedForRoleResourcesRequest
 */
export interface DefaultApiGetUserCardsExtendedForRoleResourcesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCardsExtendedForRoleResources
     */
    readonly userId: string
}

/**
 * Request parameters for getUserCardsLight operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsLightRequest
 */
export interface DefaultApiGetUserCardsLightRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCardsLight
     */
    readonly userId: string
}

/**
 * Request parameters for getUserCardsLightForRoleResources operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserCardsLightForRoleResourcesRequest
 */
export interface DefaultApiGetUserCardsLightForRoleResourcesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserCardsLightForRoleResources
     */
    readonly userId: string
}

/**
 * Request parameters for getUserEtcCardCount operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserEtcCardCountRequest
 */
export interface DefaultApiGetUserEtcCardCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserEtcCardCount
     */
    readonly userId: string

    /**
     * Search by card label or holder name (partial match)
     * @type {string}
     * @memberof DefaultApiGetUserEtcCardCount
     */
    readonly searchWord?: string

    /**
     * Filter by user account group IDs
     * @type {Array<string>}
     * @memberof DefaultApiGetUserEtcCardCount
     */
    readonly groups?: Array<string>
}

/**
 * Request parameters for getUserEtcCards operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserEtcCardsRequest
 */
export interface DefaultApiGetUserEtcCardsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserEtcCards
     */
    readonly userId: string

    /**
     * Search by card label or holder name (partial match)
     * @type {string}
     * @memberof DefaultApiGetUserEtcCards
     */
    readonly searchWord?: string

    /**
     * Filter by user account group IDs
     * @type {Array<string>}
     * @memberof DefaultApiGetUserEtcCards
     */
    readonly groups?: Array<string>

    /**
     * Number of items to return (default 50, min 1, max 200)
     * @type {number}
     * @memberof DefaultApiGetUserEtcCards
     */
    readonly limit?: number

    /**
     * Cursor for pagination. Pass the &#x60;nextCursor&#x60; or &#x60;prevCursor&#x60; value returned in the previous response.
     * @type {string}
     * @memberof DefaultApiGetUserEtcCards
     */
    readonly nextCursor?: string
}

/**
 * Request parameters for getUserMessageDetail operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserMessageDetailRequest
 */
export interface DefaultApiGetUserMessageDetailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserMessageDetail
     */
    readonly userMessageId: string
}

/**
 * Request parameters for getUserMessages operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUserMessagesRequest
 */
export interface DefaultApiGetUserMessagesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUserMessages
     */
    readonly userId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserMessages
     */
    readonly offset: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetUserMessages
     */
    readonly limit: number
}

/**
 * Request parameters for getUsers operation in DefaultApi.
 * @export
 * @interface DefaultApiGetUsersRequest
 */
export interface DefaultApiGetUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUsers
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetUsers
     */
    readonly email?: string
}

/**
 * Request parameters for getZeusOrganizationIdentityVerificationsForPresident operation in DefaultApi.
 * @export
 * @interface DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest
 */
export interface DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest {
    /**
     * 組織ID
     * @type {string}
     * @memberof DefaultApiGetZeusOrganizationIdentityVerificationsForPresident
     */
    readonly organizationId: string
}

/**
 * Request parameters for getZeusOrganizations operation in DefaultApi.
 * @export
 * @interface DefaultApiGetZeusOrganizationsRequest
 */
export interface DefaultApiGetZeusOrganizationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly key?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly offset?: number

    /**
     * 
     * @type {'ASC' | 'DESC'}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly sort?: 'ASC' | 'DESC'

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly connectedMoneytree?: boolean

    /**
     * 
     * @type {'UPSIDER' | 'PRESIDENT_CARD'}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly brandType?: 'UPSIDER' | 'PRESIDENT_CARD'

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiGetZeusOrganizations
     */
    readonly isSuspended?: boolean
}

/**
 * Request parameters for givePointsToOrganizations operation in DefaultApi.
 * @export
 * @interface DefaultApiGivePointsToOrganizationsRequest
 */
export interface DefaultApiGivePointsToOrganizationsRequest {
    /**
     * 
     * @type {GivePointsToOrganizationsRequest}
     * @memberof DefaultApiGivePointsToOrganizations
     */
    readonly givePointsToOrganizationsRequest: GivePointsToOrganizationsRequest
}

/**
 * Request parameters for initiateEtcService operation in DefaultApi.
 * @export
 * @interface DefaultApiInitiateEtcServiceRequest
 */
export interface DefaultApiInitiateEtcServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiInitiateEtcService
     */
    readonly organizationId: string
}

/**
 * Request parameters for introspectChallengeSuccessToken operation in DefaultApi.
 * @export
 * @interface DefaultApiIntrospectChallengeSuccessTokenRequest
 */
export interface DefaultApiIntrospectChallengeSuccessTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiIntrospectChallengeSuccessToken
     */
    readonly userId: string

    /**
     * 
     * @type {IntrospectChallengeSuccessTokenRequest}
     * @memberof DefaultApiIntrospectChallengeSuccessToken
     */
    readonly introspectChallengeSuccessTokenRequest: IntrospectChallengeSuccessTokenRequest
}

/**
 * Request parameters for inviteUserFromUser operation in DefaultApi.
 * @export
 * @interface DefaultApiInviteUserFromUserRequest
 */
export interface DefaultApiInviteUserFromUserRequest {
    /**
     * 
     * @type {InviteUserFromUserRequest}
     * @memberof DefaultApiInviteUserFromUser
     */
    readonly inviteUserFromUserRequest: InviteUserFromUserRequest

    /**
     * sudo-mode challenge 検証成功時に発行される token
     * @type {string}
     * @memberof DefaultApiInviteUserFromUser
     */
    readonly xChallengeSuccessToken?: string
}

/**
 * Request parameters for issueChallenge operation in DefaultApi.
 * @export
 * @interface DefaultApiIssueChallengeRequest
 */
export interface DefaultApiIssueChallengeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiIssueChallenge
     */
    readonly userId: string

    /**
     * 
     * @type {IssueChallengeRequest}
     * @memberof DefaultApiIssueChallenge
     */
    readonly issueChallengeRequest: IssueChallengeRequest
}

/**
 * Request parameters for linkingPurchaseToTransaction operation in DefaultApi.
 * @export
 * @interface DefaultApiLinkingPurchaseToTransactionRequest
 */
export interface DefaultApiLinkingPurchaseToTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiLinkingPurchaseToTransaction
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLinkingPurchaseToTransaction
     */
    readonly purchaseApplicationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLinkingPurchaseToTransaction
     */
    readonly visaTransactionReferenceId?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLinkingPurchaseToTransaction
     */
    readonly userAccountId?: string
}

/**
 * Request parameters for lockCardForPotentialFraud operation in DefaultApi.
 * @export
 * @interface DefaultApiLockCardForPotentialFraudRequest
 */
export interface DefaultApiLockCardForPotentialFraudRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiLockCardForPotentialFraud
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLockCardForPotentialFraud
     */
    readonly cardId: string

    /**
     * 
     * @type {LockCardForPotentialFraudRequest}
     * @memberof DefaultApiLockCardForPotentialFraud
     */
    readonly lockCardForPotentialFraudRequest: LockCardForPotentialFraudRequest
}

/**
 * Request parameters for lockCardOnFraudDetected operation in DefaultApi.
 * @export
 * @interface DefaultApiLockCardOnFraudDetectedRequest
 */
export interface DefaultApiLockCardOnFraudDetectedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiLockCardOnFraudDetected
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiLockCardOnFraudDetected
     */
    readonly cardId: string

    /**
     * 
     * @type {LockCardOnFraudDetectedRequest}
     * @memberof DefaultApiLockCardOnFraudDetected
     */
    readonly lockCardOnFraudDetectedRequest: LockCardOnFraudDetectedRequest
}

/**
 * Request parameters for login operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginRequest
 */
export interface DefaultApiLoginRequest {
    /**
     * 
     * @type {LoginRequest}
     * @memberof DefaultApiLogin
     */
    readonly loginRequest: LoginRequest
}

/**
 * Request parameters for loginApp operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginAppRequest
 */
export interface DefaultApiLoginAppRequest {
    /**
     * 
     * @type {LoginAppRequest}
     * @memberof DefaultApiLoginApp
     */
    readonly loginAppRequest: LoginAppRequest
}

/**
 * Request parameters for loginRecoveryCode operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginRecoveryCodeRequest
 */
export interface DefaultApiLoginRecoveryCodeRequest {
    /**
     * 
     * @type {LoginRecoveryCodeRequest}
     * @memberof DefaultApiLoginRecoveryCode
     */
    readonly loginRecoveryCodeRequest: LoginRecoveryCodeRequest
}

/**
 * Request parameters for loginSms operation in DefaultApi.
 * @export
 * @interface DefaultApiLoginSmsRequest
 */
export interface DefaultApiLoginSmsRequest {
    /**
     * 
     * @type {LoginSmsRequest}
     * @memberof DefaultApiLoginSms
     */
    readonly loginSmsRequest: LoginSmsRequest
}

/**
 * Request parameters for moveSlackNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiMoveSlackNotificationSettingForCardRequest
 */
export interface DefaultApiMoveSlackNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiMoveSlackNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiMoveSlackNotificationSettingForCard
     */
    readonly currentChannelId: string

    /**
     * 
     * @type {MoveSlackNotificationSettingForCardRequest}
     * @memberof DefaultApiMoveSlackNotificationSettingForCard
     */
    readonly moveSlackNotificationSettingForCardRequest: MoveSlackNotificationSettingForCardRequest
}

/**
 * Request parameters for moveTeamsNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiMoveTeamsNotificationSettingForCardRequest
 */
export interface DefaultApiMoveTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiMoveTeamsNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiMoveTeamsNotificationSettingForCard
     */
    readonly currentChannelId: string

    /**
     * 
     * @type {MoveTeamsNotificationSettingForCardRequest}
     * @memberof DefaultApiMoveTeamsNotificationSettingForCard
     */
    readonly moveTeamsNotificationSettingForCardRequest: MoveTeamsNotificationSettingForCardRequest
}

/**
 * Request parameters for organizationCreatePreRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiOrganizationCreatePreRequestRequest
 */
export interface DefaultApiOrganizationCreatePreRequestRequest {
    /**
     * 
     * @type {OrganizationCreatePreRequestRequest}
     * @memberof DefaultApiOrganizationCreatePreRequest
     */
    readonly organizationCreatePreRequestRequest: OrganizationCreatePreRequestRequest
}

/**
 * Request parameters for parseOrganizationChartForWorkflow operation in DefaultApi.
 * @export
 * @interface DefaultApiParseOrganizationChartForWorkflowRequest
 */
export interface DefaultApiParseOrganizationChartForWorkflowRequest {
    /**
     * 
     * @type {File}
     * @memberof DefaultApiParseOrganizationChartForWorkflow
     */
    readonly file: File
}

/**
 * Request parameters for postAdditionMerchantGeneralBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiPostAdditionMerchantGeneralBlockListRequest
 */
export interface DefaultApiPostAdditionMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {PostAdditionMerchantGeneralBlockListRequest}
     * @memberof DefaultApiPostAdditionMerchantGeneralBlockList
     */
    readonly postAdditionMerchantGeneralBlockListRequest: PostAdditionMerchantGeneralBlockListRequest
}

/**
 * Request parameters for postAlliancesGcpApplications operation in DefaultApi.
 * @export
 * @interface DefaultApiPostAlliancesGcpApplicationsRequest
 */
export interface DefaultApiPostAlliancesGcpApplicationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostAlliancesGcpApplications
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostAlliancesGcpApplicationsRequest}
     * @memberof DefaultApiPostAlliancesGcpApplications
     */
    readonly postAlliancesGcpApplicationsRequest: PostAlliancesGcpApplicationsRequest
}

/**
 * Request parameters for postAlliancesGwsApplications operation in DefaultApi.
 * @export
 * @interface DefaultApiPostAlliancesGwsApplicationsRequest
 */
export interface DefaultApiPostAlliancesGwsApplicationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostAlliancesGwsApplications
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostAlliancesGwsApplicationsRequest}
     * @memberof DefaultApiPostAlliancesGwsApplications
     */
    readonly postAlliancesGwsApplicationsRequest: PostAlliancesGwsApplicationsRequest
}

/**
 * Request parameters for postBalances operation in DefaultApi.
 * @export
 * @interface DefaultApiPostBalancesRequest
 */
export interface DefaultApiPostBalancesRequest {
    /**
     * 
     * @type {PostBalancesRequest}
     * @memberof DefaultApiPostBalances
     */
    readonly postBalancesRequest: PostBalancesRequest
}

/**
 * Request parameters for postBulkAdditionMerchantOrgBlockLists operation in DefaultApi.
 * @export
 * @interface DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest
 */
export interface DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostBulkAdditionMerchantOrgBlockLists
     */
    readonly organizationId: string

    /**
     * 
     * @type {Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>}
     * @memberof DefaultApiPostBulkAdditionMerchantOrgBlockLists
     */
    readonly postBulkAdditionMerchantOrgBlockListsRequestInner: Array<PostBulkAdditionMerchantOrgBlockListsRequestInner>
}

/**
 * Request parameters for postCallbackFreeeAuthForAccounting operation in DefaultApi.
 * @export
 * @interface DefaultApiPostCallbackFreeeAuthForAccountingRequest
 */
export interface DefaultApiPostCallbackFreeeAuthForAccountingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostCallbackFreeeAuthForAccounting
     */
    readonly orgAccountId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiPostCallbackFreeeAuthForAccounting
     */
    readonly upsidrPrivateClientApiInternal?: boolean

    /**
     * 
     * @type {PostCallbackFreeeAuthForAccountingRequest}
     * @memberof DefaultApiPostCallbackFreeeAuthForAccounting
     */
    readonly postCallbackFreeeAuthForAccountingRequest?: PostCallbackFreeeAuthForAccountingRequest
}

/**
 * Request parameters for postCancelRequestForEvidenceRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiPostCancelRequestForEvidenceRequestRequest
 */
export interface DefaultApiPostCancelRequestForEvidenceRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostCancelRequestForEvidenceRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostCancelRequestForEvidenceRequest
     */
    readonly paymentReferenceId: string
}

/**
 * Request parameters for postCardsVirtualIssue operation in DefaultApi.
 * @export
 * @interface DefaultApiPostCardsVirtualIssueRequest
 */
export interface DefaultApiPostCardsVirtualIssueRequest {
    /**
     * 
     * @type {PostCardsVirtualIssueRequest}
     * @memberof DefaultApiPostCardsVirtualIssue
     */
    readonly postCardsVirtualIssueRequest: PostCardsVirtualIssueRequest
}

/**
 * Request parameters for postFaceToFaceKycIdentityDocument operation in DefaultApi.
 * @export
 * @interface DefaultApiPostFaceToFaceKycIdentityDocumentRequest
 */
export interface DefaultApiPostFaceToFaceKycIdentityDocumentRequest {
    /**
     * Onboarding request ID
     * @type {string}
     * @memberof DefaultApiPostFaceToFaceKycIdentityDocument
     */
    readonly onboardingRequestId: string

    /**
     * Identity document file
     * @type {File}
     * @memberof DefaultApiPostFaceToFaceKycIdentityDocument
     */
    readonly file: File

    /**
     * Type of personal identification document
     * @type {string}
     * @memberof DefaultApiPostFaceToFaceKycIdentityDocument
     */
    readonly personalDocumentType?: string

    /**
     * Name of the person who verified the document
     * @type {string}
     * @memberof DefaultApiPostFaceToFaceKycIdentityDocument
     */
    readonly verifiedBy?: string
}

/**
 * Request parameters for postFaceToFaceKycRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiPostFaceToFaceKycRequestRequest
 */
export interface DefaultApiPostFaceToFaceKycRequestRequest {
    /**
     * 
     * @type {PostFaceToFaceKycRequestRequest}
     * @memberof DefaultApiPostFaceToFaceKycRequest
     */
    readonly postFaceToFaceKycRequestRequest: PostFaceToFaceKycRequestRequest
}

/**
 * Request parameters for postFreeeAccountForPoints operation in DefaultApi.
 * @export
 * @interface DefaultApiPostFreeeAccountForPointsRequest
 */
export interface DefaultApiPostFreeeAccountForPointsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostFreeeAccountForPoints
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostFreeeAccountForPointsRequest}
     * @memberof DefaultApiPostFreeeAccountForPoints
     */
    readonly postFreeeAccountForPointsRequest: PostFreeeAccountForPointsRequest
}

/**
 * Request parameters for postKycconsultingWebhooks operation in DefaultApi.
 * @export
 * @interface DefaultApiPostKycconsultingWebhooksRequest
 */
export interface DefaultApiPostKycconsultingWebhooksRequest {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DefaultApiPostKycconsultingWebhooks
     */
    readonly requestBody: { [key: string]: string; }
}

/**
 * Request parameters for postMoneytreeRefreshRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiPostMoneytreeRefreshRequestRequest
 */
export interface DefaultApiPostMoneytreeRefreshRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostMoneytreeRefreshRequest
     */
    readonly organizationId: string
}

/**
 * Request parameters for postOrganizationsDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiPostOrganizationsDealsRequest
 */
export interface DefaultApiPostOrganizationsDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostOrganizationsDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostOrganizationsDealsRequest}
     * @memberof DefaultApiPostOrganizationsDeals
     */
    readonly postOrganizationsDealsRequest: PostOrganizationsDealsRequest
}

/**
 * Request parameters for postOrganizationsPointClawBacks operation in DefaultApi.
 * @export
 * @interface DefaultApiPostOrganizationsPointClawBacksRequest
 */
export interface DefaultApiPostOrganizationsPointClawBacksRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostOrganizationsPointClawBacks
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostOrganizationsPointClawBacksRequest}
     * @memberof DefaultApiPostOrganizationsPointClawBacks
     */
    readonly postOrganizationsPointClawBacksRequest: PostOrganizationsPointClawBacksRequest
}

/**
 * Request parameters for postPaymentRequestsBankAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiPostPaymentRequestsBankAccountRequest
 */
export interface DefaultApiPostPaymentRequestsBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostPaymentRequestsBankAccount
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostPaymentRequestsBankAccountRequest}
     * @memberof DefaultApiPostPaymentRequestsBankAccount
     */
    readonly postPaymentRequestsBankAccountRequest?: PostPaymentRequestsBankAccountRequest
}

/**
 * Request parameters for postSlackMessageToCoworker operation in DefaultApi.
 * @export
 * @interface DefaultApiPostSlackMessageToCoworkerRequest
 */
export interface DefaultApiPostSlackMessageToCoworkerRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPostSlackMessageToCoworker
     */
    readonly organizationId: string

    /**
     * 
     * @type {PostSlackMessageToCoworkerRequest}
     * @memberof DefaultApiPostSlackMessageToCoworker
     */
    readonly postSlackMessageToCoworkerRequest: PostSlackMessageToCoworkerRequest
}

/**
 * Request parameters for postTransactions operation in DefaultApi.
 * @export
 * @interface DefaultApiPostTransactionsRequest
 */
export interface DefaultApiPostTransactionsRequest {
    /**
     * 
     * @type {PostTransactionsRequest}
     * @memberof DefaultApiPostTransactions
     */
    readonly postTransactionsRequest: PostTransactionsRequest
}

/**
 * Request parameters for postTrustdockWebhooks operation in DefaultApi.
 * @export
 * @interface DefaultApiPostTrustdockWebhooksRequest
 */
export interface DefaultApiPostTrustdockWebhooksRequest {
    /**
     * 
     * @type {PostTrustdockWebhooksRequest}
     * @memberof DefaultApiPostTrustdockWebhooks
     */
    readonly postTrustdockWebhooksRequest: PostTrustdockWebhooksRequest
}

/**
 * Request parameters for postTrustdockWebhooksSnailMail operation in DefaultApi.
 * @export
 * @interface DefaultApiPostTrustdockWebhooksSnailMailRequest
 */
export interface DefaultApiPostTrustdockWebhooksSnailMailRequest {
    /**
     * 
     * @type {PostTrustdockWebhooksSnailMailRequest}
     * @memberof DefaultApiPostTrustdockWebhooksSnailMail
     */
    readonly postTrustdockWebhooksSnailMailRequest: PostTrustdockWebhooksSnailMailRequest
}

/**
 * Request parameters for putDisableFeatureFlag operation in DefaultApi.
 * @export
 * @interface DefaultApiPutDisableFeatureFlagRequest
 */
export interface DefaultApiPutDisableFeatureFlagRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutDisableFeatureFlag
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutDisableFeatureFlag
     */
    readonly featureName: string
}

/**
 * Request parameters for putEnabledFeatureFlag operation in DefaultApi.
 * @export
 * @interface DefaultApiPutEnabledFeatureFlagRequest
 */
export interface DefaultApiPutEnabledFeatureFlagRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutEnabledFeatureFlag
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutEnabledFeatureFlag
     */
    readonly featureName: string
}

/**
 * Request parameters for putFreeeEndJournalEntryTransitionMode operation in DefaultApi.
 * @export
 * @interface DefaultApiPutFreeeEndJournalEntryTransitionModeRequest
 */
export interface DefaultApiPutFreeeEndJournalEntryTransitionModeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutFreeeEndJournalEntryTransitionMode
     */
    readonly organizationId: string

    /**
     * 
     * @type {PutFreeeEndJournalEntryTransitionModeRequest}
     * @memberof DefaultApiPutFreeeEndJournalEntryTransitionMode
     */
    readonly putFreeeEndJournalEntryTransitionModeRequest: PutFreeeEndJournalEntryTransitionModeRequest
}

/**
 * Request parameters for putOrganizationPaymentMethod operation in DefaultApi.
 * @export
 * @interface DefaultApiPutOrganizationPaymentMethodRequest
 */
export interface DefaultApiPutOrganizationPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutOrganizationPaymentMethod
     */
    readonly organizationId: string

    /**
     * 
     * @type {PutOrganizationPaymentMethodRequest}
     * @memberof DefaultApiPutOrganizationPaymentMethod
     */
    readonly putOrganizationPaymentMethodRequest: PutOrganizationPaymentMethodRequest
}

/**
 * Request parameters for putOrganizationsDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiPutOrganizationsDealsRequest
 */
export interface DefaultApiPutOrganizationsDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutOrganizationsDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {PutOrganizationsDealsRequest}
     * @memberof DefaultApiPutOrganizationsDeals
     */
    readonly putOrganizationsDealsRequest: PutOrganizationsDealsRequest
}

/**
 * Request parameters for putPaymentRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiPutPaymentRequestRequest
 */
export interface DefaultApiPutPaymentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutPaymentRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutPaymentRequest
     */
    readonly paymentRequestId?: string

    /**
     * 
     * @type {PutPaymentRequestRequest}
     * @memberof DefaultApiPutPaymentRequest
     */
    readonly putPaymentRequestRequest?: PutPaymentRequestRequest
}

/**
 * Request parameters for putPaymentRequestsBankAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiPutPaymentRequestsBankAccountRequest
 */
export interface DefaultApiPutPaymentRequestsBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutPaymentRequestsBankAccount
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutPaymentRequestsBankAccount
     */
    readonly bankAccountId: string

    /**
     * 
     * @type {PutPaymentRequestsBankAccountRequest}
     * @memberof DefaultApiPutPaymentRequestsBankAccount
     */
    readonly putPaymentRequestsBankAccountRequest?: PutPaymentRequestsBankAccountRequest
}

/**
 * Request parameters for putTransactionEvidenceEmailsLinkToTransaction operation in DefaultApi.
 * @export
 * @interface DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest
 */
export interface DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest {
    /**
     * 
     * @type {PutTransactionEvidenceEmailsLinkToTransactionRequest}
     * @memberof DefaultApiPutTransactionEvidenceEmailsLinkToTransaction
     */
    readonly putTransactionEvidenceEmailsLinkToTransactionRequest: PutTransactionEvidenceEmailsLinkToTransactionRequest
}

/**
 * Request parameters for putTransactionEvidenceEmailsMarkAsRead operation in DefaultApi.
 * @export
 * @interface DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest
 */
export interface DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest {
    /**
     * 
     * @type {PutTransactionEvidenceEmailsMarkAsReadRequest}
     * @memberof DefaultApiPutTransactionEvidenceEmailsMarkAsRead
     */
    readonly putTransactionEvidenceEmailsMarkAsReadRequest: PutTransactionEvidenceEmailsMarkAsReadRequest
}

/**
 * Request parameters for putTransactionEvidenceEmailsMoveToTrash operation in DefaultApi.
 * @export
 * @interface DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest
 */
export interface DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest {
    /**
     * 
     * @type {PutTransactionEvidenceEmailsMoveToTrashRequest}
     * @memberof DefaultApiPutTransactionEvidenceEmailsMoveToTrash
     */
    readonly putTransactionEvidenceEmailsMoveToTrashRequest: PutTransactionEvidenceEmailsMoveToTrashRequest
}

/**
 * Request parameters for putZeusGiveRewardPoints operation in DefaultApi.
 * @export
 * @interface DefaultApiPutZeusGiveRewardPointsRequest
 */
export interface DefaultApiPutZeusGiveRewardPointsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutZeusGiveRewardPoints
     */
    readonly organizationId: string

    /**
     * 
     * @type {PutZeusGiveRewardPointsRequest}
     * @memberof DefaultApiPutZeusGiveRewardPoints
     */
    readonly putZeusGiveRewardPointsRequest: PutZeusGiveRewardPointsRequest
}

/**
 * Request parameters for queryByIdsPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiQueryByIdsPaymentRequestsRequest
 */
export interface DefaultApiQueryByIdsPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiQueryByIdsPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {QueryByIdsPaymentRequestsRequest}
     * @memberof DefaultApiQueryByIdsPaymentRequests
     */
    readonly queryByIdsPaymentRequestsRequest?: QueryByIdsPaymentRequestsRequest
}

/**
 * Request parameters for readUserMessage operation in DefaultApi.
 * @export
 * @interface DefaultApiReadUserMessageRequest
 */
export interface DefaultApiReadUserMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiReadUserMessage
     */
    readonly userMessageId: string
}

/**
 * Request parameters for registerNote operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterNoteRequest
 */
export interface DefaultApiRegisterNoteRequest {
    /**
     * The ID of the onboarding request to retrieve
     * @type {string}
     * @memberof DefaultApiRegisterNote
     */
    readonly onboardingRequestId: string

    /**
     * 
     * @type {RegisterNoteRequest}
     * @memberof DefaultApiRegisterNote
     */
    readonly registerNoteRequest?: RegisterNoteRequest
}

/**
 * Request parameters for registerNoteForOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest
 */
export interface DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRegisterNoteForOrganizationIdentityVerification
     */
    readonly organizationIdentityVerificationId: number

    /**
     * 
     * @type {RegisterNoteForOrganizationIdentityVerificationRequest}
     * @memberof DefaultApiRegisterNoteForOrganizationIdentityVerification
     */
    readonly registerNoteForOrganizationIdentityVerificationRequest: RegisterNoteForOrganizationIdentityVerificationRequest
}

/**
 * Request parameters for registerOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterOrganizationRequest
 */
export interface DefaultApiRegisterOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRegisterOrganization
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for registerOrganizationChartForWorkflow operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterOrganizationChartForWorkflowRequest
 */
export interface DefaultApiRegisterOrganizationChartForWorkflowRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRegisterOrganizationChartForWorkflow
     */
    readonly organizationId: string

    /**
     * 
     * @type {RegisterOrganizationChartForWorkflowRequest}
     * @memberof DefaultApiRegisterOrganizationChartForWorkflow
     */
    readonly registerOrganizationChartForWorkflowRequest?: RegisterOrganizationChartForWorkflowRequest
}

/**
 * Request parameters for registerTfaAppVerificationCode operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterTfaAppVerificationCodeRequest
 */
export interface DefaultApiRegisterTfaAppVerificationCodeRequest {
    /**
     * 
     * @type {RegisterTfaAppVerificationCodeRequest}
     * @memberof DefaultApiRegisterTfaAppVerificationCode
     */
    readonly registerTfaAppVerificationCodeRequest: RegisterTfaAppVerificationCodeRequest
}

/**
 * Request parameters for registerTfaSmsAuth operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterTfaSmsAuthRequest
 */
export interface DefaultApiRegisterTfaSmsAuthRequest {
    /**
     * 
     * @type {RegisterTfaSmsAuthRequest}
     * @memberof DefaultApiRegisterTfaSmsAuth
     */
    readonly registerTfaSmsAuthRequest: RegisterTfaSmsAuthRequest
}

/**
 * Request parameters for registerTransactionEvidenceEmailAddress operation in DefaultApi.
 * @export
 * @interface DefaultApiRegisterTransactionEvidenceEmailAddressRequest
 */
export interface DefaultApiRegisterTransactionEvidenceEmailAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRegisterTransactionEvidenceEmailAddress
     */
    readonly userAccountId: string
}

/**
 * Request parameters for reissueCard operation in DefaultApi.
 * @export
 * @interface DefaultApiReissueCardRequest
 */
export interface DefaultApiReissueCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiReissueCard
     */
    readonly cardId: string

    /**
     * 
     * @type {ReissueCardRequest}
     * @memberof DefaultApiReissueCard
     */
    readonly reissueCardRequest: ReissueCardRequest
}

/**
 * Request parameters for rejectOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiRejectOrganizationIdentityVerificationRequest
 */
export interface DefaultApiRejectOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRejectOrganizationIdentityVerification
     */
    readonly organizationIdentityVerificationId: number
}

/**
 * Request parameters for rejectPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiRejectPurchaseApplicationRequest
 */
export interface DefaultApiRejectPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRejectPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiRejectPurchaseApplication
     */
    readonly purchaseApplicationId: string

    /**
     * 
     * @type {RejectPurchaseApplicationRequest}
     * @memberof DefaultApiRejectPurchaseApplication
     */
    readonly rejectPurchaseApplicationRequest: RejectPurchaseApplicationRequest
}

/**
 * Request parameters for remindOrganizationMonthlyPaymentNotification operation in DefaultApi.
 * @export
 * @interface DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest
 */
export interface DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRemindOrganizationMonthlyPaymentNotification
     */
    readonly organizationId: string
}

/**
 * Request parameters for removeFraudLockStatus operation in DefaultApi.
 * @export
 * @interface DefaultApiRemoveFraudLockStatusRequest
 */
export interface DefaultApiRemoveFraudLockStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRemoveFraudLockStatus
     */
    readonly cardId: string
}

/**
 * Request parameters for renameUserAccountGroup operation in DefaultApi.
 * @export
 * @interface DefaultApiRenameUserAccountGroupRequest
 */
export interface DefaultApiRenameUserAccountGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiRenameUserAccountGroup
     */
    readonly userAccountGroupId: number

    /**
     * 
     * @type {RenameUserAccountGroupRequest}
     * @memberof DefaultApiRenameUserAccountGroup
     */
    readonly renameUserAccountGroupRequest: RenameUserAccountGroupRequest
}

/**
 * Request parameters for replaceVirtualCard operation in DefaultApi.
 * @export
 * @interface DefaultApiReplaceVirtualCardRequest
 */
export interface DefaultApiReplaceVirtualCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiReplaceVirtualCard
     */
    readonly userAccountId: string

    /**
     * 
     * @type {ReplaceVirtualCardRequest}
     * @memberof DefaultApiReplaceVirtualCard
     */
    readonly replaceVirtualCardRequest: ReplaceVirtualCardRequest
}

/**
 * Request parameters for requestAddSystemAdminRole operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestAddSystemAdminRoleRequest
 */
export interface DefaultApiRequestAddSystemAdminRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestAddSystemAdminRole
     */
    readonly userId: string

    /**
     * 
     * @type {RequestAddSystemAdminRoleRequest}
     * @memberof DefaultApiRequestAddSystemAdminRole
     */
    readonly requestAddSystemAdminRoleRequest: RequestAddSystemAdminRoleRequest
}

/**
 * Request parameters for requestSending operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestSendingRequest
 */
export interface DefaultApiRequestSendingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestSending
     */
    readonly organizationId: string

    /**
     * 
     * @type {RequestSendingRequest}
     * @memberof DefaultApiRequestSending
     */
    readonly requestSendingRequest: RequestSendingRequest
}

/**
 * Request parameters for requestSendingMetalCard operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestSendingMetalCardRequest
 */
export interface DefaultApiRequestSendingMetalCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestSendingMetalCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {RequestSendingMetalCardRequest}
     * @memberof DefaultApiRequestSendingMetalCard
     */
    readonly requestSendingMetalCardRequest: RequestSendingMetalCardRequest
}

/**
 * Request parameters for requestSyncBankTransactionsToFreeeForAccounting operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest
 */
export interface DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestSyncBankTransactionsToFreeeForAccounting
     */
    readonly orgAccountId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiRequestSyncBankTransactionsToFreeeForAccounting
     */
    readonly upsidrPrivateClientApiInternal?: boolean

    /**
     * 
     * @type {RequestSyncBankTransactionsToFreeeForAccountingRequest}
     * @memberof DefaultApiRequestSyncBankTransactionsToFreeeForAccounting
     */
    readonly requestSyncBankTransactionsToFreeeForAccountingRequest?: RequestSyncBankTransactionsToFreeeForAccountingRequest
}

/**
 * Request parameters for requestSyncCardTransactionsToFreeeForAccounting operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest
 */
export interface DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestSyncCardTransactionsToFreeeForAccounting
     */
    readonly orgAccountId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiRequestSyncCardTransactionsToFreeeForAccounting
     */
    readonly upsidrPrivateClientApiInternal?: boolean

    /**
     * 
     * @type {RequestSyncCardTransactionsToFreeeForAccountingRequest}
     * @memberof DefaultApiRequestSyncCardTransactionsToFreeeForAccounting
     */
    readonly requestSyncCardTransactionsToFreeeForAccountingRequest?: RequestSyncCardTransactionsToFreeeForAccountingRequest
}

/**
 * Request parameters for requestToOrganizationsAccountingCsvInBackground operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest
 */
export interface DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestToOrganizationsAccountingCsvInBackground
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestToOrganizationsAccountingCsvInBackground
     */
    readonly yearMonth: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiRequestToOrganizationsAccountingCsvInBackground
     */
    readonly isMergedFiles: boolean
}

/**
 * Request parameters for requestUpdateSystemAdminRole operation in DefaultApi.
 * @export
 * @interface DefaultApiRequestUpdateSystemAdminRoleRequest
 */
export interface DefaultApiRequestUpdateSystemAdminRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiRequestUpdateSystemAdminRole
     */
    readonly userId: string

    /**
     * 
     * @type {RequestUpdateSystemAdminRoleRequest}
     * @memberof DefaultApiRequestUpdateSystemAdminRole
     */
    readonly requestUpdateSystemAdminRoleRequest: RequestUpdateSystemAdminRoleRequest
}

/**
 * Request parameters for resendSnailMailForOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest
 */
export interface DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiResendSnailMailForOrganizationIdentityVerification
     */
    readonly organizationIdentityVerificationId: number

    /**
     * 
     * @type {ResendSnailMailForOrganizationIdentityVerificationRequest}
     * @memberof DefaultApiResendSnailMailForOrganizationIdentityVerification
     */
    readonly resendSnailMailForOrganizationIdentityVerificationRequest: ResendSnailMailForOrganizationIdentityVerificationRequest
}

/**
 * Request parameters for resendUserInvite operation in DefaultApi.
 * @export
 * @interface DefaultApiResendUserInviteRequest
 */
export interface DefaultApiResendUserInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiResendUserInvite
     */
    readonly userId: string
}

/**
 * Request parameters for resumeCard operation in DefaultApi.
 * @export
 * @interface DefaultApiResumeCardRequest
 */
export interface DefaultApiResumeCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiResumeCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiResumeCard
     */
    readonly cardId: string
}

/**
 * Request parameters for resynchronizeCardTransactionsForFreee operation in DefaultApi.
 * @export
 * @interface DefaultApiResynchronizeCardTransactionsForFreeeRequest
 */
export interface DefaultApiResynchronizeCardTransactionsForFreeeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiResynchronizeCardTransactionsForFreee
     */
    readonly organizationId: string

    /**
     * 
     * @type {ResynchronizeCardTransactionsForFreeeRequest}
     * @memberof DefaultApiResynchronizeCardTransactionsForFreee
     */
    readonly resynchronizeCardTransactionsForFreeeRequest: ResynchronizeCardTransactionsForFreeeRequest
}

/**
 * Request parameters for saveDealAsDraft operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealAsDraftRequest
 */
export interface DefaultApiSaveDealAsDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsDraft
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsDraft
     */
    readonly dealId: string

    /**
     * 
     * @type {SaveDealAsDraftRequest}
     * @memberof DefaultApiSaveDealAsDraft
     */
    readonly saveDealAsDraftRequest: SaveDealAsDraftRequest
}

/**
 * Request parameters for saveDealAsIgnore operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealAsIgnoreRequest
 */
export interface DefaultApiSaveDealAsIgnoreRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsIgnore
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsIgnore
     */
    readonly dealId: string
}

/**
 * Request parameters for saveDealAsReturnToEditing operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealAsReturnToEditingRequest
 */
export interface DefaultApiSaveDealAsReturnToEditingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealAsReturnToEditing
     */
    readonly organizationId: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSaveDealAsReturnToEditing
     */
    readonly dealId: number
}

/**
 * Request parameters for saveDealWithJournalizing operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealWithJournalizingRequest
 */
export interface DefaultApiSaveDealWithJournalizingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealWithJournalizing
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealWithJournalizing
     */
    readonly dealId: string

    /**
     * 
     * @type {SaveDealWithJournalizingRequest}
     * @memberof DefaultApiSaveDealWithJournalizing
     */
    readonly saveDealWithJournalizingRequest: SaveDealWithJournalizingRequest
}

/**
 * Request parameters for saveDealsAsIgnore operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealsAsIgnoreRequest
 */
export interface DefaultApiSaveDealsAsIgnoreRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealsAsIgnore
     */
    readonly organizationId: string

    /**
     * 
     * @type {SaveDealsAsIgnoreRequest}
     * @memberof DefaultApiSaveDealsAsIgnore
     */
    readonly saveDealsAsIgnoreRequest: SaveDealsAsIgnoreRequest
}

/**
 * Request parameters for saveDealsAsJournalized operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealsAsJournalizedRequest
 */
export interface DefaultApiSaveDealsAsJournalizedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSaveDealsAsJournalized
     */
    readonly organizationId: string

    /**
     * 
     * @type {SaveDealsAsJournalizedRequest}
     * @memberof DefaultApiSaveDealsAsJournalized
     */
    readonly saveDealsAsJournalizedRequest: SaveDealsAsJournalizedRequest
}

/**
 * Request parameters for saveDealsAsReturnToEditing operation in DefaultApi.
 * @export
 * @interface DefaultApiSaveDealsAsReturnToEditingRequest
 */
export interface DefaultApiSaveDealsAsReturnToEditingRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultApiSaveDealsAsReturnToEditing
     */
    readonly organizationId: number

    /**
     * 
     * @type {SaveDealsAsReturnToEditingRequest}
     * @memberof DefaultApiSaveDealsAsReturnToEditing
     */
    readonly saveDealsAsReturnToEditingRequest: SaveDealsAsReturnToEditingRequest
}

/**
 * Request parameters for searchBankTransfers operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchBankTransfersRequest
 */
export interface DefaultApiSearchBankTransfersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred after this date.
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly transferDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the bank transfers to be returned to only those which are scheduled to be transferred before this date. Both transferDateJstFrom and transferDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly transferDateJstTo?: string

    /**
     * Filter the bank transfers by the specified source bank account id.
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly sourceBankAccountId?: string

    /**
     * Filter the bank transfers by whether the corresponding transfer data has been downloaded.
     * @type {boolean}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly downloaded?: boolean

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiSearchBankTransfers
     */
    readonly cursor?: string
}

/**
 * Request parameters for searchCorporationsInNationalTaxAgency operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchCorporationsInNationalTaxAgencyRequest
 */
export interface DefaultApiSearchCorporationsInNationalTaxAgencyRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchCorporationsInNationalTaxAgency
     */
    readonly name?: string

    /**
     * 
     * @type {'PREFIX_MATCH' | 'PARTIAL_MATCH' | ''}
     * @memberof DefaultApiSearchCorporationsInNationalTaxAgency
     */
    readonly searchMethod?: 'PREFIX_MATCH' | 'PARTIAL_MATCH' | ''
}

/**
 * Request parameters for searchDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchDealsRequest
 */
export interface DefaultApiSearchDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {SearchDealsRequest}
     * @memberof DefaultApiSearchDeals
     */
    readonly searchDealsRequest?: SearchDealsRequest
}

/**
 * Request parameters for searchEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchEvidencesRequest
 */
export interface DefaultApiSearchEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly organizationId: string

    /**
     * This parameter will be deleted soon. Use keyword instead. If you specify this parameter, it will behave like the keyword, that is, it is searched from note as well as issuer.
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly issuer?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchEvidences
     */
    readonly amountMin?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchEvidences
     */
    readonly amountMax?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly paidAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly paidAtTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiSearchEvidences
     */
    readonly irrelevantToLedger?: boolean

    /**
     * Specified keyword is searched from the issuer and the note by partial match.
     * @type {string}
     * @memberof DefaultApiSearchEvidences
     */
    readonly keyword?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiSearchEvidences
     */
    readonly includesDeleted?: boolean

    /**
     * 
     * @type {Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>}
     * @memberof DefaultApiSearchEvidences
     */
    readonly legalValidities?: Array<'VALID' | 'INVALID' | 'INPUT_REQUIRED' | 'OUT_OF_TARGET'>

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchEvidences
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchEvidences
     */
    readonly offset?: number
}

/**
 * Request parameters for searchMyPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchMyPaymentRequestsRequest
 */
export interface DefaultApiSearchMyPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly dueDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly dueDateJstTo?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly requestedDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly requestedDateJstTo?: string

    /**
     * Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
     * @type {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>

    /**
     * Filter the payment requests by the specified supplier id.
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly supplierId?: string

    /**
     * Filter the payment requests by whether the corresponding transaction data has been created.
     * @type {boolean}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly transferDataCreated?: boolean

    /**
     * Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
     * @type {boolean}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly withholdingApplied?: boolean

    /**
     * Filter the payment requests by the specified transfer fee responsibility.
     * @type {'SELF' | 'SUPPLIER'}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly transferFeeResponsibility?: 'SELF' | 'SUPPLIER'

    /**
     * A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly freeWord?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiSearchMyPaymentRequests
     */
    readonly cursor?: string
}

/**
 * Request parameters for searchOrganizations operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchOrganizationsRequest
 */
export interface DefaultApiSearchOrganizationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchOrganizations
     */
    readonly key: string
}

/**
 * Request parameters for searchPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiSearchPaymentRequestsRequest
 */
export interface DefaultApiSearchPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly organizationId: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date after this date.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly dueDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a due date before this date. Both dueDateJstFrom and dueDateJstTo are inclusive (closed interval).
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly dueDateJstTo?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at after this date.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly requestedDateJstFrom?: string

    /**
     * yyyy-MM-dd format date in JST. Filter the payment requests to be returned to only those which have a requested at before this date.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly requestedDateJstTo?: string

    /**
     * Filter the payment requests by the specified statuses. This parameter accepts both the following two forms:  - [comma separated style] /payment_requests?statuses&#x3D;PAYABLE,ATTACHED_TO_BANK_TRANSFER  - [exploded style]        /payment_requests?statuses&#x3D;PAYABLE&amp;statuses&#x3D;ATTACHED_TO_BANK_TRANSFER
     * @type {Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly statuses?: Array<'PENDING_WORKFLOW_COMPLETION' | 'CANCELED' | 'PAYABLE' | 'ATTACHED_TO_BANK_TRANSFER' | 'DEACTIVATED'>

    /**
     * Filter the payment requests by the specified supplier id.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly supplierId?: string

    /**
     * Filter the payment requests by whether the corresponding transaction data has been created.
     * @type {boolean}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly transferDataCreated?: boolean

    /**
     * Filter the payment requests by whether the withholding tax has been applied. true means the withholdingCalculatingMethod is NONE, while false, except for NONE.
     * @type {boolean}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly withholdingApplied?: boolean

    /**
     * Filter the payment requests by the specified transfer fee responsibility.
     * @type {'SELF' | 'SUPPLIER'}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly transferFeeResponsibility?: 'SELF' | 'SUPPLIER'

    /**
     * Filter the payment requests by the specified requestor id.
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly requestorId?: string

    /**
     * A keyword used to search the following fields for partial matches:  - supplier name  - requestor name  - memo  - accounting items  - sections
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly freeWord?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly limit?: number

    /**
     * See the description of &#x60;cursor&#x60; section Pagination
     * @type {number}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly offset?: number

    /**
     * Pagination is performed by specifying either offset or cursor; if neither offset nor cursor is specified, it is assumed to be cursor-pagination and the first page is obtained with the next cursor. See below how the pagination exactly behaves:  - \&quot;\&quot; ... Get the fist page and return the next cursor  - \&quot;offset&#x3D;50\&quot; ... Get from the specified offset and never return the next cursor  - \&quot;cursor&#x3D;xxx\&quot; ... Get from the specified cursor  - \&quot;offset&#x3D;50&amp;cursor&#x3D;xxx\&quot; ... Ignore the offset and get from the specified cursor
     * @type {string}
     * @memberof DefaultApiSearchPaymentRequests
     */
    readonly cursor?: string
}

/**
 * Request parameters for sendBackOnboardingRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiSendBackOnboardingRequestRequest
 */
export interface DefaultApiSendBackOnboardingRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSendBackOnboardingRequest
     */
    readonly onboardingRequestId: string
}

/**
 * Request parameters for sendOrganizationIdentityVerification operation in DefaultApi.
 * @export
 * @interface DefaultApiSendOrganizationIdentityVerificationRequest
 */
export interface DefaultApiSendOrganizationIdentityVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSendOrganizationIdentityVerification
     */
    readonly organizationId: string

    /**
     * 
     * @type {SendOrganizationIdentityVerificationRequest}
     * @memberof DefaultApiSendOrganizationIdentityVerification
     */
    readonly sendOrganizationIdentityVerificationRequest: SendOrganizationIdentityVerificationRequest
}

/**
 * Request parameters for sendTfaResetLinkAsAdmin operation in DefaultApi.
 * @export
 * @interface DefaultApiSendTfaResetLinkAsAdminRequest
 */
export interface DefaultApiSendTfaResetLinkAsAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSendTfaResetLinkAsAdmin
     */
    readonly userId: string
}

/**
 * Request parameters for sendTransactionAuthorizationRequest operation in DefaultApi.
 * @export
 * @interface DefaultApiSendTransactionAuthorizationRequestRequest
 */
export interface DefaultApiSendTransactionAuthorizationRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSendTransactionAuthorizationRequest
     */
    readonly organizationId: string

    /**
     * 
     * @type {SendTransactionAuthorizationRequestRequest}
     * @memberof DefaultApiSendTransactionAuthorizationRequest
     */
    readonly sendTransactionAuthorizationRequestRequest: SendTransactionAuthorizationRequestRequest

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSendTransactionAuthorizationRequest
     */
    readonly cardId?: string
}

/**
 * Request parameters for setAccountingActivation operation in DefaultApi.
 * @export
 * @interface DefaultApiSetAccountingActivationRequest
 */
export interface DefaultApiSetAccountingActivationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSetAccountingActivation
     */
    readonly organizationId: string

    /**
     * 
     * @type {SetAccountingActivationRequest}
     * @memberof DefaultApiSetAccountingActivation
     */
    readonly setAccountingActivationRequest: SetAccountingActivationRequest
}

/**
 * Request parameters for signUpForSlack operation in DefaultApi.
 * @export
 * @interface DefaultApiSignUpForSlackRequest
 */
export interface DefaultApiSignUpForSlackRequest {
    /**
     * 
     * @type {SignUpForSlackRequest}
     * @memberof DefaultApiSignUpForSlack
     */
    readonly signUpForSlackRequest: SignUpForSlackRequest
}

/**
 * Request parameters for submitCompletedWorkflowOfDraftPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest
 */
export interface DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequests
     */
    readonly draftPaymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * 
     * @type {SubmitCompletedWorkflowOfDraftPaymentRequestsRequest}
     * @memberof DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequests
     */
    readonly submitCompletedWorkflowOfDraftPaymentRequestsRequest?: SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
}

/**
 * Request parameters for submitCompletedWorkflowOfPaymentRequests operation in DefaultApi.
 * @export
 * @interface DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest
 */
export interface DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfPaymentRequests
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitCompletedWorkflowOfPaymentRequests
     */
    readonly xUpsidrSwitchUser?: string

    /**
     * 
     * @type {SubmitCompletedWorkflowOfPaymentRequestsRequest}
     * @memberof DefaultApiSubmitCompletedWorkflowOfPaymentRequests
     */
    readonly submitCompletedWorkflowOfPaymentRequestsRequest?: SubmitCompletedWorkflowOfPaymentRequestsRequest
}

/**
 * Request parameters for submitWorkflow operation in DefaultApi.
 * @export
 * @interface DefaultApiSubmitWorkflowRequest
 */
export interface DefaultApiSubmitWorkflowRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitWorkflow
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitWorkflow
     */
    readonly workflowInstanceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSubmitWorkflow
     */
    readonly xUpsidrSwitchUser?: string
}

/**
 * Request parameters for suspendCard operation in DefaultApi.
 * @export
 * @interface DefaultApiSuspendCardRequest
 */
export interface DefaultApiSuspendCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSuspendCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSuspendCard
     */
    readonly cardId: string
}

/**
 * Request parameters for syncFreeeAccountItems operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncFreeeAccountItemsRequest
 */
export interface DefaultApiSyncFreeeAccountItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeeAccountItems
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeeAccountItems
     */
    readonly companyId: string
}

/**
 * Request parameters for syncFreeePartners operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncFreeePartnersRequest
 */
export interface DefaultApiSyncFreeePartnersRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeePartners
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeePartners
     */
    readonly companyId: string
}

/**
 * Request parameters for syncFreeeSegmentTags operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncFreeeSegmentTagsRequest
 */
export interface DefaultApiSyncFreeeSegmentTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeeSegmentTags
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncFreeeSegmentTags
     */
    readonly companyId: string
}

/**
 * Request parameters for syncMoneytreeAccessToken operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncMoneytreeAccessTokenRequest
 */
export interface DefaultApiSyncMoneytreeAccessTokenRequest {
    /**
     * Authorization code received from Moneytree after successful authentication.
     * @type {string}
     * @memberof DefaultApiSyncMoneytreeAccessToken
     */
    readonly code: string

    /**
     * OAuth state parameter to ensure request consistency.
     * @type {string}
     * @memberof DefaultApiSyncMoneytreeAccessToken
     */
    readonly state: string

    /**
     * URL to redirect to after syncing access token.
     * @type {string}
     * @memberof DefaultApiSyncMoneytreeAccessToken
     */
    readonly nextTo?: string
}

/**
 * Request parameters for syncPointUsageToAccountingService operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncPointUsageToAccountingServiceRequest
 */
export interface DefaultApiSyncPointUsageToAccountingServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncPointUsageToAccountingService
     */
    readonly organizationId: string

    /**
     * 
     * @type {SyncPointUsageToAccountingServiceRequest}
     * @memberof DefaultApiSyncPointUsageToAccountingService
     */
    readonly syncPointUsageToAccountingServiceRequest: SyncPointUsageToAccountingServiceRequest
}

/**
 * Request parameters for syncRequestForFreeeDeals operation in DefaultApi.
 * @export
 * @interface DefaultApiSyncRequestForFreeeDealsRequest
 */
export interface DefaultApiSyncRequestForFreeeDealsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncRequestForFreeeDeals
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiSyncRequestForFreeeDeals
     */
    readonly companyId: string

    /**
     * 
     * @type {SyncRequestForFreeeDealsRequest}
     * @memberof DefaultApiSyncRequestForFreeeDeals
     */
    readonly syncRequestForFreeeDealsRequest: SyncRequestForFreeeDealsRequest
}

/**
 * Request parameters for twoFactorAuthResetAsToken operation in DefaultApi.
 * @export
 * @interface DefaultApiTwoFactorAuthResetAsTokenRequest
 */
export interface DefaultApiTwoFactorAuthResetAsTokenRequest {
    /**
     * 
     * @type {TwoFactorAuthResetAsTokenRequest}
     * @memberof DefaultApiTwoFactorAuthResetAsToken
     */
    readonly twoFactorAuthResetAsTokenRequest: TwoFactorAuthResetAsTokenRequest
}

/**
 * Request parameters for unlinkingPurchaseToTransaction operation in DefaultApi.
 * @export
 * @interface DefaultApiUnlinkingPurchaseToTransactionRequest
 */
export interface DefaultApiUnlinkingPurchaseToTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlinkingPurchaseToTransaction
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlinkingPurchaseToTransaction
     */
    readonly purchaseApplicationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlinkingPurchaseToTransaction
     */
    readonly visaTransactionReferenceId?: string
}

/**
 * Request parameters for unlockCardForNotPotentialFraud operation in DefaultApi.
 * @export
 * @interface DefaultApiUnlockCardForNotPotentialFraudRequest
 */
export interface DefaultApiUnlockCardForNotPotentialFraudRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardForNotPotentialFraud
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardForNotPotentialFraud
     */
    readonly cardId: string
}

/**
 * Request parameters for unlockCardOnFraudCleared operation in DefaultApi.
 * @export
 * @interface DefaultApiUnlockCardOnFraudClearedRequest
 */
export interface DefaultApiUnlockCardOnFraudClearedRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardOnFraudCleared
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardOnFraudCleared
     */
    readonly cardId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUnlockCardOnFraudCleared
     */
    readonly triggeredTransactionId: string
}

/**
 * Request parameters for updateAvailableCurrencies operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateAvailableCurrenciesRequest
 */
export interface DefaultApiUpdateAvailableCurrenciesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateAvailableCurrencies
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateAvailableCurrenciesRequest}
     * @memberof DefaultApiUpdateAvailableCurrencies
     */
    readonly updateAvailableCurrenciesRequest: UpdateAvailableCurrenciesRequest
}

/**
 * Request parameters for updateAvailableMerchantCategories operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateAvailableMerchantCategoriesRequest
 */
export interface DefaultApiUpdateAvailableMerchantCategoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateAvailableMerchantCategories
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateAvailableMerchantCategoriesRequest}
     * @memberof DefaultApiUpdateAvailableMerchantCategories
     */
    readonly updateAvailableMerchantCategoriesRequest: UpdateAvailableMerchantCategoriesRequest
}

/**
 * Request parameters for updateCardAccountUnit operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardAccountUnitRequest
 */
export interface DefaultApiUpdateCardAccountUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardAccountUnit
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateCardAccountUnitRequest}
     * @memberof DefaultApiUpdateCardAccountUnit
     */
    readonly updateCardAccountUnitRequest: UpdateCardAccountUnitRequest
}

/**
 * Request parameters for updateCardCountLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardCountLimitRequest
 */
export interface DefaultApiUpdateCardCountLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardCountLimit
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateCardCountLimitRequest}
     * @memberof DefaultApiUpdateCardCountLimit
     */
    readonly updateCardCountLimitRequest: UpdateCardCountLimitRequest
}

/**
 * Request parameters for updateCardHolder operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardHolderRequest
 */
export interface DefaultApiUpdateCardHolderRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardHolder
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateCardHolderRequest}
     * @memberof DefaultApiUpdateCardHolder
     */
    readonly updateCardHolderRequest: UpdateCardHolderRequest
}

/**
 * Request parameters for updateCardLock operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardLockRequest
 */
export interface DefaultApiUpdateCardLockRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardLock
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardLock
     */
    readonly cardId: string
}

/**
 * Request parameters for updateCardUnlock operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCardUnlockRequest
 */
export interface DefaultApiUpdateCardUnlockRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardUnlock
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCardUnlock
     */
    readonly cardId: string
}

/**
 * Request parameters for updateComment operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCommentRequest
 */
export interface DefaultApiUpdateCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateComment
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateComment
     */
    readonly cardTransactionCommentId: string

    /**
     * 
     * @type {UpdateCommentRequest}
     * @memberof DefaultApiUpdateComment
     */
    readonly updateCommentRequest: UpdateCommentRequest
}

/**
 * Request parameters for updateCommentTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCommentTemplateRequest
 */
export interface DefaultApiUpdateCommentTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCommentTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCommentTemplate
     */
    readonly templateId: string

    /**
     * 
     * @type {UpdateCommentTemplateRequest}
     * @memberof DefaultApiUpdateCommentTemplate
     */
    readonly updateCommentTemplateRequest: UpdateCommentTemplateRequest
}

/**
 * Request parameters for updateCorporateDocumentResult operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateCorporateDocumentResultRequest
 */
export interface DefaultApiUpdateCorporateDocumentResultRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateCorporateDocumentResult
     */
    readonly organizationIdentityVerificationId: string

    /**
     * 
     * @type {UpdateCorporateDocumentResultRequest}
     * @memberof DefaultApiUpdateCorporateDocumentResult
     */
    readonly updateCorporateDocumentResultRequest: UpdateCorporateDocumentResultRequest
}

/**
 * Request parameters for updateDailyUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateDailyUserUsageLimitRequest
 */
export interface DefaultApiUpdateDailyUserUsageLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateDailyUserUsageLimit
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateDailyUserUsageLimitRequest}
     * @memberof DefaultApiUpdateDailyUserUsageLimit
     */
    readonly updateDailyUserUsageLimitRequest: UpdateDailyUserUsageLimitRequest
}

/**
 * Request parameters for updateDepositRestrictionForOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateDepositRestrictionForOrganizationRequest
 */
export interface DefaultApiUpdateDepositRestrictionForOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateDepositRestrictionForOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateDepositRestrictionForOrganization
     */
    readonly depositRestrictionId: string

    /**
     * 
     * @type {UpdateDepositRestrictionForOrganizationRequest}
     * @memberof DefaultApiUpdateDepositRestrictionForOrganization
     */
    readonly updateDepositRestrictionForOrganizationRequest: UpdateDepositRestrictionForOrganizationRequest
}

/**
 * Request parameters for updateEmailNotification operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEmailNotificationRequest
 */
export interface DefaultApiUpdateEmailNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEmailNotification
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEmailNotification
     */
    readonly emailNotificationId: string

    /**
     * 
     * @type {UpdateEmailNotificationRequest}
     * @memberof DefaultApiUpdateEmailNotification
     */
    readonly updateEmailNotificationRequest: UpdateEmailNotificationRequest
}

/**
 * Request parameters for updateEmbedUrlMethod operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEmbedUrlMethodRequest
 */
export interface DefaultApiUpdateEmbedUrlMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEmbedUrlMethod
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateEmbedUrlMethodRequest}
     * @memberof DefaultApiUpdateEmbedUrlMethod
     */
    readonly updateEmbedUrlMethodRequest: UpdateEmbedUrlMethodRequest
}

/**
 * Request parameters for updateEtcCardHolder operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEtcCardHolderRequest
 */
export interface DefaultApiUpdateEtcCardHolderRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEtcCardHolder
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateEtcCardHolderRequest}
     * @memberof DefaultApiUpdateEtcCardHolder
     */
    readonly updateEtcCardHolderRequest: UpdateEtcCardHolderRequest
}

/**
 * Request parameters for updateEtcCardLabel operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEtcCardLabelRequest
 */
export interface DefaultApiUpdateEtcCardLabelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEtcCardLabel
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateEtcCardLabelRequest}
     * @memberof DefaultApiUpdateEtcCardLabel
     */
    readonly updateEtcCardLabelRequest: UpdateEtcCardLabelRequest
}

/**
 * Request parameters for updateEvidenceImage operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEvidenceImageRequest
 */
export interface DefaultApiUpdateEvidenceImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly cardTransactionEvidenceId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly file?: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly electronicMethod?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly documentSize?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly heightMillis?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly widthMillis?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly note?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly irrelevantToLedger?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly dpiForciblyValid?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly colorGradationForciblyValid?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly uploadedByRecipient?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly uploadedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly invoiceIssuerName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly invoiceIssuerRegistrationNumber?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateEvidenceImage
     */
    readonly asQualified?: boolean
}

/**
 * Request parameters for updateEvidenceInfo operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateEvidenceInfoRequest
 */
export interface DefaultApiUpdateEvidenceInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceInfo
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceInfo
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateEvidenceInfo
     */
    readonly cardTransactionEvidenceId: string

    /**
     * 
     * @type {UpdateEvidenceInfoRequest}
     * @memberof DefaultApiUpdateEvidenceInfo
     */
    readonly updateEvidenceInfoRequest: UpdateEvidenceInfoRequest
}

/**
 * Request parameters for updateFreeeConnect operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateFreeeConnectRequest
 */
export interface DefaultApiUpdateFreeeConnectRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeConnect
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeConnect
     */
    readonly code: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeConnect
     */
    readonly state: string
}

/**
 * Request parameters for updateFreeeConnectionSettingsForAccounting operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest
 */
export interface DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeConnectionSettingsForAccounting
     */
    readonly orgAccountId: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdateFreeeConnectionSettingsForAccounting
     */
    readonly upsidrPrivateClientApiInternal?: boolean

    /**
     * 
     * @type {UpdateFreeeConnectionSettingsForAccountingRequest}
     * @memberof DefaultApiUpdateFreeeConnectionSettingsForAccounting
     */
    readonly updateFreeeConnectionSettingsForAccountingRequest?: UpdateFreeeConnectionSettingsForAccountingRequest
}

/**
 * Request parameters for updateFreeeJournaling operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateFreeeJournalingRequest
 */
export interface DefaultApiUpdateFreeeJournalingRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeJournaling
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateFreeeJournalingRequest}
     * @memberof DefaultApiUpdateFreeeJournaling
     */
    readonly updateFreeeJournalingRequest: UpdateFreeeJournalingRequest
}

/**
 * Request parameters for updateFreeeSelectCompany operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateFreeeSelectCompanyRequest
 */
export interface DefaultApiUpdateFreeeSelectCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateFreeeSelectCompany
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateFreeeSelectCompanyRequest}
     * @memberof DefaultApiUpdateFreeeSelectCompany
     */
    readonly updateFreeeSelectCompanyRequest: UpdateFreeeSelectCompanyRequest
}

/**
 * Request parameters for updateLockStatusOfEvidences operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateLockStatusOfEvidencesRequest
 */
export interface DefaultApiUpdateLockStatusOfEvidencesRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateLockStatusOfEvidences
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateLockStatusOfEvidencesRequest}
     * @memberof DefaultApiUpdateLockStatusOfEvidences
     */
    readonly updateLockStatusOfEvidencesRequest: UpdateLockStatusOfEvidencesRequest
}

/**
 * Request parameters for updateMerchantGeneralBlockAllowedOrganizationIds operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest
 */
export interface DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIds
     */
    readonly merchantGeneralBlockListId: string

    /**
     * 
     * @type {UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest}
     * @memberof DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIds
     */
    readonly updateMerchantGeneralBlockAllowedOrganizationIdsRequest: UpdateMerchantGeneralBlockAllowedOrganizationIdsRequest
}

/**
 * Request parameters for updateMerchantGeneralBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMerchantGeneralBlockListRequest
 */
export interface DefaultApiUpdateMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantGeneralBlockList
     */
    readonly merchantGeneralBlockListId: string

    /**
     * 
     * @type {UpdateMerchantGeneralBlockListRequest}
     * @memberof DefaultApiUpdateMerchantGeneralBlockList
     */
    readonly updateMerchantGeneralBlockListRequest: UpdateMerchantGeneralBlockListRequest
}

/**
 * Request parameters for updateMerchantOrgBlockList operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMerchantOrgBlockListRequest
 */
export interface DefaultApiUpdateMerchantOrgBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantOrgBlockList
     */
    readonly merchantOrgBlockListId: string

    /**
     * 
     * @type {UpdateMerchantOrgBlockListRequest}
     * @memberof DefaultApiUpdateMerchantOrgBlockList
     */
    readonly updateMerchantOrgBlockListRequest: UpdateMerchantOrgBlockListRequest
}

/**
 * Request parameters for updateMerchantOrganizationComment operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateMerchantOrganizationCommentRequest
 */
export interface DefaultApiUpdateMerchantOrganizationCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantOrganizationComment
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantOrganizationComment
     */
    readonly merchantId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateMerchantOrganizationComment
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateMerchantOrganizationCommentRequest}
     * @memberof DefaultApiUpdateMerchantOrganizationComment
     */
    readonly updateMerchantOrganizationCommentRequest: UpdateMerchantOrganizationCommentRequest
}

/**
 * Request parameters for updateOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateOrganizationRequest
 */
export interface DefaultApiUpdateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateOrganization
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateOrganizationRequest}
     * @memberof DefaultApiUpdateOrganization
     */
    readonly updateOrganizationRequest: UpdateOrganizationRequest
}

/**
 * Request parameters for updateOrganizationsAccountingCsvExportFields operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest
 */
export interface DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateOrganizationsAccountingCsvExportFields
     */
    readonly organizationId: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiUpdateOrganizationsAccountingCsvExportFields
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for updatePaymentRequestEvidence operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdatePaymentRequestEvidenceRequest
 */
export interface DefaultApiUpdatePaymentRequestEvidenceRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidence
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidence
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidence
     */
    readonly evidenceId: string

    /**
     * 
     * @type {UpdatePaymentRequestEvidenceRequest}
     * @memberof DefaultApiUpdatePaymentRequestEvidence
     */
    readonly updatePaymentRequestEvidenceRequest: UpdatePaymentRequestEvidenceRequest
}

/**
 * Request parameters for updatePaymentRequestEvidenceFile operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdatePaymentRequestEvidenceFileRequest
 */
export interface DefaultApiUpdatePaymentRequestEvidenceFileRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly evidenceId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly file?: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly electronicMethod?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly documentSize?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly heightMillis?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly widthMillis?: number

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly dpiForciblyValid?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly colorGradationForciblyValid?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly note?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly irrelevantToLedger?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly uploadedByRecipient?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly uploadedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly invoiceIssuerRegistrationNumber?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly invoiceIssuerName?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUpdatePaymentRequestEvidenceFile
     */
    readonly asQualified?: boolean
}

/**
 * Request parameters for updatePurchaseApplicationTemplate operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdatePurchaseApplicationTemplateRequest
 */
export interface DefaultApiUpdatePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePurchaseApplicationTemplate
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdatePurchaseApplicationTemplate
     */
    readonly purchaseTemplateId: string

    /**
     * 
     * @type {UpdatePurchaseApplicationTemplateRequest}
     * @memberof DefaultApiUpdatePurchaseApplicationTemplate
     */
    readonly updatePurchaseApplicationTemplateRequest?: UpdatePurchaseApplicationTemplateRequest
}

/**
 * Request parameters for updateRemoveUserAccountGroup operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateRemoveUserAccountGroupRequest
 */
export interface DefaultApiUpdateRemoveUserAccountGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateRemoveUserAccountGroup
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateRemoveUserAccountGroupRequest}
     * @memberof DefaultApiUpdateRemoveUserAccountGroup
     */
    readonly updateRemoveUserAccountGroupRequest: UpdateRemoveUserAccountGroupRequest
}

/**
 * Request parameters for updateRoleResourceForUser operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateRoleResourceForUserRequest
 */
export interface DefaultApiUpdateRoleResourceForUserRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateRoleResourceForUser
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateRoleResourceForUserRequest}
     * @memberof DefaultApiUpdateRoleResourceForUser
     */
    readonly updateRoleResourceForUserRequest: UpdateRoleResourceForUserRequest
}

/**
 * Request parameters for updateRolesByResourceId operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateRolesByResourceIdRequest
 */
export interface DefaultApiUpdateRolesByResourceIdRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateRolesByResourceId
     */
    readonly resourceScope: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateRolesByResourceId
     */
    readonly resourceId: string

    /**
     * 
     * @type {UpdateRolesByResourceIdRequest}
     * @memberof DefaultApiUpdateRolesByResourceId
     */
    readonly updateRolesByResourceIdRequest: UpdateRolesByResourceIdRequest
}

/**
 * Request parameters for updateSlackEvidenceReminderPerChannel operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSlackEvidenceReminderPerChannelRequest
 */
export interface DefaultApiUpdateSlackEvidenceReminderPerChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackEvidenceReminderPerChannel
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackEvidenceReminderPerChannel
     */
    readonly channelId: string

    /**
     * 
     * @type {UpdateSlackEvidenceReminderPerChannelRequest}
     * @memberof DefaultApiUpdateSlackEvidenceReminderPerChannel
     */
    readonly updateSlackEvidenceReminderPerChannelRequest: UpdateSlackEvidenceReminderPerChannelRequest
}

/**
 * Request parameters for updateSlackNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSlackNotificationSettingForCardRequest
 */
export interface DefaultApiUpdateSlackNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackNotificationSettingForCard
     */
    readonly channelId: string

    /**
     * 
     * @type {UpdateSlackNotificationSettingForCardRequest}
     * @memberof DefaultApiUpdateSlackNotificationSettingForCard
     */
    readonly updateSlackNotificationSettingForCardRequest: UpdateSlackNotificationSettingForCardRequest
}

/**
 * Request parameters for updateSlackNotificationSettingForPurchaseApplication operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest
 */
export interface DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackNotificationSettingForPurchaseApplication
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSlackNotificationSettingForPurchaseApplication
     */
    readonly channelId: string

    /**
     * 
     * @type {UpdateSlackNotificationSettingForPurchaseApplicationRequest}
     * @memberof DefaultApiUpdateSlackNotificationSettingForPurchaseApplication
     */
    readonly updateSlackNotificationSettingForPurchaseApplicationRequest: UpdateSlackNotificationSettingForPurchaseApplicationRequest
}

/**
 * Request parameters for updateSyncToFreeeFromDeal operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSyncToFreeeFromDealRequest
 */
export interface DefaultApiUpdateSyncToFreeeFromDealRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSyncToFreeeFromDeal
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSyncToFreeeFromDeal
     */
    readonly companyId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSyncToFreeeFromDeal
     */
    readonly dealId: string
}

/**
 * Request parameters for updateSynchronizeToFreeeLogConfirm operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest
 */
export interface DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSynchronizeToFreeeLogConfirm
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateSynchronizeToFreeeLogConfirm
     */
    readonly companyId: string

    /**
     * 
     * @type {UpdateSynchronizeToFreeeLogConfirmRequest}
     * @memberof DefaultApiUpdateSynchronizeToFreeeLogConfirm
     */
    readonly updateSynchronizeToFreeeLogConfirmRequest: UpdateSynchronizeToFreeeLogConfirmRequest
}

/**
 * Request parameters for updateTeamsNotificationSettingForCard operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateTeamsNotificationSettingForCardRequest
 */
export interface DefaultApiUpdateTeamsNotificationSettingForCardRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateTeamsNotificationSettingForCard
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateTeamsNotificationSettingForCard
     */
    readonly channelId: string

    /**
     * 
     * @type {UpdateTeamsNotificationSettingForCardRequest}
     * @memberof DefaultApiUpdateTeamsNotificationSettingForCard
     */
    readonly updateTeamsNotificationSettingForCardRequest: UpdateTeamsNotificationSettingForCardRequest
}

/**
 * Request parameters for updateTransactionUpperLimitForTheUserAccount operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest
 */
export interface DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateTransactionUpperLimitForTheUserAccount
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateTransactionUpperLimitForTheUserAccountRequest}
     * @memberof DefaultApiUpdateTransactionUpperLimitForTheUserAccount
     */
    readonly updateTransactionUpperLimitForTheUserAccountRequest: UpdateTransactionUpperLimitForTheUserAccountRequest
}

/**
 * Request parameters for updateUserAccountGroup operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserAccountGroupRequest
 */
export interface DefaultApiUpdateUserAccountGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserAccountGroup
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateUserAccountGroupRequest}
     * @memberof DefaultApiUpdateUserAccountGroup
     */
    readonly updateUserAccountGroupRequest: UpdateUserAccountGroupRequest
}

/**
 * Request parameters for updateUserAccountName operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserAccountNameRequest
 */
export interface DefaultApiUpdateUserAccountNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserAccountName
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateUserAccountNameRequest}
     * @memberof DefaultApiUpdateUserAccountName
     */
    readonly updateUserAccountNameRequest: UpdateUserAccountNameRequest
}

/**
 * Request parameters for updateUserEmail operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserEmailRequest
 */
export interface DefaultApiUpdateUserEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserEmail
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserEmailRequest}
     * @memberof DefaultApiUpdateUserEmail
     */
    readonly updateUserEmailRequest: UpdateUserEmailRequest

    /**
     * sudo-mode challenge 検証成功時に発行される token
     * @type {string}
     * @memberof DefaultApiUpdateUserEmail
     */
    readonly xChallengeSuccessToken?: string
}

/**
 * Request parameters for updateUserName operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserNameRequest
 */
export interface DefaultApiUpdateUserNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserName
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserNameRequest}
     * @memberof DefaultApiUpdateUserName
     */
    readonly updateUserNameRequest: UpdateUserNameRequest
}

/**
 * Request parameters for updateUserOrganization operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserOrganizationRequest
 */
export interface DefaultApiUpdateUserOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserOrganization
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserOrganizationRequest}
     * @memberof DefaultApiUpdateUserOrganization
     */
    readonly updateUserOrganizationRequest: UpdateUserOrganizationRequest
}

/**
 * Request parameters for updateUserPassword operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserPasswordRequest
 */
export interface DefaultApiUpdateUserPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserPassword
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserPasswordRequest}
     * @memberof DefaultApiUpdateUserPassword
     */
    readonly updateUserPasswordRequest: UpdateUserPasswordRequest
}

/**
 * Request parameters for updateUserPrivilege operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserPrivilegeRequest
 */
export interface DefaultApiUpdateUserPrivilegeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserPrivilege
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserPrivilege
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserPrivilegeRequest}
     * @memberof DefaultApiUpdateUserPrivilege
     */
    readonly updateUserPrivilegeRequest: UpdateUserPrivilegeRequest
}

/**
 * Request parameters for updateUserUsageLimit operation in DefaultApi.
 * @export
 * @interface DefaultApiUpdateUserUsageLimitRequest
 */
export interface DefaultApiUpdateUserUsageLimitRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUpdateUserUsageLimit
     */
    readonly userAccountId: string

    /**
     * 
     * @type {UpdateUserUsageLimitRequest}
     * @memberof DefaultApiUpdateUserUsageLimit
     */
    readonly updateUserUsageLimitRequest: UpdateUserUsageLimitRequest
}

/**
 * Request parameters for uploadCardTransactionEvidenceImage operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadCardTransactionEvidenceImageRequest
 */
export interface DefaultApiUploadCardTransactionEvidenceImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly paymentReferenceId: string

    /**
     * 
     * @type {Array<File>}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly files?: Array<File>

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly electronicMethod?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly documentSize?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly heightMillis?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly widthMillis?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly note?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly irrelevantToLedger?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly uploadedByRecipient?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly uploadedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly invoiceIssuerName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly invoiceIssuerRegistrationNumber?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadCardTransactionEvidenceImage
     */
    readonly asQualified?: boolean
}

/**
 * Request parameters for uploadCorporateDocument operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadCorporateDocumentRequest
 */
export interface DefaultApiUploadCorporateDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadCorporateDocument
     */
    readonly organizationIdentityVerificationId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUploadCorporateDocument
     */
    readonly file: File
}

/**
 * Request parameters for uploadPaymentRequestEvidenceImage operation in DefaultApi.
 * @export
 * @interface DefaultApiUploadPaymentRequestEvidenceImageRequest
 */
export interface DefaultApiUploadPaymentRequestEvidenceImageRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly organizationId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly paymentRequestId: string

    /**
     * 
     * @type {File}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly file?: File

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly electronicMethod?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly documentSize?: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly heightMillis?: number

    /**
     * 
     * @type {number}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly widthMillis?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly note?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly irrelevantToLedger?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly uploadedByRecipient?: boolean

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly uploadedFrom?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly invoiceIssuerName?: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly invoiceIssuerRegistrationNumber?: string

    /**
     * 
     * @type {boolean}
     * @memberof DefaultApiUploadPaymentRequestEvidenceImage
     */
    readonly asQualified?: boolean
}

/**
 * Request parameters for usersEmailConfirm operation in DefaultApi.
 * @export
 * @interface DefaultApiUsersEmailConfirmRequest
 */
export interface DefaultApiUsersEmailConfirmRequest {
    /**
     * 
     * @type {UsersEmailConfirmRequest}
     * @memberof DefaultApiUsersEmailConfirm
     */
    readonly usersEmailConfirmRequest: UsersEmailConfirmRequest
}

/**
 * Request parameters for verifyChallenge operation in DefaultApi.
 * @export
 * @interface DefaultApiVerifyChallengeRequest
 */
export interface DefaultApiVerifyChallengeRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiVerifyChallenge
     */
    readonly userId: string

    /**
     * 
     * @type {VerifyChallengeRequest}
     * @memberof DefaultApiVerifyChallenge
     */
    readonly verifyChallengeRequest: VerifyChallengeRequest
}

/**
 * Request parameters for verifyMoneytreeConnections operation in DefaultApi.
 * @export
 * @interface DefaultApiVerifyMoneytreeConnectionsRequest
 */
export interface DefaultApiVerifyMoneytreeConnectionsRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiVerifyMoneytreeConnections
     */
    readonly organizationId: string
}

/**
 * Request parameters for zeusUpdateUserEmail operation in DefaultApi.
 * @export
 * @interface DefaultApiZeusUpdateUserEmailRequest
 */
export interface DefaultApiZeusUpdateUserEmailRequest {
    /**
     * The ID of the user whose email address will be updated
     * @type {string}
     * @memberof DefaultApiZeusUpdateUserEmail
     */
    readonly userId: string

    /**
     * 
     * @type {ZeusUpdateUserEmailRequest}
     * @memberof DefaultApiZeusUpdateUserEmail
     */
    readonly zeusUpdateUserEmailRequest: ZeusUpdateUserEmailRequest
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Add comment for card transaction
     * @param {DefaultApiAddCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addComment(requestParameters: DefaultApiAddCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.addCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add Organization Create Request
     * @param {DefaultApiAddOrganizationCreateRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addOrganizationCreateRequest(requestParameters: DefaultApiAddOrganizationCreateRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addOrganizationCreateRequest(requestParameters.addOrganizationCreateRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add point to organization
     * @param {DefaultApiAddPointToOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addPointToOrganization(requestParameters: DefaultApiAddPointToOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addPointToOrganization(requestParameters.organizationId, requestParameters.addPointToOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Agree to the agreement request
     * @param {DefaultApiAgreeToAgreementRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public agreeToAgreementRequest(requestParameters: DefaultApiAgreeToAgreementRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).agreeToAgreementRequest(requestParameters.organizationId, requestParameters.agreementRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Agree to OL info sharing consent
     * @param {DefaultApiAgreeToOlInfoSharingConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public agreeToOlInfoSharingConsent(requestParameters: DefaultApiAgreeToOlInfoSharingConsentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).agreeToOlInfoSharingConsent(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Analyze evidence
     * @param {DefaultApiAnalyzeEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public analyzeEvidence(requestParameters: DefaultApiAnalyzeEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).analyzeEvidence(requestParameters.organizationId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Analyze invoice of payment requests
     * @param {DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public analyzeInvoiceOfPaymentRequests(requestParameters: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).analyzeInvoiceOfPaymentRequests(requestParameters.organizationId, requestParameters.file, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply fraud lock status
     * @param {DefaultApiApplyFraudLockStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public applyFraudLockStatus(requestParameters: DefaultApiApplyFraudLockStatusRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).applyFraudLockStatus(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve organization identity verification
     * @param {DefaultApiApproveOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public approveOrganizationIdentityVerification(requestParameters: DefaultApiApproveOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).approveOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve purchase application.
     * @param {DefaultApiApprovePurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public approvePurchaseApplication(requestParameters: DefaultApiApprovePurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).approvePurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.approvePurchaseApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve workflow step of payment request
     * @param {DefaultApiApproveWorkflowStepPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public approveWorkflowStepPaymentRequests(requestParameters: DefaultApiApproveWorkflowStepPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).approveWorkflowStepPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.approveWorkflowStepPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Automatically journalize deals from rules
     * @param {DefaultApiAutomaticallyJournalizeDealsFromRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public automaticallyJournalizeDealsFromRules(requestParameters: DefaultApiAutomaticallyJournalizeDealsFromRulesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).automaticallyJournalizeDealsFromRules(requestParameters.organizationId, requestParameters.companyId, requestParameters.automaticallyJournalizeDealsFromRulesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bank Account Activities Withdrawal Reserve
     * @param {DefaultApiBankAccountActivitiesWithdrawalReserveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bankAccountActivitiesWithdrawalReserve(requestParameters: DefaultApiBankAccountActivitiesWithdrawalReserveRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bankAccountActivitiesWithdrawalReserve(requestParameters.bankAccountActivitiesWithdrawalReserveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable daily usage limit for an user account
     * @param {DefaultApiBulkDisableDailyUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkDisableDailyUserUsageLimit(requestParameters: DefaultApiBulkDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkDisableDailyUserUsageLimit(requestParameters.bulkDisableDailyUserUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk disable monthly usage limit
     * @param {DefaultApiBulkDisableMonthlyUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkDisableMonthlyUsageLimit(requestParameters: DefaultApiBulkDisableMonthlyUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkDisableMonthlyUsageLimit(requestParameters.bulkDisableMonthlyUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows organization administrators to invite multiple users at once by providing user details (email, name, and role). This endpoint accepts up to 300 users per request. 
     * @summary Bulk invite users to organization
     * @param {DefaultApiBulkInviteUsersAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkInviteUsersAdmin(requestParameters: DefaultApiBulkInviteUsersAdminRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkInviteUsersAdmin(requestParameters.organizationId, requestParameters.bulkInviteUsersAdminRequest, requestParameters.xChallengeSuccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk update daily usage limit
     * @param {DefaultApiBulkUpdateDailyUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkUpdateDailyUsageLimit(requestParameters: DefaultApiBulkUpdateDailyUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkUpdateDailyUsageLimit(requestParameters.bulkUpdateDailyUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk update monthly usage limit
     * @param {DefaultApiBulkUpdateMonthlyUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkUpdateMonthlyUsageLimit(requestParameters: DefaultApiBulkUpdateMonthlyUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkUpdateMonthlyUsageLimit(requestParameters.bulkUpdateMonthlyUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Update Organization User Privileges
     * @param {DefaultApiBulkUpdateOrganizationUserPrivilegesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkUpdateOrganizationUserPrivileges(requestParameters: DefaultApiBulkUpdateOrganizationUserPrivilegesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkUpdateOrganizationUserPrivileges(requestParameters.organizationId, requestParameters.bulkUpdateOrganizationUserPrivilegesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel draft payment request
     * @param {DefaultApiCancelDraftPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cancelDraftPaymentRequest(requestParameters: DefaultApiCancelDraftPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cancelDraftPaymentRequest(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel payment request
     * @param {DefaultApiCancelPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public cancelPaymentRequest(requestParameters: DefaultApiCancelPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).cancelPaymentRequest(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Identity Verification Scheduled Date
     * @param {DefaultApiChangeIdentityVerificationScheduledDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public changeIdentityVerificationScheduledDate(requestParameters: DefaultApiChangeIdentityVerificationScheduledDateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).changeIdentityVerificationScheduledDate(requestParameters.organizationId, requestParameters.changeIdentityVerificationScheduledDateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Invoice Email
     * @param {DefaultApiChangeInvoiceEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public changeInvoiceEmail(requestParameters: DefaultApiChangeInvoiceEmailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).changeInvoiceEmail(requestParameters.organizationId, requestParameters.changeInvoiceEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change to the specified ekyc result
     * @param {DefaultApiChangeToTheSpecifiedEkycResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public changeToTheSpecifiedEkycResult(requestParameters: DefaultApiChangeToTheSpecifiedEkycResultRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).changeToTheSpecifiedEkycResult(requestParameters.identificationId, requestParameters.changeToTheSpecifiedEkycResultRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check Already Registered Phone Number
     * @param {DefaultApiCheckAlreadyRegisteredPhoneNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkAlreadyRegisteredPhoneNumber(requestParameters: DefaultApiCheckAlreadyRegisteredPhoneNumberRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkAlreadyRegisteredPhoneNumber(requestParameters.checkAlreadyRegisteredPhoneNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check All Organization Available Limit And Notify
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkAvailableLimit(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkAvailableLimit(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check duplicate email addresses
     * @param {DefaultApiCheckDuplicateEmailAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkDuplicateEmailAddresses(requestParameters: DefaultApiCheckDuplicateEmailAddressesRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkDuplicateEmailAddresses(requestParameters.emailAddresses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkMonthlyUsageLimit(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkMonthlyUsageLimit(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * It is an API that waits for a redirect after the payment request fix button is pressed in the Slack App. This API does three things:   - Slack message modification - remove each button attached to the original message   - Post messages to Slack - communicate the fact that the edit button was pressed   - Create payment request for draft data
     * @summary Complete redirect from slack
     * @param {DefaultApiCompleteRedirectFromSlackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public completeRedirectFromSlack(requestParameters: DefaultApiCompleteRedirectFromSlackRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).completeRedirectFromSlack(requestParameters.organizationId, requestParameters.completeRedirectFromSlackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm Fufu hotel reservation
     * @param {DefaultApiConfirmFufuHotelReservationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public confirmFufuHotelReservation(requestParameters: DefaultApiConfirmFufuHotelReservationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).confirmFufuHotelReservation(requestParameters.confirmFufuHotelReservationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary freee接続
     * @param {DefaultApiConnectFreeeForAccountingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public connectFreeeForAccounting(requestParameters: DefaultApiConnectFreeeForAccountingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).connectFreeeForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.connectFreeeForAccountingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count deals
     * @param {DefaultApiCountDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public countDeals(requestParameters: DefaultApiCountDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).countDeals(requestParameters.organizationId, requestParameters.countDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create bank transfers for the specified payment requests.
     * @summary Create bank transfers
     * @param {DefaultApiCreateBankTransfersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createBankTransfers(requestParameters: DefaultApiCreateBankTransfersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createBankTransfers(requestParameters.organizationId, requestParameters.createBankTransfersRequest, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create category of the purchase application template.
     * @param {DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiCreateCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.createCategoryOfThePurchaseApplicationTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create comment template
     * @param {DefaultApiCreateCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createCommentTemplate(requestParameters: DefaultApiCreateCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createCommentTemplate(requestParameters.organizationId, requestParameters.createCommentTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create deposit restriction for organization
     * @param {DefaultApiCreateDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createDepositRestrictionForOrganization(requestParameters: DefaultApiCreateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.createDepositRestrictionForOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create draft of payment request
     * @param {DefaultApiCreateDraftOfPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createDraftOfPaymentRequests(requestParameters: DefaultApiCreateDraftOfPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createDraftOfPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.createDraftOfPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create ETC card issuance request
     * @param {DefaultApiCreateEtcCardIssuanceRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createEtcCardIssuanceRequest(requestParameters: DefaultApiCreateEtcCardIssuanceRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createEtcCardIssuanceRequest(requestParameters.organizationId, requestParameters.createEtcCardIssuanceRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create evidence request
     * @param {DefaultApiCreateEvidenceRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createEvidenceRequest(requestParameters: DefaultApiCreateEvidenceRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createEvidenceRequest(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary freee認可URL作成
     * @param {DefaultApiCreateFreeeAuthForAccountingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createFreeeAuthForAccounting(requestParameters: DefaultApiCreateFreeeAuthForAccountingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createFreeeAuthForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create freee partner
     * @param {DefaultApiCreateFreeePartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createFreeePartner(requestParameters: DefaultApiCreateFreeePartnerRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createFreeePartner(requestParameters.organizationId, requestParameters.companyId, requestParameters.createFreeePartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create past deals
     * @param {DefaultApiCreatePastDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPastDeals(requestParameters: DefaultApiCreatePastDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPastDeals(requestParameters.organizationId, requestParameters.createPastDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create purchase application.
     * @param {DefaultApiCreatePurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPurchaseApplication(requestParameters: DefaultApiCreatePurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPurchaseApplication(requestParameters.organizationId, requestParameters.createPurchaseApplicationRequest, requestParameters.visaTransactionReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create purchase application template.
     * @param {DefaultApiCreatePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createPurchaseApplicationTemplate(requestParameters: DefaultApiCreatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createPurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.createPurchaseApplicationTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Slack card notification settings of an organization
     * @param {DefaultApiCreateSlackCardNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSlackCardNotifications(requestParameters: DefaultApiCreateSlackCardNotificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSlackCardNotifications(requestParameters.organizationId, requestParameters.createSlackCardNotificationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create slack notification settings for purchase-application
     * @param {DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSlackNotificationSettingsForPurchaseApplication(requestParameters: DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSlackNotificationSettingsForPurchaseApplication(requestParameters.organizationId, requestParameters.createSlackNotificationSettingsForPurchaseApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Teams card notification settings of an organization
     * @param {DefaultApiCreateTeamsCardNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTeamsCardNotifications(requestParameters: DefaultApiCreateTeamsCardNotificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTeamsCardNotifications(requestParameters.organizationId, requestParameters.createTeamsCardNotificationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create user account groups
     * @param {DefaultApiCreateUserAccountGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createUserAccountGroups(requestParameters: DefaultApiCreateUserAccountGroupsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createUserAccountGroups(requestParameters.organizationId, requestParameters.createUserAccountGroupsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate a card
     * @param {DefaultApiDeactivateCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deactivateCard(requestParameters: DefaultApiDeactivateCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deactivateCard(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate ETC card
     * @param {DefaultApiDeactivateEtcCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deactivateEtcCard(requestParameters: DefaultApiDeactivateEtcCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deactivateEtcCard(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate a user
     * @param {DefaultApiDeactivateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deactivateUser(requestParameters: DefaultApiDeactivateUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deactivateUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Defrost a card
     * @param {DefaultApiDefrostCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public defrostCard(requestParameters: DefaultApiDefrostCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).defrostCard(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Card Points Rate Configs
     * @param {DefaultApiDeleteCardPointsRateConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCardPointsRateConfig(requestParameters: DefaultApiDeleteCardPointsRateConfigRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCardPointsRateConfig(requestParameters.rateConfigId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete category of the purchase application template.
     * @param {DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiDeleteCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.purchaseTemplateCategoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete comment for card transaction
     * @param {DefaultApiDeleteCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteComment(requestParameters: DefaultApiDeleteCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionCommentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete comment template
     * @param {DefaultApiDeleteCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCommentTemplate(requestParameters: DefaultApiDeleteCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCommentTemplate(requestParameters.organizationId, requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete deposit restriction for organization
     * @param {DefaultApiDeleteDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteDepositRestrictionForOrganization(requestParameters: DefaultApiDeleteDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete evidence
     * @param {DefaultApiDeleteEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteEvidence(requestParameters: DefaultApiDeleteEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteEvidence(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete freee connected
     * @param {DefaultApiDeleteFreeeConnectedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteFreeeConnected(requestParameters: DefaultApiDeleteFreeeConnectedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteFreeeConnected(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Freee End Journal Entry Transition Mode
     * @param {DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteFreeeEndJournalEntryTransitionMode(requestParameters: DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteFreeeEndJournalEntryTransitionMode(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete merchant general block allowed organization ids
     * @param {DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMerchantGeneralBlockAllowedOrganizationIds(requestParameters: DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMerchantGeneralBlockAllowedOrganizationIds(requestParameters.merchantGeneralBlockListId, requestParameters.allowedOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete merchant general block list
     * @param {DefaultApiDeleteMerchantGeneralBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMerchantGeneralBlockList(requestParameters: DefaultApiDeleteMerchantGeneralBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMerchantGeneralBlockList(requestParameters.merchantGeneralBlockListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete merchant org block list
     * @param {DefaultApiDeleteMerchantOrgBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMerchantOrgBlockList(requestParameters: DefaultApiDeleteMerchantOrgBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMerchantOrgBlockList(requestParameters.merchantOrgBlockListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an onboarding request
     * @param {DefaultApiDeleteOnboardingRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOnboardingRequest(requestParameters: DefaultApiDeleteOnboardingRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOnboardingRequest(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Organization Create Request
     * @param {DefaultApiDeleteOrganizationCreateRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOrganizationCreateRequest(requestParameters: DefaultApiDeleteOrganizationCreateRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOrganizationCreateRequest(requestParameters.organizationCreateRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a payment request evidence specified by evidenceId.
     * @summary Delete the specific payment request evidence.
     * @param {DefaultApiDeletePaymentRequestEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePaymentRequestEvidence(requestParameters: DefaultApiDeletePaymentRequestEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete purchase application.
     * @param {DefaultApiDeletePurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePurchaseApplication(requestParameters: DefaultApiDeletePurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete purchase application templates detail
     * @param {DefaultApiDeletePurchaseApplicationTemplatesDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deletePurchaseApplicationTemplatesDetail(requestParameters: DefaultApiDeletePurchaseApplicationTemplatesDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deletePurchaseApplicationTemplatesDetail(requestParameters.organizationId, requestParameters.purchaseTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete slack notification channel setting for purchase-application
     * @param {DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSlackNotificationChannelSettingForPurchaseApplication(requestParameters: DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSlackNotificationChannelSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete slack notification channel setting for card
     * @param {DefaultApiDeleteSlackNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSlackNotificationSettingForCard(requestParameters: DefaultApiDeleteSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete system admin role
     * @param {DefaultApiDeleteSystemAdminRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSystemAdminRole(requestParameters: DefaultApiDeleteSystemAdminRoleRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSystemAdminRole(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete teams notification channel setting for card
     * @param {DefaultApiDeleteTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteTeamsNotificationSettingForCard(requestParameters: DefaultApiDeleteTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user account group
     * @param {DefaultApiDeleteUserAccountGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteUserAccountGroup(requestParameters: DefaultApiDeleteUserAccountGroupRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteUserAccountGroup(requestParameters.userAccountGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deposit Guarantee Money Balance
     * @param {DefaultApiDepositGuaranteeMoneyBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public depositGuaranteeMoneyBalance(requestParameters: DefaultApiDepositGuaranteeMoneyBalanceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).depositGuaranteeMoneyBalance(requestParameters.organizationId, requestParameters.depositGuaranteeMoneyBalanceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable Approval
     * @param {DefaultApiDisableApprovalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableApproval(requestParameters: DefaultApiDisableApprovalRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableApproval(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable daily usage limit for an user account
     * @param {DefaultApiDisableDailyUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableDailyUserUsageLimit(requestParameters: DefaultApiDisableDailyUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableDailyUserUsageLimit(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable physical store payment for the user account
     * @param {DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disablePhysicalStorePaymentForTheUserAccount(requestParameters: DefaultApiDisablePhysicalStorePaymentForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disablePhysicalStorePaymentForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable transaction upper limit for the user account
     * @param {DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableTransactionUpperLimitForTheUserAccount(requestParameters: DefaultApiDisableTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableTransactionUpperLimitForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable usage limit for an user account
     * @param {DefaultApiDisableUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disableUserUsageLimit(requestParameters: DefaultApiDisableUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disableUserUsageLimit(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disagree to the agreement request
     * @param {DefaultApiDisagreeToAgreementRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disagreeToAgreementRequest(requestParameters: DefaultApiDisagreeToAgreementRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disagreeToAgreementRequest(requestParameters.organizationId, requestParameters.agreementRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary freee接続解除
     * @param {DefaultApiDisconnectFreeeForAccountingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public disconnectFreeeForAccounting(requestParameters: DefaultApiDisconnectFreeeForAccountingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).disconnectFreeeForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download bank transfer file
     * @param {DefaultApiDownloadBankTransferFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadBankTransferFile(requestParameters: DefaultApiDownloadBankTransferFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadBankTransferFile(requestParameters.organizationId, requestParameters.bankTransferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download bank transfers csv
     * @param {DefaultApiDownloadBankTransfersCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadBankTransfersCsv(requestParameters: DefaultApiDownloadBankTransfersCsvRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadBankTransfersCsv(requestParameters.organizationId, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download ETC accounting CSV
     * @param {DefaultApiDownloadEtcAccountingCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadEtcAccountingCsv(requestParameters: DefaultApiDownloadEtcAccountingCsvRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadEtcAccountingCsv(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.dateType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download journal entry for freee csv
     * @param {DefaultApiDownloadJournalEntryForFreeeCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadJournalEntryForFreeeCsv(requestParameters: DefaultApiDownloadJournalEntryForFreeeCsvRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadJournalEntryForFreeeCsv(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download Organizations Accounting Csv
     * @param {DefaultApiDownloadOrganizationsAccountingCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadOrganizationsAccountingCsv(requestParameters: DefaultApiDownloadOrganizationsAccountingCsvRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadOrganizationsAccountingCsv(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download payment requests csv
     * @param {DefaultApiDownloadPaymentRequestsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadPaymentRequestsCsv(requestParameters: DefaultApiDownloadPaymentRequestsCsvRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadPaymentRequestsCsv(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.freeWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download payment requests csv for payment request ids specification
     * @param {DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(requestParameters: DefaultApiDownloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadPaymentRequestsCsvForPaymentRequestIdsSpecification(requestParameters.organizationId, requestParameters.downloadPaymentRequestsCsvForPaymentRequestIdsSpecificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable physical store payment for the user account
     * @param {DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public enablePhysicalStorePaymentForTheUserAccount(requestParameters: DefaultApiEnablePhysicalStorePaymentForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).enablePhysicalStorePaymentForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Freeze a card
     * @param {DefaultApiFreezeCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public freezeCard(requestParameters: DefaultApiFreezeCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).freezeCard(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Freeze Organization
     * @param {DefaultApiFreezeOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public freezeOrganization(requestParameters: DefaultApiFreezeOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).freezeOrganization(requestParameters.organizationId, requestParameters.freezeOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Annual Fees Invoice
     * @param {DefaultApiGenerateAnnualFeesInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateAnnualFeesInvoice(requestParameters: DefaultApiGenerateAnnualFeesInvoiceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateAnnualFeesInvoice(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate Create Account Token
     * @param {DefaultApiGenerateCreateAccountTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateCreateAccountToken(requestParameters: DefaultApiGenerateCreateAccountTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateCreateAccountToken(requestParameters.generateCreateAccountTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate freee redirect url
     * @param {DefaultApiGenerateFreeeRedirectUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateFreeeRedirectUrl(requestParameters: DefaultApiGenerateFreeeRedirectUrlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateFreeeRedirectUrl(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate org account ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateOrgAccountIds(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateOrgAccountIds(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Card Detail as Admin
     * @param {DefaultApiGetACardDetailAsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getACardDetailAsAdmin(requestParameters: DefaultApiGetACardDetailAsAdminRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getACardDetailAsAdmin(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get accounting csv for the organization.
     * @param {DefaultApiGetAccountingCsvForTheOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountingCsvForTheOrganization(requestParameters: DefaultApiGetAccountingCsvForTheOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountingCsvForTheOrganization(requestParameters.organizationId, requestParameters.startYearMonth, requestParameters.endYearMonth, requestParameters.accountingSystemType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get accounting csv for the user account.
     * @param {DefaultApiGetAccountingCsvForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAccountingCsvForTheUserAccount(requestParameters: DefaultApiGetAccountingCsvForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAccountingCsvForTheUserAccount(requestParameters.userAccountId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admin users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAdminUsers(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAdminUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admins
     * @param {DefaultApiGetAdminsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAdmins(requestParameters: DefaultApiGetAdminsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAdmins(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get agreement requests
     * @param {DefaultApiGetAgreementRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAgreementRequests(requestParameters: DefaultApiGetAgreementRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAgreementRequests(requestParameters.organizationId, requestParameters.waitingForAgreement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all banks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllBanks(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllBanks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get analysis invoice of payment request
     * @param {DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAnalysisInvoiceOfPaymentRequest(requestParameters: DefaultApiGetAnalysisInvoiceOfPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAnalysisInvoiceOfPaymentRequest(requestParameters.organizationId, requestParameters.fileId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get annual fees eligibility
     * @param {DefaultApiGetAnnualFeesEligibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAnnualFeesEligibility(requestParameters: DefaultApiGetAnnualFeesEligibilityRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAnnualFeesEligibility(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get approvers
     * @param {DefaultApiGetApproversRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getApprovers(requestParameters: DefaultApiGetApproversRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getApprovers(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get available currency options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableCurrencyOptions(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAvailableCurrencyOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <p>   Return a list of feature names that are available for the organization.   Most features are unconditionally available to all organizations and   are not included in the response of this API, while some new features are not   available for the organization unless their names are included in this response. </p> <p>   The response schema are designed to ensure that information about new features   is not disclosed to organizations that cannot use them. </p>
     * @param {DefaultApiGetAvailableFeaturesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableFeatures(requestParameters: DefaultApiGetAvailableFeaturesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAvailableFeatures(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Available merchant category options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableMerchantCategoryOptions(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAvailableMerchantCategoryOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get balance state
     * @param {DefaultApiGetBalanceStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBalanceState(requestParameters: DefaultApiGetBalanceStateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBalanceState(requestParameters.organizationId, requestParameters.targetDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get bank account activities
     * @param {DefaultApiGetBankAccountActivitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBankAccountActivities(requestParameters: DefaultApiGetBankAccountActivitiesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBankAccountActivities(requestParameters.bankAccountActivityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a bank account confirmed activities
     * @param {DefaultApiGetBankAccountConfirmedActivitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBankAccountConfirmedActivities(requestParameters: DefaultApiGetBankAccountConfirmedActivitiesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBankAccountConfirmedActivities(requestParameters.organizationId, requestParameters.type, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get bank by name
     * @param {DefaultApiGetBankByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBankByName(requestParameters: DefaultApiGetBankByNameRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBankByName(requestParameters.bankName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a bank transfer
     * @param {DefaultApiGetBankTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBankTransfer(requestParameters: DefaultApiGetBankTransferRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBankTransfer(requestParameters.organizationId, requestParameters.bankTransferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the specified bank\'s all branches
     * @param {DefaultApiGetBanksAllBranchesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBanksAllBranches(requestParameters: DefaultApiGetBanksAllBranchesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBanksAllBranches(requestParameters.bankCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get bookkeepers
     * @param {DefaultApiGetBookkeepersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBookkeepers(requestParameters: DefaultApiGetBookkeepersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBookkeepers(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get branch
     * @param {DefaultApiGetBranchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBranch(requestParameters: DefaultApiGetBranchRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBranch(requestParameters.bankCode, requestParameters.branchName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all business descriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBusinessDescriptions(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBusinessDescriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get if an organization can activate cards
     * @param {DefaultApiGetCanActivateCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanActivateCard(requestParameters: DefaultApiGetCanActivateCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanActivateCard(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the status of whether the organization can close
     * @param {DefaultApiGetCanCloseStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanCloseStatuses(requestParameters: DefaultApiGetCanCloseStatusesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanCloseStatuses(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get can deactivate
     * @param {DefaultApiGetCanDeactivateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanDeactivate(requestParameters: DefaultApiGetCanDeactivateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanDeactivate(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get if the user can read card\'s sensitive info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanReadCardSensitive(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanReadCardSensitive(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get if an organization can request a real card to be issued.
     * @param {DefaultApiGetCanRequestSendingCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanRequestSendingCard(requestParameters: DefaultApiGetCanRequestSendingCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanRequestSendingCard(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns whether the current user is eligible for canary routing (read-only, no cookie side-effect)
     * @summary Get canary routing eligibility status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCanaryRoutingStatus(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCanaryRoutingStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Card Bill
     * @param {DefaultApiGetCardBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardBill(requestParameters: DefaultApiGetCardBillRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardBill(requestParameters.cardBillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Card Detail
     * @param {DefaultApiGetCardDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardDetail(requestParameters: DefaultApiGetCardDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardDetail(requestParameters.cardId, requestParameters.xChallengeSuccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get card monthly transactions
     * @param {DefaultApiGetCardMonthlyTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardMonthlyTransactions(requestParameters: DefaultApiGetCardMonthlyTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardMonthlyTransactions(requestParameters.userAccountId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Card Points Rate Configs By OrganizationId
     * @param {DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardPointsRateConfigsByOrganizationId(requestParameters: DefaultApiGetCardPointsRateConfigsByOrganizationIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardPointsRateConfigsByOrganizationId(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get card transaction details
     * @param {DefaultApiGetCardTransactionDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardTransactionDetails(requestParameters: DefaultApiGetCardTransactionDetailsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardTransactionDetails(requestParameters.organizationId, requestParameters.visaTransactionReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get card transaction evidence record image
     * @param {DefaultApiGetCardTransactionEvidenceRecordImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardTransactionEvidenceRecordImage(requestParameters: DefaultApiGetCardTransactionEvidenceRecordImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardTransactionEvidenceRecordImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.id, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get card transaction evidence records
     * @param {DefaultApiGetCardTransactionEvidenceRecordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardTransactionEvidenceRecords(requestParameters: DefaultApiGetCardTransactionEvidenceRecordsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardTransactionEvidenceRecords(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Card Transactions
     * @param {DefaultApiGetCardTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardTransactions(requestParameters: DefaultApiGetCardTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardTransactions(requestParameters.userAccountId, requestParameters.merchantId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get cards
     * @param {DefaultApiGetCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCards(requestParameters: DefaultApiGetCardsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCards(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get cards transactions with purchase application unlinked
     * @param {DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCardsTransactionsWithPurchaseApplicationUnlinked(requestParameters: DefaultApiGetCardsTransactionsWithPurchaseApplicationUnlinkedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCardsTransactionsWithPurchaseApplicationUnlinked(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the category of the purchase application template for use.
     * @param {DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCategoryOfThePurchaseApplicationTemplate(requestParameters: DefaultApiGetCategoryOfThePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCategoryOfThePurchaseApplicationTemplate(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comment for card transaction
     * @param {DefaultApiGetCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getComment(requestParameters: DefaultApiGetCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getComment(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comment templates
     * @param {DefaultApiGetCommentTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommentTemplates(requestParameters: DefaultApiGetCommentTemplatesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommentTemplates(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comment template
     * @param {DefaultApiGetCommentTemplatesCommentTemplateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCommentTemplatesCommentTemplateId(requestParameters: DefaultApiGetCommentTemplatesCommentTemplateIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCommentTemplatesCommentTemplateId(requestParameters.organizationId, requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current card associated with the user account
     * @param {DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCurrentCardAssociatedWithTheUserAccount(requestParameters: DefaultApiGetCurrentCardAssociatedWithTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrentCardAssociatedWithTheUserAccount(requestParameters.userAccountId, requestParameters.includeMerchantCategories, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current ETC card associated with the user account
     * @param {DefaultApiGetCurrentEtcCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCurrentEtcCard(requestParameters: DefaultApiGetCurrentEtcCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrentEtcCard(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get deals total amount
     * @param {DefaultApiGetDealsTotalAmountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDealsTotalAmount(requestParameters: DefaultApiGetDealsTotalAmountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDealsTotalAmount(requestParameters.organizationId, requestParameters.getDealsTotalAmountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get default comment template for user account
     * @param {DefaultApiGetDefaultCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDefaultCommentTemplate(requestParameters: DefaultApiGetDefaultCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDefaultCommentTemplate(requestParameters.organizationId, requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deposit bank account
     * @param {DefaultApiGetDepositBankAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDepositBankAccount(requestParameters: DefaultApiGetDepositBankAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDepositBankAccount(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deposit restriction for organization
     * @param {DefaultApiGetDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDepositRestrictionForOrganization(requestParameters: DefaultApiGetDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deposit restriction list for organization
     * @param {DefaultApiGetDepositRestrictionListForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDepositRestrictionListForOrganization(requestParameters: DefaultApiGetDepositRestrictionListForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDepositRestrictionListForOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all deposit restrictions for the organization of the currently authenticated user
     * @summary Get deposit restrictions for current user\'s organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDepositRestrictions(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDepositRestrictions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get draft payment request
     * @param {DefaultApiGetDraftPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDraftPaymentRequest(requestParameters: DefaultApiGetDraftPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDraftPaymentRequest(requestParameters.organizationId, requestParameters.draftPaymentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get draft payment request evidence file
     * @param {DefaultApiGetDraftPaymentRequestEvidenceFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDraftPaymentRequestEvidenceFile(requestParameters: DefaultApiGetDraftPaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDraftPaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get draft payment requests only created own
     * @param {DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDraftPaymentRequestsOnlyCreatedOwn(requestParameters: DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDraftPaymentRequestsOnlyCreatedOwn(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get earliest expiring guarantee money for organization
     * @param {DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEarliestExpiringGuaranteeMoneyForOrganization(requestParameters: DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEarliestExpiringGuaranteeMoneyForOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtain email notification configuration information for each user.
     * @param {DefaultApiGetEmailNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEmailNotifications(requestParameters: DefaultApiGetEmailNotificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEmailNotifications(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get error bills
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getErrorBills(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getErrorBills(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if an ETC account exists for the specified organization. This is used to determine if ETC service has been initiated for the organization.
     * @summary Get ETC account status
     * @param {DefaultApiGetEtcAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtcAccount(requestParameters: DefaultApiGetEtcAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEtcAccount(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get ETC card billing amounts per card for specified yearMonth
     * @param {DefaultApiGetEtcAmountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtcAmounts(requestParameters: DefaultApiGetEtcAmountsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEtcAmounts(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get ETC card count for organization
     * @param {DefaultApiGetEtcCardCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtcCardCount(requestParameters: DefaultApiGetEtcCardCountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEtcCardCount(requestParameters.organizationId, requestParameters.searchWord, requestParameters.statuses, requestParameters.groups, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns sensitive card information. Only accessible by the card holder. - Card number: 16 digits, displayed with spaces (e.g., \"1234 5678 9012 3456\") - Expiry: Year and month separately - Cardholder name: Copyable 
     * @summary Get ETC card personal information (card number, expiry, cardholder name)
     * @param {DefaultApiGetEtcCardDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtcCardDetail(requestParameters: DefaultApiGetEtcCardDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEtcCardDetail(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns ETC card usage history with pagination. - Amount: Negative for normal transactions, positive for cancellations - Display format for usedAt: \"12月9日\" (without zero padding) 
     * @summary Get ETC card transactions
     * @param {DefaultApiGetEtcCardTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtcCardTransactions(requestParameters: DefaultApiGetEtcCardTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEtcCardTransactions(requestParameters.userAccountId, requestParameters.yearMonth, requestParameters.search, requestParameters.limit, requestParameters.nextCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get ETC cards
     * @param {DefaultApiGetEtcCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEtcCards(requestParameters: DefaultApiGetEtcCardsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEtcCards(requestParameters.organizationId, requestParameters.searchWord, requestParameters.statuses, requestParameters.groups, requestParameters.limit, requestParameters.nextCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the evidence specified by evidenceId.
     * @summary Get a specific evidence.
     * @param {DefaultApiGetEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidence(requestParameters: DefaultApiGetEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidence(requestParameters.organizationId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence file
     * @param {DefaultApiGetEvidenceFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceFile(requestParameters: DefaultApiGetEvidenceFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceFile(requestParameters.organizationId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence image
     * @param {DefaultApiGetEvidenceImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceImage(requestParameters: DefaultApiGetEvidenceImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence information for card transactions
     * @param {DefaultApiGetEvidenceInformationForCardTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceInformationForCardTransactions(requestParameters: DefaultApiGetEvidenceInformationForCardTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceInformationForCardTransactions(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence record image
     * @param {DefaultApiGetEvidenceRecordImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceRecordImage(requestParameters: DefaultApiGetEvidenceRecordImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceRecordImage(requestParameters.organizationId, requestParameters.evidenceId, requestParameters.recordId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence records
     * @param {DefaultApiGetEvidenceRecordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceRecords(requestParameters: DefaultApiGetEvidenceRecordsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceRecords(requestParameters.organizationId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidence zip for the organization.
     * @param {DefaultApiGetEvidenceZipForTheOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidenceZipForTheOrganization(requestParameters: DefaultApiGetEvidenceZipForTheOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidenceZipForTheOrganization(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get evidences
     * @param {DefaultApiGetEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidences(requestParameters: DefaultApiGetEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidences(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count evidences
     * @param {DefaultApiGetEvidencesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEvidencesCount(requestParameters: DefaultApiGetEvidencesCountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEvidencesCount(requestParameters.organizationId, requestParameters.issuer, requestParameters.amountMin, requestParameters.amountMax, requestParameters.paidAtFrom, requestParameters.paidAtTo, requestParameters.irrelevantToLedger, requestParameters.keyword, requestParameters.includesDeleted, requestParameters.legalValidities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the triggered transaction of a fraud locked card
     * @param {DefaultApiGetFraudLockedCardTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFraudLockedCardTransaction(requestParameters: DefaultApiGetFraudLockedCardTransactionRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFraudLockedCardTransaction(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee account items
     * @param {DefaultApiGetFreeeAccountItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeAccountItems(requestParameters: DefaultApiGetFreeeAccountItemsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeAccountItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee companies
     * @param {DefaultApiGetFreeeCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeCompanies(requestParameters: DefaultApiGetFreeeCompaniesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeCompanies(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee connected
     * @param {DefaultApiGetFreeeConnectedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeConnected(requestParameters: DefaultApiGetFreeeConnectedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeConnected(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Freee Connected User
     * @param {DefaultApiGetFreeeConnectedUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeConnectedUser(requestParameters: DefaultApiGetFreeeConnectedUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeConnectedUser(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary freee接続中のユーザー取得
     * @param {DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeConnectionLinkedAccountForAccounting(requestParameters: DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeConnectionLinkedAccountForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary freee設定取得
     * @param {DefaultApiGetFreeeConnectionSettingsForAccountingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeConnectionSettingsForAccounting(requestParameters: DefaultApiGetFreeeConnectionSettingsForAccountingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeConnectionSettingsForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee items
     * @param {DefaultApiGetFreeeItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeItems(requestParameters: DefaultApiGetFreeeItemsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee memo tags
     * @param {DefaultApiGetFreeeMemoTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeMemoTags(requestParameters: DefaultApiGetFreeeMemoTagsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeMemoTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee partners
     * @param {DefaultApiGetFreeePartnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeePartners(requestParameters: DefaultApiGetFreeePartnersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeePartners(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee sections
     * @param {DefaultApiGetFreeeSectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeSections(requestParameters: DefaultApiGetFreeeSectionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeSections(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee segment tags
     * @param {DefaultApiGetFreeeSegmentTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeSegmentTags(requestParameters: DefaultApiGetFreeeSegmentTagsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeSegmentTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee sync status
     * @param {DefaultApiGetFreeeSyncStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeSyncStatus(requestParameters: DefaultApiGetFreeeSyncStatusRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeSyncStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee tags
     * @param {DefaultApiGetFreeeTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeTags(requestParameters: DefaultApiGetFreeeTagsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeTags(requestParameters.organizationId, requestParameters.companyId, requestParameters.tagName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee taxes
     * @param {DefaultApiGetFreeeTaxesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeTaxes(requestParameters: DefaultApiGetFreeeTaxesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeTaxes(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get freee token
     * @param {DefaultApiGetFreeeTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFreeeToken(requestParameters: DefaultApiGetFreeeTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFreeeToken(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a guarantee money balance history
     * @param {DefaultApiGetGuaranteeMoneyBalanceHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getGuaranteeMoneyBalanceHistory(requestParameters: DefaultApiGetGuaranteeMoneyBalanceHistoryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGuaranteeMoneyBalanceHistory(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a guarantee money balance information for a organization
     * @param {DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getGuaranteeMoneyBalanceInformationForOrganization(requestParameters: DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGuaranteeMoneyBalanceInformationForOrganization(requestParameters.organizationId, requestParameters.targetDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get guarantee money deposits for organization
     * @param {DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getGuaranteeMoneyDepositsForOrganization(requestParameters: DefaultApiGetGuaranteeMoneyDepositsForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getGuaranteeMoneyDepositsForOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetHolidaysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getHolidays(requestParameters: DefaultApiGetHolidaysRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getHolidays(requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetIdentifyVerificationsLatestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getIdentifyVerificationsLatest(requestParameters: DefaultApiGetIdentifyVerificationsLatestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIdentifyVerificationsLatest(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetIdentityVerificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getIdentityVerifications(requestParameters: DefaultApiGetIdentityVerificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIdentityVerifications(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Invoice List
     * @param {DefaultApiGetInvoiceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getInvoiceList(requestParameters: DefaultApiGetInvoiceListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getInvoiceList(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Invoice Pdf
     * @param {DefaultApiGetInvoicePdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getInvoicePdf(requestParameters: DefaultApiGetInvoicePdfRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getInvoicePdf(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get issuable status
     * @param {DefaultApiGetIssuableStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getIssuableStatus(requestParameters: DefaultApiGetIssuableStatusRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getIssuableStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get jwt for SSO
     * @param {DefaultApiGetJwtSsoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getJwtSso(requestParameters: DefaultApiGetJwtSsoRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getJwtSso(requestParameters.nonce, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of KYC reader users ordered by creation date in descending order.
     * @summary Get KYC Reader Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getKycReaderUsers(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getKycReaderUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get latest time of sync to freee
     * @param {DefaultApiGetLatestTimeOfSyncToFreeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLatestTimeOfSyncToFreee(requestParameters: DefaultApiGetLatestTimeOfSyncToFreeeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLatestTimeOfSyncToFreee(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get lock status of evidences
     * @param {DefaultApiGetLockStatusOfEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLockStatusOfEvidences(requestParameters: DefaultApiGetLockStatusOfEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLockStatusOfEvidences(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant general blocks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantGeneralBlock(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantGeneralBlock(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant general block detail
     * @param {DefaultApiGetMerchantGeneralBlockDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantGeneralBlockDetail(requestParameters: DefaultApiGetMerchantGeneralBlockDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantGeneralBlockDetail(requestParameters.merchantGeneralBlockListId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant org blocks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantOrgBlock(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantOrgBlock(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant org block list
     * @param {DefaultApiGetMerchantOrgBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantOrgBlockList(requestParameters: DefaultApiGetMerchantOrgBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantOrgBlockList(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant organization user account year month summary
     * @param {DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantOrganizationUserAccountYearMonthSummary(requestParameters: DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantOrganizationUserAccountYearMonthSummary(requestParameters.organizationId, requestParameters.merchantId, requestParameters.userAccountId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of MerchantCategoryKind
     * @param {DefaultApiGetMerchantsCategoryKindsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchantsCategoryKinds(requestParameters: DefaultApiGetMerchantsCategoryKindsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchantsCategoryKinds(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Modifiable Daily Limits For The User Account
     * @param {DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getModifiableDailyLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableDailyLimitsForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getModifiableDailyLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get modifiable monthly limits for the user account
     * @param {DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getModifiableMonthlyLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableMonthlyLimitsForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getModifiableMonthlyLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Modifiable Transaction Limits For The User Account
     * @param {DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getModifiableTransactionLimitsForTheUserAccount(requestParameters: DefaultApiGetModifiableTransactionLimitsForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getModifiableTransactionLimitsForTheUserAccount(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get moneytree connected
     * @param {DefaultApiGetMoneytreeConnectedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMoneytreeConnected(requestParameters: DefaultApiGetMoneytreeConnectedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMoneytreeConnected(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get moneytree oauth url
     * @param {DefaultApiGetMoneytreeOauthUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMoneytreeOauthUrl(requestParameters: DefaultApiGetMoneytreeOauthUrlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMoneytreeOauthUrl(requestParameters.organizationId, requestParameters.nextTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get moneytree status
     * @param {DefaultApiGetMoneytreeStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMoneytreeStatus(requestParameters: DefaultApiGetMoneytreeStatusRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMoneytreeStatus(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get monthly card bills for specified yearMonths
     * @param {DefaultApiGetMonthlyCardBillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMonthlyCardBill(requestParameters: DefaultApiGetMonthlyCardBillRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMonthlyCardBill(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.startYearMonth, requestParameters.endYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get monthly card transactions for the organization.
     * @param {DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMonthlyCardTransactionsForTheOrganization(requestParameters: DefaultApiGetMonthlyCardTransactionsForTheOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMonthlyCardTransactionsForTheOrganization(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get monthly card transactions for the user
     * @param {DefaultApiGetMonthlyCardTransactionsForTheUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMonthlyCardTransactionsForTheUser(requestParameters: DefaultApiGetMonthlyCardTransactionsForTheUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMonthlyCardTransactionsForTheUser(requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定された組織・年月のFlora課金情報（サービス料金）を取得します。 年会費、ラウンジ利用料などのFlora課金明細を返却します。  **注意**: このAPIはFlora課金情報のみを返します。カード決済情報は `/cards/monthly_card_bill` APIを使用してください。 
     * @summary Get Monthly Service Charges
     * @param {DefaultApiGetMonthlyServiceChargesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMonthlyServiceCharges(requestParameters: DefaultApiGetMonthlyServiceChargesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMonthlyServiceCharges(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get monthly user card summaries
     * @param {DefaultApiGetMonthlyUserCardSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMonthlyUserCardSummaries(requestParameters: DefaultApiGetMonthlyUserCardSummariesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMonthlyUserCardSummaries(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get OL info sharing consent status
     * @param {DefaultApiGetOlInfoSharingConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOlInfoSharingConsent(requestParameters: DefaultApiGetOlInfoSharingConsentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOlInfoSharingConsent(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific onboarding request for zeus
     * @param {DefaultApiGetOnboardingRequestByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOnboardingRequestById(requestParameters: DefaultApiGetOnboardingRequestByIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOnboardingRequestById(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get personal information of the onboarding request.
     * @summary Get Personal Information
     * @param {DefaultApiGetOnboardingRequestPersonalInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOnboardingRequestPersonalInfo(requestParameters: DefaultApiGetOnboardingRequestPersonalInfoRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOnboardingRequestPersonalInfo(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get onboarding requests for zeus
     * @param {DefaultApiGetOnboardingRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOnboardingRequests(requestParameters: DefaultApiGetOnboardingRequestsRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOnboardingRequests(requestParameters.key, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get org account state
     * @param {DefaultApiGetOrgAccountStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrgAccountState(requestParameters: DefaultApiGetOrgAccountStateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrgAccountState(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization
     * @param {DefaultApiGetOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganization(requestParameters: DefaultApiGetOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganization(requestParameters.organizationId, requestParameters.underContractOnly, requestParameters.withCredit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Accounting Csv Fields Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationAccountingCsvFieldsTypes(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationAccountingCsvFieldsTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization cards extended
     * @param {DefaultApiGetOrganizationCardsExtendedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationCardsExtended(requestParameters: DefaultApiGetOrganizationCardsExtendedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationCardsExtended(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization cards light
     * @param {DefaultApiGetOrganizationCardsLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationCardsLight(requestParameters: DefaultApiGetOrganizationCardsLightRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationCardsLight(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization chart departments
     * @param {DefaultApiGetOrganizationChartDepartmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationChartDepartments(requestParameters: DefaultApiGetOrganizationChartDepartmentsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationChartDepartments(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization chart employees
     * @param {DefaultApiGetOrganizationChartEmployeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationChartEmployees(requestParameters: DefaultApiGetOrganizationChartEmployeesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationChartEmployees(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization chart roles
     * @param {DefaultApiGetOrganizationChartRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationChartRoles(requestParameters: DefaultApiGetOrganizationChartRolesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationChartRoles(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organizations create requests for zeus
     * @param {DefaultApiGetOrganizationCreateRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationCreateRequests(requestParameters: DefaultApiGetOrganizationCreateRequestsRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationCreateRequests(requestParameters.key, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationMe(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization payment schemes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationPaymentSchemes(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationPaymentSchemes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 請求画面トップのサマリー表示に必要な情報を、組織レベルで取得する。 個別の請求実体（CardBill / ServiceCharge）に依存せず、組織に設定されている 支払スキームと、対象支払予定日に紐づく合算情報を返す。  ## 用途 - UPSIDER 請求画面トップ（`/payments/`）のサマリーカード表示 - ETC-only 組織（CARD 請求が発生しない組織）でもサマリーを描画可能にする  ## 関連 - 個別請求の詳細取得は引き続き以下を使用：   - カード請求: `/cards/{cardBillId}`   - サービス利用料明細: `/organizations/{organizationId}/service_charges/{yearMonth}` - 請求一覧（履歴全件）の取得: `/organizations/{organizationId}/payments` 
     * @summary Get payment summary for organization
     * @param {DefaultApiGetOrganizationPaymentSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationPaymentSummary(requestParameters: DefaultApiGetOrganizationPaymentSummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationPaymentSummary(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization payments
     * @param {DefaultApiGetOrganizationPaymentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationPayments(requestParameters: DefaultApiGetOrganizationPaymentsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationPayments(requestParameters.organizationId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizations(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organizations Accounting Csv Export Fields
     * @param {DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationsAccountingCsvExportFields(requestParameters: DefaultApiGetOrganizationsAccountingCsvExportFieldsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationsAccountingCsvExportFields(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a organization\'s bill
     * @param {DefaultApiGetOrganizationsBillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationsBills(requestParameters: DefaultApiGetOrganizationsBillsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationsBills(requestParameters.organizationId, requestParameters.beforeReservationOnly, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organizations deals
     * @param {DefaultApiGetOrganizationsDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrganizationsDeals(requestParameters: DefaultApiGetOrganizationsDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrganizationsDeals(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment request detail
     * @param {DefaultApiGetPaymentRequestDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestDetail(requestParameters: DefaultApiGetPaymentRequestDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestDetail(requestParameters.organizationId, requestParameters.paymentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a payment request evidence specified by evidenceId.
     * @summary Get a specific payment request evidence.
     * @param {DefaultApiGetPaymentRequestEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidence(requestParameters: DefaultApiGetPaymentRequestEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment request evidence file
     * @param {DefaultApiGetPaymentRequestEvidenceFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidenceFile(requestParameters: DefaultApiGetPaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment request evidence record file
     * @param {DefaultApiGetPaymentRequestEvidenceRecordFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidenceRecordFile(requestParameters: DefaultApiGetPaymentRequestEvidenceRecordFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidenceRecordFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.recordId, requestParameters.inPdf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment request evidence records
     * @param {DefaultApiGetPaymentRequestEvidenceRecordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidenceRecords(requestParameters: DefaultApiGetPaymentRequestEvidenceRecordsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidenceRecords(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all evidences for a specific payment request
     * @param {DefaultApiGetPaymentRequestEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestEvidences(requestParameters: DefaultApiGetPaymentRequestEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestEvidences(requestParameters.organizationId, requestParameters.paymentRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment requests bank accounts list
     * @param {DefaultApiGetPaymentRequestsBankAccountsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestsBankAccountsList(requestParameters: DefaultApiGetPaymentRequestsBankAccountsListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestsBankAccountsList(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment requests count linked bank transfer
     * @param {DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentRequestsCountLinkedBankTransfer(requestParameters: DefaultApiGetPaymentRequestsCountLinkedBankTransferRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentRequestsCountLinkedBankTransfer(requestParameters.organizationId, requestParameters.paymentRequestIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get pinretriever decrypt pin block
     * @param {DefaultApiGetPinretrieverDecryptPinBlockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPinretrieverDecryptPinBlock(requestParameters: DefaultApiGetPinretrieverDecryptPinBlockRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPinretrieverDecryptPinBlock(requestParameters.getPinretrieverDecryptPinBlockRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get pinretriever encrypt pin
     * @param {DefaultApiGetPinretrieverEncryptPinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPinretrieverEncryptPin(requestParameters: DefaultApiGetPinretrieverEncryptPinRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPinretrieverEncryptPin(requestParameters.getPinretrieverEncryptPinRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get pinretriever hsm publickey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPinretrieverHsmPublickey(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPinretrieverHsmPublickey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchase application
     * @param {DefaultApiGetPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplication(requestParameters: DefaultApiGetPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchase application templates
     * @param {DefaultApiGetPurchaseApplicationTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationTemplates(requestParameters: DefaultApiGetPurchaseApplicationTemplatesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationTemplates(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchase application templates detail
     * @param {DefaultApiGetPurchaseApplicationTemplatesDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationTemplatesDetail(requestParameters: DefaultApiGetPurchaseApplicationTemplatesDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationTemplatesDetail(requestParameters.organizationId, requestParameters.purchaseTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get purchase applications
     * @param {DefaultApiGetPurchaseApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplications(requestParameters: DefaultApiGetPurchaseApplicationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplications(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.visaTransactionReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiGetPurchaseApplicationsRequestedCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationsRequestedCount(requestParameters: DefaultApiGetPurchaseApplicationsRequestedCountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationsRequestedCount(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the purchase applications requested list
     * @param {DefaultApiGetPurchaseApplicationsRequestedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationsRequestedList(requestParameters: DefaultApiGetPurchaseApplicationsRequestedListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationsRequestedList(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the purchase applications submitted self
     * @param {DefaultApiGetPurchaseApplicationsSubmittedSelfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPurchaseApplicationsSubmittedSelf(requestParameters: DefaultApiGetPurchaseApplicationsSubmittedSelfRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPurchaseApplicationsSubmittedSelf(requestParameters.userId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get(search) qualified invoice issuer
     * @param {DefaultApiGetQualifiedInvoiceIssuerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getQualifiedInvoiceIssuer(requestParameters: DefaultApiGetQualifiedInvoiceIssuerRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getQualifiedInvoiceIssuer(requestParameters.registrationNumber, requestParameters.issuerName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Redirect URL from Tiny URL
     * @param {DefaultApiGetRedirectUrlFromTinyUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRedirectUrlFromTinyUrl(requestParameters: DefaultApiGetRedirectUrlFromTinyUrlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRedirectUrlFromTinyUrl(requestParameters.tinyUrlParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the reward points balance for the specified organization.
     * @summary Get reward points balance
     * @param {DefaultApiGetRewardPointBalanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRewardPointBalance(requestParameters: DefaultApiGetRewardPointBalanceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRewardPointBalance(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get reward point transactions for the specified organization
     * @summary Get reward point transactions
     * @param {DefaultApiGetRewardPointTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRewardPointTransactions(requestParameters: DefaultApiGetRewardPointTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRewardPointTransactions(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Rewards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRewards(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRewards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get role resource for user
     * @param {DefaultApiGetRoleResourceForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRoleResourceForUser(requestParameters: DefaultApiGetRoleResourceForUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRoleResourceForUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get roles
     * @param {DefaultApiGetRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRoles(requestParameters: DefaultApiGetRolesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRoles(requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Roles with Top Related Resources
     * @param {DefaultApiGetRolesWithTopRelatedResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRolesWithTopRelatedResources(requestParameters: DefaultApiGetRolesWithTopRelatedResourcesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRolesWithTopRelatedResources(requestParameters.resourceScope, requestParameters.resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Roles with Top Related Resources by Organization id
     * @param {DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRolesWithTopRelatedResourcesByOrganizationId(requestParameters: DefaultApiGetRolesWithTopRelatedResourcesByOrganizationIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRolesWithTopRelatedResourcesByOrganizationId(requestParameters.organizationId, requestParameters.resourceScope, requestParameters.resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack card notification settings of an organization
     * @param {DefaultApiGetSlackCardNotificationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackCardNotificationSettings(requestParameters: DefaultApiGetSlackCardNotificationSettingsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackCardNotificationSettings(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Slack channels of an organization by SlackChannelID
     * @param {DefaultApiGetSlackChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackChannel(requestParameters: DefaultApiGetSlackChannelRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack channels of an organization
     * @param {DefaultApiGetSlackChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackChannels(requestParameters: DefaultApiGetSlackChannelsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackChannels(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack channels with cursor of an organization
     * @param {DefaultApiGetSlackChannelsWithCursorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackChannelsWithCursor(requestParameters: DefaultApiGetSlackChannelsWithCursorRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackChannelsWithCursor(requestParameters.organizationId, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack evidence remind settings of an organization
     * @param {DefaultApiGetSlackEvidenceReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackEvidenceReminder(requestParameters: DefaultApiGetSlackEvidenceReminderRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackEvidenceReminder(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack evidence remind settings of an slack channel
     * @param {DefaultApiGetSlackEvidenceReminderPerChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackEvidenceReminderPerChannel(requestParameters: DefaultApiGetSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackEvidenceReminderPerChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get slack notification channel setting for purchase-application
     * @param {DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackNotificationChannelSettingForPurchaseApplication(requestParameters: DefaultApiGetSlackNotificationChannelSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackNotificationChannelSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get slack notification settings for purchase-application
     * @param {DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackNotificationSettingsForPurchaseApplication(requestParameters: DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackNotificationSettingsForPurchaseApplication(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack team
     * @param {DefaultApiGetSlackTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackTeam(requestParameters: DefaultApiGetSlackTeamRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackTeam(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Slack version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSlackVersion(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSlackVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get submitted trustdock data
     * @param {DefaultApiGetSubmittedTrustdockDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSubmittedTrustdockData(requestParameters: DefaultApiGetSubmittedTrustdockDataRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSubmittedTrustdockData(requestParameters.trustdockIdentificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get suspicious transaction detail list
     * @param {DefaultApiGetSuspiciousTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSuspiciousTransactions(requestParameters: DefaultApiGetSuspiciousTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSuspiciousTransactions(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams card notification settings of an organization
     * @param {DefaultApiGetTeamsCardNotificationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsCardNotificationSettings(requestParameters: DefaultApiGetTeamsCardNotificationSettingsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsCardNotificationSettings(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams channels of an organization by TeamsChannelID
     * @param {DefaultApiGetTeamsChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsChannel(requestParameters: DefaultApiGetTeamsChannelRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsChannel(requestParameters.organizationId, requestParameters.channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams channels with cursor of an organization
     * @param {DefaultApiGetTeamsChannelsWithCursorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsChannelsWithCursor(requestParameters: DefaultApiGetTeamsChannelsWithCursorRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsChannelsWithCursor(requestParameters.organizationId, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams team
     * @param {DefaultApiGetTeamsTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsTeam(requestParameters: DefaultApiGetTeamsTeamRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsTeam(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Teams version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTeamsVersion(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTeamsVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Technical Support Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTechnicalSupportUsers(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTechnicalSupportUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Tfa App QR Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTfaAppQrCode(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTfaAppQrCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTfaAppRecoveryCode(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTfaAppRecoveryCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get TFA SMS Recovery Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTfaSmsRecoveryCode(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTfaSmsRecoveryCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the count of monthly transactions for the user account
     * @param {DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTheCountOfMonthlyTransactionsForTheUserAccount(requestParameters: DefaultApiGetTheCountOfMonthlyTransactionsForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTheCountOfMonthlyTransactionsForTheUserAccount(requestParameters.userAccountId, requestParameters.yearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the user account information
     * @param {DefaultApiGetTheUserAccountInformationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTheUserAccountInformation(requestParameters: DefaultApiGetTheUserAccountInformationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTheUserAccountInformation(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transaction evidence email address
     * @param {DefaultApiGetTransactionEvidenceEmailAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTransactionEvidenceEmailAddress(requestParameters: DefaultApiGetTransactionEvidenceEmailAddressRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTransactionEvidenceEmailAddress(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Transaction Evidence Email File
     * @param {DefaultApiGetTransactionEvidenceEmailFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTransactionEvidenceEmailFile(requestParameters: DefaultApiGetTransactionEvidenceEmailFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTransactionEvidenceEmailFile(requestParameters.userAccountId, requestParameters.transactionEvidenceEmailFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transaction evidence emails
     * @param {DefaultApiGetTransactionEvidenceEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTransactionEvidenceEmails(requestParameters: DefaultApiGetTransactionEvidenceEmailsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTransactionEvidenceEmails(requestParameters.userAccountId, requestParameters.startYearMonth, requestParameters.endYearMonth, requestParameters.isTrash, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Trustdock Identity Verifications
     * @param {DefaultApiGetTrustdockIdentityVerificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrustdockIdentityVerifications(requestParameters: DefaultApiGetTrustdockIdentityVerificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrustdockIdentityVerifications(requestParameters.trustdockIdentificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Trustdock Submit Identification Document Publish URL
     * @param {DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrustdockSubmitIdentificationDocumentPublishUrl(requestParameters: DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrustdockSubmitIdentificationDocumentPublishUrl(requestParameters.trustdockIdentificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Trustdock Verifications
     * @param {DefaultApiGetTrustdockVerificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTrustdockVerifications(requestParameters: DefaultApiGetTrustdockVerificationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTrustdockVerifications(requestParameters.trustdockIdentificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get unread message count for a user
     * @param {DefaultApiGetUnreadMessageCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUnreadMessageCount(requestParameters: DefaultApiGetUnreadMessageCountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUnreadMessageCount(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an usage fee
     * @param {DefaultApiGetUsageFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUsageFee(requestParameters: DefaultApiGetUsageFeeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUsageFee(requestParameters.usageFeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user account groups
     * @param {DefaultApiGetUserAccountGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserAccountGroups(requestParameters: DefaultApiGetUserAccountGroupsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserAccountGroups(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user account year month summary
     * @param {DefaultApiGetUserAccountYearMonthSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserAccountYearMonthSummary(requestParameters: DefaultApiGetUserAccountYearMonthSummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserAccountYearMonthSummary(requestParameters.organizationId, requestParameters.toYearMonth, requestParameters.fromYearMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user accounts with default comment template
     * @param {DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserAccountsWithDefaultCommentTemplate(requestParameters: DefaultApiGetUserAccountsWithDefaultCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserAccountsWithDefaultCommentTemplate(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards
     * @param {DefaultApiGetUserCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCards(requestParameters: DefaultApiGetUserCardsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCards(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards extended
     * @param {DefaultApiGetUserCardsExtendedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCardsExtended(requestParameters: DefaultApiGetUserCardsExtendedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCardsExtended(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards extended for role resources
     * @param {DefaultApiGetUserCardsExtendedForRoleResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCardsExtendedForRoleResources(requestParameters: DefaultApiGetUserCardsExtendedForRoleResourcesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCardsExtendedForRoleResources(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards light
     * @param {DefaultApiGetUserCardsLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCardsLight(requestParameters: DefaultApiGetUserCardsLightRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCardsLight(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user cards light for role resources
     * @param {DefaultApiGetUserCardsLightForRoleResourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCardsLightForRoleResources(requestParameters: DefaultApiGetUserCardsLightForRoleResourcesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCardsLightForRoleResources(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get ETC card count for a user
     * @param {DefaultApiGetUserEtcCardCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserEtcCardCount(requestParameters: DefaultApiGetUserEtcCardCountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserEtcCardCount(requestParameters.userId, requestParameters.searchWord, requestParameters.groups, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get ETC cards for a user
     * @param {DefaultApiGetUserEtcCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserEtcCards(requestParameters: DefaultApiGetUserEtcCardsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserEtcCards(requestParameters.userId, requestParameters.searchWord, requestParameters.groups, requestParameters.limit, requestParameters.nextCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get message detail
     * @param {DefaultApiGetUserMessageDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserMessageDetail(requestParameters: DefaultApiGetUserMessageDetailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserMessageDetail(requestParameters.userMessageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get messages for a user
     * @param {DefaultApiGetUserMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserMessages(requestParameters: DefaultApiGetUserMessagesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserMessages(requestParameters.userId, requestParameters.offset, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users
     * @param {DefaultApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUsers(requestParameters: DefaultApiGetUsersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUsers(requestParameters.organizationId, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get information on login user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUsersMe(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUsersMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get venture capitals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getVentureCapitals(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getVentureCapitals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定された組織の取引時確認詳細情報を取得します。 createdAtの降順で返却されます。 
     * @summary 取引時確認詳細取得（ZEUS)(PRESIDENT)
     * @param {DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getZeusOrganizationIdentityVerificationsForPresident(requestParameters: DefaultApiGetZeusOrganizationIdentityVerificationsForPresidentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getZeusOrganizationIdentityVerificationsForPresident(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organizations for zeus
     * @param {DefaultApiGetZeusOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getZeusOrganizations(requestParameters: DefaultApiGetZeusOrganizationsRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getZeusOrganizations(requestParameters.key, requestParameters.limit, requestParameters.offset, requestParameters.sort, requestParameters.connectedMoneytree, requestParameters.brandType, requestParameters.isSuspended, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * give points to organizations in bulk
     * @param {DefaultApiGivePointsToOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public givePointsToOrganizations(requestParameters: DefaultApiGivePointsToOrganizationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).givePointsToOrganizations(requestParameters.givePointsToOrganizationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initialize Modifiable Limit For The User Accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public initializeModifiableLimitForTheUserAccounts(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).initializeModifiableLimitForTheUserAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates ETC card service for the specified organization. This creates an ETC account on the yachi microservice that will manage ETC cards. The orgAccountId is derived internally from the organizationId.
     * @summary Initiate ETC service for an organization
     * @param {DefaultApiInitiateEtcServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public initiateEtcService(requestParameters: DefaultApiInitiateEtcServiceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).initiateEtcService(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 保持している challengeSuccessToken がまだ有効かどうかを確認する。 保護対象エンドポイントを実際に叩く前に、フロントがチャレンジモーダルを 表示すべきか判断する用途を想定。 
     * @summary challengeSuccessToken の有効性確認
     * @param {DefaultApiIntrospectChallengeSuccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public introspectChallengeSuccessToken(requestParameters: DefaultApiIntrospectChallengeSuccessTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).introspectChallengeSuccessToken(requestParameters.userId, requestParameters.introspectChallengeSuccessTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invite a new user from user
     * @param {DefaultApiInviteUserFromUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inviteUserFromUser(requestParameters: DefaultApiInviteUserFromUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inviteUserFromUser(requestParameters.inviteUserFromUserRequest, requestParameters.xChallengeSuccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 6桁コードを生成し、登録済みメールアドレスへ送信する。 同一 (userId, scope) の組に既に有効なチャレンジが存在する場合は置き換える （異なる scope のチャレンジは互いに影響せず並行して有効）。 
     * @summary sudo-mode チャレンジの発行
     * @param {DefaultApiIssueChallengeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public issueChallenge(requestParameters: DefaultApiIssueChallengeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).issueChallenge(requestParameters.userId, requestParameters.issueChallengeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Linking purchase to transaction.
     * @param {DefaultApiLinkingPurchaseToTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public linkingPurchaseToTransaction(requestParameters: DefaultApiLinkingPurchaseToTransactionRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).linkingPurchaseToTransaction(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.visaTransactionReferenceId, requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lock a card due to potential fraud
     * @param {DefaultApiLockCardForPotentialFraudRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public lockCardForPotentialFraud(requestParameters: DefaultApiLockCardForPotentialFraudRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).lockCardForPotentialFraud(requestParameters.organizationId, requestParameters.cardId, requestParameters.lockCardForPotentialFraudRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lock a card due to fraud detected
     * @param {DefaultApiLockCardOnFraudDetectedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public lockCardOnFraudDetected(requestParameters: DefaultApiLockCardOnFraudDetectedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).lockCardOnFraudDetected(requestParameters.organizationId, requestParameters.cardId, requestParameters.lockCardOnFraudDetectedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login
     * @param {DefaultApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public login(requestParameters: DefaultApiLoginRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).login(requestParameters.loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with APP two factor auth
     * @param {DefaultApiLoginAppRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginApp(requestParameters: DefaultApiLoginAppRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginApp(requestParameters.loginAppRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with recovery code of two factor auth
     * @param {DefaultApiLoginRecoveryCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginRecoveryCode(requestParameters: DefaultApiLoginRecoveryCodeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginRecoveryCode(requestParameters.loginRecoveryCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with SMS two factor auth
     * @param {DefaultApiLoginSmsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginSms(requestParameters: DefaultApiLoginSmsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginSms(requestParameters.loginSmsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public logout(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move slack notification channel setting for card
     * @param {DefaultApiMoveSlackNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public moveSlackNotificationSettingForCard(requestParameters: DefaultApiMoveSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).moveSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.currentChannelId, requestParameters.moveSlackNotificationSettingForCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move teams notification channel setting for card
     * @param {DefaultApiMoveTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public moveTeamsNotificationSettingForCard(requestParameters: DefaultApiMoveTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).moveTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.currentChannelId, requestParameters.moveTeamsNotificationSettingForCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Organization Create Pre Request
     * @param {DefaultApiOrganizationCreatePreRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public organizationCreatePreRequest(requestParameters: DefaultApiOrganizationCreatePreRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).organizationCreatePreRequest(requestParameters.organizationCreatePreRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Parse organization chart for workflow
     * @param {DefaultApiParseOrganizationChartForWorkflowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public parseOrganizationChartForWorkflow(requestParameters: DefaultApiParseOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).parseOrganizationChartForWorkflow(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Addition Merchant General Block List
     * @param {DefaultApiPostAdditionMerchantGeneralBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postAdditionMerchantGeneralBlockList(requestParameters: DefaultApiPostAdditionMerchantGeneralBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postAdditionMerchantGeneralBlockList(requestParameters.postAdditionMerchantGeneralBlockListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostAlliancesGcpApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postAlliancesGcpApplications(requestParameters: DefaultApiPostAlliancesGcpApplicationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postAlliancesGcpApplications(requestParameters.organizationId, requestParameters.postAlliancesGcpApplicationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostAlliancesGwsApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postAlliancesGwsApplications(requestParameters: DefaultApiPostAlliancesGwsApplicationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postAlliancesGwsApplications(requestParameters.organizationId, requestParameters.postAlliancesGwsApplicationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Bank Account Balances
     * @param {DefaultApiPostBalancesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postBalances(requestParameters: DefaultApiPostBalancesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postBalances(requestParameters.postBalancesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Bulk Addition Merchant Org Block Lists
     * @param {DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postBulkAdditionMerchantOrgBlockLists(requestParameters: DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postBulkAdditionMerchantOrgBlockLists(requestParameters.organizationId, requestParameters.postBulkAdditionMerchantOrgBlockListsRequestInner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary freee認可コールバック
     * @param {DefaultApiPostCallbackFreeeAuthForAccountingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postCallbackFreeeAuthForAccounting(requestParameters: DefaultApiPostCallbackFreeeAuthForAccountingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postCallbackFreeeAuthForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.postCallbackFreeeAuthForAccountingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks whether the current user is eligible for canary routing and sets appropriate cookie
     * @summary Check if user is eligible for canary routing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postCanaryRoutingCheck(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postCanaryRoutingCheck(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post a cancel request for a evidence request
     * @param {DefaultApiPostCancelRequestForEvidenceRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postCancelRequestForEvidenceRequest(requestParameters: DefaultApiPostCancelRequestForEvidenceRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postCancelRequestForEvidenceRequest(requestParameters.organizationId, requestParameters.paymentReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostCardsVirtualIssueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postCardsVirtualIssue(requestParameters: DefaultApiPostCardsVirtualIssueRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postCardsVirtualIssue(requestParameters.postCardsVirtualIssueRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postCardsVirtualOndemandIssue(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postCardsVirtualOndemandIssue(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload identity document file with verification information.
     * @summary Upload Identity Document
     * @param {DefaultApiPostFaceToFaceKycIdentityDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postFaceToFaceKycIdentityDocument(requestParameters: DefaultApiPostFaceToFaceKycIdentityDocumentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postFaceToFaceKycIdentityDocument(requestParameters.onboardingRequestId, requestParameters.file, requestParameters.personalDocumentType, requestParameters.verifiedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit a face-to-face KYC request.
     * @summary Face-to-face KYC Request
     * @param {DefaultApiPostFaceToFaceKycRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postFaceToFaceKycRequest(requestParameters: DefaultApiPostFaceToFaceKycRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postFaceToFaceKycRequest(requestParameters.postFaceToFaceKycRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Freee Account for Points
     * @param {DefaultApiPostFreeeAccountForPointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postFreeeAccountForPoints(requestParameters: DefaultApiPostFreeeAccountForPointsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postFreeeAccountForPoints(requestParameters.organizationId, requestParameters.postFreeeAccountForPointsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostKycconsultingWebhooksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postKycconsultingWebhooks(requestParameters: DefaultApiPostKycconsultingWebhooksRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postKycconsultingWebhooks(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Moneytree Refresh Request
     * @param {DefaultApiPostMoneytreeRefreshRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postMoneytreeRefreshRequest(requestParameters: DefaultApiPostMoneytreeRefreshRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postMoneytreeRefreshRequest(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post Moneytree Refresh Request for All Organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postMoneytreeRefreshRequestAll(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postMoneytreeRefreshRequestAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create organizations deals
     * @param {DefaultApiPostOrganizationsDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postOrganizationsDeals(requestParameters: DefaultApiPostOrganizationsDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postOrganizationsDeals(requestParameters.organizationId, requestParameters.postOrganizationsDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create point claw backs
     * @param {DefaultApiPostOrganizationsPointClawBacksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postOrganizationsPointClawBacks(requestParameters: DefaultApiPostOrganizationsPointClawBacksRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postOrganizationsPointClawBacks(requestParameters.organizationId, requestParameters.postOrganizationsPointClawBacksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post payment requests bank account
     * @param {DefaultApiPostPaymentRequestsBankAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postPaymentRequestsBankAccount(requestParameters: DefaultApiPostPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postPaymentRequestsBankAccount(requestParameters.organizationId, requestParameters.postPaymentRequestsBankAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post slack message to coworker
     * @param {DefaultApiPostSlackMessageToCoworkerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postSlackMessageToCoworker(requestParameters: DefaultApiPostSlackMessageToCoworkerRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postSlackMessageToCoworker(requestParameters.organizationId, requestParameters.postSlackMessageToCoworkerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Bank Account Transactions
     * @param {DefaultApiPostTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postTransactions(requestParameters: DefaultApiPostTransactionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postTransactions(requestParameters.postTransactionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostTrustdockWebhooksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postTrustdockWebhooks(requestParameters: DefaultApiPostTrustdockWebhooksRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postTrustdockWebhooks(requestParameters.postTrustdockWebhooksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DefaultApiPostTrustdockWebhooksSnailMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postTrustdockWebhooksSnailMail(requestParameters: DefaultApiPostTrustdockWebhooksSnailMailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postTrustdockWebhooksSnailMail(requestParameters.postTrustdockWebhooksSnailMailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put disable feature flag
     * @param {DefaultApiPutDisableFeatureFlagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putDisableFeatureFlag(requestParameters: DefaultApiPutDisableFeatureFlagRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putDisableFeatureFlag(requestParameters.organizationId, requestParameters.featureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put enabled feature flag
     * @param {DefaultApiPutEnabledFeatureFlagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putEnabledFeatureFlag(requestParameters: DefaultApiPutEnabledFeatureFlagRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putEnabledFeatureFlag(requestParameters.organizationId, requestParameters.featureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Freee End Journal Entry Transition Mode
     * @param {DefaultApiPutFreeeEndJournalEntryTransitionModeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putFreeeEndJournalEntryTransitionMode(requestParameters: DefaultApiPutFreeeEndJournalEntryTransitionModeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putFreeeEndJournalEntryTransitionMode(requestParameters.organizationId, requestParameters.putFreeeEndJournalEntryTransitionModeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Organization Payment Method
     * @param {DefaultApiPutOrganizationPaymentMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putOrganizationPaymentMethod(requestParameters: DefaultApiPutOrganizationPaymentMethodRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putOrganizationPaymentMethod(requestParameters.organizationId, requestParameters.putOrganizationPaymentMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put organizations deals
     * @param {DefaultApiPutOrganizationsDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putOrganizationsDeals(requestParameters: DefaultApiPutOrganizationsDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putOrganizationsDeals(requestParameters.organizationId, requestParameters.putOrganizationsDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update payment request
     * @param {DefaultApiPutPaymentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putPaymentRequest(requestParameters: DefaultApiPutPaymentRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putPaymentRequest(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.putPaymentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put payment requests bank account
     * @param {DefaultApiPutPaymentRequestsBankAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putPaymentRequestsBankAccount(requestParameters: DefaultApiPutPaymentRequestsBankAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putPaymentRequestsBankAccount(requestParameters.organizationId, requestParameters.bankAccountId, requestParameters.putPaymentRequestsBankAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put transaction evidence emails link to transaction
     * @param {DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putTransactionEvidenceEmailsLinkToTransaction(requestParameters: DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putTransactionEvidenceEmailsLinkToTransaction(requestParameters.putTransactionEvidenceEmailsLinkToTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put transaction evidence emails mark as read
     * @param {DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putTransactionEvidenceEmailsMarkAsRead(requestParameters: DefaultApiPutTransactionEvidenceEmailsMarkAsReadRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putTransactionEvidenceEmailsMarkAsRead(requestParameters.putTransactionEvidenceEmailsMarkAsReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put transaction evidence emails move to trash
     * @param {DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putTransactionEvidenceEmailsMoveToTrash(requestParameters: DefaultApiPutTransactionEvidenceEmailsMoveToTrashRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putTransactionEvidenceEmailsMoveToTrash(requestParameters.putTransactionEvidenceEmailsMoveToTrashRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Give reward point to organization
     * @param {DefaultApiPutZeusGiveRewardPointsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putZeusGiveRewardPoints(requestParameters: DefaultApiPutZeusGiveRewardPointsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putZeusGiveRewardPoints(requestParameters.organizationId, requestParameters.putZeusGiveRewardPointsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query by ids payment requests
     * @param {DefaultApiQueryByIdsPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public queryByIdsPaymentRequests(requestParameters: DefaultApiQueryByIdsPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).queryByIdsPaymentRequests(requestParameters.organizationId, requestParameters.queryByIdsPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update read status of a message
     * @param {DefaultApiReadUserMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public readUserMessage(requestParameters: DefaultApiReadUserMessageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).readUserMessage(requestParameters.userMessageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary register note
     * @param {DefaultApiRegisterNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerNote(requestParameters: DefaultApiRegisterNoteRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerNote(requestParameters.onboardingRequestId, requestParameters.registerNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register note for organization identity verification
     * @param {DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerNoteForOrganizationIdentityVerification(requestParameters: DefaultApiRegisterNoteForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerNoteForOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, requestParameters.registerNoteForOrganizationIdentityVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register an organization using the onboarding request ID
     * @param {DefaultApiRegisterOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerOrganization(requestParameters: DefaultApiRegisterOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerOrganization(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register organization chart for workflow
     * @param {DefaultApiRegisterOrganizationChartForWorkflowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerOrganizationChartForWorkflow(requestParameters: DefaultApiRegisterOrganizationChartForWorkflowRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerOrganizationChartForWorkflow(requestParameters.organizationId, requestParameters.registerOrganizationChartForWorkflowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register Tfa App Verification Code
     * @param {DefaultApiRegisterTfaAppVerificationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerTfaAppVerificationCode(requestParameters: DefaultApiRegisterTfaAppVerificationCodeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerTfaAppVerificationCode(requestParameters.registerTfaAppVerificationCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register Tfa SMS Auth
     * @param {DefaultApiRegisterTfaSmsAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerTfaSmsAuth(requestParameters: DefaultApiRegisterTfaSmsAuthRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerTfaSmsAuth(requestParameters.registerTfaSmsAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register transaction evidence email address
     * @param {DefaultApiRegisterTransactionEvidenceEmailAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public registerTransactionEvidenceEmailAddress(requestParameters: DefaultApiRegisterTransactionEvidenceEmailAddressRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).registerTransactionEvidenceEmailAddress(requestParameters.userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reissue a card
     * @param {DefaultApiReissueCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public reissueCard(requestParameters: DefaultApiReissueCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).reissueCard(requestParameters.cardId, requestParameters.reissueCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject Organization Identity Verification
     * @param {DefaultApiRejectOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rejectOrganizationIdentityVerification(requestParameters: DefaultApiRejectOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rejectOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject purchase application.
     * @param {DefaultApiRejectPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rejectPurchaseApplication(requestParameters: DefaultApiRejectPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rejectPurchaseApplication(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.rejectPurchaseApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public remindCardTransactionEvidence(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).remindCardTransactionEvidence(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remind monthly payment notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public remindMonthlyPaymentNotifications(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).remindMonthlyPaymentNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remind organization monthly payment notifications.
     * @param {DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public remindOrganizationMonthlyPaymentNotification(requestParameters: DefaultApiRemindOrganizationMonthlyPaymentNotificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).remindOrganizationMonthlyPaymentNotification(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove fraud lock status
     * @param {DefaultApiRemoveFraudLockStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeFraudLockStatus(requestParameters: DefaultApiRemoveFraudLockStatusRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).removeFraudLockStatus(requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename user account group
     * @param {DefaultApiRenameUserAccountGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public renameUserAccountGroup(requestParameters: DefaultApiRenameUserAccountGroupRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).renameUserAccountGroup(requestParameters.userAccountGroupId, requestParameters.renameUserAccountGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace Virtual Card
     * @param {DefaultApiReplaceVirtualCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public replaceVirtualCard(requestParameters: DefaultApiReplaceVirtualCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).replaceVirtualCard(requestParameters.userAccountId, requestParameters.replaceVirtualCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary request add system admin role
     * @param {DefaultApiRequestAddSystemAdminRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestAddSystemAdminRole(requestParameters: DefaultApiRequestAddSystemAdminRoleRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestAddSystemAdminRole(requestParameters.userId, requestParameters.requestAddSystemAdminRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request sending physical cards
     * @param {DefaultApiRequestSendingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestSending(requestParameters: DefaultApiRequestSendingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestSending(requestParameters.organizationId, requestParameters.requestSendingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request sending a metal card
     * @param {DefaultApiRequestSendingMetalCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestSendingMetalCard(requestParameters: DefaultApiRequestSendingMetalCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestSendingMetalCard(requestParameters.organizationId, requestParameters.requestSendingMetalCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ポイント明細の同期リクエスト
     * @param {DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestSyncBankTransactionsToFreeeForAccounting(requestParameters: DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestSyncBankTransactionsToFreeeForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.requestSyncBankTransactionsToFreeeForAccountingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 決済明細の同期リクエスト
     * @param {DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestSyncCardTransactionsToFreeeForAccounting(requestParameters: DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestSyncCardTransactionsToFreeeForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.requestSyncCardTransactionsToFreeeForAccountingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestSyncingClearedTransaction(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestSyncingClearedTransaction(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request to Generate Organizations Accounting Csv in Background
     * @param {DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestToOrganizationsAccountingCsvInBackground(requestParameters: DefaultApiRequestToOrganizationsAccountingCsvInBackgroundRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestToOrganizationsAccountingCsvInBackground(requestParameters.organizationId, requestParameters.yearMonth, requestParameters.isMergedFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary request update system admin role
     * @param {DefaultApiRequestUpdateSystemAdminRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public requestUpdateSystemAdminRole(requestParameters: DefaultApiRequestUpdateSystemAdminRoleRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).requestUpdateSystemAdminRole(requestParameters.userId, requestParameters.requestUpdateSystemAdminRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend Snail Mail For Organization Identity Verification
     * @param {DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resendSnailMailForOrganizationIdentityVerification(requestParameters: DefaultApiResendSnailMailForOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resendSnailMailForOrganizationIdentityVerification(requestParameters.organizationIdentityVerificationId, requestParameters.resendSnailMailForOrganizationIdentityVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend an invitation to a new user
     * @param {DefaultApiResendUserInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resendUserInvite(requestParameters: DefaultApiResendUserInviteRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resendUserInvite(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resume a suspended card
     * @param {DefaultApiResumeCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resumeCard(requestParameters: DefaultApiResumeCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resumeCard(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resynchronize card transactions for freee
     * @param {DefaultApiResynchronizeCardTransactionsForFreeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resynchronizeCardTransactionsForFreee(requestParameters: DefaultApiResynchronizeCardTransactionsForFreeeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resynchronizeCardTransactionsForFreee(requestParameters.organizationId, requestParameters.resynchronizeCardTransactionsForFreeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deal as draft
     * @param {DefaultApiSaveDealAsDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealAsDraft(requestParameters: DefaultApiSaveDealAsDraftRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealAsDraft(requestParameters.organizationId, requestParameters.dealId, requestParameters.saveDealAsDraftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save Deal As Ignore
     * @param {DefaultApiSaveDealAsIgnoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealAsIgnore(requestParameters: DefaultApiSaveDealAsIgnoreRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealAsIgnore(requestParameters.organizationId, requestParameters.dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deal as return to editing
     * @param {DefaultApiSaveDealAsReturnToEditingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealAsReturnToEditing(requestParameters: DefaultApiSaveDealAsReturnToEditingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealAsReturnToEditing(requestParameters.organizationId, requestParameters.dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deal with journalizing
     * @param {DefaultApiSaveDealWithJournalizingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealWithJournalizing(requestParameters: DefaultApiSaveDealWithJournalizingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealWithJournalizing(requestParameters.organizationId, requestParameters.dealId, requestParameters.saveDealWithJournalizingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deals as ignore
     * @param {DefaultApiSaveDealsAsIgnoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealsAsIgnore(requestParameters: DefaultApiSaveDealsAsIgnoreRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealsAsIgnore(requestParameters.organizationId, requestParameters.saveDealsAsIgnoreRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deals as journalized
     * @param {DefaultApiSaveDealsAsJournalizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealsAsJournalized(requestParameters: DefaultApiSaveDealsAsJournalizedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealsAsJournalized(requestParameters.organizationId, requestParameters.saveDealsAsJournalizedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deals as return to editing
     * @param {DefaultApiSaveDealsAsReturnToEditingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public saveDealsAsReturnToEditing(requestParameters: DefaultApiSaveDealsAsReturnToEditingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).saveDealsAsReturnToEditing(requestParameters.organizationId, requestParameters.saveDealsAsReturnToEditingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search bank transfers
     * @param {DefaultApiSearchBankTransfersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchBankTransfers(requestParameters: DefaultApiSearchBankTransfersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchBankTransfers(requestParameters.organizationId, requestParameters.transferDateJstFrom, requestParameters.transferDateJstTo, requestParameters.sourceBankAccountId, requestParameters.downloaded, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Corporations In National Tax Agency
     * @param {DefaultApiSearchCorporationsInNationalTaxAgencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchCorporationsInNationalTaxAgency(requestParameters: DefaultApiSearchCorporationsInNationalTaxAgencyRequest = {}, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchCorporationsInNationalTaxAgency(requestParameters.name, requestParameters.searchMethod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search deals
     * @param {DefaultApiSearchDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchDeals(requestParameters: DefaultApiSearchDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchDeals(requestParameters.organizationId, requestParameters.searchDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search evidences
     * @param {DefaultApiSearchEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchEvidences(requestParameters: DefaultApiSearchEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchEvidences(requestParameters.organizationId, requestParameters.issuer, requestParameters.amountMin, requestParameters.amountMax, requestParameters.paidAtFrom, requestParameters.paidAtTo, requestParameters.irrelevantToLedger, requestParameters.keyword, requestParameters.includesDeleted, requestParameters.legalValidities, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search my payment requests
     * @param {DefaultApiSearchMyPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchMyPaymentRequests(requestParameters: DefaultApiSearchMyPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchMyPaymentRequests(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.requestedDateJstFrom, requestParameters.requestedDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Organizations
     * @param {DefaultApiSearchOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchOrganizations(requestParameters: DefaultApiSearchOrganizationsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchOrganizations(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search payment requests
     * @param {DefaultApiSearchPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchPaymentRequests(requestParameters: DefaultApiSearchPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchPaymentRequests(requestParameters.organizationId, requestParameters.dueDateJstFrom, requestParameters.dueDateJstTo, requestParameters.requestedDateJstFrom, requestParameters.requestedDateJstTo, requestParameters.statuses, requestParameters.supplierId, requestParameters.transferDataCreated, requestParameters.withholdingApplied, requestParameters.transferFeeResponsibility, requestParameters.requestorId, requestParameters.freeWord, requestParameters.limit, requestParameters.offset, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send back onboarding request
     * @param {DefaultApiSendBackOnboardingRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendBackOnboardingRequest(requestParameters: DefaultApiSendBackOnboardingRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendBackOnboardingRequest(requestParameters.onboardingRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send changed credit notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendChangedCreditNotifications(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendChangedCreditNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Organization Identity Verification
     * @param {DefaultApiSendOrganizationIdentityVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendOrganizationIdentityVerification(requestParameters: DefaultApiSendOrganizationIdentityVerificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendOrganizationIdentityVerification(requestParameters.organizationId, requestParameters.sendOrganizationIdentityVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send two-factor authentication reset link as admin
     * @param {DefaultApiSendTfaResetLinkAsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendTfaResetLinkAsAdmin(requestParameters: DefaultApiSendTfaResetLinkAsAdminRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendTfaResetLinkAsAdmin(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send Transaction Authorization Request
     * @param {DefaultApiSendTransactionAuthorizationRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendTransactionAuthorizationRequest(requestParameters: DefaultApiSendTransactionAuthorizationRequestRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendTransactionAuthorizationRequest(requestParameters.organizationId, requestParameters.sendTransactionAuthorizationRequestRequest, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable or disable accounting integration
     * @param {DefaultApiSetAccountingActivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public setAccountingActivation(requestParameters: DefaultApiSetAccountingActivationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).setAccountingActivation(requestParameters.organizationId, requestParameters.setAccountingActivationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sign Up For Slack
     * @param {DefaultApiSignUpForSlackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public signUpForSlack(requestParameters: DefaultApiSignUpForSlackRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).signUpForSlack(requestParameters.signUpForSlackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit completed workflow of draft payment request
     * @param {DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitCompletedWorkflowOfDraftPaymentRequests(requestParameters: DefaultApiSubmitCompletedWorkflowOfDraftPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).submitCompletedWorkflowOfDraftPaymentRequests(requestParameters.organizationId, requestParameters.draftPaymentRequestId, requestParameters.xUpsidrSwitchUser, requestParameters.submitCompletedWorkflowOfDraftPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit completed workflow of payment request
     * @param {DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitCompletedWorkflowOfPaymentRequests(requestParameters: DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).submitCompletedWorkflowOfPaymentRequests(requestParameters.organizationId, requestParameters.xUpsidrSwitchUser, requestParameters.submitCompletedWorkflowOfPaymentRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit workflow
     * @param {DefaultApiSubmitWorkflowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public submitWorkflow(requestParameters: DefaultApiSubmitWorkflowRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).submitWorkflow(requestParameters.organizationId, requestParameters.workflowInstanceId, requestParameters.xUpsidrSwitchUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Suspend a card
     * @param {DefaultApiSuspendCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public suspendCard(requestParameters: DefaultApiSuspendCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).suspendCard(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncAllCardStatuses(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncAllCardStatuses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync all users to each marketing tools
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncAllUsersToEachMarketingTools(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncAllUsersToEachMarketingTools(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync freee account items
     * @param {DefaultApiSyncFreeeAccountItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncFreeeAccountItems(requestParameters: DefaultApiSyncFreeeAccountItemsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncFreeeAccountItems(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync freee partners
     * @param {DefaultApiSyncFreeePartnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncFreeePartners(requestParameters: DefaultApiSyncFreeePartnersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncFreeePartners(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync freee segment tags
     * @param {DefaultApiSyncFreeeSegmentTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncFreeeSegmentTags(requestParameters: DefaultApiSyncFreeeSegmentTagsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncFreeeSegmentTags(requestParameters.organizationId, requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Moneytree access token
     * @param {DefaultApiSyncMoneytreeAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncMoneytreeAccessToken(requestParameters: DefaultApiSyncMoneytreeAccessTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncMoneytreeAccessToken(requestParameters.code, requestParameters.state, requestParameters.nextTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync point usage to accounting service
     * @param {DefaultApiSyncPointUsageToAccountingServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncPointUsageToAccountingService(requestParameters: DefaultApiSyncPointUsageToAccountingServiceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncPointUsageToAccountingService(requestParameters.organizationId, requestParameters.syncPointUsageToAccountingServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Request for Freee Deals
     * @param {DefaultApiSyncRequestForFreeeDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public syncRequestForFreeeDeals(requestParameters: DefaultApiSyncRequestForFreeeDealsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).syncRequestForFreeeDeals(requestParameters.organizationId, requestParameters.companyId, requestParameters.syncRequestForFreeeDealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Two Factor Auth Reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public twoFactorAuthReset(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).twoFactorAuthReset(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Two Factor Auth Reset As Token
     * @param {DefaultApiTwoFactorAuthResetAsTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public twoFactorAuthResetAsToken(requestParameters: DefaultApiTwoFactorAuthResetAsTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).twoFactorAuthResetAsToken(requestParameters.twoFactorAuthResetAsTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlinking purchase to transaction.
     * @param {DefaultApiUnlinkingPurchaseToTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public unlinkingPurchaseToTransaction(requestParameters: DefaultApiUnlinkingPurchaseToTransactionRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).unlinkingPurchaseToTransaction(requestParameters.organizationId, requestParameters.purchaseApplicationId, requestParameters.visaTransactionReferenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlock a card due to no potential fraud
     * @param {DefaultApiUnlockCardForNotPotentialFraudRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public unlockCardForNotPotentialFraud(requestParameters: DefaultApiUnlockCardForNotPotentialFraudRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).unlockCardForNotPotentialFraud(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlock a card due to fraud cleared
     * @param {DefaultApiUnlockCardOnFraudClearedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public unlockCardOnFraudCleared(requestParameters: DefaultApiUnlockCardOnFraudClearedRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).unlockCardOnFraudCleared(requestParameters.organizationId, requestParameters.cardId, requestParameters.triggeredTransactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Available Currencies
     * @param {DefaultApiUpdateAvailableCurrenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAvailableCurrencies(requestParameters: DefaultApiUpdateAvailableCurrenciesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAvailableCurrencies(requestParameters.userAccountId, requestParameters.updateAvailableCurrenciesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Available Merchant Categories
     * @param {DefaultApiUpdateAvailableMerchantCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAvailableMerchantCategories(requestParameters: DefaultApiUpdateAvailableMerchantCategoriesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAvailableMerchantCategories(requestParameters.userAccountId, requestParameters.updateAvailableMerchantCategoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update card account unit
     * @param {DefaultApiUpdateCardAccountUnitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardAccountUnit(requestParameters: DefaultApiUpdateCardAccountUnitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardAccountUnit(requestParameters.organizationId, requestParameters.updateCardAccountUnitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Card Count Limit
     * @param {DefaultApiUpdateCardCountLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardCountLimit(requestParameters: DefaultApiUpdateCardCountLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardCountLimit(requestParameters.organizationId, requestParameters.updateCardCountLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update card holder for the user account
     * @param {DefaultApiUpdateCardHolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardHolder(requestParameters: DefaultApiUpdateCardHolderRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardHolder(requestParameters.userAccountId, requestParameters.updateCardHolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lock a card
     * @param {DefaultApiUpdateCardLockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardLock(requestParameters: DefaultApiUpdateCardLockRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardLock(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlock a card
     * @param {DefaultApiUpdateCardUnlockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCardUnlock(requestParameters: DefaultApiUpdateCardUnlockRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCardUnlock(requestParameters.organizationId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update comment for card transaction
     * @param {DefaultApiUpdateCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateComment(requestParameters: DefaultApiUpdateCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateComment(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionCommentId, requestParameters.updateCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update comment template
     * @param {DefaultApiUpdateCommentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCommentTemplate(requestParameters: DefaultApiUpdateCommentTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCommentTemplate(requestParameters.organizationId, requestParameters.templateId, requestParameters.updateCommentTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update corporate document verification result
     * @param {DefaultApiUpdateCorporateDocumentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateCorporateDocumentResult(requestParameters: DefaultApiUpdateCorporateDocumentResultRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateCorporateDocumentResult(requestParameters.organizationIdentityVerificationId, requestParameters.updateCorporateDocumentResultRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update daily usage limit for the user account
     * @param {DefaultApiUpdateDailyUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateDailyUserUsageLimit(requestParameters: DefaultApiUpdateDailyUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateDailyUserUsageLimit(requestParameters.userAccountId, requestParameters.updateDailyUserUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update deposit restriction for organization
     * @param {DefaultApiUpdateDepositRestrictionForOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateDepositRestrictionForOrganization(requestParameters: DefaultApiUpdateDepositRestrictionForOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateDepositRestrictionForOrganization(requestParameters.organizationId, requestParameters.depositRestrictionId, requestParameters.updateDepositRestrictionForOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle on/off email notification settings per user
     * @param {DefaultApiUpdateEmailNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEmailNotification(requestParameters: DefaultApiUpdateEmailNotificationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEmailNotification(requestParameters.userId, requestParameters.emailNotificationId, requestParameters.updateEmailNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update embed url method
     * @param {DefaultApiUpdateEmbedUrlMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEmbedUrlMethod(requestParameters: DefaultApiUpdateEmbedUrlMethodRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEmbedUrlMethod(requestParameters.organizationId, requestParameters.updateEmbedUrlMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the card holder. Only accessible by administrators.  Note: When the holder is changed, the new holder will be able to view all previous transaction history.  Error codes: - SYSTEM_ERROR: System error occurred 
     * @summary Update ETC card holder
     * @param {DefaultApiUpdateEtcCardHolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEtcCardHolder(requestParameters: DefaultApiUpdateEtcCardHolderRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEtcCardHolder(requestParameters.userAccountId, requestParameters.updateEtcCardHolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the card label. Only accessible by administrators.  Validation: - Required: Card label must not be empty - Max length: 64 characters  Error codes: - CARD_LABEL_DUPLICATE: Same card label already exists - SYSTEM_ERROR: System error occurred 
     * @summary Update ETC card label
     * @param {DefaultApiUpdateEtcCardLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEtcCardLabel(requestParameters: DefaultApiUpdateEtcCardLabelRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEtcCardLabel(requestParameters.userAccountId, requestParameters.updateEtcCardLabelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update evidence image
     * @param {DefaultApiUpdateEvidenceImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEvidenceImage(requestParameters: DefaultApiUpdateEvidenceImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.dpiForciblyValid, requestParameters.colorGradationForciblyValid, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update evidence info
     * @param {DefaultApiUpdateEvidenceInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateEvidenceInfo(requestParameters: DefaultApiUpdateEvidenceInfoRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateEvidenceInfo(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.cardTransactionEvidenceId, requestParameters.updateEvidenceInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update freee connect
     * @param {DefaultApiUpdateFreeeConnectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFreeeConnect(requestParameters: DefaultApiUpdateFreeeConnectRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFreeeConnect(requestParameters.organizationId, requestParameters.code, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary freee設定変更
     * @param {DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFreeeConnectionSettingsForAccounting(requestParameters: DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFreeeConnectionSettingsForAccounting(requestParameters.orgAccountId, requestParameters.upsidrPrivateClientApiInternal, requestParameters.updateFreeeConnectionSettingsForAccountingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turn on/off freee journaling
     * @param {DefaultApiUpdateFreeeJournalingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFreeeJournaling(requestParameters: DefaultApiUpdateFreeeJournalingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFreeeJournaling(requestParameters.organizationId, requestParameters.updateFreeeJournalingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update freee select company
     * @param {DefaultApiUpdateFreeeSelectCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFreeeSelectCompany(requestParameters: DefaultApiUpdateFreeeSelectCompanyRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFreeeSelectCompany(requestParameters.organizationId, requestParameters.updateFreeeSelectCompanyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update lock status of evidences
     * @param {DefaultApiUpdateLockStatusOfEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateLockStatusOfEvidences(requestParameters: DefaultApiUpdateLockStatusOfEvidencesRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateLockStatusOfEvidences(requestParameters.organizationId, requestParameters.updateLockStatusOfEvidencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update merchant general block allowed organization ids
     * @param {DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMerchantGeneralBlockAllowedOrganizationIds(requestParameters: DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMerchantGeneralBlockAllowedOrganizationIds(requestParameters.merchantGeneralBlockListId, requestParameters.updateMerchantGeneralBlockAllowedOrganizationIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update merchant general block list
     * @param {DefaultApiUpdateMerchantGeneralBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMerchantGeneralBlockList(requestParameters: DefaultApiUpdateMerchantGeneralBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMerchantGeneralBlockList(requestParameters.merchantGeneralBlockListId, requestParameters.updateMerchantGeneralBlockListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update merchant org block list
     * @param {DefaultApiUpdateMerchantOrgBlockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMerchantOrgBlockList(requestParameters: DefaultApiUpdateMerchantOrgBlockListRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMerchantOrgBlockList(requestParameters.merchantOrgBlockListId, requestParameters.updateMerchantOrgBlockListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Merchant Organization Comment
     * @param {DefaultApiUpdateMerchantOrganizationCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMerchantOrganizationComment(requestParameters: DefaultApiUpdateMerchantOrganizationCommentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMerchantOrganizationComment(requestParameters.organizationId, requestParameters.merchantId, requestParameters.userAccountId, requestParameters.updateMerchantOrganizationCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Organization
     * @param {DefaultApiUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateOrganization(requestParameters: DefaultApiUpdateOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateOrganization(requestParameters.organizationId, requestParameters.updateOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Organizations Accounting Csv Export Fields
     * @param {DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateOrganizationsAccountingCsvExportFields(requestParameters: DefaultApiUpdateOrganizationsAccountingCsvExportFieldsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateOrganizationsAccountingCsvExportFields(requestParameters.organizationId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the payment request evidence specified by evidenceId.
     * @summary Update the specific payment request evidence.
     * @param {DefaultApiUpdatePaymentRequestEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePaymentRequestEvidence(requestParameters: DefaultApiUpdatePaymentRequestEvidenceRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePaymentRequestEvidence(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.updatePaymentRequestEvidenceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the payment request evidence file specified by evidenceId. This also accept properties other than a file binary.
     * @summary Update the specific payment request evidence file.
     * @param {DefaultApiUpdatePaymentRequestEvidenceFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePaymentRequestEvidenceFile(requestParameters: DefaultApiUpdatePaymentRequestEvidenceFileRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePaymentRequestEvidenceFile(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.evidenceId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.dpiForciblyValid, requestParameters.colorGradationForciblyValid, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.invoiceIssuerName, requestParameters.asQualified, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update purchase application template.
     * @param {DefaultApiUpdatePurchaseApplicationTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updatePurchaseApplicationTemplate(requestParameters: DefaultApiUpdatePurchaseApplicationTemplateRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updatePurchaseApplicationTemplate(requestParameters.organizationId, requestParameters.purchaseTemplateId, requestParameters.updatePurchaseApplicationTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update remove user account group
     * @param {DefaultApiUpdateRemoveUserAccountGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateRemoveUserAccountGroup(requestParameters: DefaultApiUpdateRemoveUserAccountGroupRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateRemoveUserAccountGroup(requestParameters.userAccountId, requestParameters.updateRemoveUserAccountGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update role resource for user
     * @param {DefaultApiUpdateRoleResourceForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateRoleResourceForUser(requestParameters: DefaultApiUpdateRoleResourceForUserRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateRoleResourceForUser(requestParameters.userId, requestParameters.updateRoleResourceForUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Roles by Resource Id
     * @param {DefaultApiUpdateRolesByResourceIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateRolesByResourceId(requestParameters: DefaultApiUpdateRolesByResourceIdRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateRolesByResourceId(requestParameters.resourceScope, requestParameters.resourceId, requestParameters.updateRolesByResourceIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Slack evidence remind settings of an slack channel
     * @param {DefaultApiUpdateSlackEvidenceReminderPerChannelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSlackEvidenceReminderPerChannel(requestParameters: DefaultApiUpdateSlackEvidenceReminderPerChannelRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSlackEvidenceReminderPerChannel(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackEvidenceReminderPerChannelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update slack notification channel setting for card
     * @param {DefaultApiUpdateSlackNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSlackNotificationSettingForCard(requestParameters: DefaultApiUpdateSlackNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSlackNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackNotificationSettingForCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update slack notification channel setting for purchase-application
     * @param {DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSlackNotificationSettingForPurchaseApplication(requestParameters: DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSlackNotificationSettingForPurchaseApplication(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateSlackNotificationSettingForPurchaseApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update sync to freee from deal
     * @param {DefaultApiUpdateSyncToFreeeFromDealRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSyncToFreeeFromDeal(requestParameters: DefaultApiUpdateSyncToFreeeFromDealRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSyncToFreeeFromDeal(requestParameters.organizationId, requestParameters.companyId, requestParameters.dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update synchronize to freee log confirm
     * @param {DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSynchronizeToFreeeLogConfirm(requestParameters: DefaultApiUpdateSynchronizeToFreeeLogConfirmRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSynchronizeToFreeeLogConfirm(requestParameters.organizationId, requestParameters.companyId, requestParameters.updateSynchronizeToFreeeLogConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Teams notification channel setting for card
     * @param {DefaultApiUpdateTeamsNotificationSettingForCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTeamsNotificationSettingForCard(requestParameters: DefaultApiUpdateTeamsNotificationSettingForCardRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTeamsNotificationSettingForCard(requestParameters.organizationId, requestParameters.channelId, requestParameters.updateTeamsNotificationSettingForCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update transaction upper limit for the user account
     * @param {DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTransactionUpperLimitForTheUserAccount(requestParameters: DefaultApiUpdateTransactionUpperLimitForTheUserAccountRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTransactionUpperLimitForTheUserAccount(requestParameters.userAccountId, requestParameters.updateTransactionUpperLimitForTheUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user account group
     * @param {DefaultApiUpdateUserAccountGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserAccountGroup(requestParameters: DefaultApiUpdateUserAccountGroupRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserAccountGroup(requestParameters.userAccountId, requestParameters.updateUserAccountGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user account name
     * @param {DefaultApiUpdateUserAccountNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserAccountName(requestParameters: DefaultApiUpdateUserAccountNameRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserAccountName(requestParameters.userAccountId, requestParameters.updateUserAccountNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update user email, settings per user
     * @param {DefaultApiUpdateUserEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserEmail(requestParameters: DefaultApiUpdateUserEmailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserEmail(requestParameters.userId, requestParameters.updateUserEmailRequest, requestParameters.xChallengeSuccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update user name, settings per user
     * @param {DefaultApiUpdateUserNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserName(requestParameters: DefaultApiUpdateUserNameRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserName(requestParameters.userId, requestParameters.updateUserNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update user organization
     * @param {DefaultApiUpdateUserOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserOrganization(requestParameters: DefaultApiUpdateUserOrganizationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserOrganization(requestParameters.userId, requestParameters.updateUserOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update user password
     * @param {DefaultApiUpdateUserPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserPassword(requestParameters: DefaultApiUpdateUserPasswordRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserPassword(requestParameters.userId, requestParameters.updateUserPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update User Privilege
     * @param {DefaultApiUpdateUserPrivilegeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserPrivilege(requestParameters: DefaultApiUpdateUserPrivilegeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserPrivilege(requestParameters.organizationId, requestParameters.userId, requestParameters.updateUserPrivilegeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update usage limit for the user account
     * @param {DefaultApiUpdateUserUsageLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateUserUsageLimit(requestParameters: DefaultApiUpdateUserUsageLimitRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateUserUsageLimit(requestParameters.userAccountId, requestParameters.updateUserUsageLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload card transaction evidence images
     * @param {DefaultApiUploadCardTransactionEvidenceImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadCardTransactionEvidenceImage(requestParameters: DefaultApiUploadCardTransactionEvidenceImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadCardTransactionEvidenceImage(requestParameters.organizationId, requestParameters.paymentReferenceId, requestParameters.files, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload corporate document
     * @param {DefaultApiUploadCorporateDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadCorporateDocument(requestParameters: DefaultApiUploadCorporateDocumentRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadCorporateDocument(requestParameters.organizationIdentityVerificationId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload payment request evidence image
     * @param {DefaultApiUploadPaymentRequestEvidenceImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadPaymentRequestEvidenceImage(requestParameters: DefaultApiUploadPaymentRequestEvidenceImageRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).uploadPaymentRequestEvidenceImage(requestParameters.organizationId, requestParameters.paymentRequestId, requestParameters.file, requestParameters.electronicMethod, requestParameters.documentSize, requestParameters.heightMillis, requestParameters.widthMillis, requestParameters.note, requestParameters.irrelevantToLedger, requestParameters.uploadedByRecipient, requestParameters.uploadedFrom, requestParameters.invoiceIssuerName, requestParameters.invoiceIssuerRegistrationNumber, requestParameters.asQualified, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Users email confirm
     * @param {DefaultApiUsersEmailConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public usersEmailConfirm(requestParameters: DefaultApiUsersEmailConfirmRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).usersEmailConfirm(requestParameters.usersEmailConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定した scope の現在有効なチャレンジに対して6桁コードを検証し、成功時に短命 JWT (challengeSuccessToken) を発行する。 チャレンジは (userId, scope) ごとに独立しているため、scope の指定が必須。 
     * @summary sudo-mode チャレンジの検証
     * @param {DefaultApiVerifyChallengeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyChallenge(requestParameters: DefaultApiVerifyChallengeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyChallenge(requestParameters.userId, requestParameters.verifyChallengeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify moneytree connections
     * @param {DefaultApiVerifyMoneytreeConnectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyMoneytreeConnections(requestParameters: DefaultApiVerifyMoneytreeConnectionsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyMoneytreeConnections(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows system administrators to directly update a user\'s email address without email verification. This is a Zeus admin API that bypasses the standard email change flow. 
     * @summary Update user email address (Admin only)
     * @param {DefaultApiZeusUpdateUserEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public zeusUpdateUserEmail(requestParameters: DefaultApiZeusUpdateUserEmailRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).zeusUpdateUserEmail(requestParameters.userId, requestParameters.zeusUpdateUserEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
